(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 98279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createCache; }
});

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@emotion+sheet@1.4.0/node_modules/@emotion/sheet/dist/emotion-sheet.esm.js
var isDevelopment = false;

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/

function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  } // this function should always return with a value
  // TS can't understand it though so we make it stop complaining here


  return undefined;
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? !isDevelopment : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    this.tags.forEach(function (tag) {
      var _tag$parentNode;

      return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ../../node_modules/.pnpm/stylis@4.2.0/node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode

/**
 * @param {object}
 * @return {object}
 */
var Utility_assign = Object.assign

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return Utility_charat(value, 0) ^ 45 ? (((((((length << 2) ^ Utility_charat(value, 0)) << 2) ^ Utility_charat(value, 1)) << 2) ^ Utility_charat(value, 2)) << 2) ^ Utility_charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function Utility_match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function Utility_replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function Utility_charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Utility_substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function Utility_strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function Utility_sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function Utility_combine (array, callback) {
	return array.map(callback).join('')
}

;// CONCATENATED MODULE: ../../node_modules/.pnpm/stylis@4.2.0/node_modules/stylis/src/Tokenizer.js


var line = 1
var column = 1
var Tokenizer_length = 0
var position = 0
var character = 0
var characters = ''

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function Tokenizer_copy (root, props) {
	return Utility_assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function Tokenizer_char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? Utility_charat(characters, --position) : 0

	if (column--, character === 10)
		column = 1, line--

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < Tokenizer_length ? Utility_charat(characters, position++) : 0

	if (column++, character === 10)
		column = 1, line++

	return character
}

/**
 * @return {number}
 */
function peek () {
	return Utility_charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return Utility_substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, Tokenizer_length = Utility_strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function Tokenizer_tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next()
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next())
		switch (token(character)) {
			case 0: append(identifier(position - 1), children)
				break
			case 2: append(delimit(character), children)
				break
			default: append(from(character), children)
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character)
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type)
				break
			// \
			case 92:
				next()
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + Utility_from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next()

	return slice(index, position)
}

;// CONCATENATED MODULE: ../../node_modules/.pnpm/stylis@4.2.0/node_modules/stylis/src/Enum.js
var Enum_MS = '-ms-'
var Enum_MOZ = '-moz-'
var Enum_WEBKIT = '-webkit-'

var COMMENT = 'comm'
var Enum_RULESET = 'rule'
var Enum_DECLARATION = 'decl'

var PAGE = '@page'
var MEDIA = '@media'
var IMPORT = '@import'
var CHARSET = '@charset'
var VIEWPORT = '@viewport'
var SUPPORTS = '@supports'
var DOCUMENT = '@document'
var NAMESPACE = '@namespace'
var Enum_KEYFRAMES = '@keyframes'
var FONT_FACE = '@font-face'
var COUNTER_STYLE = '@counter-style'
var FONT_FEATURE_VALUES = '@font-feature-values'
var LAYER = '@layer'

;// CONCATENATED MODULE: ../../node_modules/.pnpm/stylis@4.2.0/node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function Serializer_serialize (children, callback) {
	var output = ''
	var length = Utility_sizeof(children)

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || ''

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case LAYER: if (element.children.length) break
		case IMPORT: case Enum_DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case Enum_KEYFRAMES: return element.return = element.value + '{' + Serializer_serialize(element.children, callback) + '}'
		case Enum_RULESET: element.value = element.props.join(',')
	}

	return Utility_strlen(children = Serializer_serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

;// CONCATENATED MODULE: ../../node_modules/.pnpm/stylis@4.2.0/node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = Utility_sizeof(collection)

	return function (element, index, children, callback) {
		var output = ''

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || ''

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element)
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length, children)
					return
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case RULESET:
					if (element.length)
						return combine(element.props, function (value) {
							switch (match(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return serialize([copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return serialize([
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function namespace (element) {
	switch (element.type) {
		case RULESET:
			element.props = element.props.map(function (value) {
				return combine(tokenize(value), function (value, index, children) {
					switch (charat(value, 0)) {
						// \f
						case 12:
							return substr(value, 1, strlen(value))
						// \0 ( + > ~
						case 0: case 40: case 43: case 62: case 126:
							return value
						// :
						case 58:
							if (children[++index] === 'global')
								children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1)
						// \s
						case 32:
							return index === 1 ? '' : value
						default:
							switch (index) {
								case 0: element = value
									return sizeof(children) > 1 ? '' : value
								case index = sizeof(children) - 1: case 2:
									return index === 2 ? value + element + element : value + element
								default:
									return value
							}
					}
				})
			})
	}
}

;// CONCATENATED MODULE: ../../node_modules/.pnpm/stylis@4.2.0/node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0
	var offset = 0
	var length = pseudo
	var atrule = 0
	var property = 0
	var previous = 0
	var variable = 1
	var scanning = 1
	var ampersand = 1
	var character = 0
	var type = ''
	var props = rules
	var children = rulesets
	var reference = rule
	var characters = type

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && Utility_charat(characters, length - 1) == 58) {
					if (indexof(characters += Utility_replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character)
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous)
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7)
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						Utility_append(comment(commenter(next(), caret()), root, parent), declarations)
						break
					default:
						characters += '/'
				}
				break
			// {
			case 123 * variable:
				points[index++] = Utility_strlen(characters) * ampersand
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0
					// ;
					case 59 + offset: if (ampersand == -1) characters = Utility_replace(characters, /\f/g, '')
						if (property > 0 && (Utility_strlen(characters) - length))
							Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(Utility_replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations)
						break
					// @ ;
					case 59: characters += ';'
					// { rule/at-rule
					default:
						Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets)

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children)
							else
								switch (atrule === 99 && Utility_charat(characters, 3) === 110 ? 100 : atrule) {
									// d l m s
									case 100: case 108: case 109: case 115:
										parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children)
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children)
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo
				break
			// :
			case 58:
				length = 1 + Utility_strlen(characters), property = previous
			default:
				if (variable < 1)
					if (character == 123)
						--variable
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += Utility_from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1)
						break
					// ,
					case 44:
						points[index++] = (Utility_strlen(characters) - 1) * ampersand, ampersand = 1
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next())

						atrule = peek(), offset = length = Utility_strlen(type = characters += identifier(caret())), character++
						break
					// -
					case 45:
						if (previous === 45 && Utility_strlen(characters) == 2)
							variable = 0
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1
	var rule = offset === 0 ? rules : ['']
	var size = Utility_sizeof(rule)

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = Utility_substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : Utility_replace(y, /&\f/g, rule[x])))
				props[k++] = z

	return node(value, root, parent, offset === 0 ? Enum_RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), Utility_substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, Enum_DECLARATION, Utility_substr(value, 0, length), Utility_substr(value, length + 1, -1), length)
}

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@emotion+cache@11.11.0/node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js





var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Utility_from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule' || cache.compat) return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses) {
      var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
      //
      // considering this input:
      // .a {
      //   .b /* comm */ {}
      //   color: hotpink;
      // }
      // we get output corresponding to this:
      // .a {
      //   & {
      //     /* comm */
      //     color: hotpink;
      //   }
      //   .b {}
      // }

      var commentContainer = isNested ? element.parent.children : // global rule at the root level
      children;

      for (var i = commentContainer.length - 1; i >= 0; i--) {
        var node = commentContainer[i];

        if (node.line < element.line) {
          break;
        } // it is quite weird but comments are *usually* put at `column: element.column - 1`
        // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
        // this will also match inputs like this:
        // .a {
        //   /* comm */
        //   .b {}
        // }
        //
        // but that is fine
        //
        // it would be the easiest to change the placement of the comment to be the first child of the rule:
        // .a {
        //   .b { /* comm */ }
        // }
        // with such inputs we wouldn't have to search for the comment at all
        // TODO: consider changing this comment placement in the next major version


        if (node.column < element.column) {
          if (isIgnoringComment(node)) {
            return;
          }

          break;
        }
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

/* eslint-disable no-fallthrough */

function emotion_cache_browser_esm_prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return Enum_WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Enum_WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Enum_WEBKIT + value + Enum_MOZ + value + Enum_MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return Enum_WEBKIT + value + Enum_MS + value + value;
    // order

    case 6165:
      return Enum_WEBKIT + value + Enum_MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return Enum_WEBKIT + value + Utility_replace(value, /(\w+).+(:[^]+)/, Enum_WEBKIT + 'box-$1$2' + Enum_MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return Enum_WEBKIT + value + Enum_MS + 'flex-item-' + Utility_replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return Enum_WEBKIT + value + Enum_MS + 'flex-line-pack' + Utility_replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return Enum_WEBKIT + 'box-' + Utility_replace(value, '-grow', '') + Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return Enum_WEBKIT + Utility_replace(value, /([^-])(transform)/g, '$1' + Enum_WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return Utility_replace(Utility_replace(Utility_replace(value, /(zoom-|grab)/, Enum_WEBKIT + '$1'), /(image-set)/, Enum_WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return Utility_replace(value, /(image-set\([^]*)/, Enum_WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return Utility_replace(Utility_replace(value, /(.+:)(flex-)?(.*)/, Enum_WEBKIT + 'box-pack:$3' + Enum_MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + Enum_WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Utility_replace(value, /(.+)-inline(.+)/, Enum_WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (Utility_strlen(value) - 1 - length > 6) switch (Utility_charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (Utility_charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return Utility_replace(value, /(.+:)(.+)-([^]+)/, '$1' + Enum_WEBKIT + '$2-$3' + '$1' + Enum_MOZ + (Utility_charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? emotion_cache_browser_esm_prefix(Utility_replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (Utility_charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (Utility_charat(value, Utility_strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return Utility_replace(value, ':', ':' + Enum_WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return Utility_replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + Enum_WEBKIT + (Utility_charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + Enum_WEBKIT + '$2$3' + '$1' + Enum_MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (Utility_charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return Enum_WEBKIT + value + Enum_MS + value + value;
  }

  return value;
}

var emotion_cache_browser_esm_prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case Enum_DECLARATION:
      element["return"] = emotion_cache_browser_esm_prefix(element.value, element.length);
      break;

    case Enum_KEYFRAMES:
      return Serializer_serialize([Tokenizer_copy(element, {
        value: Utility_replace(element.value, '@', '@' + Enum_WEBKIT)
      })], callback);

    case Enum_RULESET:
      if (element.length) return Utility_combine(element.props, function (value) {
        switch (Utility_match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(read-\w+)/, ':' + Enum_MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_WEBKIT + 'input-$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_MOZ + '$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, Enum_MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var defaultStylisPlugins = [emotion_cache_browser_esm_prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (false) {}

  if (key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if (false) {}

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (false) {}

  {
    var currentSheet;
    var finalizingPlugins = [stringify,  false ? 0 : rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return Serializer_serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if (false) {}

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};




/***/ }),

/***/ 50261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ memoize; }
/* harmony export */ });
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}




/***/ }),

/***/ 75104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Emotion$1; },
/* harmony export */   "T": function() { return /* binding */ ThemeContext; },
/* harmony export */   "c": function() { return /* binding */ createEmotionProps; },
/* harmony export */   "h": function() { return /* binding */ hasOwnProperty; },
/* harmony export */   "i": function() { return /* binding */ isBrowser; },
/* harmony export */   "w": function() { return /* binding */ withEmotionCache; }
/* harmony export */ });
/* unused harmony exports C, _, a, b, u */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98279);
/* harmony import */ var _emotion_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63812);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82579);
/* harmony import */ var _emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25577);










var isBrowser = "object" !== 'undefined';
var hasOwnProperty = {}.hasOwnProperty;

var EmotionCacheContext = /* #__PURE__ */react__WEBPACK_IMPORTED_MODULE_0__.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */(0,_emotion_cache__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
  key: 'css'
}) : null);

if (false) {}

var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return useContext(EmotionCacheContext);
};

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (props, ref) {
    // the cache will never be null in the browser
    var cache = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

if (!isBrowser) {
  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      var cache = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(EmotionCacheContext);

      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = (0,_emotion_cache__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
          key: 'css'
        });
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(EmotionCacheContext.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}

var ThemeContext = /* #__PURE__ */react__WEBPACK_IMPORTED_MODULE_0__.createContext({});

if (false) {}

var useTheme = function useTheme() {
  return React.useContext(ThemeContext);
};

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (false) {}

    return mergedTheme;
  }

  if (false) {}

  return _extends({}, outerTheme, theme);
};

var createCacheWithTheme = /* #__PURE__ */(/* unused pure expression or super */ null && (weakMemoize(function (outerTheme) {
  return weakMemoize(function (theme) {
    return getTheme(outerTheme, theme);
  });
})));
var ThemeProvider = function ThemeProvider(props) {
  var theme = React.useContext(ThemeContext);

  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }

  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: theme
  }, props.children);
};
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    var theme = React.useContext(ThemeContext);
    return /*#__PURE__*/React.createElement(Component, _extends({
      theme: theme,
      ref: ref
    }, props));
  }; // $FlowFixMe


  var WithTheme = /*#__PURE__*/React.forwardRef(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return hoistNonReactStatics(WithTheme, Component);
}

var getLastPart = function getLastPart(functionName) {
  // The match may be something like 'Object.createEmotionProps' or
  // 'Loader.prototype.render'
  var parts = functionName.split('.');
  return parts[parts.length - 1];
};

var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
  // V8
  var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
  if (match) return getLastPart(match[1]); // Safari / Firefox

  match = /^([A-Za-z0-9$.]+)@/.exec(line);
  if (match) return getLastPart(match[1]);
  return undefined;
};

var internalReactFunctionNames = /* #__PURE__ */new Set(['renderWithHooks', 'processChild', 'finishClassComponent', 'renderToString']); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
  if (!stackTrace) return undefined;
  var lines = stackTrace.split('\n');

  for (var i = 0; i < lines.length; i++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"

    if (!functionName) continue; // If we reach one of these, we have gone too far and should quit

    if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
    // uppercase letter

    if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
  }

  return undefined;
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {}

  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
  // the label hasn't already been computed

  if (false) { var label; }

  return newProps;
};

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_4__/* .registerStyles */ .hC)(cache, serialized, isStringTag);
  (0,_emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_3__/* .useInsertionEffectAlwaysWithSyncFallback */ .L)(function () {
    return (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_4__/* .insertStyles */ .My)(cache, serialized, isStringTag);
  });

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_4__/* .getRegisteredStyles */ .fp)(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_2__/* .serializeStyles */ .O)(registeredStyles, undefined, react__WEBPACK_IMPORTED_MODULE_0__.useContext(ThemeContext));

  if (false) { var labelFromStack; }

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ( true || 0)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Insertion, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(WrappedComponent, newProps));
});

if (false) {}

var Emotion$1 = Emotion;




/***/ }),

/***/ 78049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BX": function() { return /* binding */ jsxs; },
/* harmony export */   "HY": function() { return /* binding */ Fragment; },
/* harmony export */   "tZ": function() { return /* binding */ jsx; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31549);
/* harmony import */ var _dist_emotion_element_c39617d8_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75104);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44194);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98279);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10063);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82579);
/* harmony import */ var _emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25577);












var Fragment = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment;
function jsx(type, props, key) {
  if (!_dist_emotion_element_c39617d8_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__.h.call(props, 'css')) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx(type, props, key);
  }

  return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx(_dist_emotion_element_c39617d8_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__.E, (0,_dist_emotion_element_c39617d8_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__.c)(type, props), key);
}
function jsxs(type, props, key) {
  if (!_dist_emotion_element_c39617d8_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__.h.call(props, 'css')) {
    return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs(type, props, key);
  }

  return react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs(_dist_emotion_element_c39617d8_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__.E, (0,_dist_emotion_element_c39617d8_browser_esm_js__WEBPACK_IMPORTED_MODULE_6__.c)(type, props), key);
}




/***/ }),

/***/ 82579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ serializeStyles; }
});

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@emotion+hash@0.9.2/node_modules/@emotion/hash/dist/emotion-hash.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}



;// CONCATENATED MODULE: ../../node_modules/.pnpm/@emotion+unitless@0.10.0/node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};



// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+memoize@0.9.0/node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
var emotion_memoize_esm = __webpack_require__(50261);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@emotion+serialize@1.3.3/node_modules/@emotion/serialize/dist/emotion-serialize.esm.js




var isDevelopment = false;

var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */(0,emotion_memoize_esm/* default */.Z)(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  var componentSelector = interpolation;

  if (componentSelector.__emotion_styles !== undefined) {

    return componentSelector;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        var keyframes = interpolation;

        if (keyframes.anim === 1) {
          cursor = {
            name: keyframes.name,
            styles: keyframes.styles,
            next: cursor
          };
          return keyframes.name;
        }

        var serializedStyles = interpolation;

        if (serializedStyles.styles !== undefined) {
          var next = serializedStyles.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = serializedStyles.styles + ";";
          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        }

        break;
      }
  } // finalize string values (regular strings and functions interpolated into css calls)


  var asString = interpolation;

  if (registered == null) {
    return asString;
  }

  var cached = registered[asString];
  return cached !== undefined ? cached : asString;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var key in obj) {
      var value = obj[key];

      if (typeof value !== 'object') {
        var asString = value;

        if (registered != null && registered[asString] !== undefined) {
          string += key + "{" + registered[asString] + "}";
        } else if (isProcessableValue(asString)) {
          string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        }
      } else {
        if (key === 'NO_COMPONENT_SELECTOR' && isDevelopment) {
          throw new Error(noComponentSelectorMessage);
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(key) + ":" + interpolated + ";";
                break;
              }

            default:
              {

                string += key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list

var cursor;
function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    var asTemplateStringsArr = strings;

    styles += asTemplateStringsArr[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      var templateStringsArr = strings;

      styles += templateStringsArr[i];
    }
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + match[1];
  }

  var name = murmur2(styles) + identifierName;

  return {
    name: name,
    styles: styles,
    next: cursor
  };
}




/***/ }),

/***/ 25577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useInsertionEffectAlwaysWithSyncFallback; },
/* harmony export */   "j": function() { return /* binding */ useInsertionEffectWithLayoutFallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);


var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] ? /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;




/***/ }),

/***/ 63812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "My": function() { return /* binding */ insertStyles; },
/* harmony export */   "fp": function() { return /* binding */ getRegisteredStyles; },
/* harmony export */   "hC": function() { return /* binding */ registerStyles; }
/* harmony export */ });
var isBrowser = true;

function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else if (className) {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),

/***/ 22305:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
exports.N = void 0;
exports.N = {
    "color": {
        "backgroundPrimary": "#fff",
        "backgroundSecondary": "#f9f8f8",
        "backgroundTertiary": "#f3f2f0",
        "backgroundAccentBrand": "#0042e6",
        "backgroundStateHoverPrimary": "#ebe9e7",
        "backgroundStateHoverSecondary": "#dfdbd8",
        "backgroundStateHoverTertiary": "#d3cec9",
        "backgroundStateHoverAccentBrand": "#00288b",
        "backgroundStateHoverAccentSuccess": "#005842",
        "backgroundStateHoverAccentError": "#983131",
        "backgroundStateInactivePrimary": "#fff",
        "backgroundStateInactiveSecondary": "#fdfdfd",
        "backgroundStateInactiveTertiary": "#f9f8f8",
        "backgroundStateInactiveAccentBrand": "#b5caff",
        "backgroundStateInactiveAccentSuccess": "#ddfff6",
        "backgroundStateInactiveAccentError": "#f1d3d3",
        "backgroundStateErrorPrimary": "#c13e3e",
        "backgroundStateErrorSecondary": "#f8ebeb",
        "backgroundStateSuccessDefault": "#007f5e",
        "contentPrimary": "#23201d",
        "contentSecondary": "#5e564e",
        "contentTertiary": "#786e64",
        "contentAccentBrand": "#0042e6",
        "contentStateHoverPrimary": "#786e64",
        "contentStateHoverAccentBrand": "#00288b",
        "contentStateInactivePrimary": "#a0968c",
        "contentStateInactiveSecondary": "#d3cec9",
        "contentStateInactiveAccentBrand": "#b5caff",
        "contentStateErrorDefault": "#c13e3e",
        "contentStateSuccessDefault": "#007f5e",
        "contentInfographicsBlueMedium": "#326dff",
        "contentInfographicsEarthMedium": "#cdcdbd",
        "contentInfographicsClayMedium": "#ba8e75",
        "borderPrimary": "#dfdbd8",
        "borderSecondary": "#f3f2f0",
        "borderTertiary": "#fff",
        "borderAccentBrand": "#0042e6",
        "borderStateHoverPrimary": "#786e64",
        "borderStateHoverSecondary": "#d3cec9",
        "borderStateHoverTertiary": "#ebe9e7",
        "borderStateHoverAccentBrand": "#00288b",
        "borderStateHoverAccentSuccess": "#005842",
        "borderStateHoverAccentError": "#732525",
        "borderStateInactivePrimary": "#f9f8f8",
        "borderStateInactiveSecondary": "#f3f2f0",
        "borderStateInactiveTertiary": "#ebe9e7",
        "borderStateInactiveAccentBrand": "#b5caff",
        "borderStateInactiveAccentSuccess": "#ddfff6",
        "borderStateInactiveAccentError": "#f8ebeb",
        "borderStateErrorDefault": "#c13e3e",
        "borderStateSucess": "#007f5e",
        "borderStateSelectedPrimary": "#23201d",
        "borderStateSelectedSecondary": "#433d37",
        "borderStateSelectedTertiary": "#2f2f24",
        "borderStateSelectedAccentBrand": "#001e68",
        "borderStateSelectedAccentSuccess": "#003729",
        "borderStateSelectedAccentError": "#511a1a",
        "borderStateFocusedPrimary": "#23201d",
        "borderStateFocusedSecondary": "#23201d",
        "borderStateFocusedTertiary": "#2f2f24",
        "borderStateFocusedAccentBrand": "#0042e6",
        "borderStateFocusedAccentSuccess": "#003729",
        "borderStateFocusedAccentError": "#511a1a",
        "backgroundInversePrimary": "#23201d",
        "backgroundInverseSecondary": "#37322d",
        "backgroundInverseTertiary": "#433d37",
        "backgroundInverseAccentBrand": "#0042e6",
        "backgroundInversePureBlack": "#000000",
        "backgroundInverseStateHoverPrimary": "#37322d",
        "backgroundInverseStateHoverSecondary": "#433d37",
        "backgroundInverseStateHoverTertiary": "#786e64",
        "backgroundInverseStateInactivePrimary": "#d3cec9",
        "backgroundInverseStateInactiveSecondary": "#c6c1bb",
        "backgroundInverseStateInactiveTertiary": "#b8b1aa",
        "contentInversePrimary": "#fff",
        "contentInverseSecondary": "#ebe9e7",
        "contentInverseTertiary": "#fff",
        "contentInverseAccentBrand": "#f6f9ff",
        "contentInverseStateInactivePrimary": "#f9f8f8",
        "contentInverseStateInactiveSecondary": "#ebe9e7",
        "contentInverseStateInactiveTertiary": "#dfdbd8",
        "contentInverseStateError": "#e6b1b1",
        "contentInverseStateSuccess": "#c1ffef",
        "borderInversePrimary": "#23201d",
        "borderInverseSecondary": "#37322d",
        "borderInverseTertiary": "#37322d",
        "borderInverseAccentBrand": "#e0e9ff",
        "borderInverseStateHoverPrimary": "#37322d",
        "borderInverseStateHoverSecondary": "#433d37",
        "borderInverseStateHoverTertiary": "#433d37",
        "borderInverseStateHoverAccentBrand": "#00288b",
        "borderInverseStateHoverAccentSuccess": "#005842",
        "borderInverseStateHoverAccentError": "#732525",
        "borderInverseStateInactivePrimary": "#d3cec9",
        "borderInverseStateInactiveSecondary": "#c6c1bb",
        "borderInverseStateInactiveTertiary": "#b8b1aa",
        "borderInverseStateError": "#e6b1b1",
        "borderInverseStateSuccess": "#c1ffef",
        "borderInverseStateSelectedPrimary": "#786e64",
        "borderInverseStateSelectedSecondary": "#a0968c",
        "borderInverseStateSelectedTertiary": "#a0968c",
        "borderInverseStateSelectedAccentBrand": "#0034b6",
        "borderInverseStateFocusedDefault": "#f6f9ff",
        "shadowDefault": "#000000",
        "shadowInverse": "#ffffff",
        "scrimDark": "rgba(0, 0, 0, 0.72)",
        "scrimLight": "rgba(255, 255, 255, 0.72)"
    },
    "gradient": {
        "scrimGradient180deg": {
            "direction": "180deg",
            "colorStops": [
                {
                    "color": "rgba(35, 32, 29, 0.5)",
                    "stop": 1
                },
                {
                    "color": "rgba(35, 32, 29, 0.0)",
                    "stop": 0.3
                }
            ]
        },
        "scrimGradient180degInverse": {
            "direction": "0deg",
            "colorStops": [
                {
                    "color": "rgba(255,255,255,1)",
                    "stop": 0
                },
                {
                    "color": "rgba(255,255,255,0.10)",
                    "stop": 1
                }
            ]
        },
        "scrimGradient270degInverse": {
            "direction": "270deg",
            "colorStops": [
                {
                    "color": "rgba(255,255,255,1)",
                    "stop": 0
                },
                {
                    "color": "rgba(255,255,255,0.10)",
                    "stop": 1
                }
            ]
        },
        "scrimGradient90degInverse": {
            "direction": "90deg",
            "colorStops": [
                {
                    "color": "rgba(255,255,255,1)",
                    "stop": 0
                },
                {
                    "color": "rgba(255,255,255,0.10)",
                    "stop": 1
                }
            ]
        },
        "scrimGradient290deg": {
            "direction": "290deg",
            "colorStops": [
                {
                    "color": "rgba(35, 32, 29, 1)",
                    "stop": 1
                },
                {
                    "color": "rgba(35, 32, 29, 0.0)",
                    "stop": 0.45
                }
            ]
        }
    },
    "shadow": {
        "shadowColor": {
            "default": "#000000",
            "pressed": "#000000"
        },
        "shadowOpacity": {
            "default": 0.04,
            "pressed": 0.08
        },
        "elevation": {
            "default": 6,
            "pressed": 2
        },
        "shadowOffsetWidth": {
            "default": 0,
            "pressed": 0
        },
        "shadowOffsetHeight": {
            "default": 8,
            "pressed": 3
        },
        "shadowRadius": {
            "default": 20,
            "pressed": 5
        }
    },
    "opacity": {
        "stateDisabled": 0.7,
        "stateSelected": 1,
        "stateUnselected": 0.65,
        "stateHover": 0.15,
        "statePressed": 0.04,
        "stateInvisible": 0,
        "scrim": 0.72,
        "stateInverseDisabled": 0.3,
        "stateInverseHover": 0.16,
        "stateInversePressed": 0.08
    },
    "radius": {
        "borderAllowance": 1,
        "2x": 4,
        "3x": 6,
        "4x": 8,
        "6x": 12,
        "7x": 14,
        "8x": 16,
        "9x": 18,
        "10x": 20,
        "12x": 24,
        "13x": 26,
        "14x": 28,
        "16x": 32,
        "32x": 64,
        "60x": 120,
        "full": 1998,
        "includeBorderAllowance2x": 5,
        "includeBorderAllowance4x": 9
    },
    "rad": {
        "roundedNone": 0,
        "roundedXs": 2,
        "roundedSm": 4,
        "roundedMd": 6,
        "roundedLg": 8,
        "roundedXl": 12,
        "rounded2xl": 16,
        "rounded3xl": 24,
        "rounded4xl": 32,
        "roundedFull": 9999
    },
    "borderWidth": {
        "default": 1.5,
        "object": 4,
        "thinnest": 1
    },
    "typography": {
        "size": {
            "displayLarge": 117,
            "displayMedium": 92,
            "displaySmall": 65,
            "displayXsmall": 58,
            "headerLarge": 45,
            "headerMedium": 40,
            "headerSmall": 36,
            "subheaderLarge": 32,
            "subheaderMedium": 28,
            "subheaderSmall": 25,
            "subheaderXsmall": 22,
            "bodyXlarge": 20,
            "bodyLarge": 18,
            "bodyMedium": 16,
            "bodySmall": 14,
            "bodyXsmall": 11,
            "bodyXxsmall": 8,
            "labelXlarge": 20,
            "labelLarge": 18,
            "labelMedium": 16,
            "labelSmall": 14,
            "labelXsmall": 11
        },
        "lineHeight": {
            "displayLarge": 117,
            "displayMedium": 92,
            "displaySmall": 65,
            "displayXsmall": 58,
            "headerLarge": 45,
            "headerMedium": 40,
            "headerSmall": 36,
            "subheaderLarge": 35.2,
            "subheaderMedium": 30.800000000000004,
            "subheaderSmall": 28.000000000000004,
            "subheaderXsmall": 25.08,
            "bodyXlarge": 24,
            "bodyLarge": 26.099999999999998,
            "bodyMedium": 24,
            "bodySmall": 19.599999999999998,
            "bodyXsmall": 15.399999999999999,
            "bodyXxsmall": 11.2,
            "labelXlarge": 24,
            "labelLarge": 21.599999999999998,
            "labelMedium": 20,
            "labelSmall": 17.5,
            "labelXsmall": 13.75
        },
        "letterSpacing": {
            "displayLarge": -4.212,
            "displayMedium": -3.128,
            "displaySmall": -2.21,
            "displayXsmall": -1.9720000000000002,
            "headerLarge": -1.3499999999999999,
            "headerMedium": -1.2,
            "headerSmall": -1.08,
            "subheaderLarge": -0.896,
            "subheaderMedium": -0.784,
            "subheaderSmall": -0.7000000000000001,
            "subheaderXsmall": -0.528,
            "bodyXlarge": -0.48,
            "bodyLarge": -0.432,
            "bodyMedium": -0.224,
            "bodySmall": -0.196,
            "bodyXsmall": -0.154,
            "bodyXxsmall": -0.112,
            "labelXlarge": -0.48,
            "labelLarge": -0.432,
            "labelMedium": -0.224,
            "labelSmall": -0.196,
            "labelXsmall": -0.154
        },
        "weight": {
            "displayLarge": "500",
            "displayMedium": "500",
            "displaySmall": "500",
            "displayXsmall": "500",
            "headerLarge": "500",
            "headerMedium": "500",
            "headerSmall": "500",
            "subheaderLarge": "500",
            "subheaderMedium": "500",
            "subheaderSmall": "500",
            "subheaderXsmall": "500",
            "bodyXlarge": "400",
            "bodyLarge": "400",
            "bodyMedium": "400",
            "bodySmall": "400",
            "bodyXsmall": "400",
            "bodyXxsmall": "400",
            "labelXlarge": "500",
            "labelLarge": "500",
            "labelMedium": "500",
            "labelSmall": "500",
            "labelXsmall": "500"
        },
        "family": "Graphik"
    },
    "space": {
        "0x": 0,
        "0dot5x": 1,
        "1x": 2,
        "1dot5x": 3,
        "2x": 4,
        "2dot5x": 5,
        "3x": 6,
        "4x": 8,
        "475tenthsX": 9.5,
        "5x": 10,
        "575tenthsX": 11.5,
        "6x": 12,
        "65tenthsX": 13,
        "675tenthsX": 13.5,
        "7x": 14,
        "8x": 16,
        "9x": 18,
        "975tenthsX": 19.5,
        "10x": 20,
        "10dot5x": 21,
        "11x": 22,
        "12x": 24,
        "12dot5x": 25,
        "13x": 26,
        "14x": 28,
        "15x": 30,
        "16x": 32,
        "16dot5x": 33,
        "22x": 44,
        "20x": 40,
        "21x": 42,
        "23x": 46,
        "24x": 48,
        "25x": 50,
        "26x": 52,
        "27x": 54,
        "28x": 56,
        "30x": 60,
        "32x": 64,
        "36x": 72,
        "40x": 80,
        "44x": 88,
        "50x": 100,
        "56x": 112,
        "62x": 124,
        "62dot5x": 125,
        "68x": 136,
        "80x": 160,
        "125x": 250,
        "135x": 270
    },
    "sp": {
        "0": 0,
        "1": 4,
        "2": 8,
        "3": 12,
        "4": 16,
        "5": 20,
        "6": 24,
        "7": 28,
        "8": 32,
        "9": 36,
        "10": 40,
        "11": 44,
        "12": 48,
        "13": 52,
        "14": 56,
        "15": 60,
        "16": 64,
        "17": 68,
        "18": 72,
        "19": 76,
        "20": 80,
        "21": 84,
        "22": 88,
        "23": 92,
        "24": 96,
        "25": 100,
        "26": 104,
        "27": 108,
        "28": 112,
        "29": 116,
        "30": 120,
        "31": 124,
        "32": 128,
        "33": 132,
        "34": 136,
        "35": 140,
        "36": 144,
        "37": 148,
        "38": 152,
        "39": 156,
        "40": 160,
        "41": 164,
        "42": 168,
        "43": 172,
        "44": 176,
        "45": 180,
        "46": 184,
        "47": 188,
        "48": 192,
        "49": 196,
        "50": 200,
        "51": 204,
        "52": 208,
        "53": 212,
        "54": 216,
        "55": 220,
        "56": 224,
        "57": 228,
        "58": 232,
        "59": 236,
        "60": 240,
        "61": 244,
        "62": 248,
        "63": 252,
        "64": 256,
        "65": 260,
        "66": 264,
        "67": 268,
        "68": 272,
        "69": 276,
        "70": 280,
        "71": 284,
        "72": 288,
        "73": 292,
        "74": 296,
        "75": 300,
        "76": 304,
        "77": 308,
        "78": 312,
        "79": 316,
        "80": 320,
        "81": 324,
        "82": 328,
        "83": 332,
        "84": 336,
        "85": 340,
        "86": 344,
        "87": 348,
        "88": 352,
        "89": 356,
        "90": 360,
        "91": 364,
        "92": 368,
        "93": 372,
        "94": 376,
        "95": 380,
        "96": 384,
        "97": 388,
        "98": 392,
        "99": 396,
        "100": 400,
        "101": 404,
        "102": 408,
        "103": 412,
        "104": 416,
        "105": 420,
        "106": 424,
        "107": 428,
        "108": 432,
        "109": 436,
        "110": 440,
        "111": 444,
        "112": 448,
        "113": 452,
        "114": 456,
        "115": 460,
        "116": 464,
        "117": 468,
        "118": 472,
        "119": 476,
        "120": 480,
        "121": 484,
        "122": 488,
        "123": 492,
        "124": 496,
        "125": 500,
        "126": 504,
        "127": 508,
        "128": 512,
        "129": 516,
        "130": 520,
        "131": 524,
        "132": 528,
        "133": 532,
        "134": 536,
        "135": 540,
        "136": 544,
        "137": 548,
        "138": 552,
        "139": 556,
        "140": 560,
        "141": 564,
        "142": 568,
        "143": 572,
        "144": 576,
        "145": 580,
        "146": 584,
        "147": 588,
        "148": 592,
        "149": 596,
        "150": 600,
        "151": 604,
        "152": 608,
        "153": 612,
        "154": 616,
        "155": 620,
        "156": 624,
        "157": 628,
        "158": 632,
        "159": 636,
        "160": 640,
        "161": 644,
        "162": 648,
        "163": 652,
        "164": 656,
        "165": 660,
        "166": 664,
        "167": 668,
        "168": 672,
        "169": 676,
        "170": 680,
        "171": 684,
        "172": 688,
        "173": 692,
        "174": 696,
        "175": 700,
        "176": 704,
        "177": 708,
        "178": 712,
        "179": 716,
        "180": 720,
        "181": 724,
        "182": 728,
        "183": 732,
        "184": 736,
        "185": 740,
        "186": 744,
        "187": 748,
        "188": 752,
        "189": 756,
        "190": 760,
        "191": 764,
        "192": 768,
        "193": 772,
        "194": 776,
        "195": 780,
        "196": 784,
        "197": 788,
        "198": 792,
        "199": 796,
        "200": 800,
        "201": 804,
        "202": 808,
        "203": 812,
        "204": 816,
        "205": 820,
        "206": 824,
        "207": 828,
        "208": 832,
        "209": 836,
        "210": 840,
        "211": 844,
        "212": 848,
        "213": 852,
        "214": 856,
        "215": 860,
        "216": 864,
        "217": 868,
        "218": 872,
        "219": 876,
        "220": 880,
        "221": 884,
        "222": 888,
        "223": 892,
        "224": 896,
        "225": 900,
        "226": 904,
        "227": 908,
        "228": 912,
        "229": 916,
        "230": 920,
        "231": 924,
        "232": 928,
        "233": 932,
        "234": 936,
        "235": 940,
        "236": 944,
        "237": 948,
        "238": 952,
        "239": 956,
        "240": 960,
        "241": 964,
        "242": 968,
        "243": 972,
        "244": 976,
        "245": 980,
        "246": 984,
        "247": 988,
        "248": 992,
        "249": 996,
        "250": 1000,
        "251": 1004,
        "252": 1008,
        "253": 1012,
        "254": 1016,
        "255": 1020,
        "256": 1024,
        "257": 1028,
        "258": 1032,
        "259": 1036,
        "260": 1040,
        "261": 1044,
        "262": 1048,
        "263": 1052,
        "264": 1056,
        "265": 1060,
        "266": 1064,
        "267": 1068,
        "268": 1072,
        "269": 1076,
        "270": 1080,
        "271": 1084,
        "272": 1088,
        "273": 1092,
        "274": 1096,
        "275": 1100,
        "276": 1104,
        "277": 1108,
        "278": 1112,
        "279": 1116,
        "280": 1120,
        "281": 1124,
        "282": 1128,
        "283": 1132,
        "284": 1136,
        "285": 1140,
        "286": 1144,
        "287": 1148,
        "288": 1152,
        "289": 1156,
        "290": 1160,
        "291": 1164,
        "292": 1168,
        "293": 1172,
        "294": 1176,
        "295": 1180,
        "296": 1184,
        "297": 1188,
        "298": 1192,
        "299": 1196,
        "300": 1200,
        "301": 1204,
        "302": 1208,
        "303": 1212,
        "304": 1216,
        "305": 1220,
        "306": 1224,
        "307": 1228,
        "308": 1232,
        "309": 1236,
        "310": 1240,
        "311": 1244,
        "312": 1248,
        "313": 1252,
        "314": 1256,
        "315": 1260,
        "316": 1264,
        "317": 1268,
        "318": 1272,
        "319": 1276,
        "320": 1280,
        "321": 1284,
        "322": 1288,
        "323": 1292,
        "324": 1296,
        "325": 1300,
        "326": 1304,
        "327": 1308,
        "328": 1312,
        "329": 1316,
        "330": 1320,
        "331": 1324,
        "332": 1328,
        "333": 1332,
        "334": 1336,
        "335": 1340,
        "336": 1344,
        "337": 1348,
        "338": 1352,
        "339": 1356,
        "340": 1360,
        "341": 1364,
        "342": 1368,
        "343": 1372,
        "344": 1376,
        "345": 1380,
        "346": 1384,
        "347": 1388,
        "348": 1392,
        "349": 1396,
        "350": 1400,
        "351": 1404,
        "352": 1408,
        "353": 1412,
        "354": 1416,
        "355": 1420,
        "356": 1424,
        "357": 1428,
        "358": 1432,
        "359": 1436,
        "360": 1440,
        "361": 1444,
        "362": 1448,
        "363": 1452,
        "364": 1456,
        "365": 1460,
        "366": 1464,
        "367": 1468,
        "368": 1472,
        "369": 1476,
        "370": 1480,
        "371": 1484,
        "372": 1488,
        "373": 1492,
        "374": 1496,
        "375": 1500,
        "376": 1504,
        "377": 1508,
        "378": 1512,
        "379": 1516,
        "380": 1520,
        "381": 1524,
        "382": 1528,
        "383": 1532,
        "384": 1536,
        "385": 1540,
        "386": 1544,
        "387": 1548,
        "388": 1552,
        "389": 1556,
        "390": 1560,
        "391": 1564,
        "392": 1568,
        "393": 1572,
        "394": 1576,
        "395": 1580,
        "396": 1584,
        "397": 1588,
        "398": 1592,
        "399": 1596,
        "400": 1600,
        "401": 1604,
        "402": 1608,
        "403": 1612,
        "404": 1616,
        "405": 1620,
        "406": 1624,
        "407": 1628,
        "408": 1632,
        "409": 1636,
        "410": 1640,
        "411": 1644,
        "412": 1648,
        "413": 1652,
        "414": 1656,
        "415": 1660,
        "416": 1664,
        "417": 1668,
        "418": 1672,
        "419": 1676,
        "420": 1680,
        "421": 1684,
        "422": 1688,
        "423": 1692,
        "424": 1696,
        "425": 1700,
        "426": 1704,
        "427": 1708,
        "428": 1712,
        "429": 1716,
        "430": 1720,
        "431": 1724,
        "432": 1728,
        "433": 1732,
        "434": 1736,
        "435": 1740,
        "436": 1744,
        "437": 1748,
        "438": 1752,
        "439": 1756,
        "440": 1760,
        "441": 1764,
        "442": 1768,
        "443": 1772,
        "444": 1776,
        "445": 1780,
        "446": 1784,
        "447": 1788,
        "448": 1792,
        "449": 1796,
        "450": 1800,
        "451": 1804,
        "452": 1808,
        "453": 1812,
        "454": 1816,
        "455": 1820,
        "456": 1824,
        "457": 1828,
        "458": 1832,
        "459": 1836,
        "460": 1840,
        "461": 1844,
        "462": 1848,
        "463": 1852,
        "464": 1856,
        "465": 1860,
        "466": 1864,
        "467": 1868,
        "468": 1872,
        "469": 1876,
        "470": 1880,
        "471": 1884,
        "472": 1888,
        "473": 1892,
        "474": 1896,
        "475": 1900,
        "476": 1904,
        "477": 1908,
        "478": 1912,
        "479": 1916,
        "480": 1920,
        "481": 1924,
        "482": 1928,
        "483": 1932,
        "484": 1936,
        "485": 1940,
        "486": 1944,
        "487": 1948,
        "488": 1952,
        "489": 1956,
        "490": 1960,
        "491": 1964,
        "492": 1968,
        "493": 1972,
        "494": 1976,
        "495": 1980,
        "496": 1984,
        "497": 1988,
        "498": 1992,
        "499": 1996,
        "500": 2000,
        "px": 1,
        "half": 2,
        "1half": 6,
        "2half": 10,
        "3half": 14
    },
    "state": {
        "pressedScale": 0.95,
        "pressedScaleLargerObjects": 0.98
    },
    "size": {
        "1x": 1,
        "2x": 2,
        "3x": 3,
        "4x": 4,
        "5x": 5,
        "6x": 6,
        "7x": 7,
        "8x": 8,
        "10x": 10,
        "12x": 12,
        "14x": 14,
        "15x": 15,
        "16x": 16,
        "18x": 18,
        "20x": 20,
        "24x": 24,
        "26x": 26,
        "28x": 28,
        "30x": 30,
        "32x": 32,
        "33x": 33,
        "34x": 34,
        "36x": 36,
        "38x": 38,
        "40x": 40,
        "43x": 43,
        "44x": 44,
        "45x": 45,
        "48x": 48,
        "49x": 49,
        "51x": 51,
        "55x": 55,
        "56x": 56,
        "58x": 58,
        "60x": 60,
        "62x": 62,
        "63x": 63,
        "64x": 64,
        "65x": 65,
        "67x": 67,
        "68x": 68,
        "69x": 69,
        "72x": 72,
        "75x": 75,
        "76x": 76,
        "77x": 77,
        "78x": 78,
        "80x": 80,
        "82x": 82,
        "88x": 88,
        "93x": 93,
        "101x": 101,
        "110x": 110,
        "104x": 104,
        "105x": 105,
        "112x": 112,
        "129x": 129,
        "130x": 130,
        "157x": 157,
        "165x": 165,
        "160x": 160,
        "167x": 167,
        "168x": 168,
        "180x": 180,
        "200x": 200,
        "239x": 239,
        "240x": 240,
        "250x": 250,
        "272x": 272,
        "284x": 284,
        "310x": 310,
        "314x": 314,
        "320x": 320,
        "326x": 326,
        "327x": 327,
        "328x": 328,
        "332x": 332,
        "342x": 342,
        "345x": 345,
        "374x": 374,
        "375x": 375,
        "382x": 382,
        "450x": 450,
        "430x": 430,
        "451x": 451,
        "452x": 452,
        "500x": 500,
        "512x": 512,
        "516x": 516,
        "548x": 548,
        "616x": 616,
        "636x": 636,
        "652x": 652,
        "719x": 719,
        "736x": 736,
        "744x": 744,
        "745x": 745,
        "767x": 767,
        "847x": 847,
        "848x": 848,
        "768x": 768,
        "900x": 900,
        "1023x": 1023,
        "1024x": 1024,
        "1200x": 1200,
        "1201x": 1201,
        "1399x": 1399,
        "1440x": 1440,
        "1400x": 1400
    },
    "sz": {
        "0": 0,
        "1": 4,
        "2": 8,
        "3": 12,
        "4": 16,
        "5": 20,
        "6": 24,
        "7": 28,
        "8": 32,
        "9": 36,
        "10": 40,
        "11": 44,
        "12": 48,
        "13": 52,
        "14": 56,
        "15": 60,
        "16": 64,
        "17": 68,
        "18": 72,
        "19": 76,
        "20": 80,
        "21": 84,
        "22": 88,
        "23": 92,
        "24": 96,
        "25": 100,
        "26": 104,
        "27": 108,
        "28": 112,
        "29": 116,
        "30": 120,
        "31": 124,
        "32": 128,
        "33": 132,
        "34": 136,
        "35": 140,
        "36": 144,
        "37": 148,
        "38": 152,
        "39": 156,
        "40": 160,
        "41": 164,
        "42": 168,
        "43": 172,
        "44": 176,
        "45": 180,
        "46": 184,
        "47": 188,
        "48": 192,
        "49": 196,
        "50": 200,
        "51": 204,
        "52": 208,
        "53": 212,
        "54": 216,
        "55": 220,
        "56": 224,
        "57": 228,
        "58": 232,
        "59": 236,
        "60": 240,
        "61": 244,
        "62": 248,
        "63": 252,
        "64": 256,
        "65": 260,
        "66": 264,
        "67": 268,
        "68": 272,
        "69": 276,
        "70": 280,
        "71": 284,
        "72": 288,
        "73": 292,
        "74": 296,
        "75": 300,
        "76": 304,
        "77": 308,
        "78": 312,
        "79": 316,
        "80": 320,
        "81": 324,
        "82": 328,
        "83": 332,
        "84": 336,
        "85": 340,
        "86": 344,
        "87": 348,
        "88": 352,
        "89": 356,
        "90": 360,
        "91": 364,
        "92": 368,
        "93": 372,
        "94": 376,
        "95": 380,
        "96": 384,
        "97": 388,
        "98": 392,
        "99": 396,
        "100": 400,
        "101": 404,
        "102": 408,
        "103": 412,
        "104": 416,
        "105": 420,
        "106": 424,
        "107": 428,
        "108": 432,
        "109": 436,
        "110": 440,
        "111": 444,
        "112": 448,
        "113": 452,
        "114": 456,
        "115": 460,
        "116": 464,
        "117": 468,
        "118": 472,
        "119": 476,
        "120": 480,
        "121": 484,
        "122": 488,
        "123": 492,
        "124": 496,
        "125": 500,
        "126": 504,
        "127": 508,
        "128": 512,
        "129": 516,
        "130": 520,
        "131": 524,
        "132": 528,
        "133": 532,
        "134": 536,
        "135": 540,
        "136": 544,
        "137": 548,
        "138": 552,
        "139": 556,
        "140": 560,
        "141": 564,
        "142": 568,
        "143": 572,
        "144": 576,
        "145": 580,
        "146": 584,
        "147": 588,
        "148": 592,
        "149": 596,
        "150": 600,
        "151": 604,
        "152": 608,
        "153": 612,
        "154": 616,
        "155": 620,
        "156": 624,
        "157": 628,
        "158": 632,
        "159": 636,
        "160": 640,
        "161": 644,
        "162": 648,
        "163": 652,
        "164": 656,
        "165": 660,
        "166": 664,
        "167": 668,
        "168": 672,
        "169": 676,
        "170": 680,
        "171": 684,
        "172": 688,
        "173": 692,
        "174": 696,
        "175": 700,
        "176": 704,
        "177": 708,
        "178": 712,
        "179": 716,
        "180": 720,
        "181": 724,
        "182": 728,
        "183": 732,
        "184": 736,
        "185": 740,
        "186": 744,
        "187": 748,
        "188": 752,
        "189": 756,
        "190": 760,
        "191": 764,
        "192": 768,
        "193": 772,
        "194": 776,
        "195": 780,
        "196": 784,
        "197": 788,
        "198": 792,
        "199": 796,
        "200": 800,
        "201": 804,
        "202": 808,
        "203": 812,
        "204": 816,
        "205": 820,
        "206": 824,
        "207": 828,
        "208": 832,
        "209": 836,
        "210": 840,
        "211": 844,
        "212": 848,
        "213": 852,
        "214": 856,
        "215": 860,
        "216": 864,
        "217": 868,
        "218": 872,
        "219": 876,
        "220": 880,
        "221": 884,
        "222": 888,
        "223": 892,
        "224": 896,
        "225": 900,
        "226": 904,
        "227": 908,
        "228": 912,
        "229": 916,
        "230": 920,
        "231": 924,
        "232": 928,
        "233": 932,
        "234": 936,
        "235": 940,
        "236": 944,
        "237": 948,
        "238": 952,
        "239": 956,
        "240": 960,
        "241": 964,
        "242": 968,
        "243": 972,
        "244": 976,
        "245": 980,
        "246": 984,
        "247": 988,
        "248": 992,
        "249": 996,
        "250": 1000,
        "251": 1004,
        "252": 1008,
        "253": 1012,
        "254": 1016,
        "255": 1020,
        "256": 1024,
        "257": 1028,
        "258": 1032,
        "259": 1036,
        "260": 1040,
        "261": 1044,
        "262": 1048,
        "263": 1052,
        "264": 1056,
        "265": 1060,
        "266": 1064,
        "267": 1068,
        "268": 1072,
        "269": 1076,
        "270": 1080,
        "271": 1084,
        "272": 1088,
        "273": 1092,
        "274": 1096,
        "275": 1100,
        "276": 1104,
        "277": 1108,
        "278": 1112,
        "279": 1116,
        "280": 1120,
        "281": 1124,
        "282": 1128,
        "283": 1132,
        "284": 1136,
        "285": 1140,
        "286": 1144,
        "287": 1148,
        "288": 1152,
        "289": 1156,
        "290": 1160,
        "291": 1164,
        "292": 1168,
        "293": 1172,
        "294": 1176,
        "295": 1180,
        "296": 1184,
        "297": 1188,
        "298": 1192,
        "299": 1196,
        "300": 1200,
        "301": 1204,
        "302": 1208,
        "303": 1212,
        "304": 1216,
        "305": 1220,
        "306": 1224,
        "307": 1228,
        "308": 1232,
        "309": 1236,
        "310": 1240,
        "311": 1244,
        "312": 1248,
        "313": 1252,
        "314": 1256,
        "315": 1260,
        "316": 1264,
        "317": 1268,
        "318": 1272,
        "319": 1276,
        "320": 1280,
        "321": 1284,
        "322": 1288,
        "323": 1292,
        "324": 1296,
        "325": 1300,
        "326": 1304,
        "327": 1308,
        "328": 1312,
        "329": 1316,
        "330": 1320,
        "331": 1324,
        "332": 1328,
        "333": 1332,
        "334": 1336,
        "335": 1340,
        "336": 1344,
        "337": 1348,
        "338": 1352,
        "339": 1356,
        "340": 1360,
        "341": 1364,
        "342": 1368,
        "343": 1372,
        "344": 1376,
        "345": 1380,
        "346": 1384,
        "347": 1388,
        "348": 1392,
        "349": 1396,
        "350": 1400,
        "351": 1404,
        "352": 1408,
        "353": 1412,
        "354": 1416,
        "355": 1420,
        "356": 1424,
        "357": 1428,
        "358": 1432,
        "359": 1436,
        "360": 1440,
        "361": 1444,
        "362": 1448,
        "363": 1452,
        "364": 1456,
        "365": 1460,
        "366": 1464,
        "367": 1468,
        "368": 1472,
        "369": 1476,
        "370": 1480,
        "371": 1484,
        "372": 1488,
        "373": 1492,
        "374": 1496,
        "375": 1500,
        "376": 1504,
        "377": 1508,
        "378": 1512,
        "379": 1516,
        "380": 1520,
        "381": 1524,
        "382": 1528,
        "383": 1532,
        "384": 1536,
        "385": 1540,
        "386": 1544,
        "387": 1548,
        "388": 1552,
        "389": 1556,
        "390": 1560,
        "391": 1564,
        "392": 1568,
        "393": 1572,
        "394": 1576,
        "395": 1580,
        "396": 1584,
        "397": 1588,
        "398": 1592,
        "399": 1596,
        "400": 1600,
        "401": 1604,
        "402": 1608,
        "403": 1612,
        "404": 1616,
        "405": 1620,
        "406": 1624,
        "407": 1628,
        "408": 1632,
        "409": 1636,
        "410": 1640,
        "411": 1644,
        "412": 1648,
        "413": 1652,
        "414": 1656,
        "415": 1660,
        "416": 1664,
        "417": 1668,
        "418": 1672,
        "419": 1676,
        "420": 1680,
        "421": 1684,
        "422": 1688,
        "423": 1692,
        "424": 1696,
        "425": 1700,
        "426": 1704,
        "427": 1708,
        "428": 1712,
        "429": 1716,
        "430": 1720,
        "431": 1724,
        "432": 1728,
        "433": 1732,
        "434": 1736,
        "435": 1740,
        "436": 1744,
        "437": 1748,
        "438": 1752,
        "439": 1756,
        "440": 1760,
        "441": 1764,
        "442": 1768,
        "443": 1772,
        "444": 1776,
        "445": 1780,
        "446": 1784,
        "447": 1788,
        "448": 1792,
        "449": 1796,
        "450": 1800,
        "451": 1804,
        "452": 1808,
        "453": 1812,
        "454": 1816,
        "455": 1820,
        "456": 1824,
        "457": 1828,
        "458": 1832,
        "459": 1836,
        "460": 1840,
        "461": 1844,
        "462": 1848,
        "463": 1852,
        "464": 1856,
        "465": 1860,
        "466": 1864,
        "467": 1868,
        "468": 1872,
        "469": 1876,
        "470": 1880,
        "471": 1884,
        "472": 1888,
        "473": 1892,
        "474": 1896,
        "475": 1900,
        "476": 1904,
        "477": 1908,
        "478": 1912,
        "479": 1916,
        "480": 1920,
        "481": 1924,
        "482": 1928,
        "483": 1932,
        "484": 1936,
        "485": 1940,
        "486": 1944,
        "487": 1948,
        "488": 1952,
        "489": 1956,
        "490": 1960,
        "491": 1964,
        "492": 1968,
        "493": 1972,
        "494": 1976,
        "495": 1980,
        "496": 1984,
        "497": 1988,
        "498": 1992,
        "499": 1996,
        "500": 2000,
        "px": 1,
        "half": 2,
        "1half": 6,
        "2half": 10,
        "3half": 14
    },
    "text": {
        "row1x": 1,
        "row2x": 2,
        "row3x": 3
    },
    "textDecoration": {
        "link": "underline"
    },
    "fontWeight": {
        "regular": "400",
        "medium": "500"
    },
    "backgroundBlur": {
        "8x": 8
    },
    "percentage": {
        "1000x": "10%",
        "6500x": "65%",
        "8000x": "80%",
        "9000x": "90%",
        "9500x": "95%",
        "9800x": "98%",
        "10000x": "100%",
        "15000x": "150%",
        "5000x": "50%"
    },
    "animation": {
        "timing": {
            "accelerateDecelerateFastest": {
                "web": "cubic-bezier(0.83, 0, 0.17, 1) 100ms",
                "mobile": {
                    "type": "timing",
                    "duration": 100,
                    "easing": [
                        0.83,
                        0,
                        0.17,
                        1
                    ]
                }
            },
            "accelerateDecelerateFast": {
                "web": "cubic-bezier(0.83, 0, 0.17, 1) 500ms",
                "mobile": {
                    "type": "timing",
                    "duration": 500,
                    "easing": [
                        0.83,
                        0,
                        0.17,
                        1
                    ]
                }
            },
            "accelerateDecelerateSlow": {
                "web": "cubic-bezier(0.83, 0, 0.17, 1) 1000ms",
                "mobile": {
                    "type": "timing",
                    "duration": 1000,
                    "easing": [
                        0.83,
                        0,
                        0.17,
                        1
                    ]
                }
            },
            "decelerateFastest": {
                "web": "cubic-bezier(0.22, 1, 0.36, 1) 100ms",
                "mobile": {
                    "type": "timing",
                    "duration": 100,
                    "easing": [
                        0.22,
                        1,
                        0.36,
                        1
                    ]
                }
            },
            "decelerateFast": {
                "web": "cubic-bezier(0.22, 1, 0.36, 1) 500ms",
                "mobile": {
                    "type": "timing",
                    "duration": 500,
                    "easing": [
                        0.22,
                        1,
                        0.36,
                        1
                    ]
                }
            },
            "accelerateFast": {
                "web": "cubic-bezier(0.64, 0, 0.78, 0) 400ms",
                "mobile": {
                    "type": "timing",
                    "duration": 400,
                    "easing": [
                        0.64,
                        0,
                        0.78,
                        0
                    ]
                }
            },
            "accelerateSlow": {
                "web": "cubic-bezier(0.64, 0, 0.78, 0) 800ms",
                "mobile": {
                    "type": "timing",
                    "duration": 800,
                    "easing": [
                        0.64,
                        0,
                        0.78,
                        0
                    ]
                }
            },
            "responsiveAccelerate": {
                "web": "cubic-bezier(0.11, 0, 0.5, 0) 200ms",
                "mobile": {
                    "type": "timing",
                    "duration": 200,
                    "easing": [
                        0.11,
                        0,
                        0.5,
                        0
                    ]
                }
            },
            "linear": {
                "web": "cubic-bezier(0, 0, 1, 1) 100ms",
                "mobile": {
                    "type": "timing",
                    "duration": 100,
                    "easing": [
                        0,
                        0,
                        1,
                        1
                    ]
                }
            },
            "contentfulArchAnimation": {
                "web": "cubic-bezier(0.55, 0.0, 0.15, 1.0) 1000ms",
                "mobile": {
                    "type": "timing",
                    "duration": 1000,
                    "easing": [
                        0.55,
                        0,
                        0.15,
                        1
                    ]
                }
            }
        }
    }
};


/***/ }),

/***/ 6806:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * @noflow
 */

/* eslint no-bitwise: 0 */



function normalizeColor(color) {
  if (typeof color === 'number') {
    if (color >>> 0 === color && color >= 0 && color <= 0xffffffff) {
      return color;
    }
    return null;
  }

  if (typeof color !== 'string') {
    return null;
  }

  const matchers = getMatchers();
  let match;

  // Ordered based on occurrences on Facebook codebase
  if ((match = matchers.hex6.exec(color))) {
    return parseInt(match[1] + 'ff', 16) >>> 0;
  }

  const colorFromKeyword = normalizeKeyword(color);
  if (colorFromKeyword != null) {
    return colorFromKeyword;
  }

  if ((match = matchers.rgb.exec(color))) {
    return (
      ((parse255(match[1]) << 24) | // r
        (parse255(match[2]) << 16) | // g
        (parse255(match[3]) << 8) | // b
        0x000000ff) >>> // a
      0
    );
  }

  if ((match = matchers.rgba.exec(color))) {
    // rgba(R G B / A) notation
    if (match[6] !== undefined) {
      return (
        ((parse255(match[6]) << 24) | // r
          (parse255(match[7]) << 16) | // g
          (parse255(match[8]) << 8) | // b
          parse1(match[9])) >>> // a
        0
      );
    }

    // rgba(R, G, B, A) notation
    return (
      ((parse255(match[2]) << 24) | // r
        (parse255(match[3]) << 16) | // g
        (parse255(match[4]) << 8) | // b
        parse1(match[5])) >>> // a
      0
    );
  }

  if ((match = matchers.hex3.exec(color))) {
    return (
      parseInt(
        match[1] +
          match[1] + // r
          match[2] +
          match[2] + // g
          match[3] +
          match[3] + // b
          'ff', // a
        16,
      ) >>> 0
    );
  }

  // https://drafts.csswg.org/css-color-4/#hex-notation
  if ((match = matchers.hex8.exec(color))) {
    return parseInt(match[1], 16) >>> 0;
  }

  if ((match = matchers.hex4.exec(color))) {
    return (
      parseInt(
        match[1] +
          match[1] + // r
          match[2] +
          match[2] + // g
          match[3] +
          match[3] + // b
          match[4] +
          match[4], // a
        16,
      ) >>> 0
    );
  }

  if ((match = matchers.hsl.exec(color))) {
    return (
      (hslToRgb(
        parse360(match[1]), // h
        parsePercentage(match[2]), // s
        parsePercentage(match[3]), // l
      ) |
        0x000000ff) >>> // a
      0
    );
  }

  if ((match = matchers.hsla.exec(color))) {
    // hsla(H S L / A) notation
    if (match[6] !== undefined) {
      return (
        (hslToRgb(
          parse360(match[6]), // h
          parsePercentage(match[7]), // s
          parsePercentage(match[8]), // l
        ) |
          parse1(match[9])) >>> // a
        0
      );
    }

    // hsla(H, S, L, A) notation
    return (
      (hslToRgb(
        parse360(match[2]), // h
        parsePercentage(match[3]), // s
        parsePercentage(match[4]), // l
      ) |
        parse1(match[5])) >>> // a
      0
    );
  }

  if ((match = matchers.hwb.exec(color))) {
    return (
      (hwbToRgb(
        parse360(match[1]), // h
        parsePercentage(match[2]), // w
        parsePercentage(match[3]), // b
      ) |
        0x000000ff) >>> // a
      0
    );
  }

  return null;
}

function hue2rgb(p, q, t) {
  if (t < 0) {
    t += 1;
  }
  if (t > 1) {
    t -= 1;
  }
  if (t < 1 / 6) {
    return p + (q - p) * 6 * t;
  }
  if (t < 1 / 2) {
    return q;
  }
  if (t < 2 / 3) {
    return p + (q - p) * (2 / 3 - t) * 6;
  }
  return p;
}

function hslToRgb(h, s, l) {
  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;
  const r = hue2rgb(p, q, h + 1 / 3);
  const g = hue2rgb(p, q, h);
  const b = hue2rgb(p, q, h - 1 / 3);

  return (
    (Math.round(r * 255) << 24) |
    (Math.round(g * 255) << 16) |
    (Math.round(b * 255) << 8)
  );
}

function hwbToRgb(h, w, b) {
  if (w + b >= 1) {
    const gray = Math.round((w * 255) / (w + b));

    return (gray << 24) | (gray << 16) | (gray << 8);
  }

  const red = hue2rgb(0, 1, h + 1 / 3) * (1 - w - b) + w;
  const green = hue2rgb(0, 1, h) * (1 - w - b) + w;
  const blue = hue2rgb(0, 1, h - 1 / 3) * (1 - w - b) + w;

  return (
    (Math.round(red * 255) << 24) |
    (Math.round(green * 255) << 16) |
    (Math.round(blue * 255) << 8)
  );
}

const NUMBER = '[-+]?\\d*\\.?\\d+';
const PERCENTAGE = NUMBER + '%';

function call(...args) {
  return '\\(\\s*(' + args.join(')\\s*,?\\s*(') + ')\\s*\\)';
}

function callWithSlashSeparator(...args) {
  return (
    '\\(\\s*(' +
    args.slice(0, args.length - 1).join(')\\s*,?\\s*(') +
    ')\\s*/\\s*(' +
    args[args.length - 1] +
    ')\\s*\\)'
  );
}

function commaSeparatedCall(...args) {
  return '\\(\\s*(' + args.join(')\\s*,\\s*(') + ')\\s*\\)';
}

let cachedMatchers;

function getMatchers() {
  if (cachedMatchers === undefined) {
    cachedMatchers = {
      rgb: new RegExp('rgb' + call(NUMBER, NUMBER, NUMBER)),
      rgba: new RegExp(
        'rgba(' +
          commaSeparatedCall(NUMBER, NUMBER, NUMBER, NUMBER) +
          '|' +
          callWithSlashSeparator(NUMBER, NUMBER, NUMBER, NUMBER) +
          ')',
      ),
      hsl: new RegExp('hsl' + call(NUMBER, PERCENTAGE, PERCENTAGE)),
      hsla: new RegExp(
        'hsla(' +
          commaSeparatedCall(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER) +
          '|' +
          callWithSlashSeparator(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER) +
          ')',
      ),
      hwb: new RegExp('hwb' + call(NUMBER, PERCENTAGE, PERCENTAGE)),
      hex3: /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      hex4: /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      hex6: /^#([0-9a-fA-F]{6})$/,
      hex8: /^#([0-9a-fA-F]{8})$/,
    };
  }
  return cachedMatchers;
}

function parse255(str) {
  const int = parseInt(str, 10);
  if (int < 0) {
    return 0;
  }
  if (int > 255) {
    return 255;
  }
  return int;
}

function parse360(str) {
  const int = parseFloat(str);
  return (((int % 360) + 360) % 360) / 360;
}

function parse1(str) {
  const num = parseFloat(str);
  if (num < 0) {
    return 0;
  }
  if (num > 1) {
    return 255;
  }
  return Math.round(num * 255);
}

function parsePercentage(str) {
  // parseFloat conveniently ignores the final %
  const int = parseFloat(str);
  if (int < 0) {
    return 0;
  }
  if (int > 100) {
    return 1;
  }
  return int / 100;
}

function normalizeKeyword(name) {
  // prettier-ignore
  switch (name) {
    case 'transparent': return 0x00000000;
    // http://www.w3.org/TR/css3-color/#svg-color
    case 'aliceblue': return 0xf0f8ffff;
    case 'antiquewhite': return 0xfaebd7ff;
    case 'aqua': return 0x00ffffff;
    case 'aquamarine': return 0x7fffd4ff;
    case 'azure': return 0xf0ffffff;
    case 'beige': return 0xf5f5dcff;
    case 'bisque': return 0xffe4c4ff;
    case 'black': return 0x000000ff;
    case 'blanchedalmond': return 0xffebcdff;
    case 'blue': return 0x0000ffff;
    case 'blueviolet': return 0x8a2be2ff;
    case 'brown': return 0xa52a2aff;
    case 'burlywood': return 0xdeb887ff;
    case 'burntsienna': return 0xea7e5dff;
    case 'cadetblue': return 0x5f9ea0ff;
    case 'chartreuse': return 0x7fff00ff;
    case 'chocolate': return 0xd2691eff;
    case 'coral': return 0xff7f50ff;
    case 'cornflowerblue': return 0x6495edff;
    case 'cornsilk': return 0xfff8dcff;
    case 'crimson': return 0xdc143cff;
    case 'cyan': return 0x00ffffff;
    case 'darkblue': return 0x00008bff;
    case 'darkcyan': return 0x008b8bff;
    case 'darkgoldenrod': return 0xb8860bff;
    case 'darkgray': return 0xa9a9a9ff;
    case 'darkgreen': return 0x006400ff;
    case 'darkgrey': return 0xa9a9a9ff;
    case 'darkkhaki': return 0xbdb76bff;
    case 'darkmagenta': return 0x8b008bff;
    case 'darkolivegreen': return 0x556b2fff;
    case 'darkorange': return 0xff8c00ff;
    case 'darkorchid': return 0x9932ccff;
    case 'darkred': return 0x8b0000ff;
    case 'darksalmon': return 0xe9967aff;
    case 'darkseagreen': return 0x8fbc8fff;
    case 'darkslateblue': return 0x483d8bff;
    case 'darkslategray': return 0x2f4f4fff;
    case 'darkslategrey': return 0x2f4f4fff;
    case 'darkturquoise': return 0x00ced1ff;
    case 'darkviolet': return 0x9400d3ff;
    case 'deeppink': return 0xff1493ff;
    case 'deepskyblue': return 0x00bfffff;
    case 'dimgray': return 0x696969ff;
    case 'dimgrey': return 0x696969ff;
    case 'dodgerblue': return 0x1e90ffff;
    case 'firebrick': return 0xb22222ff;
    case 'floralwhite': return 0xfffaf0ff;
    case 'forestgreen': return 0x228b22ff;
    case 'fuchsia': return 0xff00ffff;
    case 'gainsboro': return 0xdcdcdcff;
    case 'ghostwhite': return 0xf8f8ffff;
    case 'gold': return 0xffd700ff;
    case 'goldenrod': return 0xdaa520ff;
    case 'gray': return 0x808080ff;
    case 'green': return 0x008000ff;
    case 'greenyellow': return 0xadff2fff;
    case 'grey': return 0x808080ff;
    case 'honeydew': return 0xf0fff0ff;
    case 'hotpink': return 0xff69b4ff;
    case 'indianred': return 0xcd5c5cff;
    case 'indigo': return 0x4b0082ff;
    case 'ivory': return 0xfffff0ff;
    case 'khaki': return 0xf0e68cff;
    case 'lavender': return 0xe6e6faff;
    case 'lavenderblush': return 0xfff0f5ff;
    case 'lawngreen': return 0x7cfc00ff;
    case 'lemonchiffon': return 0xfffacdff;
    case 'lightblue': return 0xadd8e6ff;
    case 'lightcoral': return 0xf08080ff;
    case 'lightcyan': return 0xe0ffffff;
    case 'lightgoldenrodyellow': return 0xfafad2ff;
    case 'lightgray': return 0xd3d3d3ff;
    case 'lightgreen': return 0x90ee90ff;
    case 'lightgrey': return 0xd3d3d3ff;
    case 'lightpink': return 0xffb6c1ff;
    case 'lightsalmon': return 0xffa07aff;
    case 'lightseagreen': return 0x20b2aaff;
    case 'lightskyblue': return 0x87cefaff;
    case 'lightslategray': return 0x778899ff;
    case 'lightslategrey': return 0x778899ff;
    case 'lightsteelblue': return 0xb0c4deff;
    case 'lightyellow': return 0xffffe0ff;
    case 'lime': return 0x00ff00ff;
    case 'limegreen': return 0x32cd32ff;
    case 'linen': return 0xfaf0e6ff;
    case 'magenta': return 0xff00ffff;
    case 'maroon': return 0x800000ff;
    case 'mediumaquamarine': return 0x66cdaaff;
    case 'mediumblue': return 0x0000cdff;
    case 'mediumorchid': return 0xba55d3ff;
    case 'mediumpurple': return 0x9370dbff;
    case 'mediumseagreen': return 0x3cb371ff;
    case 'mediumslateblue': return 0x7b68eeff;
    case 'mediumspringgreen': return 0x00fa9aff;
    case 'mediumturquoise': return 0x48d1ccff;
    case 'mediumvioletred': return 0xc71585ff;
    case 'midnightblue': return 0x191970ff;
    case 'mintcream': return 0xf5fffaff;
    case 'mistyrose': return 0xffe4e1ff;
    case 'moccasin': return 0xffe4b5ff;
    case 'navajowhite': return 0xffdeadff;
    case 'navy': return 0x000080ff;
    case 'oldlace': return 0xfdf5e6ff;
    case 'olive': return 0x808000ff;
    case 'olivedrab': return 0x6b8e23ff;
    case 'orange': return 0xffa500ff;
    case 'orangered': return 0xff4500ff;
    case 'orchid': return 0xda70d6ff;
    case 'palegoldenrod': return 0xeee8aaff;
    case 'palegreen': return 0x98fb98ff;
    case 'paleturquoise': return 0xafeeeeff;
    case 'palevioletred': return 0xdb7093ff;
    case 'papayawhip': return 0xffefd5ff;
    case 'peachpuff': return 0xffdab9ff;
    case 'peru': return 0xcd853fff;
    case 'pink': return 0xffc0cbff;
    case 'plum': return 0xdda0ddff;
    case 'powderblue': return 0xb0e0e6ff;
    case 'purple': return 0x800080ff;
    case 'rebeccapurple': return 0x663399ff;
    case 'red': return 0xff0000ff;
    case 'rosybrown': return 0xbc8f8fff;
    case 'royalblue': return 0x4169e1ff;
    case 'saddlebrown': return 0x8b4513ff;
    case 'salmon': return 0xfa8072ff;
    case 'sandybrown': return 0xf4a460ff;
    case 'seagreen': return 0x2e8b57ff;
    case 'seashell': return 0xfff5eeff;
    case 'sienna': return 0xa0522dff;
    case 'silver': return 0xc0c0c0ff;
    case 'skyblue': return 0x87ceebff;
    case 'slateblue': return 0x6a5acdff;
    case 'slategray': return 0x708090ff;
    case 'slategrey': return 0x708090ff;
    case 'snow': return 0xfffafaff;
    case 'springgreen': return 0x00ff7fff;
    case 'steelblue': return 0x4682b4ff;
    case 'tan': return 0xd2b48cff;
    case 'teal': return 0x008080ff;
    case 'thistle': return 0xd8bfd8ff;
    case 'tomato': return 0xff6347ff;
    case 'turquoise': return 0x40e0d0ff;
    case 'violet': return 0xee82eeff;
    case 'wheat': return 0xf5deb3ff;
    case 'white': return 0xffffffff;
    case 'whitesmoke': return 0xf5f5f5ff;
    case 'yellow': return 0xffff00ff;
    case 'yellowgreen': return 0x9acd32ff;
  }
  return null;
}

module.exports = normalizeColor;


/***/ }),

/***/ 74247:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var compose_refs_exports = {};
__export(compose_refs_exports, {
  composeRefs: () => composeRefs,
  setRef: () => setRef,
  useComposedRefs: () => useComposedRefs
});
module.exports = __toCommonJS(compose_refs_exports);
var React = __toESM(__webpack_require__(44194));
function setRef(ref, value) {
  typeof ref == "function" ? ref(value) : ref && (ref.current = value);
}
function composeRefs(...refs) {
  return (node) => refs.forEach((ref) => setRef(ref, node));
}
function useComposedRefs(...refs) {
  return React.useCallback(composeRefs(...refs), refs);
}
//# sourceMappingURL=compose-refs.js.map


/***/ }),

/***/ 82558:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
}, __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(74247), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 23213:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var constants_exports = {};
__export(constants_exports, {
  currentPlatform: () => currentPlatform,
  isAndroid: () => isAndroid,
  isChrome: () => isChrome,
  isClient: () => isClient,
  isIos: () => isIos,
  isServer: () => isServer,
  isTouchable: () => isTouchable,
  isWeb: () => isWeb,
  isWebTouchable: () => isWebTouchable,
  isWindowDefined: () => isWindowDefined,
  useIsomorphicLayoutEffect: () => useIsomorphicLayoutEffect
});
module.exports = __toCommonJS(constants_exports);
var import_react = __toESM(__webpack_require__(44194));
const isWeb = !0, isWindowDefined = typeof window < "u", isServer = isWeb && !isWindowDefined, isClient = isWeb && isWindowDefined, useIsomorphicLayoutEffect = isServer ? import_react.default.useEffect : import_react.default.useLayoutEffect, isChrome = typeof navigator < "u" && /Chrome/.test(navigator.userAgent || ""), isWebTouchable = isClient && ("ontouchstart" in window || navigator.maxTouchPoints > 0), isTouchable = !isWeb || isWebTouchable, isAndroid = !1, isIos = !1, currentPlatform = "web";
//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 77505:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
}, __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(23213), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 20673:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var createOptimizedView_exports = {};
__export(createOptimizedView_exports, {
  createOptimizedView: () => createOptimizedView
});
module.exports = __toCommonJS(createOptimizedView_exports);
function createOptimizedView(children, viewProps, baseViews) {
}
//# sourceMappingURL=createOptimizedView.js.map


/***/ }),

/***/ 61667:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var getBaseViews_exports = {};
__export(getBaseViews_exports, {
  getBaseViews: () => getBaseViews
});
module.exports = __toCommonJS(getBaseViews_exports);
function getBaseViews() {
  return null;
}
//# sourceMappingURL=getBaseViews.js.map


/***/ }),

/***/ 62841:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var getBoundingClientRect_exports = {};
__export(getBoundingClientRect_exports, {
  getBoundingClientRect: () => getBoundingClientRect
});
module.exports = __toCommonJS(getBoundingClientRect_exports);
const getBoundingClientRect = (node) => {
  if (!(!node || node.nodeType !== 1))
    return node.getBoundingClientRect?.();
};
//# sourceMappingURL=getBoundingClientRect.js.map


/***/ }),

/***/ 18199:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var getRect_exports = {};
__export(getRect_exports, {
  getRect: () => getRect
});
module.exports = __toCommonJS(getRect_exports);
var import_getBoundingClientRect = __webpack_require__(62841);
const getRect = (node) => {
  const rect = (0, import_getBoundingClientRect.getBoundingClientRect)(node);
  if (!rect) return;
  const { x, y, top, left } = rect;
  return { x, y, width: node.offsetWidth, height: node.offsetHeight, top, left };
};
//# sourceMappingURL=getRect.js.map


/***/ }),

/***/ 48692:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var useElementLayout_exports = {};
__export(useElementLayout_exports, {
  measureElement: () => measureElement,
  measureLayout: () => measureLayout,
  useElementLayout: () => useElementLayout
});
module.exports = __toCommonJS(useElementLayout_exports);
var import_constants = __webpack_require__(77505), import_getBoundingClientRect = __webpack_require__(62841);
const LayoutHandlers = /* @__PURE__ */ new WeakMap(), resizeListeners = /* @__PURE__ */ new Set();
let resizeObserver = null;
if (typeof window < "u" && "ResizeObserver" in window && (resizeObserver = new ResizeObserver((entries) => {
  for (const { target } of entries) {
    const onLayout = LayoutHandlers.get(target);
    if (typeof onLayout != "function") return;
    measureElement(target).then((event) => {
      onLayout(event);
    });
  }
}), typeof window.addEventListener == "function")) {
  let tm;
  window.addEventListener("resize", () => {
    clearTimeout(tm), tm = setTimeout(() => {
      resizeListeners.forEach((cb) => cb());
    }, 4);
  });
}
const measureElement = async (target) => new Promise((res) => {
  measureLayout(target, null, (x, y, width, height, left, top) => {
    res({
      nativeEvent: {
        layout: { x, y, width, height, left, top },
        target
      },
      timeStamp: Date.now()
    });
  });
}), cache = /* @__PURE__ */ new WeakMap(), measureLayout = (node, relativeTo, callback) => {
  const relativeNode = relativeTo || node?.parentNode;
  if (relativeNode instanceof HTMLElement) {
    const now = Date.now();
    cache.set(node, now), Promise.all([
      getBoundingClientRectAsync(node),
      getBoundingClientRectAsync(relativeNode)
    ]).then(([nodeDim, relativeNodeDim]) => {
      if (relativeNodeDim && nodeDim && cache.get(node) === now) {
        const { x, y, width, height, left, top } = getRelativeDimensions(
          nodeDim,
          relativeNodeDim
        );
        callback(x, y, width, height, left, top);
      }
    });
  }
}, getRelativeDimensions = (a, b) => {
  const { height, left, top, width } = a, x = left - b.left, y = top - b.top;
  return { x, y, width, height, left, top };
}, getBoundingClientRectAsync = (element) => new Promise((resolve) => {
  function fallbackToSync() {
    resolve((0, import_getBoundingClientRect.getBoundingClientRect)(element));
  }
  const tm = setTimeout(fallbackToSync, 10);
  new IntersectionObserver(
    (entries, ob) => {
      clearTimeout(tm), ob.disconnect(), resolve(entries[0]?.boundingClientRect);
    },
    {
      threshold: 1e-4
    }
  ).observe(element);
});
function useElementLayout(ref, onLayout) {
  (0, import_constants.useIsomorphicLayoutEffect)(() => {
    if (!onLayout) return;
    const node = ref.current;
    node && LayoutHandlers.set(node, onLayout);
  }, [ref, onLayout]), (0, import_constants.useIsomorphicLayoutEffect)(() => {
    if (!resizeObserver) return;
    const node = ref.current;
    if (!node || !LayoutHandlers.has(node)) return;
    const onResize = () => {
      measureElement(node).then(onLayout);
    };
    return resizeListeners.add(onResize), resizeObserver.observe(node), () => {
      resizeListeners.delete(onResize), resizeObserver?.unobserve(node);
    };
  }, [ref]);
}
//# sourceMappingURL=useElementLayout.js.map


/***/ }),

/***/ 68571:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var usePlatformMethods_exports = {};
__export(usePlatformMethods_exports, {
  usePlatformMethods: () => usePlatformMethods
});
module.exports = __toCommonJS(usePlatformMethods_exports);
var import_constants = __webpack_require__(77505), import_getRect = __webpack_require__(18199), import_useElementLayout = __webpack_require__(48692);
function usePlatformMethods(hostRef) {
  (0, import_constants.useIsomorphicLayoutEffect)(() => {
    const node = hostRef.current;
    node && (node.measure ||= (callback) => (0, import_useElementLayout.measureLayout)(node, null, callback), node.measureLayout ||= (relativeToNode, success) => (0, import_useElementLayout.measureLayout)(node, relativeToNode, success), node.measureInWindow ||= (callback) => {
      node && setTimeout(() => {
        const { height, left, top, width } = (0, import_getRect.getRect)(node);
        callback(left, top, width, height);
      }, 0);
    });
  }, [hostRef]);
}
//# sourceMappingURL=usePlatformMethods.js.map


/***/ }),

/***/ 64978:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
}, __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default")), __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var src_exports = {};
__export(src_exports, {
  Stack: () => Stack,
  Text: () => Text,
  View: () => View
});
module.exports = __toCommonJS(src_exports);
var import_react = __toESM(__webpack_require__(44194)), import_react_native_use_responder_events = __webpack_require__(26865), import_web = __webpack_require__(77330), import_createOptimizedView = __webpack_require__(20673), import_getBaseViews = __webpack_require__(61667), import_useElementLayout = __webpack_require__(48692), import_usePlatformMethods = __webpack_require__(68571), import_Pressability = __webpack_require__(33773);
__reExport(src_exports, __webpack_require__(77330), module.exports);
__reExport(src_exports, __webpack_require__(78151), module.exports);
const baseViews = (0, import_getBaseViews.getBaseViews)();
(0, import_web.setupHooks)({
  getBaseViews: import_getBaseViews.getBaseViews,
  usePropsTransform(elementType, propsIn, stateRef, willHydrate) {
    {
      const isDOM = typeof elementType == "string", {
        // event props
        onMoveShouldSetResponder,
        onMoveShouldSetResponderCapture,
        onResponderEnd,
        onResponderGrant,
        onResponderMove,
        onResponderReject,
        onResponderRelease,
        onResponderStart,
        onResponderTerminate,
        onResponderTerminationRequest,
        onScrollShouldSetResponder,
        onScrollShouldSetResponderCapture,
        onSelectionChangeShouldSetResponder,
        onSelectionChangeShouldSetResponderCapture,
        onStartShouldSetResponder,
        onStartShouldSetResponderCapture,
        // android
        collapsable,
        focusable,
        // deprecated,
        accessible,
        accessibilityDisabled,
        onLayout,
        hrefAttrs,
        ...plainDOMProps
      } = propsIn;
      if (willHydrate || isDOM) {
        const hostRef = import_react.default.useMemo(
          () => ({
            get current() {
              return stateRef.current.host;
            }
          }),
          [stateRef]
        );
        (0, import_usePlatformMethods.usePlatformMethods)(hostRef), (0, import_useElementLayout.useElementLayout)(hostRef, isDOM ? onLayout : void 0), (0, import_react_native_use_responder_events.useResponderEvents)(
          hostRef,
          isDOM ? {
            onMoveShouldSetResponder,
            onMoveShouldSetResponderCapture,
            onResponderEnd,
            onResponderGrant,
            onResponderMove,
            onResponderReject,
            onResponderRelease,
            onResponderStart,
            onResponderTerminate,
            onResponderTerminationRequest,
            onScrollShouldSetResponder,
            onScrollShouldSetResponderCapture,
            onSelectionChangeShouldSetResponder,
            onSelectionChangeShouldSetResponderCapture,
            onStartShouldSetResponder,
            onStartShouldSetResponderCapture
          } : void 0
        );
      }
      if (isDOM) {
        if (plainDOMProps.href && hrefAttrs) {
          const { download, rel, target } = hrefAttrs;
          download != null && (plainDOMProps.download = download), rel && (plainDOMProps.rel = rel), typeof target == "string" && (plainDOMProps.target = target.charAt(0) !== "_" ? `_${target}` : target);
        }
        return plainDOMProps;
      }
    }
  },
  useEvents(viewProps, events, { pseudos }, setStateShallow, staticConfig) {
  }
});
const View = import_web.View, Stack = import_web.Stack, Text = import_web.Text;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 78151:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var reactNativeTypes_exports = {};
module.exports = __toCommonJS(reactNativeTypes_exports);
//# sourceMappingURL=reactNativeTypes.js.map


/***/ }),

/***/ 33773:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var Pressability_exports = {};
__export(Pressability_exports, {
  Pressability: () => Pressability,
  usePressability: () => usePressability
});
module.exports = __toCommonJS(Pressability_exports);
const Pressability = {}, usePressability = (e) => ({});
//# sourceMappingURL=Pressability.js.map


/***/ }),

/***/ 68653:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var clamp_exports = {};
__export(clamp_exports, {
  clamp: () => clamp
});
module.exports = __toCommonJS(clamp_exports);
function clamp(value, [min, max]) {
  return Math.min(max, Math.max(min, value));
}
//# sourceMappingURL=clamp.js.map


/***/ }),

/***/ 46208:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var composeEventHandlers_exports = {};
__export(composeEventHandlers_exports, {
  composeEventHandlers: () => composeEventHandlers
});
module.exports = __toCommonJS(composeEventHandlers_exports);
function composeEventHandlers(og, next, { checkDefaultPrevented = !0 } = {}) {
  return !og || !next ? next || og || void 0 : (event) => {
    if (og?.(event), !event || !(checkDefaultPrevented && "defaultPrevented" in event) || // @ts-ignore
    "defaultPrevented" in event && !event.defaultPrevented)
      return next?.(event);
  };
}
//# sourceMappingURL=composeEventHandlers.js.map


/***/ }),

/***/ 93894:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var concatClassName_exports = {};
__export(concatClassName_exports, {
  concatClassName: () => concatClassName
});
module.exports = __toCommonJS(concatClassName_exports);
function concatClassName(_cn) {
  const args = arguments, usedPrefixes = [];
  let final = "";
  const len = args.length;
  let propObjects = null;
  for (let x = len; x >= 0; x--) {
    const cns = args[x];
    if (!cns) continue;
    if (!Array.isArray(cns) && typeof cns != "string") {
      propObjects = propObjects || [], propObjects.push(cns);
      continue;
    }
    const names = Array.isArray(cns) ? cns : cns.split(" "), numNames = names.length;
    for (let i = numNames - 1; i >= 0; i--) {
      const name = names[i];
      if (!name || name === " ") continue;
      if (name[0] !== "_") {
        final = name + " " + final;
        continue;
      }
      const splitIndex = name.indexOf("-");
      if (splitIndex < 1) {
        final = name + " " + final;
        continue;
      }
      const isMediaQuery = name[splitIndex + 1] === "_", styleKey = name.slice(1, name.lastIndexOf("-")), mediaKey = isMediaQuery ? name.slice(splitIndex + 2, splitIndex + 7) : null, uid = mediaKey ? styleKey + mediaKey : styleKey;
      if (usedPrefixes.indexOf(uid) > -1)
        continue;
      usedPrefixes.push(uid);
      const propName = styleKey;
      propName && propObjects && propObjects.some((po) => {
        if (mediaKey) {
          const propKey = pseudoInvert[mediaKey];
          return po && po[propKey] && propName in po[propKey] && po[propKey] !== null;
        }
        return po && propName in po && po[propName] !== null;
      }) || (final = name + " " + final);
    }
  }
  return final;
}
const pseudoInvert = {
  hover: "hoverStyle",
  focus: "focusStyle",
  press: "pressStyle",
  focusVisible: "focusVisibleStyle",
  disabled: "disabledStyle"
};
//# sourceMappingURL=concatClassName.js.map


/***/ }),

/***/ 89953:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
}, __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(31023), module.exports);
__reExport(src_exports, __webpack_require__(68653), module.exports);
__reExport(src_exports, __webpack_require__(46208), module.exports);
__reExport(src_exports, __webpack_require__(93894), module.exports);
__reExport(src_exports, __webpack_require__(20290), module.exports);
__reExport(src_exports, __webpack_require__(62772), module.exports);
__reExport(src_exports, __webpack_require__(75124), module.exports);
__reExport(src_exports, __webpack_require__(19927), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 62772:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var shouldRenderNativePlatform_exports = {};
__export(shouldRenderNativePlatform_exports, {
  shouldRenderNativePlatform: () => shouldRenderNativePlatform
});
module.exports = __toCommonJS(shouldRenderNativePlatform_exports);
var import_constants = __webpack_require__(77505);
const ALL_PLATFORMS = ["web", "android", "ios"];
function shouldRenderNativePlatform(nativeProp) {
  if (!nativeProp)
    return null;
  const userRequestedPlatforms = resolvePlatformNames(nativeProp);
  for (const platform of ALL_PLATFORMS)
    if (platform === import_constants.currentPlatform && userRequestedPlatforms.has(platform))
      return platform;
  return null;
}
function resolvePlatformNames(nativeProp) {
  const platforms = nativeProp === !0 ? ALL_PLATFORMS : nativeProp === !1 ? [] : Array.isArray(nativeProp) ? nativeProp : [nativeProp], set = new Set(platforms);
  return set.has("mobile") && (set.add("android"), set.add("ios"), set.delete("mobile")), set;
}
//# sourceMappingURL=shouldRenderNativePlatform.js.map


/***/ }),

/***/ 20290:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var types_exports = {};
__export(types_exports, {
  StyleObjectIdentifier: () => StyleObjectIdentifier,
  StyleObjectProperty: () => StyleObjectProperty,
  StyleObjectPseudo: () => StyleObjectPseudo,
  StyleObjectRules: () => StyleObjectRules,
  StyleObjectValue: () => StyleObjectValue
});
module.exports = __toCommonJS(types_exports);
const StyleObjectProperty = 0, StyleObjectValue = 1, StyleObjectIdentifier = 2, StyleObjectPseudo = 3, StyleObjectRules = 4;
//# sourceMappingURL=types.js.map


/***/ }),

/***/ 75124:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var validStyleProps_exports = {};
__export(validStyleProps_exports, {
  stylePropsAll: () => stylePropsAll,
  stylePropsFont: () => stylePropsFont,
  stylePropsText: () => stylePropsText,
  stylePropsTextOnly: () => stylePropsTextOnly,
  stylePropsTransform: () => stylePropsTransform,
  stylePropsUnitless: () => stylePropsUnitless,
  stylePropsView: () => stylePropsView,
  tokenCategories: () => tokenCategories,
  validPseudoKeys: () => validPseudoKeys,
  validStyles: () => validStyles
});
module.exports = __toCommonJS(validStyleProps_exports);
var import_constants = __webpack_require__(77505);
const textColors = {
  color: !0,
  textDecorationColor: !0,
  textShadowColor: !0
}, tokenCategories = {
  radius: {
    borderRadius: !0,
    borderTopLeftRadius: !0,
    borderTopRightRadius: !0,
    borderBottomLeftRadius: !0,
    borderBottomRightRadius: !0,
    // logical
    borderStartStartRadius: !0,
    borderStartEndRadius: !0,
    borderEndStartRadius: !0,
    borderEndEndRadius: !0
  },
  size: {
    width: !0,
    height: !0,
    minWidth: !0,
    minHeight: !0,
    maxWidth: !0,
    maxHeight: !0,
    blockSize: !0,
    minBlockSize: !0,
    maxBlockSize: !0,
    inlineSize: !0,
    minInlineSize: !0,
    maxInlineSize: !0
  },
  zIndex: {
    zIndex: !0
  },
  color: {
    backgroundColor: !0,
    borderColor: !0,
    borderBlockStartColor: !0,
    borderBlockEndColor: !0,
    borderBlockColor: !0,
    borderBottomColor: !0,
    borderInlineColor: !0,
    borderInlineStartColor: !0,
    borderInlineEndColor: !0,
    borderTopColor: !0,
    borderLeftColor: !0,
    borderRightColor: !0,
    borderEndColor: !0,
    borderStartColor: !0,
    shadowColor: !0,
    ...textColors,
    outlineColor: !0,
    caretColor: !0
  }
}, stylePropsUnitless = {
  WebkitLineClamp: !0,
  animationIterationCount: !0,
  aspectRatio: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  columnCount: !0,
  flex: !0,
  flexGrow: !0,
  flexOrder: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  fontWeight: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowGap: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnGap: !0,
  gridColumnStart: !0,
  gridTemplateColumns: !0,
  gridTemplateAreas: !0,
  lineClamp: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  scale: !0,
  scaleX: !0,
  scaleY: !0,
  scaleZ: !0,
  shadowOpacity: !0
}, stylePropsTransform = {
  x: !0,
  y: !0,
  scale: !0,
  perspective: !0,
  scaleX: !0,
  scaleY: !0,
  skewX: !0,
  skewY: !0,
  matrix: !0,
  rotate: !0,
  rotateY: !0,
  rotateX: !0,
  rotateZ: !0
}, stylePropsView = {
  backfaceVisibility: !0,
  borderBottomEndRadius: !0,
  borderBottomStartRadius: !0,
  borderBottomWidth: !0,
  borderLeftWidth: !0,
  borderRightWidth: !0,
  borderBlockWidth: !0,
  borderBlockEndWidth: !0,
  borderBlockStartWidth: !0,
  borderInlineWidth: !0,
  borderInlineEndWidth: !0,
  borderInlineStartWidth: !0,
  borderStyle: !0,
  borderBlockStyle: !0,
  borderBlockEndStyle: !0,
  borderBlockStartStyle: !0,
  borderInlineStyle: !0,
  borderInlineEndStyle: !0,
  borderInlineStartStyle: !0,
  borderTopEndRadius: !0,
  borderTopStartRadius: !0,
  borderTopWidth: !0,
  borderWidth: !0,
  transform: !0,
  transformOrigin: !0,
  alignContent: !0,
  alignItems: !0,
  alignSelf: !0,
  borderEndWidth: !0,
  borderStartWidth: !0,
  bottom: !0,
  display: !0,
  end: !0,
  flexBasis: !0,
  flexDirection: !0,
  flexWrap: !0,
  gap: !0,
  columnGap: !0,
  rowGap: !0,
  justifyContent: !0,
  left: !0,
  margin: !0,
  marginBlock: !0,
  marginBlockEnd: !0,
  marginBlockStart: !0,
  marginInline: !0,
  marginInlineStart: !0,
  marginInlineEnd: !0,
  marginBottom: !0,
  marginEnd: !0,
  marginHorizontal: !0,
  marginLeft: !0,
  marginRight: !0,
  marginStart: !0,
  marginTop: !0,
  marginVertical: !0,
  overflow: !0,
  padding: !0,
  paddingBottom: !0,
  paddingInline: !0,
  paddingBlock: !0,
  paddingBlockStart: !0,
  paddingInlineEnd: !0,
  paddingInlineStart: !0,
  paddingEnd: !0,
  paddingHorizontal: !0,
  paddingLeft: !0,
  paddingRight: !0,
  paddingStart: !0,
  paddingTop: !0,
  paddingVertical: !0,
  position: !0,
  right: !0,
  start: !0,
  top: !0,
  inset: !0,
  insetBlock: !0,
  insetBlockEnd: !0,
  insetBlockStart: !0,
  insetInline: !0,
  insetInlineEnd: !0,
  insetInlineStart: !0,
  direction: !0,
  shadowOffset: !0,
  shadowRadius: !0,
  ...tokenCategories.color,
  ...tokenCategories.radius,
  ...tokenCategories.size,
  ...tokenCategories.radius,
  ...stylePropsTransform,
  ...stylePropsUnitless,
  // RN doesn't support specific border styles per-edge
  transition: !0,
  textWrap: !0,
  backdropFilter: !0,
  background: !0,
  backgroundAttachment: !0,
  backgroundBlendMode: !0,
  backgroundClip: !0,
  backgroundColor: !0,
  backgroundImage: !0,
  backgroundOrigin: !0,
  backgroundPosition: !0,
  backgroundRepeat: !0,
  backgroundSize: !0,
  borderBottomStyle: !0,
  borderImage: !0,
  borderLeftStyle: !0,
  borderRightStyle: !0,
  borderTopStyle: !0,
  boxShadow: !0,
  boxSizing: !0,
  caretColor: !0,
  clipPath: !0,
  contain: !0,
  containerType: !0,
  content: !0,
  cursor: !0,
  filter: !0,
  float: !0,
  mask: !0,
  maskBorder: !0,
  maskBorderMode: !0,
  maskBorderOutset: !0,
  maskBorderRepeat: !0,
  maskBorderSlice: !0,
  maskBorderSource: !0,
  maskBorderWidth: !0,
  maskClip: !0,
  maskComposite: !0,
  maskImage: !0,
  maskMode: !0,
  maskOrigin: !0,
  maskPosition: !0,
  maskRepeat: !0,
  maskSize: !0,
  maskType: !0,
  mixBlendMode: !0,
  objectFit: !0,
  objectPosition: !0,
  outlineOffset: !0,
  outlineStyle: !0,
  outlineWidth: !0,
  overflowBlock: !0,
  overflowInline: !0,
  overflowX: !0,
  overflowY: !0,
  pointerEvents: !0,
  scrollbarWidth: !0,
  textEmphasis: !0,
  touchAction: !0,
  transformStyle: !0,
  userSelect: !0,
  ...import_constants.isAndroid ? { elevationAndroid: !0 } : {}
}, stylePropsFont = {
  fontFamily: !0,
  fontSize: !0,
  fontStyle: !0,
  fontWeight: !0,
  letterSpacing: !0,
  lineHeight: !0,
  textTransform: !0
}, stylePropsTextOnly = {
  ...stylePropsFont,
  textAlign: !0,
  textDecorationLine: !0,
  textDecorationStyle: !0,
  ...textColors,
  textShadowOffset: !0,
  textShadowRadius: !0,
  userSelect: !0,
  selectable: !0,
  verticalAlign: !0,
  whiteSpace: !0,
  wordWrap: !0,
  textOverflow: !0,
  textDecorationDistance: !0,
  cursor: !0,
  WebkitLineClamp: !0,
  WebkitBoxOrient: !0
}, stylePropsText = {
  ...stylePropsView,
  ...stylePropsTextOnly
}, stylePropsAll = stylePropsText, validPseudoKeys = {
  enterStyle: !0,
  exitStyle: !0,
  hoverStyle: !0,
  pressStyle: !0,
  focusStyle: !0,
  disabledStyle: !0,
  focusVisibleStyle: !0
}, validStyles = {
  ...validPseudoKeys,
  ...stylePropsView
};
//# sourceMappingURL=validStyleProps.js.map


/***/ }),

/***/ 19927:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var withStaticProperties_exports = {};
__export(withStaticProperties_exports, {
  withStaticProperties: () => withStaticProperties
});
module.exports = __toCommonJS(withStaticProperties_exports);
var import_react = __toESM(__webpack_require__(44194));
const Decorated = Symbol(), withStaticProperties = (component, staticProps) => {
  const next = (() => {
    if (component[Decorated]) {
      const _ = import_react.default.forwardRef(
        (props, ref) => import_react.default.createElement(component, { ...props, ref })
      );
      for (const key in component) {
        const v = component[key];
        _[key] = v && typeof v == "object" ? { ...v } : v;
      }
    }
    return component;
  })();
  return Object.assign(next, staticProps), next[Decorated] = !0, next;
};
//# sourceMappingURL=withStaticProperties.js.map


/***/ }),

/***/ 73225:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var src_exports = {};
__export(src_exports, {
  default: () => src_default,
  normalizeCSSColor: () => normalizeCSSColor,
  rgba: () => rgba
});
module.exports = __toCommonJS(src_exports);
var normalizeColor = __toESM(__webpack_require__(6806));
const norm = normalizeColor.default || normalizeColor, normalizeCSSColor = norm;
function rgba(colorInt) {
  const r = Math.round((colorInt & 4278190080) >>> 24), g = Math.round((colorInt & 16711680) >>> 16), b = Math.round((colorInt & 65280) >>> 8), a = ((colorInt & 255) >>> 0) / 255;
  return {
    r,
    g,
    b,
    a
  };
}
var src_default = normalizeCSSColor;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 18467:
/***/ (function() {

if (typeof globalThis['__DEV__'] === 'undefined') {
  globalThis['__DEV__'] = "production" === 'development'
}


/***/ }),

/***/ 23187:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var ResponderSystem_exports = {};
__export(ResponderSystem_exports, {
  addNode: () => addNode,
  attachListeners: () => attachListeners,
  getResponderNode: () => getResponderNode,
  removeNode: () => removeNode,
  terminateResponder: () => terminateResponder
});
module.exports = __toCommonJS(ResponderSystem_exports);
var import_createResponderEvent = __toESM(__webpack_require__(2805)), import_ResponderTouchHistoryStore = __webpack_require__(69102), import_types = __webpack_require__(55718), import_utils = __webpack_require__(20189), import_utils2 = __webpack_require__(20189);
const emptyObject = {}, startRegistration = [
  "onStartShouldSetResponderCapture",
  "onStartShouldSetResponder",
  { bubbles: !0 }
], moveRegistration = [
  "onMoveShouldSetResponderCapture",
  "onMoveShouldSetResponder",
  { bubbles: !0 }
], scrollRegistration = [
  "onScrollShouldSetResponderCapture",
  "onScrollShouldSetResponder",
  { bubbles: !1 }
], shouldSetResponderEvents = {
  touchstart: startRegistration,
  mousedown: startRegistration,
  touchmove: moveRegistration,
  mousemove: moveRegistration,
  scroll: scrollRegistration
}, emptyResponder = { id: null, idPath: null, node: null }, responderListenersMap = /* @__PURE__ */ new Map();
let isEmulatingMouseEvents = !1, trackedTouchCount = 0, currentResponder = {
  id: null,
  node: null,
  idPath: null
};
const responderTouchHistoryStore = new import_ResponderTouchHistoryStore.ResponderTouchHistoryStore();
function changeCurrentResponder(responder) {
  currentResponder = responder;
}
function getResponderConfig(id) {
  const config = responderListenersMap.get(id);
  return config ?? emptyObject;
}
function eventListener(domEvent) {
  const eventType = domEvent.type, eventTarget = domEvent.target;
  if (eventType === "touchstart" && (isEmulatingMouseEvents = !0), (eventType === "touchmove" || trackedTouchCount > 1) && (isEmulatingMouseEvents = !1), // Ignore browser emulated mouse events
  eventType === "mousedown" && isEmulatingMouseEvents || eventType === "mousemove" && isEmulatingMouseEvents || // Ignore mousemove if a mousedown didn't occur first
  eventType === "mousemove" && trackedTouchCount < 1)
    return;
  if (isEmulatingMouseEvents && eventType === "mouseup") {
    trackedTouchCount === 0 && (isEmulatingMouseEvents = !1);
    return;
  }
  const isStartEvent = (0, import_types.isStartish)(eventType) && (0, import_utils2.isPrimaryPointerDown)(domEvent), isMoveEvent = (0, import_types.isMoveish)(eventType), isEndEvent = (0, import_types.isEndish)(eventType), isScrollEvent = (0, import_types.isScroll)(eventType), isSelectionChangeEvent = (0, import_types.isSelectionChange)(eventType), responderEvent = (0, import_createResponderEvent.default)(domEvent, responderTouchHistoryStore);
  (isStartEvent || isMoveEvent || isEndEvent) && (domEvent.touches ? trackedTouchCount = domEvent.touches.length : isStartEvent ? trackedTouchCount = 1 : isEndEvent && (trackedTouchCount = 0), responderTouchHistoryStore.recordTouchTrack(
    eventType,
    responderEvent.nativeEvent
  ));
  let eventPaths = (0, import_utils2.getResponderPaths)(domEvent), wasNegotiated = !1, wantsResponder;
  if (isStartEvent || isMoveEvent || isScrollEvent && trackedTouchCount > 0) {
    const currentResponderIdPath = currentResponder.idPath, eventIdPath = eventPaths.idPath;
    if (currentResponderIdPath != null && eventIdPath != null) {
      const lowestCommonAncestor = (0, import_utils2.getLowestCommonAncestor)(
        currentResponderIdPath,
        eventIdPath
      );
      if (lowestCommonAncestor != null) {
        const index = eventIdPath.indexOf(lowestCommonAncestor) + (lowestCommonAncestor === currentResponder.id ? 1 : 0);
        eventPaths = {
          idPath: eventIdPath.slice(index),
          nodePath: eventPaths.nodePath.slice(index)
        };
      } else
        eventPaths = null;
    }
    eventPaths != null && (wantsResponder = findWantsResponder(eventPaths, domEvent, responderEvent), wantsResponder != null && (attemptTransfer(responderEvent, wantsResponder), wasNegotiated = !0));
  }
  if (currentResponder.id != null && currentResponder.node != null) {
    const { id, node } = currentResponder, {
      onResponderStart,
      onResponderMove,
      onResponderEnd,
      onResponderRelease,
      onResponderTerminate,
      onResponderTerminationRequest
    } = getResponderConfig(id);
    if (responderEvent.bubbles = !1, responderEvent.cancelable = !1, responderEvent.currentTarget = node, isStartEvent)
      onResponderStart != null && (responderEvent.dispatchConfig.registrationName = "onResponderStart", onResponderStart(responderEvent));
    else if (isMoveEvent)
      onResponderMove != null && (responderEvent.dispatchConfig.registrationName = "onResponderMove", onResponderMove(responderEvent));
    else {
      const isTerminateEvent = (0, import_types.isCancelish)(eventType) || // native context menu
      eventType === "contextmenu" || // window blur
      eventType === "blur" && eventTarget === window || // responder (or ancestors) blur
      eventType === "blur" && eventTarget.contains(node) && domEvent.relatedTarget !== node || // native scroll without using a pointer
      isScrollEvent && trackedTouchCount === 0 || // native scroll on node that is parent of the responder (allow siblings to scroll)
      isScrollEvent && eventTarget.contains(node) && eventTarget !== node || // native select/selectionchange on node
      isSelectionChangeEvent && (0, import_utils2.hasValidSelection)(domEvent), isReleaseEvent = isEndEvent && !isTerminateEvent && !(0, import_utils2.hasTargetTouches)(node, domEvent.touches);
      if (isEndEvent && onResponderEnd != null && (responderEvent.dispatchConfig.registrationName = "onResponderEnd", onResponderEnd(responderEvent)), isReleaseEvent && (onResponderRelease != null && (responderEvent.dispatchConfig.registrationName = "onResponderRelease", onResponderRelease(responderEvent)), changeCurrentResponder(emptyResponder)), isTerminateEvent) {
        let shouldTerminate = !0;
        (eventType === "contextmenu" || eventType === "scroll" || eventType === "selectionchange") && (wasNegotiated ? shouldTerminate = !1 : onResponderTerminationRequest != null && (responderEvent.dispatchConfig.registrationName = "onResponderTerminationRequest", onResponderTerminationRequest(responderEvent) === !1 && (shouldTerminate = !1))), shouldTerminate && (onResponderTerminate != null && (responderEvent.dispatchConfig.registrationName = "onResponderTerminate", onResponderTerminate(responderEvent)), changeCurrentResponder(emptyResponder), isEmulatingMouseEvents = !1, trackedTouchCount = 0);
      }
    }
  }
}
function findWantsResponder(eventPaths, domEvent, responderEvent) {
  const shouldSetCallbacks = shouldSetResponderEvents[domEvent.type];
  if (shouldSetCallbacks != null) {
    const { idPath, nodePath } = eventPaths, shouldSetCallbackCaptureName = shouldSetCallbacks[0], shouldSetCallbackBubbleName = shouldSetCallbacks[1], { bubbles } = shouldSetCallbacks[2], check = (id, node, callbackName) => {
      const shouldSetCallback = getResponderConfig(id)[callbackName];
      if (shouldSetCallback != null && (responderEvent.currentTarget = node, shouldSetCallback(responderEvent) === !0)) {
        const prunedIdPath = idPath.slice(idPath.indexOf(id));
        return { id, node, idPath: prunedIdPath };
      }
    };
    for (let i = idPath.length - 1; i >= 0; i--) {
      const id = idPath[i], node = nodePath[i], result = check(id, node, shouldSetCallbackCaptureName);
      if (result != null)
        return result;
      if (responderEvent.isPropagationStopped() === !0)
        return;
    }
    if (bubbles)
      for (let i = 0; i < idPath.length; i++) {
        const id = idPath[i], node = nodePath[i], result = check(id, node, shouldSetCallbackBubbleName);
        if (result != null)
          return result;
        if (responderEvent.isPropagationStopped() === !0)
          return;
      }
    else {
      const id = idPath[0], node = nodePath[0];
      if (domEvent.target === node)
        return check(id, node, shouldSetCallbackBubbleName);
    }
  }
}
function attemptTransfer(responderEvent, wantsResponder) {
  const { id: currentId, node: currentNode } = currentResponder, { id, node } = wantsResponder, { onResponderGrant, onResponderReject } = getResponderConfig(id);
  if (responderEvent.bubbles = !1, responderEvent.cancelable = !1, responderEvent.currentTarget = node, currentId == null)
    onResponderGrant != null && (responderEvent.currentTarget = node, responderEvent.dispatchConfig.registrationName = "onResponderGrant", onResponderGrant(responderEvent)), changeCurrentResponder(wantsResponder);
  else {
    const { onResponderTerminate, onResponderTerminationRequest } = getResponderConfig(currentId);
    let allowTransfer = !0;
    onResponderTerminationRequest != null && (responderEvent.currentTarget = currentNode, responderEvent.dispatchConfig.registrationName = "onResponderTerminationRequest", onResponderTerminationRequest(responderEvent) === !1 && (allowTransfer = !1)), allowTransfer ? (onResponderTerminate != null && (responderEvent.currentTarget = currentNode, responderEvent.dispatchConfig.registrationName = "onResponderTerminate", onResponderTerminate(responderEvent)), onResponderGrant != null && (responderEvent.currentTarget = node, responderEvent.dispatchConfig.registrationName = "onResponderGrant", onResponderGrant(responderEvent)), changeCurrentResponder(wantsResponder)) : onResponderReject != null && (responderEvent.currentTarget = node, responderEvent.dispatchConfig.registrationName = "onResponderReject", onResponderReject(responderEvent));
  }
}
const documentEventsCapturePhase = ["blur", "scroll"], documentEventsBubblePhase = [
  // mouse
  "mousedown",
  "mousemove",
  "mouseup",
  "dragstart",
  // touch
  "touchstart",
  "touchmove",
  "touchend",
  "touchcancel",
  // other
  "contextmenu",
  "select",
  "selectionchange"
], isTamaguiResponderActive = Symbol();
function attachListeners() {
  import_utils.canUseDOM && !window[isTamaguiResponderActive] && (window.addEventListener("blur", eventListener), documentEventsBubblePhase.forEach((eventType) => {
    document.addEventListener(eventType, eventListener);
  }), documentEventsCapturePhase.forEach((eventType) => {
    document.addEventListener(eventType, eventListener, !0);
  }), window[isTamaguiResponderActive] = !0);
}
function addNode(id, node, config) {
  (0, import_utils2.setResponderId)(node, id), responderListenersMap.set(id, config);
}
function removeNode(id) {
  currentResponder.id === id && terminateResponder(), responderListenersMap.has(id) && responderListenersMap.delete(id);
}
function terminateResponder() {
  const { id, node } = currentResponder;
  if (id != null && node != null) {
    const { onResponderTerminate } = getResponderConfig(id);
    if (onResponderTerminate != null) {
      const event = (0, import_createResponderEvent.default)({}, responderTouchHistoryStore);
      event.currentTarget = node, onResponderTerminate(event);
    }
    changeCurrentResponder(emptyResponder);
  }
  isEmulatingMouseEvents = !1, trackedTouchCount = 0;
}
function getResponderNode() {
  return currentResponder.node;
}
//# sourceMappingURL=ResponderSystem.js.map


/***/ }),

/***/ 69102:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var ResponderTouchHistoryStore_exports = {};
__export(ResponderTouchHistoryStore_exports, {
  ResponderTouchHistoryStore: () => ResponderTouchHistoryStore
});
module.exports = __toCommonJS(ResponderTouchHistoryStore_exports);
var import_types = __webpack_require__(55718);
class ResponderTouchHistoryStore {
  _touchHistory = {
    touchBank: [],
    //Array<TouchRecord>
    numberActiveTouches: 0,
    // If there is only one active touch, we remember its location. This prevents
    // us having to loop through all of the touches all the time in the most
    // common case.
    indexOfSingleActiveTouch: -1,
    mostRecentTimeStamp: 0
  };
  recordTouchTrack(topLevelType, nativeEvent) {
    const touchHistory = this._touchHistory;
    if ((0, import_types.isMoveish)(topLevelType))
      nativeEvent.changedTouches.forEach((touch) => recordTouchMove(touch, touchHistory));
    else if ((0, import_types.isStartish)(topLevelType))
      nativeEvent.changedTouches.forEach((touch) => recordTouchStart(touch, touchHistory)), touchHistory.numberActiveTouches = nativeEvent.touches.length, touchHistory.numberActiveTouches === 1 && (touchHistory.indexOfSingleActiveTouch = nativeEvent.touches[0].identifier);
    else if ((0, import_types.isEndish)(topLevelType) && (nativeEvent.changedTouches.forEach((touch) => recordTouchEnd(touch, touchHistory)), touchHistory.numberActiveTouches = nativeEvent.touches.length, touchHistory.numberActiveTouches === 1)) {
      const { touchBank } = touchHistory;
      for (let i = 0; i < touchBank.length; i++)
        if (touchBank[i]?.touchActive) {
          touchHistory.indexOfSingleActiveTouch = i;
          break;
        }
       false && (0);
    }
  }
  get touchHistory() {
    return this._touchHistory;
  }
}
const MAX_TOUCH_BANK = 20;
function timestampForTouch(touch) {
  return touch.timeStamp || touch.timestamp;
}
function createTouchRecord(touch) {
  return {
    touchActive: !0,
    startPageX: touch.pageX,
    startPageY: touch.pageY,
    startTimeStamp: timestampForTouch(touch),
    currentPageX: touch.pageX,
    currentPageY: touch.pageY,
    currentTimeStamp: timestampForTouch(touch),
    previousPageX: touch.pageX,
    previousPageY: touch.pageY,
    previousTimeStamp: timestampForTouch(touch)
  };
}
function resetTouchRecord(touchRecord, touch) {
  touchRecord.touchActive = !0, touchRecord.startPageX = touch.pageX, touchRecord.startPageY = touch.pageY, touchRecord.startTimeStamp = timestampForTouch(touch), touchRecord.currentPageX = touch.pageX, touchRecord.currentPageY = touch.pageY, touchRecord.currentTimeStamp = timestampForTouch(touch), touchRecord.previousPageX = touch.pageX, touchRecord.previousPageY = touch.pageY, touchRecord.previousTimeStamp = timestampForTouch(touch);
}
function getTouchIdentifier({ identifier }) {
  return identifier == null && console.error("Touch object is missing identifier."),  false && 0, identifier;
}
function recordTouchStart(touch, touchHistory) {
  const identifier = getTouchIdentifier(touch), touchRecord = touchHistory.touchBank[identifier];
  touchRecord ? resetTouchRecord(touchRecord, touch) : touchHistory.touchBank[identifier] = createTouchRecord(touch), touchHistory.mostRecentTimeStamp = timestampForTouch(touch);
}
function recordTouchMove(touch, touchHistory) {
  const touchRecord = touchHistory.touchBank[getTouchIdentifier(touch)];
  touchRecord ? (touchRecord.touchActive = !0, touchRecord.previousPageX = touchRecord.currentPageX, touchRecord.previousPageY = touchRecord.currentPageY, touchRecord.previousTimeStamp = touchRecord.currentTimeStamp, touchRecord.currentPageX = touch.pageX, touchRecord.currentPageY = touch.pageY, touchRecord.currentTimeStamp = timestampForTouch(touch), touchHistory.mostRecentTimeStamp = timestampForTouch(touch)) : console.warn(
    `Cannot record touch move without a touch start.
`,
    `Touch Move: ${printTouch(touch)}
`,
    `Touch Bank: ${printTouchBank(touchHistory)}`
  );
}
function recordTouchEnd(touch, touchHistory) {
  const touchRecord = touchHistory.touchBank[getTouchIdentifier(touch)];
  touchRecord ? (touchRecord.touchActive = !1, touchRecord.previousPageX = touchRecord.currentPageX, touchRecord.previousPageY = touchRecord.currentPageY, touchRecord.previousTimeStamp = touchRecord.currentTimeStamp, touchRecord.currentPageX = touch.pageX, touchRecord.currentPageY = touch.pageY, touchRecord.currentTimeStamp = timestampForTouch(touch), touchHistory.mostRecentTimeStamp = timestampForTouch(touch)) : console.warn(
    `Cannot record touch end without a touch start.
`,
    `Touch End: ${printTouch(touch)}
`,
    `Touch Bank: ${printTouchBank(touchHistory)}`
  );
}
function printTouch(touch) {
  return JSON.stringify({
    identifier: touch.identifier,
    pageX: touch.pageX,
    pageY: touch.pageY,
    timestamp: timestampForTouch(touch)
  });
}
function printTouchBank(touchHistory) {
  const { touchBank } = touchHistory;
  let printed = JSON.stringify(touchBank.slice(0, MAX_TOUCH_BANK));
  return touchBank.length > MAX_TOUCH_BANK && (printed += ` (original size: ${touchBank.length})`), printed;
}
//# sourceMappingURL=ResponderTouchHistoryStore.js.map


/***/ }),

/***/ 2805:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var createResponderEvent_exports = {};
__export(createResponderEvent_exports, {
  default: () => createResponderEvent
});
module.exports = __toCommonJS(createResponderEvent_exports);
var import_utils = __webpack_require__(20189);
const emptyFunction = () => {
}, emptyObject = {}, emptyArray = [];
function normalizeIdentifier(identifier) {
  return identifier > 20 ? identifier % 20 : identifier;
}
function createResponderEvent(domEvent, responderTouchHistoryStore) {
  let rect, propagationWasStopped = !1, changedTouches, touches;
  const domEventChangedTouches = domEvent.changedTouches, domEventType = domEvent.type, metaKey = domEvent.metaKey === !0, shiftKey = domEvent.shiftKey === !0, force = domEventChangedTouches?.[0].force || 0, identifier = normalizeIdentifier(domEventChangedTouches?.[0].identifier || 0), clientX = domEventChangedTouches?.[0].clientX || domEvent.clientX, clientY = domEventChangedTouches?.[0].clientY || domEvent.clientY, pageX = domEventChangedTouches?.[0].pageX || domEvent.pageX, pageY = domEventChangedTouches?.[0].pageY || domEvent.pageY, preventDefault = typeof domEvent.preventDefault == "function" ? domEvent.preventDefault.bind(domEvent) : emptyFunction, timestamp = domEvent.timeStamp;
  function normalizeTouches(touches2) {
    return Array.prototype.slice.call(touches2).map((touch) => ({
      force: touch.force,
      identifier: normalizeIdentifier(touch.identifier),
      get locationX() {
        return locationX(touch.clientX);
      },
      get locationY() {
        return locationY(touch.clientY);
      },
      pageX: touch.pageX,
      pageY: touch.pageY,
      target: touch.target,
      timestamp
    }));
  }
  if (domEventChangedTouches != null)
    changedTouches = normalizeTouches(domEventChangedTouches), touches = normalizeTouches(domEvent.touches);
  else {
    const emulatedTouches = [
      {
        force,
        identifier,
        get locationX() {
          return locationX(clientX);
        },
        get locationY() {
          return locationY(clientY);
        },
        pageX,
        pageY,
        target: domEvent.target,
        timestamp
      }
    ];
    changedTouches = emulatedTouches, touches = domEventType === "mouseup" || domEventType === "dragstart" ? emptyArray : emulatedTouches;
  }
  const responderEvent = {
    bubbles: !0,
    cancelable: !0,
    // `currentTarget` is set before dispatch
    currentTarget: null,
    defaultPrevented: domEvent.defaultPrevented,
    dispatchConfig: emptyObject,
    eventPhase: domEvent.eventPhase,
    isDefaultPrevented() {
      return domEvent.defaultPrevented;
    },
    isPropagationStopped() {
      return propagationWasStopped;
    },
    isTrusted: domEvent.isTrusted,
    nativeEvent: {
      altKey: !1,
      ctrlKey: !1,
      metaKey,
      shiftKey,
      changedTouches,
      force,
      identifier,
      get locationX() {
        return locationX(clientX);
      },
      get locationY() {
        return locationY(clientY);
      },
      pageX,
      pageY,
      target: domEvent.target,
      timestamp,
      touches,
      type: domEventType
    },
    persist: emptyFunction,
    preventDefault,
    stopPropagation() {
      propagationWasStopped = !0;
    },
    target: domEvent.target,
    timeStamp: timestamp,
    touchHistory: responderTouchHistoryStore.touchHistory
  };
  function locationX(x) {
    if (rect = rect || (0, import_utils.getBoundingClientRect)(responderEvent.currentTarget), rect)
      return x - rect.left;
  }
  function locationY(y) {
    if (rect = rect || (0, import_utils.getBoundingClientRect)(responderEvent.currentTarget), rect)
      return y - rect.top;
  }
  return responderEvent;
}
//# sourceMappingURL=createResponderEvent.js.map


/***/ }),

/***/ 26865:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
}, __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(16108), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 55718:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var types_exports = {};
__export(types_exports, {
  BLUR: () => BLUR,
  CONTEXT_MENU: () => CONTEXT_MENU,
  FOCUS_OUT: () => FOCUS_OUT,
  MOUSE_CANCEL: () => MOUSE_CANCEL,
  MOUSE_DOWN: () => MOUSE_DOWN,
  MOUSE_MOVE: () => MOUSE_MOVE,
  MOUSE_UP: () => MOUSE_UP,
  SCROLL: () => SCROLL,
  SELECT: () => SELECT,
  SELECTION_CHANGE: () => SELECTION_CHANGE,
  TOUCH_CANCEL: () => TOUCH_CANCEL,
  TOUCH_END: () => TOUCH_END,
  TOUCH_MOVE: () => TOUCH_MOVE,
  TOUCH_START: () => TOUCH_START,
  isCancelish: () => isCancelish,
  isEndish: () => isEndish,
  isMoveish: () => isMoveish,
  isScroll: () => isScroll,
  isSelectionChange: () => isSelectionChange,
  isStartish: () => isStartish
});
module.exports = __toCommonJS(types_exports);
const BLUR = "blur", CONTEXT_MENU = "contextmenu", FOCUS_OUT = "focusout", MOUSE_DOWN = "mousedown", MOUSE_MOVE = "mousemove", MOUSE_UP = "mouseup", MOUSE_CANCEL = "dragstart", TOUCH_START = "touchstart", TOUCH_MOVE = "touchmove", TOUCH_END = "touchend", TOUCH_CANCEL = "touchcancel", SCROLL = "scroll", SELECT = "select", SELECTION_CHANGE = "selectionchange";
function isStartish(eventType) {
  return eventType === TOUCH_START || eventType === MOUSE_DOWN;
}
function isMoveish(eventType) {
  return eventType === TOUCH_MOVE || eventType === MOUSE_MOVE;
}
function isEndish(eventType) {
  return eventType === TOUCH_END || eventType === MOUSE_UP || isCancelish(eventType);
}
function isCancelish(eventType) {
  return eventType === TOUCH_CANCEL || eventType === MOUSE_CANCEL;
}
function isScroll(eventType) {
  return eventType === SCROLL;
}
function isSelectionChange(eventType) {
  return eventType === SELECT || eventType === SELECTION_CHANGE;
}
//# sourceMappingURL=types.js.map


/***/ }),

/***/ 16108:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
}, __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default")), __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var useResponderEvents_exports = {};
__export(useResponderEvents_exports, {
  useResponderEvents: () => useResponderEvents
});
module.exports = __toCommonJS(useResponderEvents_exports);
var React = __toESM(__webpack_require__(44194)), ResponderSystem = __toESM(__webpack_require__(23187));
__reExport(useResponderEvents_exports, __webpack_require__(20189), module.exports);
const emptyObject = {};
function useResponderEvents(hostRef, config = emptyObject) {
  const id = React.useId(), isAttachedRef = React.useRef(!1);
  React.useEffect(() => (ResponderSystem.attachListeners(), () => {
    ResponderSystem.removeNode(id);
  }), [id]), React.useEffect(() => {
    const {
      onMoveShouldSetResponder,
      onMoveShouldSetResponderCapture,
      onScrollShouldSetResponder,
      onScrollShouldSetResponderCapture,
      onSelectionChangeShouldSetResponder,
      onSelectionChangeShouldSetResponderCapture,
      onStartShouldSetResponder,
      onStartShouldSetResponderCapture
    } = config, requiresResponderSystem = onMoveShouldSetResponder != null || onMoveShouldSetResponderCapture != null || onScrollShouldSetResponder != null || onScrollShouldSetResponderCapture != null || onSelectionChangeShouldSetResponder != null || onSelectionChangeShouldSetResponderCapture != null || onStartShouldSetResponder != null || onStartShouldSetResponderCapture != null, node = hostRef.current;
    requiresResponderSystem ? (ResponderSystem.addNode(id, node, config), isAttachedRef.current = !0) : isAttachedRef.current && (ResponderSystem.removeNode(id), isAttachedRef.current = !1);
  }, [config, hostRef, id]),  false && (0);
}
//# sourceMappingURL=useResponderEvents.js.map


/***/ }),

/***/ 20189:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var utils_exports = {};
__export(utils_exports, {
  canUseDOM: () => canUseDOM,
  getBoundingClientRect: () => getBoundingClientRect,
  getLowestCommonAncestor: () => getLowestCommonAncestor,
  getResponderPaths: () => getResponderPaths,
  hasTargetTouches: () => hasTargetTouches,
  hasValidSelection: () => hasValidSelection,
  isPrimaryPointerDown: () => isPrimaryPointerDown,
  isSelectionValid: () => isSelectionValid,
  setResponderId: () => setResponderId
});
module.exports = __toCommonJS(utils_exports);
const keyName = "__reactResponderId", canUseDOM = !!(typeof window < "u" && window.document && window.document.createElement), getBoundingClientRect = (node) => {
  if (node && node.nodeType === 1 && node.getBoundingClientRect)
    return node.getBoundingClientRect();
};
function getEventPath(domEvent) {
  if (domEvent.type === "selectionchange") {
    const target = window.getSelection()?.anchorNode;
    return composedPathFallback(target);
  }
  return domEvent.composedPath != null ? domEvent.composedPath() : composedPathFallback(domEvent.target);
}
function composedPathFallback(target) {
  const path = [];
  for (; target != null && target !== document.body; )
    path.push(target), target = target.parentNode;
  return path;
}
function getResponderId(node) {
  return node != null ? node[keyName] : null;
}
function setResponderId(node, id) {
  node != null && (node[keyName] = id);
}
function getResponderPaths(domEvent) {
  const idPath = [], nodePath = [], eventPath = getEventPath(domEvent);
  for (let i = 0; i < eventPath.length; i++) {
    const node = eventPath[i], id = getResponderId(node);
    id != null && (idPath.push(id), nodePath.push(node));
  }
  return { idPath, nodePath };
}
function getLowestCommonAncestor(pathA, pathB) {
  let pathALength = pathA.length, pathBLength = pathB.length;
  if (
    // If either path is empty
    pathALength === 0 || pathBLength === 0 || // If the last elements aren't the same there can't be a common ancestor
    // that is connected to the responder system
    pathA[pathALength - 1] !== pathB[pathBLength - 1]
  )
    return null;
  let itemA = pathA[0], indexA = 0, itemB = pathB[0], indexB = 0;
  pathALength - pathBLength > 0 && (indexA = pathALength - pathBLength, itemA = pathA[indexA], pathALength = pathBLength), pathBLength - pathALength > 0 && (indexB = pathBLength - pathALength, itemB = pathB[indexB], pathBLength = pathALength);
  let depth = pathALength;
  for (; depth--; ) {
    if (itemA === itemB)
      return itemA;
    itemA = pathA[indexA++], itemB = pathB[indexB++];
  }
  return null;
}
function hasTargetTouches(target, touches) {
  if (!touches || touches.length === 0)
    return !1;
  for (let i = 0; i < touches.length; i++) {
    const node = touches[i].target;
    if (node != null && target.contains(node))
      return !0;
  }
  return !1;
}
function hasValidSelection(domEvent) {
  return domEvent.type === "selectionchange" ? isSelectionValid() : domEvent.type === "select";
}
function isPrimaryPointerDown(domEvent) {
  const { altKey, button, buttons, ctrlKey, type } = domEvent, isTouch = type === "touchstart" || type === "touchmove", isPrimaryMouseDown = type === "mousedown" && (button === 0 || buttons === 1), isPrimaryMouseMove = type === "mousemove" && buttons === 1, noModifiers = altKey === !1 && ctrlKey === !1;
  return !!(isTouch || isPrimaryMouseDown && noModifiers || isPrimaryMouseMove && noModifiers);
}
function isSelectionValid() {
  const selection = window.getSelection();
  if (!selection) return !1;
  const string = selection.toString(), anchorNode = selection.anchorNode, focusNode = selection.focusNode, isTextNode = anchorNode && anchorNode.nodeType === window.Node.TEXT_NODE || focusNode && focusNode.nodeType === window.Node.TEXT_NODE;
  return string.length >= 1 && string !== `
` && !!isTextNode;
}
//# sourceMappingURL=utils.js.map


/***/ }),

/***/ 31023:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var src_exports = {};
__export(src_exports, {
  simpleHash: () => simpleHash
});
module.exports = __toCommonJS(src_exports);
const cache = /* @__PURE__ */ new Map(), simpleHash = (str, hashMin = 10) => {
  if (cache.has(str))
    return cache.get(str);
  let hash = 0, valids = "", added = 0;
  const len = str.length;
  for (let i = 0; i < len; i++) {
    if (hashMin !== "strict" && added <= hashMin) {
      const char = str.charCodeAt(i);
      if (char === 46) {
        valids += "--";
        continue;
      }
      if (isValidCSSCharCode(char)) {
        added++, valids += str[i];
        continue;
      }
    }
    hash = hashChar(hash, str[i]);
  }
  const res = valids + (hash ? Math.abs(hash) : "");
  return cache.size > 1e4 && cache.clear(), cache.set(str, res), res;
}, hashChar = (hash, c) => Math.imul(31, hash) + c.charCodeAt(0) | 0;
function isValidCSSCharCode(code) {
  return (
    // A-Z
    code >= 65 && code <= 90 || // a-z
    code >= 97 && code <= 122 || // _
    code === 95 || // -
    code === 45 || // 0-9
    code >= 48 && code <= 57
  );
}
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 87899:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var src_exports = {};
__export(src_exports, {
  useClientValue: () => useClientValue,
  useDidFinishSSR: () => useDidFinishSSR,
  useDidFinishSSRSync: () => useDidFinishSSRSync
});
module.exports = __toCommonJS(src_exports);
var React = __toESM(__webpack_require__(44194));
const emptyFn = () => {
}, emptyFnFn = () => emptyFn;
function useDidFinishSSR(value, options) {
  if (options?.sync)
    return React.useSyncExternalStore(
      emptyFnFn,
      () => value ?? !0,
      () => !1
    );
  const [cur, setCur] = React.useState(value);
  return React.useEffect(() => {
    setCur(value ?? !0);
  }, []), cur ?? !1;
}
function useDidFinishSSRSync(value) {
  return useDidFinishSSR(value, {
    sync: !0
  });
}
function useClientValue(value) {
  return useDidFinishSSR() ? typeof value == "function" ? value() : value : void 0;
}
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 77305:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
}, __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var src_exports = {};
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(24238), module.exports);
__reExport(src_exports, __webpack_require__(41469), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 24238:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var useEvent_exports = {};
__export(useEvent_exports, {
  useEvent: () => useEvent
});
module.exports = __toCommonJS(useEvent_exports);
var import_useGet = __webpack_require__(41469);
function useEvent(callback) {
  return (0, import_useGet.useGet)(callback, defaultValue, !0);
}
const defaultValue = () => {
  throw new Error("Cannot call an event handler while rendering.");
};
//# sourceMappingURL=useEvent.js.map


/***/ }),

/***/ 41469:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var useGet_exports = {};
__export(useGet_exports, {
  useGet: () => useGet
});
module.exports = __toCommonJS(useGet_exports);
var import_constants = __webpack_require__(77505), React = __toESM(__webpack_require__(44194));
function useGet(currentValue, initialValue, forwardToFunction) {
  const curRef = React.useRef(initialValue ?? currentValue);
  return (0, import_constants.useIsomorphicLayoutEffect)(() => {
    curRef.current = currentValue;
  }), React.useCallback(
    forwardToFunction ? (...args) => curRef.current?.apply(null, args) : () => curRef.current,
    []
  );
}
//# sourceMappingURL=useGet.js.map


/***/ }),

/***/ 9889:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var src_exports = {};
__export(src_exports, {
  isServerSide: () => isServerSide,
  useForceUpdate: () => useForceUpdate
});
module.exports = __toCommonJS(src_exports);
var import_react = __toESM(__webpack_require__(44194));
const isServerSide = typeof window > "u", idFn = () => {
};
function useForceUpdate() {
  return isServerSide ? idFn : import_react.default.useReducer((x) => Math.random(), 0)[1];
}
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 9172:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var Tamagui_exports = {};
__export(Tamagui_exports, {
  Tamagui: () => Tamagui,
  getValueFromIdentifier: () => getValueFromIdentifier,
  setIdentifierValue: () => setIdentifierValue
});
module.exports = __toCommonJS(Tamagui_exports);
var Helpers = __toESM(__webpack_require__(89953)), import_config = __webpack_require__(98211), import_insertStyleRule = __webpack_require__(55915), import_useMedia = __webpack_require__(31094), import_useTheme = __webpack_require__(67265);
const Tamagui = (() => {
  if (false) {}
})(), identifierToValue = /* @__PURE__ */ new Map(), getValueFromIdentifier = (identifier) => identifierToValue.get(identifier), setIdentifierValue = (identifier, value) => {
  identifierToValue.set(identifier, value);
};
//# sourceMappingURL=Tamagui.js.map


/***/ }),

/***/ 75425:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var withStableStyle_exports = {};
__export(withStableStyle_exports, {
  _withStableStyle: () => _withStableStyle
});
module.exports = __toCommonJS(withStableStyle_exports);
var import_react = __toESM(__webpack_require__(44194)), import_useTheme = __webpack_require__(67265), import_jsx_runtime = __webpack_require__(31549);
const _withStableStyle = (Component, styleProvider) => import_react.default.forwardRef((props, ref) => {
  const { _expressions = [], ...rest } = props, theme = (0, import_useTheme.useTheme)();
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Component, { ref, style: styleProvider(theme, _expressions), ...rest });
});
//# sourceMappingURL=_withStableStyle.js.map


/***/ }),

/***/ 98211:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var config_exports = {};
__export(config_exports, {
  configListeners: () => configListeners,
  devConfig: () => devConfig,
  getConfig: () => getConfig,
  getFont: () => getFont,
  getSetting: () => getSetting,
  getThemes: () => getThemes,
  getToken: () => getToken,
  getTokenObject: () => getTokenObject,
  getTokenValue: () => getTokenValue,
  getTokens: () => getTokens,
  onConfiguredOnce: () => onConfiguredOnce,
  setConfig: () => setConfig,
  setConfigFont: () => setConfigFont,
  setTokens: () => setTokens,
  setupDev: () => setupDev,
  updateConfig: () => updateConfig,
  useTokens: () => useTokens
});
module.exports = __toCommonJS(config_exports);
var import_constants = __webpack_require__(77505);
let conf;
const getSetting = (key) => {
  if (false)
    {}
  return conf.settings[key] ?? // @ts-expect-error
  conf[key];
}, setConfig = (next) => {
  conf = next;
}, setConfigFont = (name, font, fontParsed) => {
  if (false)
    {}
  conf.fonts[name] = font, conf.fontsParsed[`$${name}`] = fontParsed;
}, getConfig = () => {
  if (!conf)
    throw new Error(
       false ? 0 : "Err0"
    );
  return conf;
};
let tokensMerged;
function setTokens(_) {
  tokensMerged = _;
}
const getTokens = ({
  prefixed
} = {}) => {
  if (false)
    {}
  const { tokens, tokensParsed } = conf;
  return prefixed === !1 ? tokens : prefixed === !0 ? tokensParsed : tokensMerged;
}, getTokenObject = (value, group) => conf.specificTokens[value] ?? (group ? tokensMerged[group]?.[value] : tokensMerged[Object.keys(tokensMerged).find((cat) => tokensMerged[cat][value]) || ""]?.[value]), getToken = (value, group, useVariable = import_constants.isWeb) => {
  const token = getTokenObject(value, group);
  return useVariable ? token?.variable : token?.val;
}, getTokenValue = (value, group) => {
  if (!(value === "unset" || value === "auto"))
    return getToken(value, group, !1);
}, useTokens = getTokens, getThemes = () => conf.themes, configListeners = /* @__PURE__ */ new Set(), onConfiguredOnce = (cb) => {
  conf ? cb(conf) : configListeners.add(cb);
}, updateConfig = (key, value) => {
  Object.assign(conf[key], value);
}, getFont = (name) => {
  const conf2 = getConfig();
  return conf2.fontsParsed[name] ?? Object.entries(conf2.fontsParsed).find(
    ([k]) => conf2.fontsParsed[k]?.family?.val === name
  )?.[1];
};
let devConfig;
function setupDev(conf2) {
   false && (0);
}
//# sourceMappingURL=config.js.map


/***/ }),

/***/ 65906:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var accessibilityDirectMap_exports = {};
__export(accessibilityDirectMap_exports, {
  accessibilityDirectMap: () => accessibilityDirectMap,
  accessibilityWebRoleToNativeRole: () => accessibilityWebRoleToNativeRole,
  nativeAccessibilityState: () => nativeAccessibilityState,
  nativeAccessibilityValue: () => nativeAccessibilityValue,
  webToNativeAccessibilityDirectMap: () => webToNativeAccessibilityDirectMap
});
module.exports = __toCommonJS(accessibilityDirectMap_exports);
const accessibilityDirectMap = {};
{
  const items = {
    Hidden: !0,
    ActiveDescendant: !0,
    Atomic: !0,
    AutoComplete: !0,
    Busy: !0,
    Checked: !0,
    ColumnCount: "colcount",
    ColumnIndex: "colindex",
    ColumnSpan: "colspan",
    Current: !0,
    Details: !0,
    ErrorMessage: !0,
    Expanded: !0,
    HasPopup: !0,
    Invalid: !0,
    Label: !0,
    Level: !0,
    Modal: !0,
    Multiline: !0,
    MultiSelectable: !0,
    Orientation: !0,
    Owns: !0,
    Placeholder: !0,
    PosInSet: !0,
    Pressed: !0,
    RoleDescription: !0,
    RowCount: !0,
    RowIndex: !0,
    RowSpan: !0,
    Selected: !0,
    SetSize: !0,
    Sort: !0,
    ValueMax: !0,
    ValueMin: !0,
    ValueNow: !0,
    ValueText: !0
  };
  for (const key in items) {
    let val = items[key];
    val === !0 && (val = key.toLowerCase()), accessibilityDirectMap[`accessibility${key}`] = `aria-${val}`;
  }
}
const webToNativeAccessibilityDirectMap = null, nativeAccessibilityValue = null, nativeAccessibilityState = null, accessibilityWebRoleToNativeRole = null;
//# sourceMappingURL=accessibilityDirectMap.js.map


/***/ }),

/***/ 24881:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var constants_exports = {};
__export(constants_exports, {
  FONT_DATA_ATTRIBUTE_NAME: () => FONT_DATA_ATTRIBUTE_NAME,
  THEME_CLASSNAME_PREFIX: () => THEME_CLASSNAME_PREFIX,
  THEME_NAME_SEPARATOR: () => THEME_NAME_SEPARATOR,
  stackDefaultStyles: () => stackDefaultStyles,
  webViewFlexCompatStyles: () => webViewFlexCompatStyles
});
module.exports = __toCommonJS(constants_exports);
const THEME_NAME_SEPARATOR = "_", THEME_CLASSNAME_PREFIX = "t_", FONT_DATA_ATTRIBUTE_NAME = "data-tamagui-font", stackDefaultStyles = {}, webViewFlexCompatStyles = {
  display: "flex",
  alignItems: "stretch",
  flexDirection: "column",
  flexBasis: "auto",
  boxSizing: "border-box",
  position: "relative",
  minHeight: 0,
  minWidth: 0,
  flexShrink: 0
};
Object.assign(stackDefaultStyles, webViewFlexCompatStyles);
//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 15799:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var isDevTools_exports = {};
__export(isDevTools_exports, {
  isDevTools: () => isDevTools
});
module.exports = __toCommonJS(isDevTools_exports);
const isDevTools = (() => {
  if (false)
    {}
  return !1;
})();
//# sourceMappingURL=isDevTools.js.map


/***/ }),

/***/ 43233:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var webToNativeProps_exports = {};
__export(webToNativeProps_exports, {
  webToNativeDynamicExpansion: () => webToNativeDynamicExpansion,
  webToNativeExpansion: () => webToNativeExpansion
});
module.exports = __toCommonJS(webToNativeProps_exports);
const webToNativeDynamicExpansion = {}, webToNativeExpansion = {};
//# sourceMappingURL=webToNativeProps.js.map


/***/ }),

/***/ 31301:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var ComponentContext_exports = {};
__export(ComponentContext_exports, {
  ComponentContext: () => ComponentContext
});
module.exports = __toCommonJS(ComponentContext_exports);
var import_createStyledContext = __webpack_require__(7936);
const ComponentContext = (0, import_createStyledContext.createStyledContext)({
  disableSSR: void 0,
  inText: !1,
  language: null,
  animationDriver: null,
  groups: {
    emit: null,
    subscribe: null,
    state: {}
  }
});
//# sourceMappingURL=ComponentContext.js.map


/***/ }),

/***/ 92594:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(73656);
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var createComponent_exports = {};
__export(createComponent_exports, {
  Spacer: () => Spacer,
  Unspaced: () => Unspaced,
  componentSetStates: () => componentSetStates,
  createComponent: () => createComponent,
  isDisabled: () => isDisabled,
  spacedChildren: () => spacedChildren,
  subscribeToContextGroup: () => subscribeToContextGroup,
  useComponentState: () => useComponentState
});
module.exports = __toCommonJS(createComponent_exports);
var import_react = __toESM(__webpack_require__(44194)), import_compose_refs = __webpack_require__(82558), import_constants = __webpack_require__(77505), import_helpers = __webpack_require__(89953), import_config = __webpack_require__(98211), import_constants2 = __webpack_require__(24881), import_isDevTools = __webpack_require__(15799), import_ComponentContext = __webpack_require__(31301), import_createVariable = __webpack_require__(68836), import_defaultComponentState = __webpack_require__(4580), import_createShallowSetState = __webpack_require__(69345), import_getSplitStyles = __webpack_require__(11792), import_isObj = __webpack_require__(91032), import_log = __webpack_require__(50265), import_mergeProps = __webpack_require__(60355), import_setElementProps = __webpack_require__(37188), import_themeable = __webpack_require__(68867), import_useDidHydrateOnce = __webpack_require__(25851), import_useMedia = __webpack_require__(31094), import_useTheme = __webpack_require__(67265), import_setupHooks = __webpack_require__(27780), import_Slot = __webpack_require__(91423), import_Theme = __webpack_require__(32676), import_ThemeDebug = __webpack_require__(54109), import_jsx_runtime = __webpack_require__(31549);
let tamaguiConfig, time, debugKeyListeners, startVisualizer;
const componentSetStates = /* @__PURE__ */ new Set();
if (typeof document < "u") {
  const cancelTouches = () => {
    componentSetStates.forEach(
      (setState) => setState((prev) => prev.press || prev.pressIn ? {
        ...prev,
        press: !1,
        pressIn: !1
      } : prev)
    ), componentSetStates.clear();
  };
  addEventListener("mouseup", cancelTouches), addEventListener("touchend", cancelTouches), addEventListener("touchcancel", cancelTouches),  false && (0);
}
const useComponentState = (props, { animationDriver, groups }, staticConfig, config) => {
  const useAnimations = animationDriver?.useAnimations, stateRef = import_react.default.useRef(
    void 0
  );
  stateRef.current || (stateRef.current = {});
  const hasAnimationProp = !!("animation" in props || props.style && hasAnimatedStyleValue(props.style)), supportsCSSVars = animationDriver?.supportsCSSVars, curStateRef = stateRef.current, willBeAnimatedClient = !!(!!(hasAnimationProp && !staticConfig.isHOC && useAnimations) || curStateRef.hasAnimated), willBeAnimated = !import_constants.isServer && willBeAnimatedClient;
  willBeAnimated && !curStateRef.hasAnimated && (curStateRef.hasAnimated = !0);
  const presence = willBeAnimated && props.animatePresence !== !1 && animationDriver?.usePresence?.() || null, presenceState = presence?.[2], isExiting = presenceState?.isPresent === !1, isEntering = presenceState?.isPresent === !0 && presenceState.initial !== !1, hasEnterStyle = !!props.enterStyle, hasRNAnimation = hasAnimationProp && animationDriver?.isReactNative;
   false && 0;
  const hasEnterState = hasEnterStyle || isEntering, didHydrateOnce = willBeAnimated ? (0, import_useDidHydrateOnce.useDidHydrateOnce)() : !0, initialState = hasEnterState || !didHydrateOnce && hasRNAnimation ? (
    // on the very first render we switch all spring animation drivers to css rendering
    // this is because we need to use css variables, which they don't support to do proper SSR
    // without flickers of the wrong colors.
    // but once we do that initial hydration and we are in client side rendering mode,
    // we can avoid the extra re-render on mount
    import_constants.isWeb && !didHydrateOnce ? import_defaultComponentState.defaultComponentState : import_defaultComponentState.defaultComponentStateShouldEnter
  ) : import_defaultComponentState.defaultComponentStateMounted, disabled = isDisabled(props);
  disabled != null && (initialState.disabled = disabled);
  const states = import_react.default.useState(initialState), state = props.forceStyle ? { ...states[0], [props.forceStyle]: !0 } : states[0], setState = states[1], isHydrated = state.unmounted === !1 || state.unmounted === "should-enter";
  let isAnimated = willBeAnimated;
  import_constants.isWeb && hasRNAnimation && !staticConfig.isHOC && state.unmounted === !0 && (isAnimated = !1, curStateRef.willHydrate = !0), disabled !== state.disabled && (state.disabled = disabled, disabled && Object.assign(state, import_defaultComponentState.defaultComponentStateMounted), setState({ ...state }));
  let setStateShallow = (0, import_createShallowSetState.createShallowSetState)(setState, disabled, !1, props.debug);
  if (presenceState && isAnimated && isHydrated && staticConfig.variants) {
     false && 0;
    const { enterVariant, exitVariant, enterExitVariant, custom } = presenceState;
    (0, import_isObj.isObj)(custom) && Object.assign(props, custom);
    const exv = exitVariant ?? enterExitVariant, env = enterVariant ?? enterExitVariant;
    state.unmounted && env && staticConfig.variants[env] ? ( false && 0, props[env] = !0) : isExiting && exv && ( false && 0, props[exv] = exitVariant !== enterExitVariant);
  }
  let shouldAvoidClasses = !import_constants.isWeb;
  if (import_constants.isWeb) {
    const { disableClassName } = props, isAnimatedAndHydrated = isAnimated && !supportsCSSVars && didHydrateOnce && !import_constants.isServer, isClassNameDisabled = !staticConfig.acceptsClassName && (config.disableSSR || didHydrateOnce), isDisabledManually = disableClassName && !import_constants.isServer && didHydrateOnce && state.unmounted === !0;
    (isAnimatedAndHydrated || isDisabledManually || isClassNameDisabled) && (shouldAvoidClasses = !0,  false && 0);
  }
  const groupName = props.group;
  if (groupName && !curStateRef.group) {
    const listeners = /* @__PURE__ */ new Set();
    curStateRef.group = {
      listeners,
      emit(name, state2) {
        listeners.forEach((l) => l(name, state2));
      },
      subscribe(cb) {
        return listeners.add(cb), () => {
          listeners.delete(cb);
        };
      }
    };
  }
  if (groupName) {
    const groupContextState = groups.state, og = setStateShallow;
    setStateShallow = (state2) => {
      og(state2), curStateRef.group.emit(groupName, {
        pseudo: state2
      });
      const next = {
        ...groupContextState[groupName],
        ...state2
      };
      groupContextState[groupName] = next;
    };
  }
  return {
    curStateRef,
    disabled,
    groupName,
    hasAnimationProp,
    hasEnterStyle,
    isAnimated,
    isExiting,
    isHydrated,
    presence,
    presenceState,
    setState,
    setStateShallow,
    shouldAvoidClasses,
    state,
    stateRef,
    supportsCSSVars,
    willBeAnimated,
    willBeAnimatedClient
  };
};
let BaseText, BaseView;
const lastInteractionWasKeyboard = { value: !1 };
import_constants.isWeb && globalThis.document && (document.addEventListener("keydown", () => {
  lastInteractionWasKeyboard.value = !0;
}), document.addEventListener("mousedown", () => {
  lastInteractionWasKeyboard.value = !1;
}), document.addEventListener("mousemove", () => {
  lastInteractionWasKeyboard.value = !1;
}));
function createComponent(staticConfig) {
  const { componentName } = staticConfig;
  let config = null, defaultProps = staticConfig.defaultProps;
  (0, import_config.onConfiguredOnce)((conf) => {
    if (config = conf, componentName) {
      const defaultForComponent = conf.defaultProps?.[componentName];
      defaultForComponent && (defaultProps = { ...defaultForComponent, ...defaultProps });
    }
  });
  const {
    Component,
    isText,
    isZStack,
    isHOC,
    validStyles: validStyles2 = {},
    variants = {}
  } = staticConfig;
   false && 0;
  const component = import_react.default.forwardRef((propsIn, forwardedRef) => {
    const internalID =  false ? 0 : "";
     false && (0),  false && (0);
    const componentContext = import_react.default.useContext(import_ComponentContext.ComponentContext);
    let styledContextProps, overriddenContextProps, contextValue;
    const { context, isReactNative } = staticConfig;
    if (context) {
      contextValue = import_react.default.useContext(context);
      const { inverseShorthands } = (0, import_config.getConfig)();
      for (const key in context.props) {
        const propVal = (
          // because its after default props but before props this annoying amount of checks
          propsIn[key] ?? propsIn[inverseShorthands[key]] ?? defaultProps?.[key] ?? defaultProps?.[inverseShorthands[key]]
        );
        propVal === void 0 ? contextValue && (key in validStyles2 || key in variants) && (styledContextProps ||= {}, styledContextProps[key] = contextValue[key]) : (overriddenContextProps ||= {}, overriddenContextProps[key] = propVal);
      }
    }
    const curDefaultProps = styledContextProps ? { ...defaultProps, ...styledContextProps } : defaultProps;
    let props = propsIn;
    curDefaultProps && (props = (0, import_mergeProps.mergeProps)(curDefaultProps, propsIn));
    const debugProp = props.debug, componentName2 = props.componentName || staticConfig.componentName;
     false && 0, !process.env.TAMAGUI_IS_CORE_NODE && "production" === "development" && 0 && 0 && (0),  false && 0,  false && 0,  false && 0;
    const animationDriver = componentContext.animationDriver, useAnimations = animationDriver?.useAnimations, {
      curStateRef,
      disabled,
      groupName,
      hasAnimationProp,
      hasEnterStyle,
      isAnimated,
      isExiting,
      isHydrated,
      presence,
      presenceState,
      setState,
      setStateShallow,
      shouldAvoidClasses,
      state,
      stateRef,
      supportsCSSVars,
      willBeAnimated,
      willBeAnimatedClient
    } = useComponentState(props, componentContext, staticConfig, config), shouldForcePseudo = !!propsIn.forceStyle, noClassNames = shouldAvoidClasses || shouldForcePseudo;
     false && 0;
    const hasTextAncestor = !!(import_constants.isWeb && isText && componentContext.inText);
     false && 0;
    const isTaggable = !Component || typeof Component == "string", tagProp = props.tag, element = import_constants.isWeb && isTaggable && tagProp || Component;
    let elementType = isText ? BaseText || element || "span" : BaseView || element || (hasTextAncestor ? "span" : "div");
    animationDriver && isAnimated && (elementType = animationDriver[isText ? "Text" : "View"] || elementType);
    const disableTheme = props["data-disable-theme"] || isHOC;
     false && 0, props.themeShallow && (curStateRef.themeShallow = !0);
    const themeStateProps = {
      componentName: componentName2,
      disable: disableTheme,
      shallow: curStateRef.themeShallow,
      debug: debugProp
    };
    if ("themeInverse" in props && (themeStateProps.inverse = props.themeInverse), "theme" in props && (themeStateProps.name = props.theme), typeof curStateRef.isListeningToTheme == "boolean" && (themeStateProps.shouldUpdate = () => stateRef.current.isListeningToTheme),  false && 0) {
      const name = `${componentName2 || Component?.displayName || Component?.name || "[Unnamed Component]"}`, type = (hasEnterStyle ? "(hasEnter)" : " ") + (isAnimated ? "(animated)" : " ") + (isReactNative ? "(rnw)" : " ") + (shouldAvoidClasses ? "(shouldAvoidClasses)" : " ") + (state.press || state.pressIn ? "(PRESSED)" : " ") + (state.hover ? "(HOVERED)" : " ") + (state.focus ? "(FOCUSED)" : " ") + (presenceState?.isPresent === !1 ? "(EXIT)" : ""), dataIs = propsIn["data-is"] || "", banner = `${internalID} ${name}${dataIs ? ` ${dataIs}` : ""} ${type}`;
      if (console.info(
        `%c ${banner} (hydrated: ${isHydrated}) (unmounted: ${state.unmounted})`,
        "background: green; color: white;"
      ), import_constants.isServer)
        (0, import_log.log)({ noClassNames, isAnimated, shouldAvoidClasses, isWeb: import_constants.isWeb, supportsCSSVars });
      else {
        console.groupEnd();
        const ch = propsIn.children;
        let childLog = typeof ch == "string" ? ch.length > 4 ? ch.slice(0, 4) + "..." : ch : "";
        childLog.length && (childLog = `(children: ${childLog})`), console.groupCollapsed(`${childLog} Props:`), (0, import_log.log)("props in:", propsIn), (0, import_log.log)("final props:", props), (0, import_log.log)({ state, staticConfig, elementType, themeStateProps }), (0, import_log.log)({ contextProps: styledContextProps, overriddenContextProps }), (0, import_log.log)({ presence, isAnimated, isHOC, hasAnimationProp, useAnimations }), console.groupEnd();
      }
    }
     false && 0;
    const [themeState, theme] = (0, import_useTheme.useThemeWithState)(themeStateProps);
    elementType = Component || elementType;
    const isStringElement = typeof elementType == "string";
     false && 0;
    const mediaState = (0, import_useMedia.useMedia)(stateRef, componentContext, debugProp);
    (0, import_createVariable.setDidGetVariableValue)(!1),  false && 0;
    const resolveValues = (
      // if HOC + mounted + has animation prop, resolve as value so it passes non-variable to child
      isAnimated && !supportsCSSVars || isHOC && state.unmounted == !1 && hasAnimationProp ? "value" : "auto"
    ), styleProps = {
      mediaState,
      noClassNames,
      resolveValues,
      isExiting,
      isAnimated,
      willBeAnimated
    }, splitStyles = (0, import_getSplitStyles.useSplitStyles)(
      props,
      staticConfig,
      theme,
      themeState?.state?.name || "",
      state,
      styleProps,
      null,
      componentContext,
      elementType,
      debugProp
    );
    props.group && props.untilMeasured === "hide" && !curStateRef.hasMeasured && (splitStyles.style ||= {}, splitStyles.style.opacity = 0),  false && 0, curStateRef.isListeningToTheme = splitStyles.dynamicThemeAccess;
    const hasRuntimeMediaKeys = splitStyles.hasMedia && splitStyles.hasMedia !== !0, shouldListenForMedia = (0, import_createVariable.didGetVariableValue)() || hasRuntimeMediaKeys || noClassNames && splitStyles.hasMedia === !0, mediaListeningKeys = hasRuntimeMediaKeys ? splitStyles.hasMedia : null;
     false && 0, (0, import_useMedia.setMediaShouldUpdate)(stateRef, {
      enabled: shouldListenForMedia,
      keys: mediaListeningKeys
    });
    const {
      viewProps: viewPropsIn,
      pseudos,
      style: splitStylesStyle,
      classNames,
      space
    } = splitStyles, propsWithAnimation = props, {
      asChild,
      children,
      themeShallow,
      spaceDirection: _spaceDirection,
      onPress,
      onLongPress,
      onPressIn,
      onPressOut,
      onHoverIn,
      onHoverOut,
      onMouseUp,
      onMouseDown,
      onMouseEnter,
      onMouseLeave,
      onFocus,
      onBlur,
      separator,
      // ignore from here on out
      forceStyle: _forceStyle,
      // @ts-ignore  for next/link compat etc
      onClick,
      theme: _themeProp,
      ...nonTamaguiProps
    } = viewPropsIn;
    let viewProps = nonTamaguiProps;
    !isTaggable && props.forceStyle && (viewProps.forceStyle = props.forceStyle), isHOC && _themeProp && (viewProps.theme = _themeProp), elementType.acceptTagProp && (viewProps.tag = tagProp);
    let animationStyles;
    if (
      // if it supports css vars we run it on server too to get matching initial style
      (supportsCSSVars ? willBeAnimatedClient : willBeAnimated) && useAnimations && !isHOC
    ) {
      const animations = useAnimations({
        props: propsWithAnimation,
        // if hydrating, send empty style
        style: splitStylesStyle || {},
        presence,
        componentState: state,
        styleProps,
        theme: themeState.state?.theme,
        pseudos: pseudos || null,
        staticConfig,
        stateRef
      });
      (isAnimated || supportsCSSVars) && animations && (animationStyles = animations.style, viewProps.style = animationStyles, animations.className && (viewProps.className = `${viewProps.className || ""} ${animations.className}`)),  false && 0;
    }
     false && 0,  false && 0, groupName && (nonTamaguiProps.onLayout = (0, import_helpers.composeEventHandlers)(
      nonTamaguiProps.onLayout,
      (e) => {
        stateRef.current.group.emit(groupName, {
          layout: e.nativeEvent.layout
        }), !stateRef.current.hasMeasured && props.untilMeasured === "hide" && setState((prev) => ({ ...prev })), stateRef.current.hasMeasured = !0;
      }
    )), viewProps = import_setupHooks.hooks.usePropsTransform?.(
      elementType,
      nonTamaguiProps,
      stateRef,
      curStateRef.willHydrate
    ) || nonTamaguiProps, curStateRef.composedRef || (curStateRef.composedRef = (0, import_compose_refs.composeRefs)(
      (x) => stateRef.current.host = x,
      forwardedRef,
      import_setElementProps.setElementProps
    )), viewProps.ref = curStateRef.composedRef,  false && 0,  false && 0;
    const { pseudoGroups, mediaGroups } = splitStyles, unPress = () => setStateShallow({ press: !1, pressIn: !1 });
     false && 0, import_react.default.useEffect(() => {
      if (disabled)
        return;
      if (state.unmounted === !0 && hasEnterStyle) {
        setStateShallow({ unmounted: "should-enter" });
        return;
      }
      if (state.unmounted) {
        setStateShallow({ unmounted: !1 });
        return;
      }
      const dispose = subscribeToContextGroup({
        disabled,
        componentContext,
        setStateShallow,
        state,
        mediaGroups,
        pseudoGroups
      });
      return () => {
        dispose?.(), componentSetStates.delete(setState);
      };
    }, [
      state.unmounted,
      disabled,
      pseudoGroups ? Object.keys([...pseudoGroups]).join("") : 0,
      mediaGroups ? Object.keys([...mediaGroups]).join("") : 0
    ]);
    const runtimePressStyle = !disabled && noClassNames && pseudos?.pressStyle, runtimeFocusStyle = !disabled && noClassNames && pseudos?.focusStyle, runtimeFocusVisibleStyle = !disabled && noClassNames && pseudos?.focusVisibleStyle, attachFocus = !!(runtimePressStyle || runtimeFocusStyle || runtimeFocusVisibleStyle || onFocus || onBlur), attachPress = !!(groupName || runtimePressStyle || onPress || onPressOut || onPressIn || onMouseDown || onMouseUp || onLongPress || onClick || pseudos?.focusVisibleStyle), runtimeHoverStyle = !disabled && noClassNames && pseudos?.hoverStyle, needsHoverState = !!(groupName || runtimeHoverStyle || onHoverIn || onHoverOut), attachHover = import_constants.isWeb && !!(groupName || needsHoverState || onMouseEnter || onMouseLeave), shouldAttach = !disabled && !props.asChild && !!(attachFocus || attachPress || attachHover || runtimePressStyle || runtimeHoverStyle || runtimeFocusStyle), needsPressState = !!(groupName || runtimePressStyle);
     false && 0,  false && 0;
    const events = shouldAttach ? {
      onPressOut: attachPress ? (e) => {
        unPress(), onPressOut?.(e), onMouseUp?.(e);
      } : void 0,
      ...(attachHover || attachPress) && {
        onMouseEnter: (e) => {
          const next = {};
          needsHoverState && (next.hover = !0), needsPressState && state.pressIn && (next.press = !0), setStateShallow(next), onHoverIn?.(e), onMouseEnter?.(e);
        },
        onMouseLeave: (e) => {
          const next = {};
          needsHoverState && (next.hover = !1), needsPressState && state.pressIn && (next.press = !1, next.pressIn = !1), setStateShallow(next), onHoverOut?.(e), onMouseLeave?.(e);
        }
      },
      onPressIn: attachPress ? (e) => {
        (runtimePressStyle || groupName) && setStateShallow({
          press: !0,
          pressIn: !0
        }), onPressIn?.(e), onMouseDown?.(e), import_constants.isWeb && componentSetStates.add(setState);
      } : void 0,
      onPress: attachPress ? (e) => {
        unPress(), import_constants.isWeb && onClick?.(e), onPress?.(e), onLongPress?.(e);
      } : void 0,
      ...attachFocus && {
        onFocus: (e) => {
          pseudos?.focusVisibleStyle ? setTimeout(() => {
            setStateShallow({
              focus: !0,
              focusVisible: !!lastInteractionWasKeyboard.value
            });
          }, 0) : setStateShallow({
            focus: !0,
            focusVisible: !1
          }), onFocus?.(e);
        },
        onBlur: (e) => {
          setStateShallow({
            focus: !1,
            focusVisible: !1
          }), onBlur?.(e);
        }
      }
    } : null;
    events && !isReactNative && Object.assign(viewProps, getWebEvents(events)),  false && 0,  false && 0, import_setupHooks.hooks.useEvents?.(viewProps, events, splitStyles, setStateShallow, staticConfig);
    const direction = props.spaceDirection || "both";
     false && 0;
    let content = !children || asChild ? children : spacedChildren({
      separator,
      children,
      space,
      direction,
      isZStack,
      debug: debugProp
    });
    if (asChild) {
      elementType = import_Slot.Slot;
      {
        const passEvents = getWebEvents(
          {
            onPress,
            onLongPress,
            onPressIn,
            onPressOut,
            onMouseUp,
            onMouseDown,
            onMouseEnter,
            onMouseLeave
          },
          asChild === "web" || asChild === "except-style-web"
        );
        Object.assign(viewProps, passEvents);
      }
    }
     false && 0;
    let useChildrenResult;
    import_setupHooks.hooks.useChildren && (useChildrenResult = import_setupHooks.hooks.useChildren(
      elementType,
      content,
      viewProps,
      events,
      staticConfig
    )), useChildrenResult ? content = useChildrenResult : content = import_react.default.createElement(elementType, viewProps, content);
    const ResetPresence = config?.animations?.ResetPresence;
    ResetPresence && willBeAnimated && (hasEnterStyle || presenceState) && content && typeof content != "string" && (content = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ResetPresence, { children: content })),  false && 0;
    const groupState = curStateRef.group, subGroupContext = import_react.default.useMemo(() => {
      if (!(!groupState || !groupName))
        return groupState.listeners.clear(), {
          ...componentContext.groups,
          // change reference so as we mutate it doesn't affect siblings etc
          state: {
            ...componentContext.groups.state,
            [groupName]: {
              pseudo: import_defaultComponentState.defaultComponentStateMounted,
              // capture just initial width and height if they exist
              // will have top, left, width, height (not x, y)
              layout: {
                width: fromPx(splitStyles.style?.width),
                height: fromPx(splitStyles.style?.height)
              }
            }
          },
          emit: groupState.emit,
          subscribe: groupState.subscribe
        };
    }, [groupName]);
    if (groupName && subGroupContext && (content = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ComponentContext.ComponentContext.Provider, { ...componentContext, groups: subGroupContext, children: content })),  false && 0, content = disableTheme ? content : (0, import_Theme.getThemedChildren)(themeState, content, themeStateProps, !1, stateRef),  false && 0,  false && (0), isReactNative && !asChild && (content = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      "span",
      {
        className: "_dsp_contents",
        ...isHydrated && events && getWebEvents(events),
        children: content
      }
    )), staticConfig.context) {
      const contextProps = staticConfig.context.props;
      for (const key in contextProps)
        (viewProps.style && key in viewProps.style || key in viewProps) && (overriddenContextProps ||= {}, overriddenContextProps[key] = viewProps.style?.[key] ?? viewProps[key]);
    }
    if (overriddenContextProps) {
      const Provider = staticConfig.context.Provider;
      content = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Provider, { ...contextValue, ...overriddenContextProps, children: content });
    }
    if (process.env.TAMAGUI_REACT_19) {
      const { rulesToInsert } = splitStyles, keys = Object.keys(splitStyles.rulesToInsert);
      keys.length && (content = /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, { children: [
        content,
        keys.map((key) => {
          const styleObject = rulesToInsert[key], identifier = styleObject[import_helpers.StyleObjectIdentifier];
          return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
            "style",
            {
              href: `t_${identifier}`,
              precedence: "default",
              children: styleObject[import_helpers.StyleObjectRules].join(`
`)
            },
            identifier
          );
        })
      ] }));
    }
    if (false) {}
    return  false && (0), content;
  });
  staticConfig.componentName && (component.displayName = staticConfig.componentName);
  let res = component;
  (process.env.TAMAGUI_FORCE_MEMO || staticConfig.memo) && (res = import_react.default.memo(res)), res.staticConfig = staticConfig;
  function extendStyledConfig(extended) {
    return {
      ...staticConfig,
      ...extended,
      neverFlatten: !0,
      isHOC: !0,
      isStyledHOC: !1
    };
  }
  function extractable(Component2, extended) {
    return Component2.staticConfig = extendStyledConfig(extended), Component2.styleable = styleable, Component2;
  }
  function styleable(Component2, options) {
    let out = Component2.render?.length === 2 ? Component2 : import_react.default.forwardRef(Component2);
    const extendedConfig = extendStyledConfig(options?.staticConfig);
    return out = options?.disableTheme ? out : (0, import_themeable.themeable)(out, extendedConfig), process.env.TAMAGUI_MEMOIZE_STYLEABLE && (out = import_react.default.memo(out)), out.staticConfig = extendedConfig, out.styleable = styleable, out;
  }
  return res.extractable = extractable, res.styleable = styleable, res;
}
function getWebEvents(events, webStyle = !0) {
  return {
    onMouseEnter: events.onMouseEnter,
    onMouseLeave: events.onMouseLeave,
    [webStyle ? "onClick" : "onPress"]: events.onPress,
    onMouseDown: events.onPressIn,
    onMouseUp: events.onPressOut,
    onTouchStart: events.onPressIn,
    onTouchEnd: events.onPressOut,
    onFocus: events.onFocus,
    onBlur: events.onBlur
  };
}
function Unspaced(props) {
  return props.children;
}
Unspaced.isUnspaced = !0;
const getSpacerSize = (size, { tokens }) => {
  size = size === !0 ? "$true" : size;
  const sizePx = tokens.space[size] ?? size;
  return {
    width: sizePx,
    height: sizePx,
    minWidth: sizePx,
    minHeight: sizePx
  };
}, Spacer = createComponent({
  acceptsClassName: !0,
  memo: !0,
  componentName: "Spacer",
  validStyles: import_helpers.validStyles,
  defaultProps: {
    ...import_constants2.stackDefaultStyles,
    // avoid nesting issues
    tag: "span",
    size: !0,
    pointerEvents: "none"
  },
  variants: {
    size: {
      "...": getSpacerSize
    },
    flex: {
      true: {
        flexGrow: 1
      }
    },
    direction: {
      horizontal: {
        height: 0,
        minHeight: 0
      },
      vertical: {
        width: 0,
        minWidth: 0
      },
      both: {}
    }
  }
});
function spacedChildren(props) {
  const { isZStack, children, space, direction, spaceFlex, separator, ensureKeys } = props, hasSpace = !!(space || spaceFlex), hasSeparator = separator != null, areChildrenArray = Array.isArray(children);
  if (!ensureKeys && !(hasSpace || hasSeparator || isZStack))
    return children;
  const childrenList = areChildrenArray ? children : import_react.default.Children.toArray(children);
  if (childrenList.length <= 1 && !isZStack && !childrenList[0]?.type?.shouldForwardSpace)
    return children;
  const final = [];
  for (let [index, child] of childrenList.entries()) {
    const isEmpty = child == null || Array.isArray(child) && child.length === 0;
    if (!isEmpty && import_react.default.isValidElement(child) && child.type?.shouldForwardSpace && (child = import_react.default.cloneElement(child, {
      space,
      spaceFlex,
      separator,
      key: child.key
    })), isEmpty || !child || child.key && !isZStack ? final.push(child) : final.push(
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.default.Fragment, { children: isZStack ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(AbsoluteFill, { children: child }) : child }, `${index}0t`)
    ), isUnspaced(child) && index === 0 || isZStack) continue;
    const next = childrenList[index + 1];
    next && !isEmpty && !isUnspaced(next) && (separator ? (hasSpace && final.push(
      createSpacer({
        key: `_${index}_00t`,
        direction,
        space,
        spaceFlex
      })
    ), final.push(/* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.default.Fragment, { children: separator }, `${index}03t`)), hasSpace && final.push(
      createSpacer({
        key: `_${index}01t`,
        direction,
        space,
        spaceFlex
      })
    )) : final.push(
      createSpacer({
        key: `_${index}02t`,
        direction,
        space,
        spaceFlex
      })
    ));
  }
  return  false && 0, final;
}
function createSpacer({ key, direction, space, spaceFlex }) {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    Spacer,
    {
      size: space,
      direction,
      ...typeof spaceFlex < "u" && {
        flex: spaceFlex === !0 ? 1 : spaceFlex === !1 ? 0 : spaceFlex
      }
    },
    key
  );
}
function isUnspaced(child) {
  const t = child?.type;
  return t?.isVisuallyHidden || t?.isUnspaced;
}
const AbsoluteFill = createComponent({
  defaultProps: {
    ...import_constants2.stackDefaultStyles,
    flexDirection: "column",
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    pointerEvents: "box-none"
  }
});
function hasAnimatedStyleValue(style) {
  return Object.keys(style).some((k) => {
    const val = style[k];
    return val && typeof val == "object" && "_animation" in val;
  });
}
const fromPx = (val) => typeof val != "string" ? val : +val.replace("px", ""), isDisabled = (props) => props.disabled || props.accessibilityState?.disabled || props["aria-disabled"] || props.accessibilityDisabled || !1, subscribeToContextGroup = ({
  disabled = !1,
  setStateShallow,
  pseudoGroups,
  mediaGroups,
  componentContext,
  state
}) => {
  if (pseudoGroups || mediaGroups) {
    const current = {
      pseudo: {},
      media: {}
    };
    return  false && 0, componentContext.groups?.subscribe?.((name, { layout, pseudo }) => {
      if (pseudo && pseudoGroups?.has(String(name)))
        Object.assign(current.pseudo, pseudo), persist();
      else if (layout && mediaGroups) {
        const mediaState = (0, import_useMedia.getMediaState)(mediaGroups, layout), next = (0, import_createShallowSetState.mergeIfNotShallowEqual)(current.media, mediaState);
        next !== current.media && (Object.assign(current.media, next), persist());
      }
      function persist() {
        const group = {
          ...state.group,
          [name]: current
        };
        setStateShallow({
          group
        });
      }
    });
  }
};
//# sourceMappingURL=createComponent.js.map


/***/ }),

/***/ 41684:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var createFont_exports = {};
__export(createFont_exports, {
  createFont: () => createFont
});
module.exports = __toCommonJS(createFont_exports);
const fontWeights = [
  "100",
  "200",
  "300",
  "400",
  "500",
  "600",
  "700",
  "800",
  "900"
], processSection = (section, keys, defaultValue) => {
  if (typeof section == "string") return section;
  const sectionKeys = Object.keys(section);
  let fillValue = section[sectionKeys[0]];
  return Object.fromEntries(
    [.../* @__PURE__ */ new Set([...keys, ...sectionKeys])].map((key) => {
      const value = section[key] ?? defaultValue ?? fillValue;
      return fillValue = value, defaultValue = value, [key, value];
    })
  );
}, createFont = (font) => {
  const sizeKeys = Object.keys(font.size), processedFont = Object.fromEntries(
    Object.entries(font).map(([key, section]) => [
      key,
      processSection(
        section,
        key === "face" ? fontWeights : sizeKeys,
        key === "face" ? { normal: font.family } : void 0
      )
    ])
  );
  return Object.freeze(processedFont);
};
//# sourceMappingURL=createFont.js.map


/***/ }),

/***/ 33961:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var createShorthands_exports = {};
__export(createShorthands_exports, {
  createShorthands: () => createShorthands
});
module.exports = __toCommonJS(createShorthands_exports);
function createShorthands(shorthands) {
  return Object.freeze(shorthands);
}
//# sourceMappingURL=createShorthands.js.map


/***/ }),

/***/ 79803:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var createTamagui_exports = {};
__export(createTamagui_exports, {
  createTamagui: () => createTamagui
});
module.exports = __toCommonJS(createTamagui_exports);
var import_constants = __webpack_require__(77505), import_config = __webpack_require__(98211), import_createVariables = __webpack_require__(12817), import_getThemeCSSRules = __webpack_require__(42274), import_insertStyleRule = __webpack_require__(55915), import_proxyThemeToParents = __webpack_require__(85335), import_registerCSSVariable = __webpack_require__(2277), import_themes = __webpack_require__(52531), import_useMedia = __webpack_require__(31094), import_insertFont = __webpack_require__(65196), import_Tamagui = __webpack_require__(9172);
const createdConfigs = /* @__PURE__ */ new WeakMap();
function createTamagui(configIn) {
  if (createdConfigs.has(configIn))
    return configIn;
  const tokensParsed = {}, tokens = (0, import_createVariables.createVariables)(configIn.tokens || {});
  if (configIn.tokens) {
    const tokensMerged = {};
    for (const cat in tokens) {
      tokensParsed[cat] = {}, tokensMerged[cat] = {};
      const tokenCat = tokens[cat];
      for (const key in tokenCat) {
        const val = tokenCat[key], prefixedKey = `$${key}`;
        tokensParsed[cat][prefixedKey] = val, tokensMerged[cat][prefixedKey] = val, tokensMerged[cat][key] = val;
      }
    }
    (0, import_config.setTokens)(tokensMerged);
  }
  let foundThemes;
  if (configIn.themes) {
    const noThemes = Object.keys(configIn.themes).length === 0;
    foundThemes = (0, import_insertStyleRule.scanAllSheets)(noThemes, tokensParsed);
  }
  (0, import_insertStyleRule.listenForSheetChanges)();
  let fontSizeTokens = null, fontsParsed;
  if (configIn.fonts) {
    const fontTokens = Object.fromEntries(
      Object.entries(configIn.fonts).map(([k, v]) => [k, (0, import_createVariables.createVariables)(v, "f", !0)])
    );
    fontsParsed = (() => {
      const res = {};
      for (const familyName in fontTokens) {
        const font = fontTokens[familyName], fontParsed = (0, import_insertFont.parseFont)(font);
        res[`$${familyName}`] = fontParsed, !fontSizeTokens && fontParsed.size && (fontSizeTokens = new Set(Object.keys(fontParsed.size)));
      }
      return res;
    })();
  }
  const specificTokens = {}, themeConfig = (() => {
    const cssRuleSets = [], declarations = [], fontDeclarations = {};
    for (const key in tokens)
      for (const skey in tokens[key]) {
        const variable = tokens[key][skey];
        if (specificTokens[`$${key}.${skey}`] = variable,  false && 0)
          throw new Error(
            `No value for tokens.${key}.${skey}:
${JSON.stringify(variable, null, 2)}`
          );
        import_constants.isWeb && ((0, import_registerCSSVariable.registerCSSVariable)(variable), declarations.push((0, import_registerCSSVariable.variableToCSS)(variable, key === "zIndex")));
      }
    if (import_constants.isWeb) {
      let declarationsToRuleSet = function(decs, selector = "") {
        return `:root${selector} {${sep}${[...decs].join(`;${sep}`)}${sep}}`;
      };
      for (const key in fontsParsed) {
        const fontParsed = fontsParsed[key], [name, language] = key.includes("_") ? key.split("_") : [key], fontVars = (0, import_insertFont.registerFontVariables)(fontParsed);
        fontDeclarations[key] = {
          name: name.slice(1),
          declarations: fontVars,
          language
        };
      }
      const sep = configIn.cssStyleSeparator || "";
      if (cssRuleSets.push(declarationsToRuleSet(declarations)), fontDeclarations)
        for (const key in fontDeclarations) {
          const { name, declarations: declarations2, language = "default" } = fontDeclarations[key], fontSelector = `.font_${name}`, langSelector = `:root .t_lang-${name}-${language} ${fontSelector}`, selectors = language === "default" ? ` ${fontSelector}, ${langSelector}` : langSelector, specificRuleSet = declarationsToRuleSet(declarations2, selectors);
          cssRuleSets.push(specificRuleSet);
        }
    }
    const themesIn = { ...configIn.themes }, dedupedThemes = foundThemes ?? getThemesDeduped(themesIn);
    return {
      themes: (0, import_proxyThemeToParents.proxyThemesToParents)(dedupedThemes),
      cssRuleSets,
      getThemeRulesSets() {
        let themeRuleSets = [];
        if (import_constants.isWeb)
          for (const { names, theme } of dedupedThemes) {
            const nextRules = (0, import_getThemeCSSRules.getThemeCSSRules)({
              config: configIn,
              themeName: names[0],
              names,
              theme
            });
            themeRuleSets = [...themeRuleSets, ...nextRules];
          }
        return themeRuleSets;
      }
    };
  })(), shorthands = configIn.shorthands || {};
  let lastCSSInsertedRulesIndex = -1;
  const getCSS = (opts = {}) => {
    const { separator = `
`, sinceLastCall, exclude } = opts;
    if (sinceLastCall && lastCSSInsertedRulesIndex >= 0) {
      const rules = (0, import_insertStyleRule.getAllRules)();
      return lastCSSInsertedRulesIndex = rules.length, rules.slice(lastCSSInsertedRulesIndex).join(separator);
    }
    lastCSSInsertedRulesIndex = 0;
    const runtimeStyles = (0, import_insertStyleRule.getAllRules)().join(separator);
    return exclude === "design-system" ? runtimeStyles : `${`._ovs-contain {overscroll-behavior:contain;}
.is_Text .is_Text {display:inline-flex;}
._dsp_contents {display:contents;}
${themeConfig.cssRuleSets.join(separator)}`}
${exclude ? "" : themeConfig.getThemeRulesSets().join(separator)}
${runtimeStyles}`;
  }, getNewCSS = (opts) => getCSS({ ...opts, sinceLastCall: !0 });
  let defaultFontName = (configIn.settings?.defaultFont ?? configIn.defaultFont) || // uses font named "body" if present for compat
  configIn.fonts && ("body" in configIn.fonts ? "body" : "");
  !defaultFontName && configIn.fonts && (defaultFontName = Object.keys(configIn.fonts)[0]), defaultFontName?.[0] === "$" && (defaultFontName = defaultFontName.slice(1));
  const defaultFont = `$${defaultFontName}`, config = {
    fonts: {},
    onlyAllowShorthands: !1,
    fontLanguages: [],
    animations: {},
    media: {},
    ...configIn,
    unset: {
      fontFamily: defaultFontName ? defaultFont : void 0,
      ...configIn.unset
    },
    settings: {
      // move deprecated settings here so we can reference them all using `getSetting`
      // TODO remove this on v2
      disableSSR: configIn.disableSSR,
      defaultFont: configIn.defaultFont,
      disableRootThemeClass: configIn.disableRootThemeClass,
      onlyAllowShorthands: configIn.onlyAllowShorthands,
      mediaQueryDefaultActive: configIn.mediaQueryDefaultActive,
      themeClassNameOnRoot: configIn.themeClassNameOnRoot,
      cssStyleSeparator: configIn.cssStyleSeparator,
      webContainerType: "inline-size",
      ...configIn.settings
    },
    tokens,
    // vite made this into a function if it wasn't set
    shorthands,
    inverseShorthands: shorthands ? Object.fromEntries(Object.entries(shorthands).map(([k, v]) => [v, k])) : {},
    themes: themeConfig.themes,
    fontsParsed: fontsParsed || {},
    themeConfig,
    tokensParsed,
    parsed: !0,
    getNewCSS,
    getCSS,
    defaultFont,
    fontSizeTokens: fontSizeTokens || /* @__PURE__ */ new Set(),
    specificTokens
    // const tokens = [...getToken(tokens.size[0])]
    // .spacer-sm + ._dsp_contents._dsp-sm-hidden { margin-left: -var(--${}) }
  };
  return (0, import_config.setConfig)(config), (0, import_useMedia.configureMedia)(config), createdConfigs.set(config, !0), import_config.configListeners.size && (import_config.configListeners.forEach((cb) => cb(config)), import_config.configListeners.clear()),  false && (0), config;
}
function getThemesDeduped(themes) {
  const dedupedThemes = [], existing = /* @__PURE__ */ new Map();
  for (const themeName in themes) {
    const darkOrLightSpecificPrefix = themeName.startsWith("dark") ? "dark" : themeName.startsWith("light") ? "light" : "", rawTheme = themes[themeName], key = darkOrLightSpecificPrefix + JSON.stringify(rawTheme);
    if (existing.has(key)) {
      existing.get(key).names.push(themeName);
      continue;
    }
    const theme = { ...rawTheme };
    for (const key2 in theme)
      (0, import_themes.ensureThemeVariable)(theme, key2);
    const deduped = {
      names: [themeName],
      theme
    };
    dedupedThemes.push(deduped), existing.set(key, deduped);
  }
  return dedupedThemes;
}
//# sourceMappingURL=createTamagui.js.map


/***/ }),

/***/ 5257:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var createTheme_exports = {};
__export(createTheme_exports, {
  createTheme: () => createTheme
});
module.exports = __toCommonJS(createTheme_exports);
const createTheme = (theme) => theme;
//# sourceMappingURL=createTheme.js.map


/***/ }),

/***/ 24358:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var createTokens_exports = {};
__export(createTokens_exports, {
  createTokens: () => createTokens
});
module.exports = __toCommonJS(createTokens_exports);
var import_createVariables = __webpack_require__(12817);
function createTokens(tokens) {
  return (0, import_createVariables.createVariables)(tokens);
}
//# sourceMappingURL=createTokens.js.map


/***/ }),

/***/ 68836:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(73656);
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var createVariable_exports = {};
__export(createVariable_exports, {
  createCSSVariable: () => createCSSVariable,
  createVariable: () => createVariable,
  didGetVariableValue: () => didGetVariableValue,
  getVariable: () => getVariable,
  getVariableName: () => getVariableName,
  getVariableValue: () => getVariableValue,
  getVariableVariable: () => getVariableVariable,
  isVariable: () => isVariable,
  setDidGetVariableValue: () => setDidGetVariableValue,
  variableToString: () => variableToString
});
module.exports = __toCommonJS(createVariable_exports);
var import_constants = __webpack_require__(77505), import_helpers = __webpack_require__(89953), import_config = __webpack_require__(98211);
function constructCSSVariableName(name) {
  return `var(--${process.env.TAMAGUI_CSS_VARIABLE_PREFIX || ""}${name})`;
}
const createVariable = (props, skipHash = !1) => {
  if (!skipHash && isVariable(props)) return props;
  const { key, name, val } = props;
  return {
    isVar: !0,
    key,
    name: skipHash ? name : (0, import_helpers.simpleHash)(name, 40),
    val,
    variable: import_constants.isWeb ? skipHash ? constructCSSVariableName(name) : createCSSVariable(name) : ""
  };
};
function variableToString(vrble, getValue = !1) {
  return isVariable(vrble) ? !getValue && import_constants.isWeb && vrble.variable ? vrble.variable : `${vrble.val}` : `${vrble || ""}`;
}
function isVariable(v) {
  return v && typeof v == "object" && "isVar" in v;
}
function getVariable(nameOrVariable, group = "size") {
  if (setDidGetVariableValue(!0), isVariable(nameOrVariable))
    return variableToString(nameOrVariable);
  const tokens = (0, import_config.getConfig)().tokensParsed;
  return variableToString(tokens[group]?.[nameOrVariable] ?? nameOrVariable);
}
let accessed = !1;
const setDidGetVariableValue = (val) => accessed = val, didGetVariableValue = () => accessed;
function getVariableValue(v, group) {
  if (isVariable(v))
    return setDidGetVariableValue(!0), v.val;
  if (group) {
    const token = (0, import_config.getConfig)().tokensParsed[group]?.[v];
    if (token)
      return setDidGetVariableValue(!0), token.val;
  }
  return v;
}
function getVariableName(v) {
  return isVariable(v) ? v.name : v;
}
function getVariableVariable(v) {
  return isVariable(v) ? v.variable : v;
}
const createCSSVariable = (nameProp, includeVar = !0) => {
  if (false)
    {}
  const name = (0, import_helpers.simpleHash)(nameProp, 60);
  return includeVar ? constructCSSVariableName(name) : name;
};
//# sourceMappingURL=createVariable.js.map


/***/ }),

/***/ 12817:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var createVariables_exports = {};
__export(createVariables_exports, {
  createVariables: () => createVariables
});
module.exports = __toCommonJS(createVariables_exports);
var import_helpers = __webpack_require__(89953), import_createVariable = __webpack_require__(68836);
const cache = /* @__PURE__ */ new WeakMap(), createVariables = (tokens, parentPath = "", isFont = !1) => {
  if (cache.has(tokens)) return tokens;
  const res = {};
  let i = 0;
  for (let keyIn in tokens) {
    i++;
    const val = tokens[keyIn], isPrefixed = keyIn[0] === "$", keyWithPrefix = isPrefixed ? keyIn : `$${keyIn}`, key = isPrefixed ? keyWithPrefix.slice(1) : keyIn;
    if ((0, import_createVariable.isVariable)(val)) {
      res[key] = val;
      continue;
    }
    const niceKey = (0, import_helpers.simpleHash)(key, 1e3), name = parentPath && parentPath !== "color" ? `${parentPath}-${niceKey}` : niceKey;
    if (val && typeof val == "object") {
      res[key] = createVariables(
        tokens[key],
        name,
        !1
        /* note: don't pass isFont down, we want to avoid it past the first level */
      );
      continue;
    }
    const finalValue = (0, import_createVariable.isVariable)(val) ? val : (0, import_createVariable.createVariable)({ val, name, key: keyWithPrefix });
    res[key] = finalValue;
  }
  return cache.set(res, !0), res;
};
//# sourceMappingURL=createVariables.js.map


/***/ }),

/***/ 4580:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var defaultComponentState_exports = {};
__export(defaultComponentState_exports, {
  defaultComponentState: () => defaultComponentState,
  defaultComponentStateMounted: () => defaultComponentStateMounted,
  defaultComponentStateShouldEnter: () => defaultComponentStateShouldEnter
});
module.exports = __toCommonJS(defaultComponentState_exports);
const defaultComponentState = {
  hover: !1,
  press: !1,
  pressIn: !1,
  focus: !1,
  focusVisible: !1,
  unmounted: !0,
  disabled: !1
}, defaultComponentStateMounted = {
  ...defaultComponentState,
  unmounted: !1
}, defaultComponentStateShouldEnter = {
  ...defaultComponentState,
  unmounted: "should-enter"
};
//# sourceMappingURL=defaultComponentState.js.map


/***/ }),

/***/ 24647:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var ThemeManager_exports = {};
__export(ThemeManager_exports, {
  ThemeManager: () => ThemeManager,
  getHasThemeUpdatingProps: () => getHasThemeUpdatingProps,
  getManagers: () => getManagers
});
module.exports = __toCommonJS(ThemeManager_exports);
var import_constants = __webpack_require__(77505), import_config = __webpack_require__(98211), import_constants2 = __webpack_require__(24881);
const emptyState = { name: "" };
function getHasThemeUpdatingProps(props) {
  return !!(props.name || props.componentName || props.inverse || props.reset);
}
let uid = 0;
class ThemeManager {
  constructor(props = {}, parentManager) {
    this.props = props;
    if (uid = (uid + 1) % Number.MAX_VALUE, this.id = uid, parentManager === "root") {
      this.updateStateFromProps(props, !1);
      return;
    }
    if (!parentManager)
      throw  false ? 0 : "\u274C 000";
    if (this.parentManager = parentManager, !this.updateStateFromProps(props, !1))
      return parentManager;
  }
  id = 0;
  themeListeners = /* @__PURE__ */ new Set();
  parentManager = null;
  state = emptyState;
  updateStateFromProps(props = this.props || {}, shouldNotify = !0) {
    if (this.props = props, props.forceTheme)
      return this.state.theme = props.forceTheme, this.state.name = props.name || "", this.updateState(this.state, !0), this.state;
    const nextState = this.getStateIfChanged(props);
    if (nextState)
      return this.updateState(nextState, shouldNotify), nextState;
  }
  updateState(nextState, shouldNotify = !0) {
    this.state = nextState, this._allKeys = null, shouldNotify && queueMicrotask(() => {
      this.notify();
    });
  }
  getStateIfChanged(props = this.props, state = this.state, parentManager = this.parentManager) {
    const _ = this.getState(props, parentManager);
    if (state && state !== emptyState && !_)
      return parentManager?.state;
    if (this.getStateShouldChange(_, state))
      return _;
  }
  getStateShouldChange(nextState, state = this.state) {
    return !(!nextState?.theme || nextState.theme === state?.theme);
  }
  getState(props = this.props, parentManager = this.parentManager) {
    return getState(props, parentManager) || null;
  }
  _allKeys = null;
  get allKeys() {
    return this._allKeys ||= /* @__PURE__ */ new Set([
      ...this.parentManager?.allKeys || [],
      ...Object.keys(this.state.theme || {})
    ]), this._allKeys;
  }
  notify(forced = !1) {
    this.themeListeners.forEach((cb) => cb(this.state.name, this, forced)),  false && (0);
  }
  onChangeTheme(cb, debugId) {
    return  false && (0), this.themeListeners.add(cb), () => {
      this.themeListeners.delete(cb);
    };
  }
}
function getState(props, manager) {
  if (props.name && props.reset)
    throw new Error(
       true ? "\u274C004" : 0
    );
  if (!getHasThemeUpdatingProps(props))
    return null;
  const themes = (0, import_config.getThemes)(), [allManagers, componentManagers] = getManagers(manager), isDirectParentAComponentTheme = !!manager?.state.isComponent, startIndex = props.reset && !isDirectParentAComponentTheme ? 1 : 0;
  let baseManager = allManagers[startIndex], parentManager = allManagers[startIndex + 1];
  if (!baseManager && props.reset)
    return  false && 0, null;
  const { componentName } = props;
  let result = null, baseName = baseManager?.state.name || "";
  baseManager?.state.isComponent && (baseName = baseName.replace(/_[A-Z][A-Za-z]+/, ""));
  const nextName = props.reset ? baseName : props.name || "", allComponentThemes = componentManagers.map((x) => x?.state.name || "");
  isDirectParentAComponentTheme && allComponentThemes.shift();
  const base = baseName.split(import_constants2.THEME_NAME_SEPARATOR), max = base.length, min = props.componentName && !nextName ? max : 0;
  for (let i = max; i >= min; i--) {
    let prefix = base.slice(0, i).join(import_constants2.THEME_NAME_SEPARATOR);
    props.inverse && (prefix = inverseThemeName(prefix));
    let potentials = [];
    if (prefix && prefix !== baseName && prefix.includes(nextName) && potentials.push(prefix), nextName && potentials.unshift(prefix ? `${prefix}_${nextName}` : nextName), i === 1) {
      const lastSegment = potentials.findIndex((x) => !x.includes("_"));
      lastSegment > 0 && potentials.splice(lastSegment, 0, nextName);
    }
    if (componentName && !props.reset) {
      const baseLen = base.length;
      let componentPotentials = [];
      if (nextName && baseLen > 1) {
        const beforeSeparator = base[0];
        componentPotentials.push(`${beforeSeparator}_${nextName}_${componentName}`);
      }
      if (componentPotentials.push(`${prefix}_${componentName}`), nextName) {
        if (i > baseLen) {
          const prefixLessOne = base.slice(0, i - 1).join(import_constants2.THEME_NAME_SEPARATOR);
          if (prefixLessOne) {
            const lessSpecific = `${prefixLessOne}_${nextName}_${componentName}`;
            componentPotentials.unshift(lessSpecific);
          }
        }
        const moreSpecific = `${prefix}_${nextName}_${componentName}`;
        componentPotentials.unshift(moreSpecific);
      }
      potentials = [...componentPotentials, ...potentials, ...allComponentThemes];
    }
    const found = potentials.find((t) => t in themes);
    if ( false && 0, found) {
      const names = found.split("_"), [firstName, ...restNames] = names, lastName = names[names.length - 1], isComponent = lastName[0] === lastName[0].toUpperCase(), scheme = firstName === "light" ? "light" : firstName === "dark" ? "dark" : void 0, pre = import_constants2.THEME_CLASSNAME_PREFIX, className = import_constants.isWeb ? `${pre}sub_theme ${pre}${!scheme || !restNames.length ? firstName : restNames.join("_")}` : "", parentName = (baseManager || parentManager)?.state?.name;
      result = {
        name: found,
        parentName,
        theme: themes[found],
        className,
        isComponent,
        scheme
      };
      break;
    }
  }
  return  false && (0), result;
}
const inverseThemeName = (themeName) => themeName.startsWith("light") ? themeName.replace(/^light/, "dark") : themeName.replace(/^dark/, "light");
function getManagers(themeManager) {
  const comp = [], all = [];
  let cur = themeManager;
  for (; cur; )
    all.push(cur), cur.state.isComponent && comp.push(cur), cur = cur.parentManager;
  return [all, comp];
}
//# sourceMappingURL=ThemeManager.js.map


/***/ }),

/***/ 99953:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var ThemeManagerContext_exports = {};
__export(ThemeManagerContext_exports, {
  ThemeManagerIDContext: () => ThemeManagerIDContext
});
module.exports = __toCommonJS(ThemeManagerContext_exports);
var import_react = __toESM(__webpack_require__(44194));
const ThemeManagerIDContext = import_react.default.createContext(1);
//# sourceMappingURL=ThemeManagerContext.js.map


/***/ }),

/***/ 15446:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var createMediaStyle_exports = {};
__export(createMediaStyle_exports, {
  MEDIA_SEP: () => MEDIA_SEP,
  createMediaStyle: () => createMediaStyle
});
module.exports = __toCommonJS(createMediaStyle_exports);
var import_config = __webpack_require__(98211), import_useMedia = __webpack_require__(31094), import_getGroupPropParts = __webpack_require__(34950);
const MEDIA_SEP = "_";
let prefixes = null, selectors = null;
const groupPseudoToPseudoCSSMap = {
  press: "active"
}, specifities = new Array(5).fill(0).map((_, i) => new Array(i).fill(":root").join(""));
function getThemeOrGroupSelector(name, styleInner, isGroup, groupParts, isTheme = !1, precedenceImportancePrefix = "") {
  const selectorStart = styleInner.indexOf(":root"), selectorEnd = styleInner.lastIndexOf("{"), selector = styleInner.slice(selectorStart, selectorEnd), precedenceSpace = (0, import_config.getSetting)("themeClassNameOnRoot") && isTheme ? "" : " ", pseudoSelectorName = groupParts.pseudo ? groupPseudoToPseudoCSSMap[groupParts.pseudo] || groupParts.pseudo : void 0, pseudoSelector = pseudoSelectorName ? `:${pseudoSelectorName}` : "", presedencePrefix = `:root${precedenceImportancePrefix}${precedenceSpace}`, mediaSelector = `.t_${isGroup ? "group_" : ""}${name}${pseudoSelector}`;
  return [
    selector,
    `${presedencePrefix}${mediaSelector} ${selector.replace(":root", "")}`
  ];
}
const createMediaStyle = (styleObject, mediaKeyIn, mediaQueries, type, negate, priority) => {
  const [property, , identifier, , rules] = styleObject, enableMediaPropOrder = (0, import_config.getSetting)("mediaPropOrder"), isTheme = type === "theme", isPlatform = type === "platform", isGroup = type === "group", isNonWindowMedia = isTheme || isPlatform || isGroup, negKey = negate ? "0" : "", ogPrefix = identifier.slice(0, identifier.indexOf("-") + 1), id = `${ogPrefix}${MEDIA_SEP}${mediaKeyIn.replace("-", "")}${negKey}${MEDIA_SEP}`;
  let styleRule = "", groupPriority = "", groupMediaKey, containerName, nextIdentifier = identifier.replace(ogPrefix, id), styleInner = rules.map((rule) => rule.replace(identifier, nextIdentifier)).join(";"), isHover = !1;
  if (isNonWindowMedia) {
    let specificity = (priority || 0) + (isGroup || isPlatform ? 1 : 0);
    if (isTheme || isGroup) {
      const { name, media, pseudo } = (0, import_getGroupPropParts.getGroupPropParts)(mediaKeyIn);
      groupMediaKey = media;
      const groupParts = (0, import_getGroupPropParts.getGroupPropParts)(mediaKeyIn);
      isGroup && (containerName = name), pseudo === "press" && (specificity += 2), pseudo === "hover" && (isHover = !0);
      const [selector, nextSelector] = getThemeOrGroupSelector(
        name,
        styleInner,
        isGroup,
        groupParts,
        isTheme,
        specifities[specificity]
      );
      styleRule = styleInner.replace(selector, nextSelector);
    } else
      styleRule = `${specifities[specificity]}${styleInner}`;
  }
  if (!isNonWindowMedia || groupMediaKey) {
    if (!selectors) {
      const mediaKeys = Object.keys(mediaQueries);
      selectors = Object.fromEntries(
        mediaKeys.map((key) => [key, (0, import_useMedia.mediaObjectToString)(mediaQueries[key])])
      ), enableMediaPropOrder || (prefixes = Object.fromEntries(
        mediaKeys.map((k, index) => [k, new Array(index + 1).fill(":root").join("")])
      ));
    }
    const mediaKey = groupMediaKey || mediaKeyIn, mediaSelector = selectors[mediaKey], mediaQuery = `${negate ? "not all and " : ""}${mediaSelector}`, precedenceImportancePrefix = groupMediaKey ? groupPriority : enableMediaPropOrder && priority ? (
      // this new array should be cached
      specifities[priority]
    ) : (
      // @ts-ignore
      prefixes[mediaKey]
    ), prefix = groupMediaKey ? `@container ${containerName}` : "@media";
    groupMediaKey && (styleInner = styleRule), styleInner.includes(prefix) ? styleRule = styleInner.replace("{", ` and ${mediaQuery} {`).replace("and screen and", "and") : styleRule = `${prefix} ${mediaQuery}{${precedenceImportancePrefix}${styleInner}}`, groupMediaKey && (styleRule = `@supports (contain: ${(0, import_config.getSetting)("webContainerType") || "inline-size"}) {${styleRule}}`);
  }
  return isHover && (styleRule = `@media (hover:hover){${styleRule}}`), [property, void 0, nextIdentifier, void 0, [styleRule]];
};
//# sourceMappingURL=createMediaStyle.js.map


/***/ }),

/***/ 69345:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var createShallowSetState_exports = {};
__export(createShallowSetState_exports, {
  createShallowSetState: () => createShallowSetState,
  isEqualShallow: () => isEqualShallow,
  mergeIfNotShallowEqual: () => mergeIfNotShallowEqual
});
module.exports = __toCommonJS(createShallowSetState_exports);
var import_react = __webpack_require__(44194);
const callImmediate = (cb) => cb();
function createShallowSetState(setter, isDisabled, transition, debug) {
  return (next) => {
    (transition ? import_react.startTransition : callImmediate)(() => {
      setter((prev) => mergeIfNotShallowEqual(prev, next, isDisabled, debug));
    });
  };
}
function mergeIfNotShallowEqual(prev, next, isDisabled, debug) {
  if (isDisabled || !prev || !next || isEqualShallow(prev, next))
    return prev || next;
  if (false)
    {}
  return { ...prev, ...next };
}
function isEqualShallow(prev, next) {
  for (const key in next)
    if (prev[key] !== next[key])
      return !1;
  return !0;
}
//# sourceMappingURL=createShallowSetState.js.map


/***/ }),

/***/ 7936:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var createStyledContext_exports = {};
__export(createStyledContext_exports, {
  createStyledContext: () => createStyledContext
});
module.exports = __toCommonJS(createStyledContext_exports);
var import_react = __toESM(__webpack_require__(44194)), import_objectIdentityKey = __webpack_require__(53136), import_jsx_runtime = __webpack_require__(31549);
function createStyledContext(defaultValues) {
  const OGContext = import_react.default.createContext(defaultValues), OGProvider = OGContext.Provider, Context = OGContext, scopedContexts = /* @__PURE__ */ new Map(), Provider = ({
    children,
    scope,
    ...values
  }) => {
    const next = import_react.default.useMemo(() => ({
      // this ! is a workaround for ts error
      ...defaultValues,
      ...values
    }), [(0, import_objectIdentityKey.objectIdentityKey)(values)]);
    let Provider2 = OGProvider;
    if (scope) {
      let ScopedContext = scopedContexts.get(scope);
      ScopedContext || (ScopedContext = import_react.default.createContext(defaultValues), scopedContexts.set(scope, ScopedContext)), Provider2 = ScopedContext.Provider;
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Provider2, { value: next, children });
  }, useStyledContext = (scope) => {
    const context = scope ? scopedContexts.get(scope) : OGContext;
    return import_react.default.useContext(context);
  };
  return Context.Provider = Provider, Context.props = defaultValues, Context.context = OGContext, Context.useStyledContext = useStyledContext, Context;
}
//# sourceMappingURL=createStyledContext.js.map


/***/ }),

/***/ 20816:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var defaultOffset_exports = {};
__export(defaultOffset_exports, {
  defaultOffset: () => defaultOffset
});
module.exports = __toCommonJS(defaultOffset_exports);
const defaultOffset = { height: 0, width: 0 };
//# sourceMappingURL=defaultOffset.js.map


/***/ }),

/***/ 7943:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all2) => {
  for (var name in all2)
    __defProp(target, name, { get: all2[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var expandStyle_exports = {};
__export(expandStyle_exports, {
  expandStyle: () => expandStyle
});
module.exports = __toCommonJS(expandStyle_exports);
var import_constants = __webpack_require__(77505), import_webToNativeProps = __webpack_require__(43233), import_config = __webpack_require__(98211);
const neg1Flex = [
  ["flexGrow", 0],
  ["flexShrink", 1],
  ["flexBasis", "auto"]
];
function expandStyle(key, value) {
  if (key === "flex")
    return value === -1 ? neg1Flex : [
      ["flexGrow", value],
      ["flexShrink", 1],
      ["flexBasis", (0, import_config.getConfig)().settings.styleCompat === "react-native" ? 0 : "auto"]
    ];
  switch (key) {
    case "textAlignVertical":
      return [["verticalAlign", value === "center" ? "middle" : value]];
    case "writingDirection":
      return [["direction", value]];
  }
  if (key in EXPANSIONS)
    return EXPANSIONS[key].map((key2) => [key2, value]);
  if (key in import_webToNativeProps.webToNativeExpansion)
    return import_webToNativeProps.webToNativeExpansion[key].map((key2) => [key2, value]);
  if (key in import_webToNativeProps.webToNativeDynamicExpansion)
    return import_webToNativeProps.webToNativeDynamicExpansion[key](value);
}
const all = ["Top", "Right", "Bottom", "Left"], horiz = ["Right", "Left"], vert = ["Top", "Bottom"], xy = ["X", "Y"], EXPANSIONS = {
  borderColor: ["TopColor", "RightColor", "BottomColor", "LeftColor"],
  borderRadius: [
    "TopLeftRadius",
    "TopRightRadius",
    "BottomRightRadius",
    "BottomLeftRadius"
  ],
  borderWidth: ["TopWidth", "RightWidth", "BottomWidth", "LeftWidth"],
  margin: all,
  marginHorizontal: horiz,
  marginVertical: vert,
  overscrollBehavior: xy,
  padding: all,
  paddingHorizontal: horiz,
  paddingVertical: vert,
  ...import_constants.isWeb && {
    // react-native only supports borderStyle
    borderStyle: ["TopStyle", "RightStyle", "BottomStyle", "LeftStyle"],
    // react-native doesn't support X / Y
    overflow: xy
  }
};
for (const parent in EXPANSIONS) {
  const prefix = parent.slice(0, /[A-Z]/.exec(parent)?.index ?? parent.length);
  EXPANSIONS[parent] = EXPANSIONS[parent].map((k) => `${prefix}${k}`);
}
//# sourceMappingURL=expandStyle.js.map


/***/ }),

/***/ 87138:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var expandStyles_exports = {};
__export(expandStyles_exports, {
  fixStyles: () => fixStyles
});
module.exports = __toCommonJS(expandStyles_exports);
var import_constants = __webpack_require__(77505), import_normalizeShadow = __webpack_require__(64040);
function fixStyles(style) {
  (style.shadowRadius != null || style.shadowColor || style.shadowOpacity != null || style.shadowOffset) && Object.assign(style, (0, import_normalizeShadow.normalizeShadow)(style));
  for (const key in borderDefaults)
    key in style && (style[borderDefaults[key]] ||= "solid");
}
const nativeStyle = import_constants.isWeb ? null : "borderStyle", borderDefaults = {
  borderWidth: "borderStyle",
  borderBottomWidth: nativeStyle || "borderBottomStyle",
  borderTopWidth: nativeStyle || "borderTopStyle",
  borderLeftWidth: nativeStyle || "borderLeftStyle",
  borderRightWidth: nativeStyle || "borderRightStyle"
  // TODO: need to add borderBlock and borderInline here, but they are alot and might impact performance
};
//# sourceMappingURL=expandStyles.js.map


/***/ }),

/***/ 62719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var getExpandedShorthands_exports = {};
__export(getExpandedShorthands_exports, {
  getExpandedShorthands: () => getExpandedShorthands
});
module.exports = __toCommonJS(getExpandedShorthands_exports);
var import_config = __webpack_require__(98211);
function getExpandedShorthands(props) {
  const shorthands = (0, import_config.getConfig)().shorthands;
  if (!shorthands) return props;
  const res = {};
  for (const key in props)
    res[shorthands[key] || key] = props[key];
  return res;
}
//# sourceMappingURL=getExpandedShorthands.js.map


/***/ }),

/***/ 34950:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var getGroupPropParts_exports = {};
__export(getGroupPropParts_exports, {
  getGroupPropParts: () => getGroupPropParts
});
module.exports = __toCommonJS(getGroupPropParts_exports);
var import_useMedia = __webpack_require__(31094);
function getGroupPropParts(groupProp) {
  const mediaQueries = (0, import_useMedia.getMedia)(), [_, name, part3, part4] = groupProp.split("-");
  let pseudo;
  const media = part3 in mediaQueries ? part3 : void 0;
  return media ? pseudo = part4 : pseudo = part3, { name, pseudo, media };
}
//# sourceMappingURL=getGroupPropParts.js.map


/***/ }),

/***/ 11792:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(73656);
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var getSplitStyles_exports = {};
__export(getSplitStyles_exports, {
  PROP_SPLIT: () => PROP_SPLIT,
  getSplitStyles: () => getSplitStyles,
  getSubStyle: () => getSubStyle,
  useSplitStyles: () => useSplitStyles
});
module.exports = __toCommonJS(getSplitStyles_exports);
var import_react = __toESM(__webpack_require__(44194)), import_constants = __webpack_require__(77505), import_helpers = __webpack_require__(89953), import_config = __webpack_require__(98211), import_accessibilityDirectMap = __webpack_require__(65906), import_constants2 = __webpack_require__(24881), import_isDevTools = __webpack_require__(15799), import_useMedia = __webpack_require__(31094), import_createMediaStyle = __webpack_require__(15446), import_expandStyles = __webpack_require__(87138), import_getGroupPropParts = __webpack_require__(34950), import_getStylesAtomic = __webpack_require__(12538), import_insertStyleRule = __webpack_require__(55915), import_log = __webpack_require__(50265), import_normalizeValueWithProperty = __webpack_require__(29681), import_propMapper = __webpack_require__(10069), import_pseudoDescriptors = __webpack_require__(71721), import_skipProps = __webpack_require__(49495), import_transformsToString = __webpack_require__(73488), import_isActivePlatform = __webpack_require__(16565);
const consoleGroupCollapsed = import_constants.isWeb ? console.groupCollapsed : console.info;
let conf;
const PROP_SPLIT = "-";
function isValidStyleKey(key, staticConfig) {
  return (staticConfig.validStyles || (staticConfig.isText || staticConfig.isInput ? import_helpers.stylePropsText : import_helpers.validStyles))[key] || staticConfig.accept?.[key];
}
const getSplitStyles = (props, staticConfig, theme, themeName, componentState, styleProps, parentSplitStyles, context, elementType, debug, skipThemeTokenResolution) => {
  conf = conf || (0, import_config.getConfig)(), import_constants.isWeb && styleProps.isAnimated && conf.animations.isReactNative && !styleProps.noNormalize && (styleProps.noNormalize = "values");
  const { shorthands } = conf, {
    isHOC,
    isText,
    isInput,
    variants,
    isReactNative,
    inlineProps,
    inlineWhenUnflattened,
    parentStaticConfig,
    acceptsClassName
  } = staticConfig, viewProps = {}, mediaState = styleProps.mediaState || import_useMedia.mediaState, usedKeys = {}, shouldDoClasses = acceptsClassName && import_constants.isWeb && !styleProps.noClassNames, rulesToInsert = {}, classNames = {}, transforms = {};
  let pseudos = null, space = props.space, hasMedia = !1, dynamicThemeAccess, pseudoGroups, mediaGroups, className = props.className || "", mediaStylesSeen = 0;
  const styleState = {
    classNames,
    conf,
    props,
    styleProps,
    componentState,
    staticConfig,
    style: null,
    theme,
    usedKeys,
    viewProps,
    context,
    debug,
    skipThemeTokenResolution
  };
   false && (0);
  const { asChild } = props, { accept } = staticConfig, { noSkip, disableExpandShorthands, noExpand } = styleProps, { webContainerType } = conf.settings, parentVariants = parentStaticConfig?.variants;
  for (const keyOg in props) {
    let keyInit = keyOg, valInit = props[keyInit];
    if (accept) {
      const accepted = accept[keyInit];
      if ((accepted === "style" || accepted === "textStyle") && valInit && typeof valInit == "object") {
        viewProps[keyInit] = getSubStyle(
          styleState,
          keyInit,
          valInit,
          styleProps.noClassNames
        );
        continue;
      }
    }
    if ( false && 0, disableExpandShorthands || keyInit in shorthands && (keyInit = shorthands[keyInit]), keyInit === "className" || keyInit in usedKeys || asChild && import_constants2.webViewFlexCompatStyles[keyInit] === valInit)
      continue;
    if (keyInit in import_skipProps.skipProps && !noSkip && !isHOC) {
      if (keyInit === "group") {
        const identifier = `t_group_${valInit}`, containerCSS = [
          "continer",
          void 0,
          identifier,
          void 0,
          [
            `.${identifier} { container-name: ${valInit}; container-type: ${webContainerType || "inline-size"}; }`
          ]
        ];
        addStyleToInsertRules(rulesToInsert, containerCSS);
      }
      continue;
    }
    const valInitType = typeof valInit, isValidStyleKeyInit = isValidStyleKey(keyInit, staticConfig);
    if (isValidStyleKeyInit && valInitType === "string" && valInit[0] === "_") {
      const isValidClassName = keyInit in import_helpers.validStyles, isMediaOrPseudo2 = !isValidClassName && // media are flattened for some reason to color-hover keys,
      // we should probably just leave them in place to avoid extra complexity
      keyInit.includes(PROP_SPLIT) && import_helpers.validStyles[keyInit.split(PROP_SPLIT)[0]];
      if (isValidClassName || isMediaOrPseudo2) {
        shouldDoClasses ? (mergeClassName(transforms, classNames, keyInit, valInit, isMediaOrPseudo2), styleState.style && delete styleState.style[keyInit]) : (styleState.style ||= {}, styleState.style[keyInit] = (0, import_normalizeValueWithProperty.reverseMapClassNameToValue)(keyInit, valInit), delete classNames[keyInit]);
        continue;
      }
    }
    if (keyInit === "dataSet") {
      for (const keyInit2 in valInit)
        viewProps[`data-${hyphenate(keyInit2)}`] = valInit[keyInit2];
      continue;
    }
    if (!noExpand) {
      if (keyInit === "disabled" && valInit === !0 && (viewProps["aria-disabled"] = !0, (elementType === "button" || elementType === "form" || elementType === "input" || elementType === "select" || elementType === "textarea") && (viewProps.disabled = !0), !variants?.disabled))
        continue;
      if (keyInit === "testID") {
        viewProps[isReactNative ? keyInit : "data-testid"] = valInit;
        continue;
      }
      if (keyInit === "id" || keyInit === "nativeID") {
        viewProps.id = valInit;
        continue;
      }
      let didUseKeyInit = !1;
      if (isReactNative) {
        if (keyInit in import_accessibilityDirectMap.accessibilityDirectMap || keyInit.startsWith("accessibility")) {
          viewProps[keyInit] = valInit;
          continue;
        }
      } else {
        if (didUseKeyInit = !0, keyInit in import_accessibilityDirectMap.accessibilityDirectMap) {
          viewProps[import_accessibilityDirectMap.accessibilityDirectMap[keyInit]] = valInit;
          continue;
        }
        switch (keyInit) {
          case "accessibilityRole": {
            valInit === "none" ? viewProps.role = "presentation" : viewProps.role = accessibilityRoleToWebRole[valInit] || valInit;
            continue;
          }
          case "accessibilityLabelledBy":
          case "accessibilityFlowTo":
          case "accessibilityControls":
          case "accessibilityDescribedBy": {
            viewProps[`aria-${keyInit.replace("accessibility", "").toLowerCase()}`] = processIDRefList(valInit);
            continue;
          }
          case "accessibilityKeyShortcuts": {
            Array.isArray(valInit) && (viewProps["aria-keyshortcuts"] = valInit.join(" "));
            continue;
          }
          case "accessibilityLiveRegion": {
            viewProps["aria-live"] = valInit === "none" ? "off" : valInit;
            continue;
          }
          case "accessibilityReadOnly": {
            viewProps["aria-readonly"] = valInit, (elementType === "input" || elementType === "select" || elementType === "textarea") && (viewProps.readOnly = !0);
            continue;
          }
          case "accessibilityRequired": {
            viewProps["aria-required"] = valInit, (elementType === "input" || elementType === "select" || elementType === "textarea") && (viewProps.required = valInit);
            continue;
          }
          default:
            didUseKeyInit = !1;
        }
      }
      if (didUseKeyInit)
        continue;
    }
    const isShorthand = keyInit in shorthands;
    let isVariant = !isValidStyleKeyInit && variants && keyInit in variants;
    const isStyleLikeKey = isShorthand || isValidStyleKeyInit || isVariant;
    let isPseudo = keyInit in import_helpers.validPseudoKeys, isMedia = !isStyleLikeKey && !isPseudo && (0, import_useMedia.isMediaKey)(keyInit), isMediaOrPseudo = !!(isMedia || isPseudo);
    if (isMediaOrPseudo && keyInit.startsWith("$group-")) {
      const name = keyInit.split("-")[1];
      context?.groups.subscribe && !context?.groups.state[name] && (keyInit = keyInit.replace("$group-", "$group-true-"));
    }
    const isStyleProp = isValidStyleKeyInit || isMediaOrPseudo || isVariant && !noExpand || isShorthand;
    if (isStyleProp && (asChild === "except-style" || asChild === "except-style-web"))
      continue;
    const shouldPassProp = !isStyleProp || // is in parent variants
    isHOC && parentVariants && keyInit in parentVariants || inlineProps?.has(keyInit), parentVariant = parentVariants?.[keyInit], isHOCShouldPassThrough = !!(isHOC && (isShorthand || isValidStyleKeyInit || isMediaOrPseudo || parentVariant || keyInit in import_skipProps.skipProps)), shouldPassThrough = shouldPassProp || isHOCShouldPassThrough;
    if ( false && (0), shouldPassThrough && (passDownProp(viewProps, keyInit, valInit, isMediaOrPseudo), !isVariant)) {
       false && 0;
      continue;
    }
    if (!noSkip && keyInit in import_skipProps.skipProps) {
       false && 0;
      continue;
    }
    (isText || isInput) && valInit && (keyInit === "fontFamily" || keyInit === shorthands.fontFamily) && valInit in conf.fontsParsed && (styleState.fontFamily = valInit);
    const avoidPropMap = isMediaOrPseudo || !isVariant && !isValidStyleKeyInit, expanded = avoidPropMap ? null : (0, import_propMapper.propMapper)(keyInit, valInit, styleState);
    if (!avoidPropMap) {
      if (!expanded) continue;
      const next = (0, import_propMapper.getPropMappedFontFamily)(expanded);
      next && (styleState.fontFamily = next);
    }
    if (false) {}
    let key = keyInit, val = valInit;
    const max = expanded ? expanded.length : 1;
    for (let i = 0; i < max; i++) {
      if (expanded) {
        const [k, v] = expanded[i];
        key = k, val = v;
      }
      if (val == null || key in usedKeys) continue;
      if (isPseudo = key in import_helpers.validPseudoKeys, isMedia = !isPseudo && !isValidStyleKeyInit && (0, import_useMedia.isMediaKey)(key), isMediaOrPseudo = !!(isMedia || isPseudo), isVariant = variants && key in variants, (inlineProps?.has(key) ||  false && 0) && (viewProps[key] = props[key] ?? val), styleProps.noExpand && isPseudo || isHOC && (isMediaOrPseudo || parentStaticConfig?.variants?.[keyInit])) {
        passDownProp(viewProps, key, val, isMediaOrPseudo),  false && (0);
        continue;
      }
      if (isPseudo) {
        if (!val) continue;
        const pseudoStyleObject = getSubStyle(
          styleState,
          key,
          val,
          styleProps.noClassNames
        ), descriptor = import_pseudoDescriptors.pseudoDescriptors[key], isEnter = key === "enterStyle", isExit = key === "exitStyle";
        if (!descriptor)
          continue;
        if ((!shouldDoClasses || "" === "is_static") && (pseudos ||= {}, pseudos[key] ||= {}, "" === "is_static")) {
          Object.assign(pseudos[key], pseudoStyleObject);
          continue;
        }
        if (shouldDoClasses && !isExit) {
          const pseudoStyles = (0, import_getStylesAtomic.getStyleAtomic)(pseudoStyleObject, descriptor);
           false && (0);
          for (const psuedoStyle of pseudoStyles) {
            const fullKey = `${psuedoStyle[import_helpers.StyleObjectProperty]}${PROP_SPLIT}${descriptor.name}`;
            fullKey in usedKeys || (addStyleToInsertRules(rulesToInsert, psuedoStyle), mergeClassName(
              transforms,
              classNames,
              fullKey,
              psuedoStyle[import_helpers.StyleObjectIdentifier],
              isMediaOrPseudo,
              !0
            ));
          }
        }
        if (!shouldDoClasses || isExit || isEnter) {
          const descriptorKey = descriptor.stateKey || descriptor.name;
          let isDisabled = componentState[descriptorKey] === !1;
          isExit && (isDisabled = !styleProps.isExiting), isEnter && componentState.unmounted === !1 && (isDisabled = !0),  false && (0);
          const importance = descriptor.priority;
          for (const pkey in pseudoStyleObject) {
            const val2 = pseudoStyleObject[pkey];
            if (isDisabled)
              applyDefaultStyle(pkey, styleState);
            else {
              const curImportance = usedKeys[pkey] || 0, shouldMerge = importance >= curImportance;
              shouldMerge && (pseudos ||= {}, pseudos[key] ||= {}, pseudos[key][pkey] = val2, mergeStyle(styleState, pkey, val2)),  false && 0;
            }
          }
          if (!isDisabled)
            for (const key2 in val) {
              const k = shorthands[key2] || key2;
              usedKeys[k] = Math.max(importance, usedKeys[k] || 0);
            }
        }
        continue;
      }
      if (isMedia) {
        if (!val) continue;
        const hasSpace = val.space, mediaKeyShort = key.slice(1);
        if (hasMedia ||= !0, (hasSpace || !shouldDoClasses || styleProps.willBeAnimated) && (typeof hasMedia != "object" && (hasMedia = {}), hasMedia[mediaKeyShort] = !0), isMedia === "platform" && !(0, import_isActivePlatform.isActivePlatform)(key))
          continue;
        if ( false && 0, shouldDoClasses) {
          const mediaStyle = getSubStyle(styleState, key, val, !1);
          if (hasSpace && (delete mediaStyle.space, mediaState[mediaKeyShort])) {
            const importance = (0, import_useMedia.getMediaImportanceIfMoreImportant)(
              mediaKeyShort,
              "space",
              usedKeys,
              !0
            );
            importance && (space = val.space, usedKeys.space = importance,  false && 0);
          }
          const mediaStyles = (0, import_getStylesAtomic.getStylesAtomic)(mediaStyle), priority = mediaStylesSeen;
          mediaStylesSeen += 1;
          for (const style of mediaStyles) {
            const property = style[0];
            if (property[0] === "$" && property.startsWith("$platform") && !(0, import_isActivePlatform.isActivePlatform)(property))
              continue;
            const out = (0, import_createMediaStyle.createMediaStyle)(
              style,
              mediaKeyShort,
              import_useMedia.mediaQueryConfig,
              isMedia,
              !1,
              priority
            );
             false && 0;
            const fullKey = `${style[import_helpers.StyleObjectProperty]}${PROP_SPLIT}${mediaKeyShort}${style[import_helpers.StyleObjectPseudo] || ""}`;
            fullKey in usedKeys || (addStyleToInsertRules(rulesToInsert, out), mergeClassName(
              transforms,
              classNames,
              fullKey,
              out[import_helpers.StyleObjectIdentifier],
              !0,
              !0
            ));
          }
        } else {
          let mergeMediaStyle = function(key2, val2) {
            styleState.style ||= {}, mergeMediaByImportance(
              styleState,
              mediaKeyShort,
              key2,
              val2,
              usedKeys,
              mediaState[mediaKeyShort],
              importanceBump,
              debug
            ) && key2 === "fontFamily" && (styleState.fontFamily = mediaStyle.fontFamily);
          };
          const isThemeMedia = isMedia === "theme", isGroupMedia = isMedia === "group";
          if (!isThemeMedia && !(isMedia === "platform") && !isGroupMedia) {
            if (!mediaState[mediaKeyShort]) {
               false && 0;
              continue;
            }
             false && 0;
          }
          const mediaStyle = getSubStyle(styleState, key, val, !0);
          let importanceBump = 0;
          if (isThemeMedia) {
            dynamicThemeAccess = !0;
            const mediaThemeName = mediaKeyShort.slice(6);
            if (!(themeName === mediaThemeName || themeName.startsWith(mediaThemeName)))
              continue;
          } else if (isGroupMedia) {
            const groupInfo = (0, import_getGroupPropParts.getGroupPropParts)(mediaKeyShort), groupName = groupInfo.name, groupContext = context?.groups.state[groupName];
            if (!groupContext) {
               false && 0;
              continue;
            }
            const groupPseudoKey = groupInfo.pseudo, groupMediaKey = groupInfo.media, componentGroupState = componentState.group?.[groupName];
            if (groupMediaKey) {
              mediaGroups ||= /* @__PURE__ */ new Set(), mediaGroups.add(groupMediaKey);
              const mediaState2 = componentGroupState?.media;
              let isActive = mediaState2?.[groupMediaKey];
              if (!mediaState2 && groupContext.layout && (isActive = (0, import_useMedia.mediaKeyMatch)(groupMediaKey, groupContext.layout)),  false && 0, !isActive) {
                for (const pkey in mediaStyle)
                  applyDefaultStyle(pkey, styleState);
                continue;
              }
              importanceBump = 2;
            }
            if (groupPseudoKey) {
              pseudoGroups ||= /* @__PURE__ */ new Set(), pseudoGroups.add(groupName);
              const isActive = (componentGroupState || // fallback to context initially
              context.groups.state[groupName]).pseudo?.[groupPseudoKey], priority = import_pseudoDescriptors.pseudoPriorities[groupPseudoKey];
              if ( false && 0, !isActive) {
                for (const pkey in mediaStyle)
                  applyDefaultStyle(pkey, styleState);
                continue;
              }
              importanceBump = priority;
            }
          }
          for (const subKey in mediaStyle) {
            if (subKey === "space") {
              space = valInit.space;
              continue;
            }
            if (subKey[0] === "$") {
              if (!(0, import_isActivePlatform.isActivePlatform)(subKey))
                continue;
              for (const subSubKey in mediaStyle[subKey])
                mergeMediaStyle(subSubKey, mediaStyle[subKey][subSubKey]);
            } else
              mergeMediaStyle(subKey, mediaStyle[subKey]);
          }
        }
        continue;
      }
      if (
        // is HOC we can just pass through the styles as props
        // this fixes issues where style prop got merged with wrong priority
        !isHOC && isValidStyleKey(key, staticConfig)
      ) {
        mergeStyle(styleState, key, val);
        continue;
      }
      isVariant || (viewProps[key] = val);
    }
    if (false) {}
  }
  if (!(styleProps.noNormalize === !1) && (styleState.style && ((0, import_expandStyles.fixStyles)(styleState.style), import_constants.isWeb && !isReactNative && (0, import_getStylesAtomic.styleToCSS)(styleState.style)), styleState.flatTransforms && (styleState.style ||= {}, Object.entries(styleState.flatTransforms).sort(([a], [b]) => a.localeCompare(b)).forEach(([key, val]) => {
    mergeTransform(styleState.style, key, val, !0);
  })), parentSplitStyles)) {
    if (shouldDoClasses)
      for (const key in parentSplitStyles.classNames) {
        const val = parentSplitStyles.classNames[key];
        styleState.style && key in styleState.style || key in classNames || (classNames[key] = val);
      }
    if (!shouldDoClasses)
      for (const key in parentSplitStyles.style)
        key in classNames || styleState.style && key in styleState.style || (styleState.style ||= {}, styleState.style[key] = parentSplitStyles.style[key]);
  }
  if (!styleProps.noNormalize && !staticConfig.isReactNative && !staticConfig.isHOC && (!styleProps.isAnimated || conf.animations.supportsCSSVars) && Array.isArray(styleState.style?.transform) && (styleState.style.transform = (0, import_transformsToString.transformsToString)(styleState.style.transform)), styleState.style && shouldDoClasses) {
    let retainedStyles, shouldRetain = !1;
    if (!styleState.style.$$css) {
      const atomic = (0, import_getStylesAtomic.getStylesAtomic)(styleState.style);
      for (const atomicStyle of atomic) {
        const [key, value, identifier] = atomicStyle, isAnimatedAndAnimateOnly = styleProps.isAnimated && styleProps.noClassNames && (!props.animateOnly || props.animateOnly.includes(key)), nonAnimatedAnimateOnly = !isAnimatedAndAnimateOnly && !styleProps.isAnimated && props.animateOnly?.includes(key);
        isAnimatedAndAnimateOnly ? (retainedStyles ||= {}, retainedStyles[key] = styleState.style[key]) : nonAnimatedAnimateOnly ? (retainedStyles ||= {}, retainedStyles[key] = value, shouldRetain = !0) : (addStyleToInsertRules(rulesToInsert, atomicStyle), mergeClassName(transforms, classNames, key, identifier, !1, !0));
      }
       false && (0), (shouldRetain || "" !== "is_static") && (styleState.style = retainedStyles || {});
    }
    if (transforms)
      for (const namespace in transforms) {
        if (!transforms[namespace]) {
           false && 0;
          continue;
        }
        const [hash, val] = transforms[namespace], identifier = `_transform${hash}`;
        if (import_constants.isClient && !import_insertStyleRule.insertedTransforms[identifier]) {
          const rule = `.${identifier} { transform: ${val}; }`;
          addStyleToInsertRules(rulesToInsert, [
            namespace,
            val,
            identifier,
            void 0,
            [rule]
          ]);
        }
        classNames[namespace] = identifier;
      }
  }
  if (isReactNative)
    viewProps.tabIndex === 0 && (viewProps.accessible ??= !0);
  else if (viewProps.tabIndex == null) {
    const isFocusable = viewProps.focusable ?? viewProps.accessible;
    viewProps.focusable && delete viewProps.focusable;
    const role = viewProps.role;
    isFocusable === !1 && (viewProps.tabIndex = "-1"), // These native elements are focusable by default
    elementType === "a" || elementType === "button" || elementType === "input" || elementType === "select" || elementType === "textarea" ? (isFocusable === !1 || props.accessibilityDisabled === !0) && (viewProps.tabIndex = "-1") : (
      // These roles are made focusable by default
      (role === "button" || role === "checkbox" || role === "link" || role === "radio" || // @ts-expect-error (consistent with RNW)
      role === "textbox" || role === "switch") && isFocusable !== !1 && (viewProps.tabIndex = "0")
    ), isFocusable && (viewProps.tabIndex = "0", delete viewProps.focusable);
  }
  const styleProp = props.style;
  if (styleProp)
    if (isHOC)
      viewProps.style = normalizeStyle(styleProp);
    else {
      const isArray = Array.isArray(styleProp), len = isArray ? styleProp.length : 1;
      for (let i = 0; i < len; i++) {
        const style = isArray ? styleProp[i] : styleProp;
        style && (style.$$css ? Object.assign(styleState.classNames, style) : (styleState.style ||= {}, Object.assign(styleState.style, normalizeStyle(style))));
      }
    }
  const result = {
    space,
    hasMedia,
    fontFamily: styleState.fontFamily,
    viewProps,
    style: styleState.style,
    pseudos,
    classNames,
    rulesToInsert,
    dynamicThemeAccess,
    pseudoGroups,
    mediaGroups
  };
  if (!(asChild === "except-style" || asChild === "except-style-web")) {
    const style = styleState.style;
    {
      let fontFamily = isText || isInput ? styleState.fontFamily || staticConfig.defaultProps?.fontFamily : null;
      fontFamily && fontFamily[0] === "$" && (fontFamily = fontFamily.slice(1));
      const fontFamilyClassName = fontFamily ? `font_${fontFamily}` : "", groupClassName = props.group ? `t_group_${props.group}` : "", componentNameFinal = props.componentName || staticConfig.componentName, componentClassName = props.asChild || !componentNameFinal ? "" : `is_${componentNameFinal}`;
      let classList = [];
      componentClassName && classList.push(componentClassName), fontFamilyClassName && classList.push(fontFamilyClassName), classNames && classList.push(Object.values(classNames).join(" ")), groupClassName && classList.push(groupClassName), props.className && classList.push(props.className);
      const finalClassName = classList.join(" ");
      if (styleProps.noMergeStyle)
        finalClassName && (viewProps.className = finalClassName);
      else if (styleProps.isAnimated && !conf.animations.supportsCSSVars && isReactNative)
        style && (viewProps.style = style);
      else if (isReactNative) {
        const cnStyles = { $$css: !0 };
        for (const name of finalClassName.split(" "))
          cnStyles[name] = name;
        viewProps.style = [...Array.isArray(style) ? style : [style], cnStyles];
      } else
        finalClassName && (viewProps.className = finalClassName), style && (viewProps.style = style);
    }
  }
  if (false) {}
  return result;
};
function mergeClassName(transforms, classNames, key, val, isMediaOrPseudo = !1, isInsertingNow = !1) {
  if (val)
    if (!isInsertingNow && val[0] === "_" && val.startsWith("_transform-")) {
      const ns = isMediaOrPseudo ? key : "transform";
      let transform = import_insertStyleRule.insertedTransforms[val];
      import_constants.isClient && !transform && ((0, import_insertStyleRule.scanAllSheets)(), transform = import_insertStyleRule.insertedTransforms[val], !transform && import_constants.isWeb && val[0] !== "_" && (transform = val)), transforms[ns] ||= ["", ""], transforms[ns][0] += val.replace("_transform", ""), transform && (transforms[ns][1] += transform);
    } else
      classNames[key] = val;
}
function mergeStyle(styleState, key, val, disableNormalize = !1) {
  const { classNames, viewProps, usedKeys, styleProps, staticConfig } = styleState;
  if (import_constants.isWeb && val?.[0] === "_")
    classNames[key] = val, usedKeys[key] ||= 1;
  else if (key in import_helpers.stylePropsTransform)
    styleState.flatTransforms ||= {}, styleState.flatTransforms[key] = val;
  else {
    const out = import_constants.isWeb && !disableNormalize && !styleProps.noNormalize ? (0, import_normalizeValueWithProperty.normalizeValueWithProperty)(val, key) : val;
    // accept is for props not styles
    staticConfig.accept && key in staticConfig.accept ? viewProps[key] = out : (styleState.style ||= {}, styleState.style[key] = out);
  }
}
const getSubStyle = (styleState, subKey, styleIn, avoidMergeTransform) => {
  const { staticConfig, conf: conf2, styleProps } = styleState, styleOut = {};
  for (let key in styleIn) {
    const val = styleIn[key];
    key = conf2.shorthands[key] || key;
    const expanded = (0, import_propMapper.propMapper)(key, val, styleState);
    if (!(!expanded || !staticConfig.isHOC && key in import_skipProps.skipProps && !styleProps.noSkip))
      for (const [skey, sval] of expanded)
        !avoidMergeTransform && skey in import_helpers.stylePropsTransform ? mergeTransform(styleOut, skey, sval) : styleOut[skey] = styleProps.noNormalize ? sval : (0, import_normalizeValueWithProperty.normalizeValueWithProperty)(sval, key);
  }
  return styleProps.noNormalize || (0, import_expandStyles.fixStyles)(styleOut), styleOut;
}, useInsertEffectCompat = import_constants.isWeb ? import_react.default.useInsertionEffect || import_constants.useIsomorphicLayoutEffect : () => {
}, useSplitStyles = (a, b, c, d, e, f, g, h, i, j) => {
  conf = conf || (0, import_config.getConfig)();
  const res = getSplitStyles(a, b, c, d, e, f, g, h, i, j);
  return process.env.TAMAGUI_REACT_19 || useInsertEffectCompat(() => {
    (0, import_insertStyleRule.insertStyleRules)(res.rulesToInsert);
  }, [res.rulesToInsert]), res;
};
function addStyleToInsertRules(rulesToInsert, styleObject) {
  {
    const identifier = styleObject[import_helpers.StyleObjectIdentifier];
    process.env.TAMAGUI_REACT_19 || (0, import_insertStyleRule.shouldInsertStyleRules)(identifier) && (0, import_insertStyleRule.updateRules)(identifier, styleObject[import_helpers.StyleObjectRules]), rulesToInsert[identifier] = styleObject;
  }
}
function processIDRefList(idRefList) {
  return Array.isArray(idRefList) ? idRefList.join(" ") : idRefList;
}
const defaultColor = process.env.TAMAGUI_DEFAULT_COLOR || "rgba(0,0,0,0)", animatableDefaults = {
  ...Object.fromEntries(
    Object.entries(import_helpers.tokenCategories.color).map(([k, v]) => [k, defaultColor])
  ),
  opacity: 1,
  scale: 1,
  rotate: "0deg",
  rotateY: "0deg",
  rotateX: "0deg",
  x: 0,
  y: 0,
  borderRadius: 0
}, lowercaseHyphenate = (match) => `-${match.toLowerCase()}`, hyphenate = (str) => str.replace(/[A-Z]/g, lowercaseHyphenate), mergeTransform = (obj, key, val, backwards = !1) => {
  typeof obj.transform != "string" && (obj.transform ||= [], obj.transform[backwards ? "unshift" : "push"]({
    [mapTransformKeys[key] || key]: val
  }));
}, mapTransformKeys = {
  x: "translateX",
  y: "translateY"
}, accessibilityRoleToWebRole = {
  adjustable: "slider",
  header: "heading",
  image: "img",
  link: "link",
  none: "presentation",
  summary: "region"
};
function passDownProp(viewProps, key, val, shouldMergeObject = !1) {
  if (shouldMergeObject) {
    const next = {
      ...viewProps[key],
      ...val
    };
    delete viewProps[key], viewProps[key] = next;
  } else
    viewProps[key] = val;
}
function mergeMediaByImportance(styleState, mediaKey, key, value, importancesUsed, isSizeMedia, importanceBump, debugProp) {
  let importance = (0, import_useMedia.getMediaImportanceIfMoreImportant)(
    mediaKey,
    key,
    importancesUsed,
    isSizeMedia
  );
  if (importanceBump && (importance = (importance || 0) + importanceBump),  false && 0, importance === null)
    return !1;
  if (importancesUsed[key] = importance, key in import_pseudoDescriptors.pseudoDescriptors) {
    const descriptor = import_pseudoDescriptors.pseudoDescriptors[key], descriptorKey = descriptor.stateKey || descriptor.name;
    if (styleState.componentState[descriptorKey] === !1)
      return !1;
    for (const subKey in value)
      mergeStyle(styleState, subKey, value[subKey]);
  } else
    mergeStyle(styleState, key, value);
  return !0;
}
function normalizeStyle(style) {
  const out = {};
  for (const key in style) {
    const val = style[key];
    key in import_helpers.stylePropsTransform ? mergeTransform(out, key, val) : out[key] = (0, import_normalizeValueWithProperty.normalizeValueWithProperty)(val, key);
  }
  return import_constants.isWeb && Array.isArray(out.transform) && (out.transform = (0, import_transformsToString.transformsToString)(out.transform)), (0, import_expandStyles.fixStyles)(out), out;
}
function applyDefaultStyle(pkey, styleState) {
  const defaultValues = animatableDefaults[pkey];
  defaultValues != null && !(pkey in styleState.usedKeys) && (!styleState.style || !(pkey in styleState.style)) && mergeStyle(styleState, pkey, defaultValues);
}
//# sourceMappingURL=getSplitStyles.js.map


/***/ }),

/***/ 12538:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var getStylesAtomic_exports = {};
__export(getStylesAtomic_exports, {
  getStyleAtomic: () => getStyleAtomic,
  getStylesAtomic: () => getStylesAtomic,
  styleToCSS: () => styleToCSS
});
module.exports = __toCommonJS(getStylesAtomic_exports);
var import_helpers = __webpack_require__(89953), import_config = __webpack_require__(98211), import_defaultOffset = __webpack_require__(20816), import_normalizeColor = __webpack_require__(66503), import_normalizeValueWithProperty = __webpack_require__(29681), import_pseudoDescriptors = __webpack_require__(71721), import_transformsToString = __webpack_require__(73488), import_useMedia = __webpack_require__(31094);
function getStylesAtomic(style) {
  styleToCSS(style);
  const out = [];
  for (const key in style) {
    const val = style[key];
    if (key in import_pseudoDescriptors.pseudoDescriptors)
      val && out.push(...getStyleAtomic(val, import_pseudoDescriptors.pseudoDescriptors[key]));
    else if ((0, import_useMedia.isMediaKey)(key))
      for (const subKey in val) {
        const so = getStyleObject(val, subKey);
        so && (so[0] = key, out.push(so));
      }
    else {
      const so = getStyleObject(style, key);
      so && out.push(so);
    }
  }
  return out;
}
const getStyleAtomic = (style, pseudo) => {
  styleToCSS(style);
  const out = [];
  for (const key in style) {
    const so = getStyleObject(style, key, pseudo);
    so && out.push(so);
  }
  return out;
};
let conf;
const getStyleObject = (style, key, pseudo) => {
  let val = style[key];
  if (val == null) return;
  key === "transform" && Array.isArray(style.transform) && (val = (0, import_transformsToString.transformsToString)(val));
  const value = (0, import_normalizeValueWithProperty.normalizeValueWithProperty)(val, key), hash = (0, import_helpers.simpleHash)(`${value}`), pseudoPrefix = pseudo ? `0${pseudo.name}-` : "";
  conf ||= (0, import_config.getConfig)();
  const identifier = `_${conf.inverseShorthands[key] || key}-${pseudoPrefix}${hash}`, rules = createAtomicRules(identifier, key, value, pseudo);
  return [
    // array for performance
    key,
    value,
    identifier,
    pseudo?.name,
    rules
  ];
};
function styleToCSS(style) {
  const { shadowOffset, shadowRadius, shadowColor, shadowOpacity } = style;
  if (shadowRadius || shadowColor) {
    const offset = shadowOffset || import_defaultOffset.defaultOffset, width = (0, import_normalizeValueWithProperty.normalizeValueWithProperty)(offset.width), height = (0, import_normalizeValueWithProperty.normalizeValueWithProperty)(offset.height), radius = (0, import_normalizeValueWithProperty.normalizeValueWithProperty)(shadowRadius), color = (0, import_normalizeColor.normalizeColor)(shadowColor, shadowOpacity), shadow = `${width} ${height} ${radius} ${color}`;
    style.boxShadow = style.boxShadow ? `${style.boxShadow}, ${shadow}` : shadow, delete style.shadowOffset, delete style.shadowRadius, delete style.shadowColor, delete style.shadowOpacity;
  }
  const { textShadowColor, textShadowOffset, textShadowRadius } = style;
  if (textShadowColor || textShadowOffset || textShadowRadius) {
    const { height, width } = textShadowOffset || import_defaultOffset.defaultOffset, radius = textShadowRadius || 0, color = (0, import_normalizeValueWithProperty.normalizeValueWithProperty)(textShadowColor, "textShadowColor");
    if (color && (height !== 0 || width !== 0 || radius !== 0)) {
      const blurRadius = (0, import_normalizeValueWithProperty.normalizeValueWithProperty)(radius), offsetX = (0, import_normalizeValueWithProperty.normalizeValueWithProperty)(width), offsetY = (0, import_normalizeValueWithProperty.normalizeValueWithProperty)(height);
      style.textShadow = `${offsetX} ${offsetY} ${blurRadius} ${color}`;
    }
    delete style.textShadowColor, delete style.textShadowOffset, delete style.textShadowRadius;
  }
}
function createDeclarationBlock(style, important = !1) {
  let next = "";
  for (const [key, value] of style)
    next += `${hyphenateStyleName(key)}:${value}${important ? " !important" : ""};`;
  return `{${next}}`;
}
const hcache = {}, toHyphenLower = (match) => `-${match.toLowerCase()}`, hyphenateStyleName = (key) => {
  if (key in hcache) return hcache[key];
  const val = key.replace(/[A-Z]/g, toHyphenLower);
  return hcache[key] = val, val;
}, selectorPriority = (() => {
  const res = {};
  for (const key in import_pseudoDescriptors.pseudoDescriptors) {
    const pseudo = import_pseudoDescriptors.pseudoDescriptors[key];
    res[pseudo.name] = `${[...Array(pseudo.priority)].map(() => ":root").join("")} `;
  }
  return res;
})();
function createAtomicRules(identifier, property, value, pseudo) {
  const pseudoIdPostfix = pseudo ? pseudo.name === "disabled" ? "[aria-disabled]" : `:${pseudo.name}` : "", pseudoSelector = pseudo?.selector;
  let selector = pseudo ? pseudoSelector ? `${pseudoSelector} .${identifier}` : `${selectorPriority[pseudo.name]} .${identifier}${pseudoIdPostfix}` : `:root .${identifier}`;
  pseudoSelector === import_pseudoDescriptors.pseudoDescriptors.enterStyle.selector && (selector = `${selector}, .${identifier}${pseudoSelector}`);
  const important = !!pseudo;
  let rules = [];
  switch (property) {
    case "placeholderTextColor": {
      const block = createDeclarationBlock(
        [
          ["color", value],
          ["opacity", 1]
        ],
        important
      );
      rules.push(`${selector}::placeholder${block}`);
      break;
    }
    case "backgroundClip":
    case "userSelect": {
      const webkitProperty = `Webkit${`${property[0].toUpperCase()}${property.slice(1)}`}`, block = createDeclarationBlock(
        [
          [property, value],
          [webkitProperty, value]
        ],
        important
      );
      rules.push(`${selector}${block}`);
      break;
    }
    case "pointerEvents": {
      let finalValue = value;
      value === "auto" || value === "box-only" ? (finalValue = "auto", value === "box-only" && rules.push(`${selector}>*${boxOnly}`)) : (value === "none" || value === "box-none") && (finalValue = "none", value === "box-none" && rules.push(`${selector}>*${boxNone}`));
      const block = createDeclarationBlock([["pointerEvents", finalValue]], !0);
      rules.push(`${selector}${block}`);
      break;
    }
    default: {
      const block = createDeclarationBlock([[property, value]], important);
      rules.push(`${selector}${block}`);
      break;
    }
  }
  return pseudo?.name === "hover" && (rules = rules.map((r) => `@media (hover) {${r}}`)), rules;
}
const boxNone = createDeclarationBlock([["pointerEvents", "auto"]], !0), boxOnly = createDeclarationBlock([["pointerEvents", "none"]], !0);
//# sourceMappingURL=getStylesAtomic.js.map


/***/ }),

/***/ 42274:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(73656);
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var getThemeCSSRules_exports = {};
__export(getThemeCSSRules_exports, {
  getThemeCSSRules: () => getThemeCSSRules
});
module.exports = __toCommonJS(getThemeCSSRules_exports);
var import_helpers = __webpack_require__(89953), import_constants = __webpack_require__(24881), import_createVariable = __webpack_require__(68836), import_registerCSSVariable = __webpack_require__(2277), import_config = __webpack_require__(98211);
const darkLight = ["dark", "light"], lightDark = ["light", "dark"];
function getThemeCSSRules(props) {
  const cssRuleSets = [];
  if (!process.env.TAMAGUI_DOES_SSR_CSS || process.env.TAMAGUI_DOES_SSR_CSS === "mutates-themes" || process.env.TAMAGUI_DOES_SSR_CSS === "false") {
    const { config, themeName, theme, names } = props, hasDarkLight = props.hasDarkLight ?? (config.themes && ("light" in config.themes || "dark" in config.themes)), CNP = `.${import_constants.THEME_CLASSNAME_PREFIX}`;
    let vars = "";
    for (const themeKey in theme) {
      const variable = theme[themeKey];
      let value = null;
      import_registerCSSVariable.tokensValueToVariable.has(variable.val) ? value = import_registerCSSVariable.tokensValueToVariable.get(variable.val).variable : value = variable.val, vars += `--${process.env.TAMAGUI_CSS_VARIABLE_PREFIX || ""}${(0, import_helpers.simpleHash)(
        themeKey,
        40
      )}:${value};`;
    }
    const isDarkBase = themeName === "dark", isLightBase = themeName === "light", baseSelectors = names.map((name) => `${CNP}${name}`), selectorsSet = new Set(isDarkBase || isLightBase ? baseSelectors : []);
    if (hasDarkLight) {
      const maxDepth = (0, import_config.getSetting)("maxDarkLightNesting") ?? 3;
      for (const subName of names) {
        const isDark = isDarkBase || subName.startsWith("dark_"), isLight = !isDark && (isLightBase || subName.startsWith("light_"));
        if (!(isDark || isLight)) {
          selectorsSet.add(`${CNP}${subName}`);
          continue;
        }
        const childSelector = `${CNP}${subName.replace(/^(dark|light)_/, "")}`, order = isDark ? darkLight : lightDark, [stronger, weaker] = order, numSelectors = Math.round(maxDepth * 1.5);
        for (let depth = 0; depth < numSelectors; depth++) {
          const isOdd = depth % 2 === 1;
          if (isOdd && depth < 3)
            continue;
          const parents = new Array(depth + 1).fill(0).map((_, idx) => `${CNP}${idx % 2 === 0 ? stronger : weaker}`);
          let parentSelectors = parents.length > 1 ? parents.slice(1) : parents;
          if (isOdd) {
            const [_first, second, ...rest] = parentSelectors;
            parentSelectors = [second, ...rest, second];
          }
          const lastParentSelector = parentSelectors[parentSelectors.length - 1], nextChildSelector = childSelector === lastParentSelector ? "" : childSelector, parentSelectorString = parentSelectors.join(" ");
          selectorsSet.add(`${parentSelectorString} ${nextChildSelector}`);
        }
      }
    }
    const selectors = [...selectorsSet].sort((a, b) => a.localeCompare(b)), css = `${selectors.map((x) => `:root${isBaseTheme(x) && (0, import_config.getSetting)("themeClassNameOnRoot") ? "" : " "}${x}`).join(", ")} {${vars}}`;
    if (cssRuleSets.push(css), (0, import_config.getSetting)("shouldAddPrefersColorThemes")) {
      const bgString = theme.background ? `background:${(0, import_createVariable.variableToString)(theme.background)};` : "", fgString = theme.color ? `color:${(0, import_createVariable.variableToString)(theme.color)}` : "", bodyRules = `body{${bgString}${fgString}}`, isDark = themeName.startsWith("dark"), baseName = isDark ? "dark" : "light", themeRules = `${selectors.map((x) => {
        if (x == darkSelector || x === lightSelector) return ":root";
        if (!(isDark && x.startsWith(lightSelector) || !isDark && x.startsWith(darkSelector)))
          return x.replace(/^\.t_(dark|light) /, "").trim();
      }).filter(Boolean).join(", ")} {${vars}}`, prefersMediaSelectors = `@media(prefers-color-scheme:${baseName}){
    ${bodyRules}
    ${themeRules}
  }`;
      cssRuleSets.push(prefersMediaSelectors);
    }
    const selectionStyles = (0, import_config.getSetting)("selectionStyles");
    if (selectionStyles) {
      const rules = selectionStyles(theme);
      if (rules) {
        const selectionSelectors = baseSelectors.map((s) => `${s} ::selection`).join(", "), styles = Object.entries(rules).flatMap(
          ([k, v]) => v ? `${k === "backgroundColor" ? "background" : k}:${(0, import_createVariable.variableToString)(v)}` : []
        ).join(";");
        if (styles) {
          const css2 = `${selectionSelectors}{${styles}}`;
          cssRuleSets.push(css2);
        }
      }
    }
  }
  return cssRuleSets;
}
const darkSelector = ".t_dark", lightSelector = ".t_light", isBaseTheme = (x) => x === darkSelector || x === lightSelector || x.startsWith(".t_dark ") || x.startsWith(".t_light ");
//# sourceMappingURL=getThemeCSSRules.js.map


/***/ }),

/***/ 17419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var getVariantExtras_exports = {};
__export(getVariantExtras_exports, {
  getFontsForLanguage: () => getFontsForLanguage,
  getVariantExtras: () => getVariantExtras
});
module.exports = __toCommonJS(getVariantExtras_exports);
var import_createVariable = __webpack_require__(68836);
const cache = /* @__PURE__ */ new WeakMap(), getVariantExtras = (styleState) => {
  if (cache.has(styleState))
    return cache.get(styleState);
  const { props, conf, context, theme } = styleState;
  let fonts = conf.fontsParsed;
  context?.language && (fonts = getFontsForLanguage(conf.fontsParsed, context.language));
  const next = {
    fonts,
    tokens: conf.tokensParsed,
    theme,
    get fontFamily() {
      return (0, import_createVariable.getVariableValue)(styleState.fontFamily || styleState.props.fontFamily) || props.fontFamily || (0, import_createVariable.getVariableValue)(styleState.conf.defaultFont);
    },
    get font() {
      return fonts[this.fontFamily] || (!props.fontFamily || props.fontFamily[0] === "$" ? fonts[styleState.conf.defaultFont] : void 0);
    },
    props
  };
  return cache.set(styleState, next), next;
}, fontLanguageCache = /* @__PURE__ */ new WeakMap();
function getFontsForLanguage(fonts, language) {
  if (fontLanguageCache.has(language))
    return fontLanguageCache.get(language);
  const next = {
    ...fonts,
    ...Object.fromEntries(
      Object.entries(language).map(([name, lang]) => {
        if (lang === "default")
          return [];
        const langKey = `$${name}_${lang}`;
        return [`$${name}`, fonts[langKey]];
      })
    )
  };
  return fontLanguageCache.set(language, next), next;
}
//# sourceMappingURL=getVariantExtras.js.map


/***/ }),

/***/ 55915:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(73656);
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var insertStyleRule_exports = {};
__export(insertStyleRule_exports, {
  getAllRules: () => getAllRules,
  getAllSelectors: () => getAllSelectors,
  getAllTransforms: () => getAllTransforms,
  insertStyleRules: () => insertStyleRules,
  insertedTransforms: () => insertedTransforms,
  listenForSheetChanges: () => listenForSheetChanges,
  scanAllSheets: () => scanAllSheets,
  setNonce: () => setNonce,
  shouldInsertStyleRules: () => shouldInsertStyleRules,
  updateRules: () => updateRules
});
module.exports = __toCommonJS(insertStyleRule_exports);
var import_constants = __webpack_require__(77505), import_helpers = __webpack_require__(89953), import_createVariable = __webpack_require__(68836);
const scannedCache = /* @__PURE__ */ new WeakMap(), totalSelectorsInserted = /* @__PURE__ */ new Map(), allSelectors = {}, allRules = {}, insertedTransforms = {}, getAllSelectors = () => allSelectors, getAllRules = () => Object.values(allRules), getAllTransforms = () => insertedTransforms;
function addTransform(identifier, css, rule) {
  const s = css.indexOf("transform:");
  if (s === -1) {
     false && 0;
    return;
  }
  const startI = s + 10, endI = css.indexOf(";"), value = css.slice(startI, endI);
  if (!insertedTransforms[identifier])
    return insertedTransforms[identifier] = value, !0;
}
function listenForSheetChanges() {
  if (!import_constants.isClient) return;
  new MutationObserver((entries) => {
    for (const entry of entries)
      if (entry instanceof HTMLStyleElement && entry.sheet || entry instanceof HTMLLinkElement && entry.href.endsWith(".css")) {
        scanAllSheets();
        break;
      }
  }).observe(document.head, {
    childList: !0
  });
}
let lastScannedSheets = null;
function scanAllSheets(collectThemes = !1, tokens) {
  if ( false || !import_constants.isClient) return;
  let themes;
  const sheets = document.styleSheets || [], prev = lastScannedSheets, current = new Set(sheets);
  if (document.styleSheets) {
    for (const sheet2 of current)
      if (sheet2) {
        const out = updateSheetStyles(sheet2, !1, collectThemes, tokens);
        out && (themes = out);
      }
    lastScannedSheets = current;
  }
  if (prev)
    for (const sheet2 of prev)
      sheet2 && !current.has(sheet2) && updateSheetStyles(sheet2, !0);
  return themes;
}
function track(id, remove = !1) {
  const next = (totalSelectorsInserted.get(id) || 0) + (remove ? -1 : 1);
  return totalSelectorsInserted.set(id, next), next;
}
const bailAfterEnv = process.env.TAMAGUI_BAIL_AFTER_SCANNING_X_CSS_RULES, bailAfter = bailAfterEnv ? +bailAfterEnv : 250;
function updateSheetStyles(sheet2, remove = !1, collectThemes = !1, tokens) {
  let rules;
  try {
    if (rules = sheet2.cssRules, !rules)
      return;
  } catch {
    return;
  }
  const firstSelector = getTamaguiSelector(rules[0], collectThemes)?.[0], lastSelector = getTamaguiSelector(rules[rules.length - 1], collectThemes)?.[0], cacheKey = `${rules.length}${firstSelector}${lastSelector}`, lastScanned = scannedCache.get(sheet2);
  if (!remove && lastScanned === cacheKey)
    return;
  const len = rules.length;
  let fails = 0, dedupedThemes;
  for (let i = 0; i < len; i++) {
    const rule = rules[i];
    if (!(rule instanceof CSSStyleRule)) continue;
    const response = getTamaguiSelector(rule, collectThemes);
    if (response)
      fails = 0;
    else {
      if (fails++, fails > bailAfter)
        return;
      continue;
    }
    const [identifier, cssRule, isTheme] = response;
    if (isTheme) {
      const deduped = addThemesFromCSS(cssRule, tokens);
      deduped && (dedupedThemes ||= [], dedupedThemes.push(deduped));
      continue;
    }
    if (!process.env.TAMAGUI_REACT_19) {
      const total = track(identifier, remove);
      remove ? total === 0 && delete allSelectors[identifier] : identifier in allSelectors || (!identifier.startsWith("_transform-") || addTransform(identifier, cssRule.cssText, cssRule)) && (allSelectors[identifier] = cssRule.cssText);
    }
  }
  return scannedCache.set(sheet2, cacheKey), dedupedThemes;
}
let colorVarToVal, rootComputedStyle = null;
function addThemesFromCSS(cssStyleRule, tokens) {
  const selectors = cssStyleRule.selectorText.split(",");
  if (!selectors.length) return;
  if (tokens && !colorVarToVal) {
    colorVarToVal = {};
    for (const key in tokens.color) {
      const token = tokens.color[key];
      colorVarToVal[token.name] = token.val;
    }
  }
  const rules = (cssStyleRule.cssText || "").slice(
    cssStyleRule.selectorText.length + 2,
    -1
  ).split(";"), values = {};
  for (const rule of rules) {
    const sepI = rule.indexOf(":");
    if (sepI === -1) continue;
    const varIndex = rule.indexOf("--");
    let key = rule.slice(varIndex === -1 ? 0 : varIndex + 2, sepI);
    process.env.TAMAGUI_CSS_VARIABLE_PREFIX && (key = key.replace(process.env.TAMAGUI_CSS_VARIABLE_PREFIX, ""));
    const val = rule.slice(sepI + 2);
    let value;
    if (val[0] === "v" && val.startsWith("var(")) {
      const varName = val.slice(6, -1), tokenVal = colorVarToVal[varName];
      tokenVal ? value = tokenVal : (rootComputedStyle ||= getComputedStyle(document.body), value = rootComputedStyle.getPropertyValue("--" + varName));
    } else
      value = val;
    values[key] = (0, import_createVariable.createVariable)(
      {
        key,
        name: key,
        val: value
      },
      !0
    );
  }
  const names = /* @__PURE__ */ new Set();
  for (const selector of selectors) {
    const lastThemeSelectorIndex = selector.lastIndexOf(".t_"), name = selector.slice(lastThemeSelectorIndex).slice(3), [schemeChar] = selector[lastThemeSelectorIndex - 5], scheme = schemeChar === "d" ? "dark" : schemeChar === "i" ? "light" : "", themeName = scheme && scheme !== name ? `${scheme}_${name}` : name;
    !themeName || themeName === "light_dark" || themeName === "dark_light" || names.add(themeName);
  }
  return {
    names: [...names],
    theme: values
  };
}
function getTamaguiSelector(rule, collectThemes = !1) {
  if (rule instanceof CSSStyleRule) {
    const text = rule.selectorText;
    if (text[0] === ":" && text[1] === "r") {
      if (text.startsWith(":root ._"))
        return [getIdentifierFromTamaguiSelector(text), rule];
      if (collectThemes && (text.startsWith(":root.t_") || text.startsWith(":root .t_")))
        return [
          text.slice(0, 20),
          // just used as uid
          rule,
          !0
        ];
    }
  } else if (rule instanceof CSSMediaRule)
    return rule.cssRules.length > 1 ? void 0 : getTamaguiSelector(rule.cssRules[0]);
}
const getIdentifierFromTamaguiSelector = (selector) => {
  const dotIndex = selector.indexOf(":");
  return dotIndex > -1 ? selector.slice(7, dotIndex) : selector.slice(7);
};
let sheet = null;
function updateRules(identifier, rules) {
  if (!process.env.TAMAGUI_REACT_19)
    return identifier in allRules ? !1 : (allRules[identifier] = rules.join(" "), identifier.startsWith("_transform-") ? addTransform(identifier, rules[0]) : !0);
}
let nonce = "";
function setNonce(_) {
  nonce = _;
}
function insertStyleRules(rulesToInsert) {
  if (!process.env.TAMAGUI_REACT_19) {
    if (!sheet && import_constants.isClient && document.head) {
      const styleTag = document.createElement("style");
      nonce && (styleTag.nonce = nonce), sheet = document.head.appendChild(styleTag).sheet;
    }
    if (!sheet) return;
    for (const key in rulesToInsert) {
      const styleObject = rulesToInsert[key], identifier = styleObject[import_helpers.StyleObjectIdentifier];
      if (!shouldInsertStyleRules(identifier))
        continue;
      const rules = styleObject[import_helpers.StyleObjectRules];
      allSelectors[identifier] = rules.join(`
`), track(identifier), updateRules(identifier, rules);
      for (const rule of rules)
        if (true)
          try {
            sheet.insertRule(rule, sheet.cssRules.length);
          } catch (err) {
            console.error("Error inserting CSS", err);
          }
        else
          {}
    }
  }
}
const minInsertAmt = process.env.TAMAGUI_INSERT_SELECTOR_TRIES ? +process.env.TAMAGUI_INSERT_SELECTOR_TRIES : 1;
function shouldInsertStyleRules(identifier) {
  if (process.env.TAMAGUI_REACT_19)
    return !0;
  {
    if (false)
      {}
    const total = totalSelectorsInserted.get(identifier);
    return  false && 0, total === void 0 || total < minInsertAmt;
  }
}
//# sourceMappingURL=insertStyleRule.js.map


/***/ }),

/***/ 16565:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var isActivePlatform_exports = {};
__export(isActivePlatform_exports, {
  isActivePlatform: () => isActivePlatform
});
module.exports = __toCommonJS(isActivePlatform_exports);
var import_constants = __webpack_require__(77505);
function isActivePlatform(key) {
  const platform = key.slice(10);
  return (
    // web, ios, android
    platform === import_constants.currentPlatform || // web, native
    platform === "web"
  );
}
//# sourceMappingURL=isActivePlatform.js.map


/***/ }),

/***/ 91032:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var isObj_exports = {};
__export(isObj_exports, {
  isObj: () => isObj
});
module.exports = __toCommonJS(isObj_exports);
const isObj = (x) => x && !Array.isArray(x) && typeof x == "object";
//# sourceMappingURL=isObj.js.map


/***/ }),

/***/ 20023:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var isTamaguiComponent_exports = {};
__export(isTamaguiComponent_exports, {
  isTamaguiComponent: () => isTamaguiComponent
});
module.exports = __toCommonJS(isTamaguiComponent_exports);
function isTamaguiComponent(comp, name) {
  const config = comp?.staticConfig;
  return !!(config && (!name || name === config.componentName));
}
//# sourceMappingURL=isTamaguiComponent.js.map


/***/ }),

/***/ 33224:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var isTamaguiElement_exports = {};
__export(isTamaguiElement_exports, {
  isTamaguiElement: () => isTamaguiElement
});
module.exports = __toCommonJS(isTamaguiElement_exports);
var import_react = __toESM(__webpack_require__(44194)), import_isTamaguiComponent = __webpack_require__(20023);
const isTamaguiElement = (child, name) => import_react.default.isValidElement(child) && (0, import_isTamaguiComponent.isTamaguiComponent)(child.type, name);
//# sourceMappingURL=isTamaguiElement.js.map


/***/ }),

/***/ 50265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var log_exports = {};
__export(log_exports, {
  log: () => log
});
module.exports = __toCommonJS(log_exports);
var import_useMedia = __webpack_require__(31094);
function log(...args) {
  if (false) {}
}
//# sourceMappingURL=log.js.map


/***/ }),

/***/ 53960:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var matchMedia_exports = {};
__export(matchMedia_exports, {
  matchMedia: () => matchMedia,
  setupMatchMedia: () => setupMatchMedia
});
module.exports = __toCommonJS(matchMedia_exports);
const matchMedia = typeof window < "u" && window.matchMedia || matchMediaFallback;
function matchMediaFallback(_) {
  return {
    match: (a, b) => !1,
    addListener() {
    },
    removeListener() {
    },
    matches: !1
  };
}
function setupMatchMedia(_) {
}
//# sourceMappingURL=matchMedia.js.map


/***/ }),

/***/ 60355:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var mergeProps_exports = {};
__export(mergeProps_exports, {
  mergeProps: () => mergeProps
});
module.exports = __toCommonJS(mergeProps_exports);
var import_useMedia = __webpack_require__(31094), import_pseudoDescriptors = __webpack_require__(71721);
const mergeProps = (a, b, inverseShorthands) => {
  const out = {};
  for (const key in a)
    mergeProp(out, a, b, key, inverseShorthands);
  if (b)
    for (const key in b)
      mergeProp(out, b, void 0, key, inverseShorthands);
  return out;
};
function mergeProp(out, a, b, key, inverseShorthands) {
  const longhand = inverseShorthands?.[key] || null, val = a[key];
  if (key in import_pseudoDescriptors.pseudoDescriptors || import_useMedia.mediaKeys.has(key)) {
    out[key] = {
      ...out[key],
      ...val
    };
    return;
  }
  b && (key in b || longhand && longhand in b) || (out[longhand || key] = val);
}
//# sourceMappingURL=mergeProps.js.map


/***/ }),

/***/ 61686:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var mergeVariants_exports = {};
__export(mergeVariants_exports, {
  mergeVariants: () => mergeVariants
});
module.exports = __toCommonJS(mergeVariants_exports);
const mergeVariants = (parentVariants, ourVariants, level = 0) => {
  const variants = {};
  for (const key in ourVariants) {
    const parentVariant = parentVariants?.[key], ourVariant = ourVariants[key];
    !parentVariant || typeof ourVariant == "function" ? variants[key] = ourVariant : parentVariant && !ourVariant ? variants[key] = parentVariant[key] : level === 0 ? variants[key] = mergeVariants(
      parentVariant,
      ourVariant,
      level + 1
    ) : variants[key] = {
      ...parentVariant,
      ...ourVariant
    };
  }
  return {
    ...parentVariants,
    ...variants
  };
};
//# sourceMappingURL=mergeVariants.js.map


/***/ }),

/***/ 66503:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var normalizeColor_exports = {};
__export(normalizeColor_exports, {
  getRgba: () => getRgba,
  normalizeColor: () => normalizeColor,
  rgba: () => import_normalize_css_color2.rgba
});
module.exports = __toCommonJS(normalizeColor_exports);
var import_normalize_css_color = __webpack_require__(73225), import_normalize_css_color2 = __webpack_require__(73225);
const normalizeColor = (color, opacity) => {
  if (color) {
    if (color[0] === "$") return color;
    if (color.startsWith("var(")) {
      if (typeof opacity == "number" && opacity < 1)
        return `color-mix(in srgb, ${color} ${opacity * 100}%, transparent)`;
    } else {
      const rgba3 = getRgba(color);
      if (rgba3) {
        const colors = `${rgba3.r},${rgba3.g},${rgba3.b}`;
        return opacity === 1 ? `rgb(${colors})` : `rgba(${colors},${opacity ?? rgba3.a ?? 1})`;
      }
    }
    return color;
  }
}, getRgba = (color) => {
  const colorNum = (0, import_normalize_css_color.normalizeCSSColor)(color);
  if (colorNum != null)
    return (0, import_normalize_css_color.rgba)(colorNum);
};
//# sourceMappingURL=normalizeColor.js.map


/***/ }),

/***/ 64040:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var normalizeShadow_exports = {};
__export(normalizeShadow_exports, {
  normalizeShadow: () => normalizeShadow
});
module.exports = __toCommonJS(normalizeShadow_exports);
var import_defaultOffset = __webpack_require__(20816), import_normalizeColor = __webpack_require__(66503);
function normalizeShadow({
  shadowColor,
  shadowOffset,
  shadowOpacity,
  shadowRadius
}) {
  const { height, width } = shadowOffset || import_defaultOffset.defaultOffset;
  return {
    shadowOffset: {
      width: width || 0,
      height: height || 0
    },
    shadowRadius: shadowRadius || 0,
    shadowColor: (0, import_normalizeColor.normalizeColor)(shadowColor, 1),
    shadowOpacity: shadowOpacity ?? (shadowColor ? (0, import_normalizeColor.getRgba)(shadowColor)?.a : 1)
  };
}
//# sourceMappingURL=normalizeShadow.js.map


/***/ }),

/***/ 84423:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var normalizeStyle_exports = {};
__export(normalizeStyle_exports, {
  normalizeStyle: () => normalizeStyle
});
module.exports = __toCommonJS(normalizeStyle_exports);
var import_expandStyle = __webpack_require__(7943), import_expandStyles = __webpack_require__(87138), import_isObj = __webpack_require__(91032), import_normalizeValueWithProperty = __webpack_require__(29681), import_pseudoDescriptors = __webpack_require__(71721);
function normalizeStyle(style, disableNormalize = !1) {
  const res = {};
  for (let key in style) {
    const prop = style[key];
    if (prop == null) continue;
    if (key in import_pseudoDescriptors.pseudoDescriptors || // this should capture all parent-based styles like media, group, etc
    key[0] === "$" && (0, import_isObj.isObj)(prop)) {
      res[key] = normalizeStyle(prop, disableNormalize);
      continue;
    }
    const value = disableNormalize ? prop : (0, import_normalizeValueWithProperty.normalizeValueWithProperty)(prop, key), out = (0, import_expandStyle.expandStyle)(key, value);
    out ? Object.assign(res, Object.fromEntries(out)) : res[key] = value;
  }
  return (0, import_expandStyles.fixStyles)(res), res;
}
//# sourceMappingURL=normalizeStyle.js.map


/***/ }),

/***/ 29681:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var normalizeValueWithProperty_exports = {};
__export(normalizeValueWithProperty_exports, {
  normalizeValueWithProperty: () => normalizeValueWithProperty,
  reverseMapClassNameToValue: () => reverseMapClassNameToValue
});
module.exports = __toCommonJS(normalizeValueWithProperty_exports);
var import_constants = __webpack_require__(77505), import_helpers = __webpack_require__(89953), import_insertStyleRule = __webpack_require__(55915);
const stylePropsAllPlusTransforms = {
  ...import_helpers.stylePropsAll,
  translateX: !0,
  translateY: !0
};
function normalizeValueWithProperty(value, property = "") {
  if (!import_constants.isWeb || import_helpers.stylePropsUnitless[property] || property && !stylePropsAllPlusTransforms[property] || typeof value == "boolean")
    return value;
  let res = value;
  return value && typeof value == "object" ? value : (typeof value == "number" ? res = `${value}px` : property && (res = `${res}`), res);
}
const rcache = {};
function reverseMapClassNameToValue(key, className) {
  const cssRule = (0, import_insertStyleRule.getAllSelectors)()[className];
  if (rcache[cssRule])
    return rcache[cssRule];
  if (!cssRule) {
     false && 0;
    return;
  }
  const cssVal = cssRule.replace(/.*:/, "").replace(/;.*/, "").trim();
  let res;
  return cssVal.startsWith("var(") ? res = cssVal : import_helpers.stylePropsUnitless[key] ? res = +cssVal : cssVal.endsWith("px") ? res = +cssVal.replace("px", "") : res = cssVal, rcache[cssRule] = res,  false && 0, res;
}
//# sourceMappingURL=normalizeValueWithProperty.js.map


/***/ }),

/***/ 53136:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var objectIdentityKey_exports = {};
__export(objectIdentityKey_exports, {
  objectIdentityKey: () => objectIdentityKey
});
module.exports = __toCommonJS(objectIdentityKey_exports);
function objectIdentityKey(obj) {
  let k = "";
  for (const key in obj) {
    k += key;
    const arg = obj[key];
    let type = typeof arg;
    if (!arg || type !== "object" && type !== "function")
      k += type + arg;
    else if (cache.has(arg))
      k += cache.get(arg);
    else {
      let v = Math.random();
      cache.set(arg, v), k += v;
    }
  }
  return k;
}
const cache = /* @__PURE__ */ new WeakMap();
//# sourceMappingURL=objectIdentityKey.js.map


/***/ }),

/***/ 10069:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(73656);
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var propMapper_exports = {};
__export(propMapper_exports, {
  getFontFamilyFromNameOrVariable: () => getFontFamilyFromNameOrVariable,
  getPropMappedFontFamily: () => getPropMappedFontFamily,
  getTokenForKey: () => getTokenForKey,
  propMapper: () => propMapper
});
module.exports = __toCommonJS(propMapper_exports);
var import_constants = __webpack_require__(77505), import_helpers = __webpack_require__(89953), import_config = __webpack_require__(98211), import_createVariable = __webpack_require__(68836), import_expandStyle = __webpack_require__(7943), import_normalizeStyle = __webpack_require__(84423), import_getVariantExtras = __webpack_require__(17419), import_isObj = __webpack_require__(91032), import_pseudoDescriptors = __webpack_require__(71721), import_skipProps = __webpack_require__(49495);
const propMapper = (key, value, styleState) => {
  if (lastFontFamilyToken = null, key === "elevationAndroid") return;
  const { conf, styleProps, fontFamily, staticConfig } = styleState;
  if (value === "unset") {
    const unsetVal = conf.unset?.[key];
    if (unsetVal != null)
      value = unsetVal;
    else
      return;
  }
  styleProps.fallbackProps && (styleState.props = styleProps.fallbackProps);
  const { variants } = staticConfig;
  if ( false && 0, !styleProps.noExpand && variants && key in variants) {
    const variantValue = resolveVariants(key, value, styleProps, styleState, "");
    if (variantValue)
      return variantValue;
  }
  if (styleProps.disableExpandShorthands || key in conf.shorthands && (key = conf.shorthands[key]), value && (value[0] === "$" ? value = getTokenForKey(key, value, styleProps.resolveValues, styleState) : (0, import_createVariable.isVariable)(value) && (value = resolveVariableValue(key, value, styleProps.resolveValues))), value != null) {
    const result = (styleProps.noExpand ? null : (0, import_expandStyle.expandStyle)(key, value)) || [
      [key, value]
    ];
    return key === "fontFamily" && lastFontFamilyToken && fontFamilyCache.set(result, lastFontFamilyToken), result;
  }
}, resolveVariants = (key, value, styleProps, styleState, parentVariantKey) => {
  const { staticConfig, conf, debug } = styleState, { variants } = staticConfig;
  if (!variants) return;
  let variantValue = getVariantDefinition(variants[key], value, conf);
  if ( false && (0), !variantValue) {
    if (process.env.TAMAGUI_WARN_ON_MISSING_VARIANT === "1" && typeof value != "boolean") {
      const name = staticConfig.componentName || "[UnnamedComponent]";
      console.warn(
        `No variant found: ${name} has variant "${key}", but no matching value "${value}"`
      );
    }
    return;
  }
  if (typeof variantValue == "function") {
    const fn = variantValue, extras = (0, import_getVariantExtras.getVariantExtras)(styleState);
    variantValue = fn(value, extras),  false && (0);
  }
  let fontFamilyResult;
  if ((0, import_isObj.isObj)(variantValue)) {
    const fontFamilyUpdate = variantValue.fontFamily || variantValue[conf.inverseShorthands.fontFamily];
    fontFamilyUpdate && (fontFamilyResult = getFontFamilyFromNameOrVariable(fontFamilyUpdate, conf), styleState.fontFamily = fontFamilyResult,  false && 0), variantValue = resolveTokensAndVariants(
      key,
      variantValue,
      styleProps,
      styleState,
      parentVariantKey
    );
  }
  if (variantValue) {
    const expanded = (0, import_normalizeStyle.normalizeStyle)(variantValue, !!styleProps.noNormalize);
     false && 0;
    const next = Object.entries(expanded);
    return fontFamilyResult && fontFamilyResult[0] === "$" && fontFamilyCache.set(next, (0, import_createVariable.getVariableValue)(fontFamilyResult)), next;
  }
};
function getFontFamilyFromNameOrVariable(input, conf) {
  if ((0, import_createVariable.isVariable)(input)) {
    const val = variableToFontNameCache.get(input);
    if (val) return val;
    for (const key in conf.fontsParsed) {
      const familyVariable = conf.fontsParsed[key].family;
      if ((0, import_createVariable.isVariable)(familyVariable) && (variableToFontNameCache.set(familyVariable, key), familyVariable === input))
        return key;
    }
  } else if (typeof input == "string" && input[0] === "$")
    return input;
}
const variableToFontNameCache = /* @__PURE__ */ new WeakMap(), fontFamilyCache = /* @__PURE__ */ new WeakMap(), getPropMappedFontFamily = (expanded) => expanded && fontFamilyCache.get(expanded), resolveTokensAndVariants = (key, value, styleProps, styleState, parentVariantKey) => {
  const { conf, staticConfig, debug, theme } = styleState, { variants } = staticConfig, res = {};
   false && 0;
  for (const _key in value) {
    const subKey = conf.shorthands[_key] || _key, val = value[_key];
    if (!(!styleProps.noSkip && subKey in import_skipProps.skipProps)) {
      if (styleProps.noExpand)
        res[subKey] = val;
      else if (variants && subKey in variants) {
        if (parentVariantKey && parentVariantKey === key)
          res[subKey] = // SYNC WITH *1
          val[0] === "$" ? getTokenForKey(subKey, val, styleProps.resolveValues, styleState) : val;
        else {
          const variantOut = resolveVariants(subKey, val, styleProps, styleState, key);
          if (variantOut)
            for (const [key2, val2] of variantOut)
              val2 != null && (key2 in import_pseudoDescriptors.pseudoDescriptors ? (res[key2] ??= {}, Object.assign(res[key2], val2)) : res[key2] = val2);
        }
        continue;
      }
      if ((0, import_createVariable.isVariable)(val)) {
        res[subKey] = resolveVariableValue(subKey, val, styleProps.resolveValues),  false && 0;
        continue;
      }
      if (typeof val == "string") {
        const fVal = (
          // SYNC WITH *1
          val[0] === "$" ? getTokenForKey(subKey, val, styleProps.resolveValues, styleState) : val
        );
        res[subKey] = fVal;
        continue;
      }
      if ((0, import_isObj.isObj)(val)) {
        const subObject = resolveTokensAndVariants(subKey, val, styleProps, styleState, key);
         false && 0, res[subKey] ??= {}, Object.assign(res[subKey], subObject);
      } else
        res[subKey] = val;
       false && 0;
    }
  }
  return res;
}, tokenCats = ["size", "color", "radius", "space", "zIndex"].map((name) => ({
  name,
  spreadName: `...${name}`
}));
function getVariantDefinition(variant, value, conf) {
  if (typeof variant == "function")
    return variant;
  const exact = variant[value];
  if (exact)
    return exact;
  if (value != null) {
    const { tokensParsed } = conf;
    for (const { name, spreadName } of tokenCats)
      if (spreadName in variant && value in tokensParsed[name])
        return variant[spreadName];
    const fontSizeVariant = variant["...fontSize"];
    if (fontSizeVariant && conf.fontSizeTokens.has(value))
      return fontSizeVariant;
  }
  return variant[`:${typeof value}`] || variant["..."];
}
const fontShorthand = {
  fontSize: "size",
  fontWeight: "weight"
};
let lastFontFamilyToken = null;
const getTokenForKey = (key, value, resolveAs = "none", styleState) => {
  if (resolveAs === "none")
    return value;
  const { theme, conf = (0, import_config.getConfig)(), context, fontFamily, staticConfig } = styleState, tokensParsed = conf.tokensParsed;
  let valOrVar, hasSet = !1;
  const customTokenAccept = staticConfig?.accept?.[key];
  if (customTokenAccept) {
    const val = theme?.[value] ?? tokensParsed[customTokenAccept][value];
    val != null && (resolveAs = "value", valOrVar = val, hasSet = !0);
  }
  if (theme && value in theme) {
    if (valOrVar = theme[value], styleState.skipThemeTokenResolution && valOrVar?.val)
      return  false && 0, value;
     false && 0, hasSet = !0;
  } else {
    if (value in conf.specificTokens)
      hasSet = !0, valOrVar = conf.specificTokens[value];
    else {
      switch (key) {
        case "fontFamily": {
          valOrVar = (context?.language ? (0, import_getVariantExtras.getFontsForLanguage)(conf.fontsParsed, context.language) : conf.fontsParsed)[value]?.family || value, lastFontFamilyToken = value, hasSet = !0;
          break;
        }
        case "fontSize":
        case "lineHeight":
        case "letterSpacing":
        case "fontWeight": {
          const defaultFont = conf.defaultFont || "$body", fam = fontFamily || defaultFont;
          if (fam) {
            const fontsParsed = context?.language ? (0, import_getVariantExtras.getFontsForLanguage)(conf.fontsParsed, context.language) : conf.fontsParsed;
            valOrVar = (fontsParsed[fam] || fontsParsed[defaultFont])?.[fontShorthand[key] || key]?.[value] || value, hasSet = !0;
          }
          break;
        }
      }
      for (const cat in import_helpers.tokenCategories)
        if (key in import_helpers.tokenCategories[cat]) {
          const res = tokensParsed[cat][value];
          res != null && (valOrVar = res, hasSet = !0);
        }
    }
    if (!hasSet) {
      const spaceVar = tokensParsed.space[value];
      spaceVar != null && (valOrVar = spaceVar, hasSet = !0);
    }
  }
  if (hasSet) {
    const out = resolveVariableValue(key, valOrVar, resolveAs);
    return  false && 0, out;
  }
   false && 0;
};
function resolveVariableValue(key, valOrVar, resolveValues) {
  if (resolveValues === "none") return valOrVar;
  if ((0, import_createVariable.isVariable)(valOrVar)) {
    if (resolveValues === "value")
      return valOrVar.val;
    const get = valOrVar?.get;
    return typeof get == "function" ? get(resolveValues === "web" ? "web" : void 0) : valOrVar.variable;
  }
  return valOrVar;
}
//# sourceMappingURL=propMapper.js.map


/***/ }),

/***/ 85335:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var proxyThemeToParents_exports = {};
__export(proxyThemeToParents_exports, {
  proxyThemeToParents: () => proxyThemeToParents,
  proxyThemesToParents: () => proxyThemesToParents
});
module.exports = __toCommonJS(proxyThemeToParents_exports);
var import_config = __webpack_require__(98211);
const themesRaw = {};
function proxyThemesToParents(dedupedThemes) {
  for (const { names, theme } of dedupedThemes)
    for (const name of names)
      themesRaw[name] = theme;
  const themes = {};
  for (const { names, theme } of dedupedThemes)
    for (const themeName of names) {
      const proxiedTheme = proxyThemeToParents(themeName, theme);
      themes[themeName] = proxiedTheme;
    }
  return themes;
}
function proxyThemeToParents(themeName, theme) {
  const cur = [], parents = themeName.split("_").slice(0, -1).map((part) => (cur.push(part), cur.join("_"))), numParents = parents.length;
  return new Proxy(theme, {
    get(target, key) {
      if (!key || // dont ask me, idk why but on hermes you can see that useTheme()[undefined] passes in STRING undefined to proxy
      // if someone is crazy enough to use "undefined" as a theme key then this not working is on them
      key == "undefined" || Reflect.has(target, key))
        return Reflect.get(target, key);
      for (let i = numParents - 1; i >= 0; i--) {
        const parent = themesRaw[parents[i]];
        if (parent && Reflect.has(parent, key))
          return Reflect.get(parent, key);
      }
      return (0, import_config.getTokenObject)(key);
    }
  });
}
//# sourceMappingURL=proxyThemeToParents.js.map


/***/ }),

/***/ 88715:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var proxyThemeVariables_exports = {};
__export(proxyThemeVariables_exports, {
  proxyThemeVariables: () => proxyThemeVariables
});
module.exports = __toCommonJS(proxyThemeVariables_exports);
function proxyThemeVariables(obj) {
  return new Proxy(obj || {}, {
    has(target, key) {
      return Reflect.has(target, removeStarting$(key));
    },
    get(target, key) {
      return Reflect.get(target, removeStarting$(key));
    }
  });
}
const removeStarting$ = (str) => typeof str == "string" && str[0] === "$" ? str.slice(1) : str;
//# sourceMappingURL=proxyThemeVariables.js.map


/***/ }),

/***/ 71721:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var pseudoDescriptors_exports = {};
__export(pseudoDescriptors_exports, {
  pseudoDescriptors: () => pseudoDescriptors,
  pseudoDescriptorsBase: () => pseudoDescriptorsBase,
  pseudoPriorities: () => pseudoPriorities
});
module.exports = __toCommonJS(pseudoDescriptors_exports);
const pseudoDescriptorsBase = {
  // order of keys here important! in priority order
  hoverStyle: {
    name: "hover",
    priority: 1
  },
  pressStyle: {
    name: "active",
    stateKey: "press",
    priority: 2
  },
  focusVisibleStyle: {
    name: "focus-visible",
    priority: 3,
    stateKey: "focusVisible"
  },
  focusStyle: {
    name: "focus",
    priority: 3
  },
  disabledStyle: {
    name: "disabled",
    priority: 4,
    stateKey: "disabled"
  }
}, pseudoPriorities = {
  hover: 1,
  press: 2,
  focus: 3,
  focusVisible: 3,
  disabled: 4
}, pseudoDescriptors = {
  ...pseudoDescriptorsBase,
  enterStyle: {
    name: "enter",
    selector: ".t_unmounted",
    priority: 4
  },
  exitStyle: {
    name: "exit",
    priority: 5
  }
};
//# sourceMappingURL=pseudoDescriptors.js.map


/***/ }),

/***/ 2277:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(73656);
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var registerCSSVariable_exports = {};
__export(registerCSSVariable_exports, {
  registerCSSVariable: () => registerCSSVariable,
  tokensValueToVariable: () => tokensValueToVariable,
  variableToCSS: () => variableToCSS
});
module.exports = __toCommonJS(registerCSSVariable_exports);
var import_createVariable = __webpack_require__(68836);
const registerCSSVariable = (v) => {
  tokensValueToVariable.set((0, import_createVariable.getVariableValue)(v), v);
}, variableToCSS = (v, unitless = !1) => `--${process.env.TAMAGUI_CSS_VARIABLE_PREFIX || ""}${(0, import_createVariable.createCSSVariable)(
  v.name,
  !1
)}:${!unitless && typeof v.val == "number" ? `${v.val}px` : v.val}`, tokensValueToVariable = /* @__PURE__ */ new Map();
//# sourceMappingURL=registerCSSVariable.js.map


/***/ }),

/***/ 37188:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var setElementProps_exports = {};
__export(setElementProps_exports, {
  setElementProps: () => setElementProps
});
module.exports = __toCommonJS(setElementProps_exports);
const setElementProps = void 0;
//# sourceMappingURL=setElementProps.js.map


/***/ }),

/***/ 49495:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var skipProps_exports = {};
__export(skipProps_exports, {
  skipProps: () => skipProps
});
module.exports = __toCommonJS(skipProps_exports);
var import_webPropsToSkip = __webpack_require__(31541);
const skipProps = {
  untilMeasured: 1,
  animation: 1,
  space: 1,
  animateOnly: 1,
  disableClassName: 1,
  debug: 1,
  componentName: 1,
  disableOptimization: 1,
  tag: 1,
  style: 1,
  // handled after loop so pseudos set usedKeys and override it if necessary
  group: 1,
  themeInverse: 1,
  animatePresence: 1
};
 false && (0);
 false && 0;
//# sourceMappingURL=skipProps.js.map


/***/ }),

/***/ 68867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var themeable_exports = {};
__export(themeable_exports, {
  themeable: () => themeable
});
module.exports = __toCommonJS(themeable_exports);
var import_react = __toESM(__webpack_require__(44194)), import_Theme = __webpack_require__(32676), import_jsx_runtime = (
  // @ts-expect-error its ok
  __webpack_require__(31549)
);
function themeable(Component, staticConfig) {
  const withTheme = import_react.default.forwardRef(function(props, ref) {
    const { themeInverse, theme, componentName, themeReset, ...rest } = props, element = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Component, { ref, ...rest, "data-disable-theme": !0 });
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      import_Theme.Theme,
      {
        componentName: componentName || staticConfig?.componentName,
        name: theme,
        "disable-child-theme": !0,
        debug: props.debug,
        inverse: themeInverse,
        reset: themeReset,
        children: element
      }
    );
  });
  return withTheme.displayName = `Themed(${Component?.displayName || Component?.name || "Anonymous"})`, withTheme;
}
//# sourceMappingURL=themeable.js.map


/***/ }),

/***/ 52531:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var themes_exports = {};
__export(themes_exports, {
  ensureThemeVariable: () => ensureThemeVariable
});
module.exports = __toCommonJS(themes_exports);
var import_createVariable = __webpack_require__(68836);
function ensureThemeVariable(theme, key) {
  const val = theme[key];
  (0, import_createVariable.isVariable)(val) ? val.name !== key && (theme[key] = (0, import_createVariable.createVariable)({
    key: val.name,
    name: key,
    val: val.val
  })) : theme[key] = (0, import_createVariable.createVariable)({
    key,
    name: key,
    val
  });
}
//# sourceMappingURL=themes.js.map


/***/ }),

/***/ 73488:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var transformsToString_exports = {};
__export(transformsToString_exports, {
  transformsToString: () => transformsToString
});
module.exports = __toCommonJS(transformsToString_exports);
var import_normalizeValueWithProperty = __webpack_require__(29681);
function transformsToString(transforms) {
  return transforms.map(
    // { scale: 2 } => 'scale(2)'
    // { translateX: 20 } => 'translateX(20px)'
    // { matrix: [1,2,3,4,5,6] } => 'matrix(1,2,3,4,5,6)'
    (transform) => {
      const type = Object.keys(transform)[0], value = transform[type];
      return type === "matrix" || type === "matrix3d" ? `${type}(${value.join(",")})` : `${type}(${(0, import_normalizeValueWithProperty.normalizeValueWithProperty)(value, type)})`;
    }
  ).join(" ");
}
//# sourceMappingURL=transformsToString.js.map


/***/ }),

/***/ 31541:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var webPropsToSkip_exports = {};
__export(webPropsToSkip_exports, {
  webPropsToSkip: () => webPropsToSkip
});
module.exports = __toCommonJS(webPropsToSkip_exports);
const webPropsToSkip = {};
//# sourceMappingURL=webPropsToSkip.js.map


/***/ }),

/***/ 2647:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var useConfiguration_exports = {};
__export(useConfiguration_exports, {
  useConfiguration: () => useConfiguration
});
module.exports = __toCommonJS(useConfiguration_exports);
var import_react = __toESM(__webpack_require__(44194)), import_config = __webpack_require__(98211), import_ComponentContext = __webpack_require__(31301);
const useConfiguration = () => {
  const { groups, animationDriver, ...restComponentConfig } = import_react.default.useContext(import_ComponentContext.ComponentContext), { animations, ...restConfig } = (0, import_config.getConfig)();
  return {
    ...restConfig,
    ...restComponentConfig,
    animationDriver: animationDriver ?? (0, import_config.getConfig)().animations
  };
};
//# sourceMappingURL=useConfiguration.js.map


/***/ }),

/***/ 25851:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var useDidHydrateOnce_exports = {};
__export(useDidHydrateOnce_exports, {
  useDidHydrateOnce: () => useDidHydrateOnce,
  useDidHydrateOnceRoot: () => useDidHydrateOnceRoot
});
module.exports = __toCommonJS(useDidHydrateOnce_exports);
var import_react = __toESM(__webpack_require__(44194)), import_config = __webpack_require__(98211);
function useDidHydrateOnceRoot() {
  return !0;
}
let last = Date.now();
function useDidHydrateOnce() {
  return (0, import_config.getSetting)("disableSSR") ? !0 : useDidHydrateSync();
}
const emptySubscribe = () => () => {
}, getClientSnapshot = () => !0, getServerSnapshot = () => !1, useDidHydrateSync = () => import_react.default.useSyncExternalStore(emptySubscribe, getClientSnapshot, getServerSnapshot);
//# sourceMappingURL=useDidHydrateOnce.js.map


/***/ }),

/***/ 85754:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var useDisableSSR_exports = {};
__export(useDisableSSR_exports, {
  getDisableSSR: () => getDisableSSR
});
module.exports = __toCommonJS(useDisableSSR_exports);
var import_config = __webpack_require__(98211);
function getDisableSSR(componentContext) {
  return componentContext?.disableSSR ?? (0, import_config.getSetting)("disableSSR");
}
//# sourceMappingURL=useDisableSSR.js.map


/***/ }),

/***/ 48081:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var useIsTouchDevice_exports = {};
__export(useIsTouchDevice_exports, {
  useIsTouchDevice: () => useIsTouchDevice
});
module.exports = __toCommonJS(useIsTouchDevice_exports);
var import_constants = __webpack_require__(77505), import_use_did_finish_ssr = __webpack_require__(87899);
const useIsTouchDevice = () => import_constants.isWeb ? (0, import_use_did_finish_ssr.useDidFinishSSR)() ? import_constants.isTouchable : !1 : !0;
//# sourceMappingURL=useIsTouchDevice.js.map


/***/ }),

/***/ 31094:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(73656);
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var useMedia_exports = {};
__export(useMedia_exports, {
  _dmt: () => _dmt,
  configureMedia: () => configureMedia,
  getMedia: () => getMedia,
  getMediaImportanceIfMoreImportant: () => getMediaImportanceIfMoreImportant,
  getMediaKeyImportance: () => getMediaKeyImportance,
  getMediaState: () => getMediaState,
  isMediaKey: () => isMediaKey,
  mediaKeyMatch: () => mediaKeyMatch,
  mediaKeyToQuery: () => mediaKeyToQuery,
  mediaKeys: () => mediaKeys,
  mediaObjectToString: () => mediaObjectToString,
  mediaQueryConfig: () => mediaQueryConfig,
  mediaState: () => mediaState,
  setMediaShouldUpdate: () => setMediaShouldUpdate,
  setupMediaListeners: () => setupMediaListeners,
  useMedia: () => useMedia
});
module.exports = __toCommonJS(useMedia_exports);
var import_react = __toESM(__webpack_require__(44194)), import_constants = __webpack_require__(77505), import_config = __webpack_require__(98211), import_matchMedia = __webpack_require__(53960), import_pseudoDescriptors = __webpack_require__(71721), import_useDisableSSR = __webpack_require__(85754);
let mediaState = (
  // development only safeguard
   false ? 0 : {}
);
const mediaQueryConfig = {}, getMedia = () => mediaState, mediaKeys = /* @__PURE__ */ new Set(), mediaKeyRegex = /\$(platform|theme|group)-/, isMediaKey = (key) => {
  if (mediaKeys.has(key)) return !0;
  if (key[0] === "$") {
    const match = key.match(mediaKeyRegex);
    if (match) return match[1];
  }
  return !1;
};
let initState;
const defaultMediaImportance = Object.keys(import_pseudoDescriptors.pseudoDescriptors).length;
let mediaKeysOrdered;
const getMediaKeyImportance = (key) => {
  if (false)
    {}
  return (0, import_config.getConfig)().settings.mediaPropOrder ? defaultMediaImportance : mediaKeysOrdered.indexOf(key) + 100;
}, dispose = /* @__PURE__ */ new Set();
let mediaVersion = 0;
const configureMedia = (config) => {
  const { media } = config, mediaQueryDefaultActive = (0, import_config.getSetting)("mediaQueryDefaultActive");
  if (media) {
    mediaVersion++;
    for (const key in media)
      mediaState[key] = mediaQueryDefaultActive?.[key] || !1, mediaKeys.add(`$${key}`);
    Object.assign(mediaQueryConfig, media), initState = { ...mediaState }, mediaKeysOrdered = Object.keys(media), config.disableSSR ? setupMediaListeners() : updateCurrentState();
  }
};
function unlisten() {
  dispose.forEach((cb) => cb()), dispose.clear();
}
let setupVersion = -1;
function setupMediaListeners() {
  if (!(import_constants.isWeb && import_constants.isServer) && setupVersion !== mediaVersion) {
    setupVersion = mediaVersion, unlisten();
    for (const key in mediaQueryConfig) {
      let update = function() {
        const next = !!getMatch().matches;
        next !== mediaState[key] && (mediaState = { ...mediaState, [key]: next }, updateCurrentState());
      };
      const str = mediaObjectToString(mediaQueryConfig[key], key), getMatch = () => (0, import_matchMedia.matchMedia)(str), match = getMatch();
      if (!match)
        throw new Error("\u26A0\uFE0F No match");
      match.addListener(update), dispose.add(() => {
        match.removeListener(update);
      }), update();
    }
  }
}
const listeners = /* @__PURE__ */ new Set();
let flushing = !1, flushVersion = -1;
function updateCurrentState() {
  flushing && flushVersion === mediaVersion || (flushVersion = mediaVersion, flushing = !0, Promise.resolve().then(() => {
    flushing = !1, listeners.forEach((cb) => cb(mediaState));
  }));
}
const States = /* @__PURE__ */ new WeakMap();
function setMediaShouldUpdate(ref, props) {
  return States.set(ref, {
    ...States.get(ref),
    ...props
  });
}
function subscribe(subscriber) {
  return listeners.add(subscriber), () => {
    listeners.delete(subscriber);
  };
}
function useMedia(uidIn, componentContext, debug) {
  const uid = uidIn ?? import_react.default.useRef(), disableSSR = (0, import_useDisableSSR.getDisableSSR)(componentContext), initialState = (disableSSR || !import_constants.isWeb ? mediaState : initState) || {};
  let componentState = States.get(uid);
  componentState || (componentState = { prev: initialState }, States.set(uid, componentState));
  const getSnapshot = () => {
    if (!componentState)
      return initialState;
    const { enabled, keys, prev = initialState } = componentState;
    if (enabled === !1)
      return prev;
    const testKeys = keys ?? (enabled && keys) ?? null;
    return !testKeys || Object.keys(testKeys).every((key) => mediaState[key] === prev[key]) ? prev : (componentState.prev = mediaState, mediaState);
  };
  let state;
  if (process.env.TAMAGUI_SYNC_MEDIA_QUERY)
    state = import_react.default.useSyncExternalStore(
      subscribe,
      getSnapshot,
      () => initialState
    );
  else {
    const [_state, setState] = import_react.default.useState(initialState);
    state = _state, (0, import_constants.useIsomorphicLayoutEffect)(() => {
      function update() {
        setState(getSnapshot);
      }
      return update(), disableSSR || Promise.resolve().then(() => {
        update();
      }), subscribe(update);
    }, []);
  }
  return new Proxy(state, {
    get(_, key) {
      if (!disableMediaTouch)
        return typeof key == "string" && (componentState.keys ||= {}, componentState.keys[key] = !0,  false && 0), Reflect.get(state, key);
    }
  });
}
let disableMediaTouch = !1;
function _dmt(val) {
  disableMediaTouch = val;
}
function getMediaState(mediaGroups, layout) {
  disableMediaTouch = !0;
  let res;
  try {
    res = Object.fromEntries(
      [...mediaGroups].map((mediaKey) => [mediaKey, mediaKeyMatch(mediaKey, layout)])
    );
  } finally {
    disableMediaTouch = !1;
  }
  return res;
}
const getMediaImportanceIfMoreImportant = (mediaKey, key, importancesUsed, isSizeMedia) => {
  const importance = isSizeMedia && !(0, import_config.getSetting)("mediaPropOrder") ? getMediaKeyImportance(mediaKey) : defaultMediaImportance;
  return !importancesUsed[key] || importance > importancesUsed[key] ? importance : null;
};
function camelToHyphen(str) {
  return str.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`).toLowerCase();
}
const cache = /* @__PURE__ */ new WeakMap(), cachedMediaKeyToQuery = {};
function mediaObjectToString(query, key) {
  if (typeof query == "string")
    return query;
  if (cache.has(query))
    return cache.get(query);
  const res = Object.entries(query).map(([feature, value]) => (feature = camelToHyphen(feature), typeof value == "string" ? `(${feature}: ${value})` : (typeof value == "number" && /[height|width]$/.test(feature) && (value = `${value}px`), `(${feature}: ${value})`))).join(" and ");
  return key && (cachedMediaKeyToQuery[key] = res), cache.set(query, res), res;
}
function mediaKeyToQuery(key) {
  return cachedMediaKeyToQuery[key] || mediaObjectToString(mediaQueryConfig[key], key);
}
function mediaKeyMatch(key, dimensions) {
  const mediaQueries = mediaQueryConfig[key];
  return Object.keys(mediaQueries).every((query) => {
    const expectedVal = +mediaQueries[query], isMax = query.startsWith("max"), isWidth = query.endsWith("Width"), givenVal = dimensions[isWidth ? "width" : "height"];
    return isMax ? givenVal < expectedVal : givenVal > expectedVal;
  });
}
//# sourceMappingURL=useMedia.js.map


/***/ }),

/***/ 7942:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var useProps_exports = {};
__export(useProps_exports, {
  useProps: () => useProps,
  usePropsAndStyle: () => usePropsAndStyle,
  useStyle: () => useStyle
});
module.exports = __toCommonJS(useProps_exports);
var import_react = __toESM(__webpack_require__(44194)), import_config = __webpack_require__(98211), import_ComponentContext = __webpack_require__(31301), import_createComponent = __webpack_require__(92594), import_getSplitStyles = __webpack_require__(11792), import_Stack = __webpack_require__(56104), import_useMedia = __webpack_require__(31094), import_useTheme = __webpack_require__(67265);
function useProps(props, opts) {
  const [propsOut, styleOut] = usePropsAndStyle(props, {
    ...opts,
    noExpand: !0,
    noNormalize: !0,
    resolveValues: "none"
  });
  return {
    ...propsOut,
    ...styleOut
  };
}
function useStyle(props, opts) {
  return usePropsAndStyle(props, opts)[1] || {};
}
function usePropsAndStyle(props, opts) {
  const staticConfig = opts?.forComponent?.staticConfig ?? import_Stack.Stack.staticConfig, [themeState, theme] = (0, import_useTheme.useThemeWithState)({
    componentName: staticConfig.componentName,
    name: "theme" in props ? props.theme : void 0,
    inverse: "themeInverse" in props ? props.themeInverse : void 0
  }), componentContext = import_react.default.useContext(import_ComponentContext.ComponentContext), { state, disabled, setStateShallow } = (0, import_createComponent.useComponentState)(
    props,
    componentContext,
    staticConfig,
    (0, import_config.getConfig)()
  ), media = (0, import_useMedia.useMedia)(), splitStyles = (0, import_getSplitStyles.useSplitStyles)(
    props,
    staticConfig,
    theme,
    themeState.state?.name || "",
    state,
    {
      isAnimated: !1,
      mediaState: media,
      noSkip: !0,
      noMergeStyle: !0,
      noClassNames: !0,
      resolveValues: "auto",
      ...opts
    },
    null,
    componentContext
  ), { mediaGroups, pseudoGroups } = splitStyles;
  return import_react.default.useEffect(() => {
    if (!disabled) {
      if (state.unmounted) {
        setStateShallow({ unmounted: !1 });
        return;
      }
      return (0, import_createComponent.subscribeToContextGroup)({
        disabled,
        componentContext,
        setStateShallow,
        state,
        mediaGroups,
        pseudoGroups
      });
    }
  }, [
    disabled,
    pseudoGroups ? Object.keys([...pseudoGroups]).join("") : 0,
    mediaGroups ? Object.keys([...mediaGroups]).join("") : 0
  ]), [splitStyles.viewProps, splitStyles.style || {}, theme, media];
}
//# sourceMappingURL=useProps.js.map


/***/ }),

/***/ 67265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var useTheme_exports = {};
__export(useTheme_exports, {
  activeThemeManagers: () => activeThemeManagers,
  getThemeManager: () => getThemeManager,
  getThemeProxied: () => getThemeProxied,
  useChangeThemeEffect: () => useChangeThemeEffect,
  useTheme: () => useTheme,
  useThemeWithState: () => useThemeWithState
});
module.exports = __toCommonJS(useTheme_exports);
var import_react = __toESM(__webpack_require__(44194)), import_constants = __webpack_require__(77505), import_config = __webpack_require__(98211), import_createVariable = __webpack_require__(68836), import_ThemeManager = __webpack_require__(24647), import_ThemeManagerContext = __webpack_require__(99953), import_createShallowSetState = __webpack_require__(69345);
const emptyProps = { name: null };
let cached;
function getDefaultThemeProxied() {
  if (cached) return cached;
  const config = (0, import_config.getConfig)(), name = config.themes.light ? "light" : Object.keys(config.themes)[0], defaultTheme = config.themes[name];
  return cached = getThemeProxied({ theme: defaultTheme, name }), cached;
}
const useTheme = (props = emptyProps) => {
  const [_, theme] = useThemeWithState(props);
  return theme || getDefaultThemeProxied();
}, useThemeWithState = (props) => {
  const keys = import_react.default.useRef([]), changedThemeState = useChangeThemeEffect(
    props,
    !1,
    keys.current,
    import_constants.isServer ? void 0 : () => {
      const next = props.shouldUpdate?.() ?? (keys.current.length > 0 ? !0 : void 0);
      return  false && 0, next;
    }
  ), { themeManager, state } = changedThemeState;
   false && (0);
  const themeProxied = import_react.default.useMemo(() => !themeManager || !state?.theme ? {} : getThemeProxied(state, props.deopt, themeManager, keys.current, props.debug), [state?.theme, themeManager, props.deopt, props.debug]);
  return  false && (0), [changedThemeState, themeProxied];
};
function getThemeProxied({ theme, name, scheme }, deopt = !1, themeManager, keys, debug) {
  if (!theme) return {};
  const config = (0, import_config.getConfig)();
  function track(key) {
    keys && !keys.includes(key) && (keys.push(key),  false && 0);
  }
  return new Proxy(theme, {
    has(_, key) {
      if (Reflect.has(theme, key))
        return !0;
      if (typeof key == "string")
        return key[0] === "$" && (key = key.slice(1)), themeManager?.allKeys.has(key);
    },
    get(_, key) {
      if (
        // dont ask me, idk why but on hermes you can see that useTheme()[undefined] passes in STRING undefined to proxy
        // if someone is crazy enough to use "undefined" as a theme key then this not working is on them
        key !== "undefined" && typeof key == "string"
      ) {
        const keyString = key[0] === "$" ? key.slice(1) : key, val = theme[keyString];
        if (val && typeof val == "object")
          return new Proxy(val, {
            // when they touch the actual value we only track it
            // if its a variable (web), its ignored!
            get(_2, subkey) {
              if (subkey === "val")
                track(keyString);
              else if (subkey === "get")
                return (platform) => (0, import_createVariable.getVariable)(val);
              return Reflect.get(val, subkey);
            }
          });
        if (false)
          {}
      }
      return Reflect.get(_, key);
    }
  });
}
const activeThemeManagers = /* @__PURE__ */ new Set(), _uidToManager = /* @__PURE__ */ new WeakMap(), _idToUID = {}, getId = (id) => _idToUID[id], getThemeManager = (id) => _uidToManager.get(getId(id)), registerThemeManager = (t) => {
  if (!_idToUID[t.id]) {
    const id = _idToUID[t.id] = {};
    _uidToManager.set(id, t);
  }
}, ogLog = console.error, preventWarnSetState =  true ? ogLog : (
  // temporary fix for logs, they are harmless in that i've tried to rewrite this
  // a few times using the "right" ways, but they are always slower. maybe skill issue
  0
), useChangeThemeEffect = (props, isRoot = !1, keys, shouldUpdate) => {
  const { disable } = props, parentManagerId = import_react.default.useContext(import_ThemeManagerContext.ThemeManagerIDContext), parentManager = getThemeManager(parentManagerId);
  if (!isRoot && !parentManager || disable)
    return {
      isNewTheme: !1,
      state: parentManager?.state,
      themeManager: parentManager
    };
  const [themeState, setThemeState] = import_react.default.useState(createState), { state, mounted, isNewTheme, themeManager, inversed } = themeState, isInversingOnMount = !!(!themeState.mounted && props.inverse);
  function getShouldUpdateTheme(manager = themeManager, nextState, prevState = state, forceShouldChange = !1) {
    const forceUpdate = shouldUpdate?.();
    if (!manager || !forceShouldChange && forceUpdate === !1) return;
    const next = nextState || manager.getState(props, parentManager);
    if (forceShouldChange) return next;
    if (next && !(forceUpdate !== !0 && !manager.getStateShouldChange(next, prevState)))
      return next;
  }
  if (import_constants.isServer || (import_react.default.useEffect(() => {
    if (!themeManager) return;
    if (props.inverse && !mounted) {
      setThemeState((prev) => createState({
        ...prev,
        mounted: !0
      }));
      return;
    }
    (isNewTheme || getShouldUpdateTheme(themeManager)) && (activeThemeManagers.add(themeManager), setThemeState(createState));
    const selfListenerDispose = themeManager.onChangeTheme((_a, _b, forced) => {
      forced && (console.error = preventWarnSetState, setThemeState((prev) => createState(prev, !0)), console.error = ogLog);
    }), disposeChangeListener = parentManager?.onChangeTheme(
      (name, manager, forced) => {
        const force = forced || shouldUpdate?.() || props.deopt || void 0, shouldTryUpdate = force ?? !!(keys?.length || isNewTheme);
         false && 0, shouldTryUpdate && (console.error = preventWarnSetState, setThemeState((prev) => createState(prev, force)), console.error = ogLog);
      },
      themeManager.id
    );
    return () => {
      selfListenerDispose(), disposeChangeListener?.(), isNewTheme && activeThemeManagers.delete(themeManager);
    };
  }, [
    themeManager,
    parentManager,
    isNewTheme,
    props.componentName,
    props.inverse,
    props.name,
    props.reset,
    mounted
  ]),  false && 0), import_constants.isWeb && isInversingOnMount)
    return {
      isNewTheme: !1,
      inversed: !1,
      themeManager: parentManager,
      state: {
        name: "",
        ...parentManager?.state,
        className: ""
      }
    };
  return {
    state,
    isNewTheme,
    inversed,
    themeManager
  };
  function createState(prev, force = !1) {
    if (prev && shouldUpdate?.() === !1 && !force)
      return prev;
    let themeManager2 = parentManager, state2;
    if ((0, import_ThemeManager.getHasThemeUpdatingProps)(props)) {
      const getNewThemeManager = () => new import_ThemeManager.ThemeManager(props, isRoot ? "root" : parentManager);
      if (prev?.themeManager) {
        themeManager2 = prev.themeManager;
        const forceChange = force || !!keys?.length, next = themeManager2.getState(props, parentManager), nextState = getShouldUpdateTheme(
          themeManager2,
          next,
          prev.state,
          forceChange
        );
        nextState ? (state2 = nextState, !prev.isNewTheme && !isRoot ? themeManager2 = getNewThemeManager() : themeManager2.updateState(nextState)) : prev.isNewTheme && parentManager && !next && (themeManager2 = parentManager);
      } else
        themeManager2 = getNewThemeManager(), state2 = { ...themeManager2.state };
    }
    const isNewTheme2 = !!(themeManager2 !== parentManager || props.inverse);
    isNewTheme2 && registerThemeManager(themeManager2);
    const isWebSSR = import_constants.isWeb ? !(0, import_config.getSetting)("disableSSR") : !1, mounted2 = isWebSSR ? isRoot || prev?.mounted : !0;
    state2 || (isNewTheme2 ? state2 = themeManager2.state : (state2 = parentManager.state, themeManager2 = parentManager));
    const wasInversed = prev?.inversed, isInherentlyInversed = isNewTheme2 && state2.scheme !== parentManager?.state.scheme, inversed2 = isRoot ? !1 : isInherentlyInversed ? !0 : isWebSSR ? wasInversed != null ? !1 : null : props.inverse, response = {
      themeManager: themeManager2,
      isNewTheme: isNewTheme2,
      mounted: mounted2,
      inversed: inversed2
    }, shouldReturnPrev = prev && !force && // isEqualShallow uses the second arg as the keys so this should compare without state first...
    (0, import_createShallowSetState.isEqualShallow)(prev, response) && // ... and then compare just the state, because we make a new state obj but is likely the same
    (0, import_createShallowSetState.isEqualShallow)(prev.state, state2);
    if (prev && shouldReturnPrev)
      return prev;
    if (response.state = state2,  false && 0) {
      console.groupCollapsed(`\u{1F537} [${themeManager2.id}] useChangeThemeEffect createState`);
      const parentState = { ...parentManager?.state }, parentId = parentManager?.id, themeManagerState = { ...themeManager2.state };
      console.info({
        props,
        parentState,
        parentId,
        themeManager: themeManager2,
        prev,
        response,
        themeManagerState
      }), console.groupEnd();
    }
    return response;
  }
};
//# sourceMappingURL=useTheme.js.map


/***/ }),

/***/ 67515:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var useThemeName_exports = {};
__export(useThemeName_exports, {
  useThemeName: () => useThemeName
});
module.exports = __toCommonJS(useThemeName_exports);
var import_react = __toESM(__webpack_require__(44194)), import_constants = __webpack_require__(77505), import_ThemeManagerContext = __webpack_require__(99953), import_useTheme = __webpack_require__(67265);
function useThemeName(opts) {
  const manager = (0, import_useTheme.getThemeManager)(import_react.default.useContext(import_ThemeManagerContext.ThemeManagerIDContext)), [name, setName] = import_react.default.useState(manager?.state.name || "");
  return (0, import_constants.useIsomorphicLayoutEffect)(() => {
    if (manager)
      return setName(manager.state.name), manager.onChangeTheme((next, manager2) => {
        const name2 = opts?.parent && manager2.state.parentName || next;
        name2 && setName(name2);
      });
  }, [manager?.state.name]), name;
}
//# sourceMappingURL=useThemeName.js.map


/***/ }),

/***/ 77330:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
}, __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var src_exports = {};
__export(src_exports, {
  configureMedia: () => import_useMedia.configureMedia,
  getConfig: () => import_config.getConfig,
  getMedia: () => import_useMedia.getMedia,
  getThemes: () => import_config.getThemes,
  getToken: () => import_config.getToken,
  getTokenValue: () => import_config.getTokenValue,
  getTokens: () => import_config.getTokens,
  mediaKeyMatch: () => import_useMedia.mediaKeyMatch,
  mediaObjectToString: () => import_useMedia.mediaObjectToString,
  mediaQueryConfig: () => import_useMedia.mediaQueryConfig,
  mediaState: () => import_useMedia.mediaState,
  setNonce: () => import_insertStyleRule.setNonce,
  setupDev: () => import_config.setupDev,
  updateConfig: () => import_config.updateConfig,
  useMedia: () => import_useMedia.useMedia
});
module.exports = __toCommonJS(src_exports);
__reExport(src_exports, __webpack_require__(9172), module.exports);
__reExport(src_exports, __webpack_require__(92594), module.exports);
__reExport(src_exports, __webpack_require__(33961), module.exports);
__reExport(src_exports, __webpack_require__(5257), module.exports);
__reExport(src_exports, __webpack_require__(79803), module.exports);
__reExport(src_exports, __webpack_require__(41684), module.exports);
__reExport(src_exports, __webpack_require__(24358), module.exports);
__reExport(src_exports, __webpack_require__(68836), module.exports);
__reExport(src_exports, __webpack_require__(12817), module.exports);
__reExport(src_exports, __webpack_require__(65196), module.exports);
__reExport(src_exports, __webpack_require__(80207), module.exports);
__reExport(src_exports, __webpack_require__(14319), module.exports);
__reExport(src_exports, __webpack_require__(13131), module.exports);
var import_config = __webpack_require__(98211), import_insertStyleRule = __webpack_require__(55915);
__reExport(src_exports, __webpack_require__(24881), module.exports);
__reExport(src_exports, __webpack_require__(31301), module.exports);
__reExport(src_exports, __webpack_require__(75425), module.exports);
__reExport(src_exports, __webpack_require__(15446), module.exports);
__reExport(src_exports, __webpack_require__(69345), module.exports);
__reExport(src_exports, __webpack_require__(7936), module.exports);
__reExport(src_exports, __webpack_require__(87138), module.exports);
__reExport(src_exports, __webpack_require__(62719), module.exports);
__reExport(src_exports, __webpack_require__(11792), module.exports);
__reExport(src_exports, __webpack_require__(12538), module.exports);
__reExport(src_exports, __webpack_require__(92594), module.exports);
__reExport(src_exports, __webpack_require__(42274), module.exports);
__reExport(src_exports, __webpack_require__(17419), module.exports);
__reExport(src_exports, __webpack_require__(20023), module.exports);
__reExport(src_exports, __webpack_require__(33224), module.exports);
__reExport(src_exports, __webpack_require__(53960), module.exports);
__reExport(src_exports, __webpack_require__(60355), module.exports);
__reExport(src_exports, __webpack_require__(66503), module.exports);
__reExport(src_exports, __webpack_require__(84423), module.exports);
__reExport(src_exports, __webpack_require__(29681), module.exports);
__reExport(src_exports, __webpack_require__(10069), module.exports);
__reExport(src_exports, __webpack_require__(85335), module.exports);
__reExport(src_exports, __webpack_require__(88715), module.exports);
__reExport(src_exports, __webpack_require__(71721), module.exports);
__reExport(src_exports, __webpack_require__(68867), module.exports);
__reExport(src_exports, __webpack_require__(52531), module.exports);
__reExport(src_exports, __webpack_require__(73488), module.exports);
var import_useMedia = __webpack_require__(31094);
__reExport(src_exports, __webpack_require__(67265), module.exports);
__reExport(src_exports, __webpack_require__(67515), module.exports);
__reExport(src_exports, __webpack_require__(2647), module.exports);
__reExport(src_exports, __webpack_require__(48081), module.exports);
__reExport(src_exports, __webpack_require__(7942), module.exports);
__reExport(src_exports, __webpack_require__(2647), module.exports);
__reExport(src_exports, __webpack_require__(91423), module.exports);
__reExport(src_exports, __webpack_require__(56104), module.exports);
__reExport(src_exports, __webpack_require__(12949), module.exports);
__reExport(src_exports, __webpack_require__(16573), module.exports);
__reExport(src_exports, __webpack_require__(32676), module.exports);
__reExport(src_exports, __webpack_require__(92198), module.exports);
__reExport(src_exports, __webpack_require__(7714), module.exports);
__reExport(src_exports, __webpack_require__(52259), module.exports);
__reExport(src_exports, __webpack_require__(70435), module.exports);
__reExport(src_exports, __webpack_require__(87899), module.exports);
__reExport(src_exports, __webpack_require__(77305), module.exports);
__reExport(src_exports, __webpack_require__(82558), module.exports);
__reExport(src_exports, __webpack_require__(89953), module.exports);
__reExport(src_exports, __webpack_require__(77505), module.exports);
__reExport(src_exports, __webpack_require__(27780), module.exports);
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 65196:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var insertFont_exports = {};
__export(insertFont_exports, {
  insertFont: () => insertFont,
  parseFont: () => parseFont,
  registerFontVariables: () => registerFontVariables,
  updateFont: () => updateFont
});
module.exports = __toCommonJS(insertFont_exports);
var import_config = __webpack_require__(98211), import_constants = __webpack_require__(24881), import_createFont = __webpack_require__(41684), import_createVariables = __webpack_require__(12817), import_registerCSSVariable = __webpack_require__(2277);
function insertFont(name, fontIn) {
  const font = (0, import_createFont.createFont)(fontIn), tokened = (0, import_createVariables.createVariables)(font, name), parsed = parseFont(tokened);
  if (typeof document < "u") {
    const fontVars = registerFontVariables(parsed), styleElement = document.querySelector(`style[${import_constants.FONT_DATA_ATTRIBUTE_NAME}="${name}"]`) || document.createElement("style");
    styleElement.innerText = `:root .font_${name} {${fontVars.join(";")}}`, styleElement.setAttribute(import_constants.FONT_DATA_ATTRIBUTE_NAME, name), document.head.appendChild(styleElement);
  }
  return (0, import_config.setConfigFont)(name, tokened, parsed), parsed;
}
const updateFont = insertFont;
function parseFont(definition) {
  const parsed = {};
  for (const attrKey in definition) {
    const attr = definition[attrKey];
    if (attrKey === "family" || attrKey === "face")
      parsed[attrKey] = attr;
    else {
      parsed[attrKey] = {};
      for (const key in attr) {
        let val = attr[key];
        val.val?.[0] === "$" && (val = val.val), parsed[attrKey][`$${key}`] = val;
      }
    }
  }
  return parsed;
}
function registerFontVariables(parsedFont) {
  const response = [];
  for (const fkey in parsedFont)
    if (fkey !== "face") {
      if (fkey === "family") {
        const val = parsedFont[fkey];
        (0, import_registerCSSVariable.registerCSSVariable)(val), response.push((0, import_registerCSSVariable.variableToCSS)(val));
      } else
        for (const fskey in parsedFont[fkey])
          if (typeof parsedFont[fkey][fskey] != "string") {
            const val = parsedFont[fkey][fskey];
            (0, import_registerCSSVariable.registerCSSVariable)(val), response.push((0, import_registerCSSVariable.variableToCSS)(val));
          }
    }
  return response;
}
//# sourceMappingURL=insertFont.js.map


/***/ }),

/***/ 13131:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var GetRef_exports = {};
module.exports = __toCommonJS(GetRef_exports);
//# sourceMappingURL=GetRef.js.map


/***/ }),

/***/ 27780:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var setupHooks_exports = {};
__export(setupHooks_exports, {
  hooks: () => hooks,
  setupHooks: () => setupHooks
});
module.exports = __toCommonJS(setupHooks_exports);
const hooks = {};
function setupHooks(next) {
  Object.assign(hooks, next);
}
//# sourceMappingURL=setupHooks.js.map


/***/ }),

/***/ 14319:
/***/ (function(module) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var setupReactNative_exports = {};
__export(setupReactNative_exports, {
  getReactNativeConfig: () => getReactNativeConfig,
  setupReactNative: () => setupReactNative
});
module.exports = __toCommonJS(setupReactNative_exports);
const ReactNativeStaticConfigs = /* @__PURE__ */ new WeakMap();
function getReactNativeConfig(Component) {
  if (Component)
    return Component.getSize && Component.prefetch ? RNConfigs.Image : Component.displayName === "Text" && Component.render ? RNConfigs.Text : Component.render && (Component.displayName === "ScrollView" || Component.displayName === "View") ? RNConfigs.default : Component.State?.blurTextInput ? RNConfigs.TextInput : ReactNativeStaticConfigs.get(Component);
}
const RNConfigs = {
  Image: {
    isReactNative: !0,
    inlineProps: /* @__PURE__ */ new Set(["src", "width", "height"])
  },
  Text: {
    isReactNative: !0,
    isText: !0
  },
  TextInput: {
    isReactNative: !0,
    isInput: !0,
    isText: !0
  },
  default: {
    isReactNative: !0
  }
};
function setupReactNative(rnExports) {
}
//# sourceMappingURL=setupReactNative.js.map


/***/ }),

/***/ 80207:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var styled_exports = {};
__export(styled_exports, {
  styled: () => styled
});
module.exports = __toCommonJS(styled_exports);
var import_createComponent = __webpack_require__(92594), import_mergeVariants = __webpack_require__(61686), import_setupReactNative = __webpack_require__(14319);
function styled(ComponentIn, options, staticExtractionOptions) {
  if (false)
    {}
  const parentStaticConfig = ComponentIn.staticConfig, isPlainStyledComponent = !!parentStaticConfig && !(parentStaticConfig.isReactNative || parentStaticConfig.isHOC);
  let Component = parentStaticConfig?.isHOC && !parentStaticConfig?.isStyledHOC || isPlainStyledComponent ? ComponentIn : parentStaticConfig?.Component || ComponentIn;
  const reactNativeConfig = parentStaticConfig ? void 0 : (0, import_setupReactNative.getReactNativeConfig)(Component), isReactNative = !!(reactNativeConfig || staticExtractionOptions?.isReactNative || parentStaticConfig?.isReactNative), staticConfigProps = (() => {
    if (options) {
      let {
        variants,
        name,
        defaultVariants,
        acceptsClassName: acceptsClassNameProp,
        context,
        ...defaultProps
      } = options, parentDefaultVariants, parentDefaultProps;
      if (parentStaticConfig && !(parentStaticConfig.isHOC && !parentStaticConfig.isStyledHOC)) {
        const pdp = parentStaticConfig.defaultProps;
        for (const key in pdp) {
          const val = pdp[key];
          parentStaticConfig.defaultVariants && key in parentStaticConfig.defaultVariants && (!defaultVariants || !(key in defaultVariants)) && (parentDefaultVariants ||= {}, parentDefaultVariants[key] = val), key in defaultProps || (parentDefaultProps ||= {}, parentDefaultProps[key] = pdp[key]);
        }
        parentStaticConfig.variants && (variants = (0, import_mergeVariants.mergeVariants)(parentStaticConfig.variants, variants));
      }
      (parentDefaultProps || defaultVariants || parentDefaultVariants) && (defaultProps = {
        ...parentDefaultProps,
        ...parentDefaultVariants,
        ...defaultProps,
        ...defaultVariants
      }), parentStaticConfig?.isHOC && name && (defaultProps.componentName = name);
      const isText = !!(staticExtractionOptions?.isText || parentStaticConfig?.isText), acceptsClassName = staticExtractionOptions?.acceptsClassName ?? acceptsClassNameProp ?? (isPlainStyledComponent || isReactNative || parentStaticConfig?.isHOC && parentStaticConfig?.acceptsClassName), conf = {
        ...parentStaticConfig,
        ...staticExtractionOptions,
        ...!isPlainStyledComponent && {
          Component
        },
        // @ts-expect-error
        variants,
        defaultProps,
        defaultVariants,
        componentName: name || parentStaticConfig?.componentName,
        isReactNative,
        isText,
        acceptsClassName,
        context,
        ...reactNativeConfig,
        isStyledHOC: !!parentStaticConfig?.isHOC,
        parentStaticConfig
      };
      return (defaultProps.children || !acceptsClassName || context) && (conf.neverFlatten = !0), conf;
    }
  })(), component = (0, import_createComponent.createComponent)(staticConfigProps || {});
  for (const key in ComponentIn)
    key !== "propTypes" && (key in component || (component[key] = ComponentIn[key]));
  return component;
}
//# sourceMappingURL=styled.js.map


/***/ }),

/***/ 70435:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var Configuration_exports = {};
__export(Configuration_exports, {
  Configuration: () => Configuration
});
module.exports = __toCommonJS(Configuration_exports);
var import_react = __toESM(__webpack_require__(44194)), import_ComponentContext = __webpack_require__(31301), import_jsx_runtime = __webpack_require__(31549);
const Configuration = (props) => {
  const current = import_react.default.useContext(import_ComponentContext.ComponentContext);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ComponentContext.ComponentContext.Provider, { ...current, ...props });
};
Configuration.displayName = "Configuration";
//# sourceMappingURL=Configuration.js.map


/***/ }),

/***/ 7714:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var FontLanguage_exports = {};
__export(FontLanguage_exports, {
  FontLanguage: () => FontLanguage
});
module.exports = __toCommonJS(FontLanguage_exports);
var import_jsx_runtime = __webpack_require__(31549);
const FontLanguage = ({ children, ...props }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
  "div",
  {
    style: {
      display: "contents"
    },
    className: Object.entries(props).map(([name, language]) => `t_lang-${name}-${language}`).join(" "),
    children
  }
);
FontLanguage.displayName = "FontLanguage";
//# sourceMappingURL=FontLanguage.js.map


/***/ }),

/***/ 91423:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var Slot_exports = {};
__export(Slot_exports, {
  Slot: () => Slot,
  Slottable: () => Slottable
});
module.exports = __toCommonJS(Slot_exports);
var import_compose_refs = __webpack_require__(82558), import_constants = __webpack_require__(77505), import_helpers = __webpack_require__(89953), import_react = __webpack_require__(44194), import_jsx_runtime = __webpack_require__(31549);
const is19 = import_react.version.startsWith("19."), Slot = (0, import_react.forwardRef)(function(props, forwardedRef) {
  const { children, ...slotProps } = props;
  if ((0, import_react.isValidElement)(children)) {
    const mergedProps = mergeSlotProps(children, slotProps);
    return (0, import_react.cloneElement)(
      children,
      children.type.avoidForwardRef ? mergedProps : {
        ...mergedProps,
        ref: (0, import_compose_refs.composeRefs)(
          forwardedRef,
          is19 ? children.props.ref : children.ref
        )
      }
    );
  }
  return import_react.Children.count(children) > 1 ? import_react.Children.only(null) : null;
});
Slot.displayName = "Slot";
const Slottable = ({ children }) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, { children });
Slottable.displayName = "Slottable";
const pressMap = import_constants.isWeb ? {
  onPress: "onClick",
  onPressOut: "onMouseUp",
  onPressIn: "onMouseDown"
} : {};
function mergeSlotProps(child, slotProps) {
  const childProps = child.props, overrideProps = { ...childProps }, isHTMLChild = typeof child.type == "string";
  if (isHTMLChild)
    for (const key in pressMap)
      key in slotProps && (slotProps[pressMap[key]] = slotProps[key], delete slotProps[key]);
  for (let propName in childProps) {
    const slotPropValue = slotProps[propName], childPropValue = childProps[propName];
    isHTMLChild && propName in pressMap && (propName = pressMap[propName], delete overrideProps[propName]), handleRegex.test(propName) ? overrideProps[propName] = (0, import_helpers.composeEventHandlers)(childPropValue, slotPropValue) : propName === "style" ? overrideProps[propName] = { ...slotPropValue, ...childPropValue } : propName === "className" && (overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" "));
  }
  return { ...slotProps, ...overrideProps };
}
const handleRegex = /^on[A-Z]/;
//# sourceMappingURL=Slot.js.map


/***/ }),

/***/ 56104:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var Stack_exports = {};
__export(Stack_exports, {
  Stack: () => Stack
});
module.exports = __toCommonJS(Stack_exports);
var import_helpers = __webpack_require__(89953), import_constants = __webpack_require__(24881), import_createComponent = __webpack_require__(92594);
const Stack = (0, import_createComponent.createComponent)({
  acceptsClassName: !0,
  defaultProps: import_constants.stackDefaultStyles,
  validStyles: import_helpers.validStyles
});
Stack.displayName = "Stack";
//# sourceMappingURL=Stack.js.map


/***/ }),

/***/ 52259:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var TamaguiProvider_exports = {};
__export(TamaguiProvider_exports, {
  TamaguiProvider: () => TamaguiProvider
});
module.exports = __toCommonJS(TamaguiProvider_exports);
var import_react = __toESM(__webpack_require__(44194)), import_constants = __webpack_require__(77505), import_ComponentContext = __webpack_require__(31301), import_useDidHydrateOnce = __webpack_require__(25851), import_useMedia = __webpack_require__(31094), import_ThemeProvider = __webpack_require__(92198), import_config = __webpack_require__(98211), import_jsx_runtime = __webpack_require__(31549);
function TamaguiProvider({
  children,
  disableInjectCSS,
  config,
  className,
  defaultTheme,
  disableRootThemeClass,
  reset,
  themeClassNameOnRoot
}) {
  return (0, import_useMedia.setupMediaListeners)(), import_constants.isClient && ((0, import_useDidHydrateOnce.useDidHydrateOnceRoot)(), (0, import_constants.useIsomorphicLayoutEffect)(() => {
    if (config && !disableInjectCSS) {
      const style = document.createElement("style");
      return style.appendChild(document.createTextNode(config.getCSS())), document.head.appendChild(style), () => {
        document.head.removeChild(style);
      };
    }
  }, [config, disableInjectCSS])), /* @__PURE__ */ (0, import_jsx_runtime.jsx)(UnmountedClassName, { children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ComponentContext.ComponentContext.Provider, { animationDriver: config?.animations, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_ThemeProvider.ThemeProvider,
    {
      themeClassNameOnRoot: themeClassNameOnRoot ?? (0, import_config.getSetting)("themeClassNameOnRoot"),
      disableRootThemeClass: disableRootThemeClass ?? (0, import_config.getSetting)("disableRootThemeClass"),
      defaultTheme: defaultTheme ?? (config ? Object.keys(config.themes)[0] : ""),
      reset,
      className,
      children
    }
  ) }) });
}
function UnmountedClassName(props) {
  const [mounted, setMounted] = import_react.default.useState(!1);
  return import_react.default.useEffect(() => {
    setMounted(!0);
  }, []), import_constants.isWeb ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", { style: { display: "contents" }, className: mounted ? "" : "t_unmounted", children: props.children }) : props.children;
}
TamaguiProvider.displayName = "TamaguiProvider";
//# sourceMappingURL=TamaguiProvider.js.map


/***/ }),

/***/ 16573:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var Text_exports = {};
__export(Text_exports, {
  Text: () => Text
});
module.exports = __toCommonJS(Text_exports);
var import_helpers = __webpack_require__(89953), import_createComponent = __webpack_require__(92594);
const ellipseStyle = {
  maxWidth: "100%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, defaultWebStyle = {
  display: "inline",
  // display: inline breaks css transform styles
  boxSizing: "border-box",
  wordWrap: "break-word",
  whiteSpace: "pre-wrap",
  margin: 0
}, ellipsisStyle = ellipseStyle, Text = (0, import_createComponent.createComponent)({
  acceptsClassName: !0,
  isText: !0,
  defaultProps: {
    fontFamily: "unset",
    ...defaultWebStyle
  },
  inlineWhenUnflattened: /* @__PURE__ */ new Set(["fontFamily"]),
  variants: {
    numberOfLines: {
      1: ellipseStyle,
      ":number": (numberOfLines) => numberOfLines >= 1 ? {
        WebkitLineClamp: numberOfLines,
        WebkitBoxOrient: "vertical",
        display: "-webkit-box",
        overflow: "hidden"
      } : null
    },
    selectable: {
      true: {
        userSelect: "text",
        cursor: "text"
      },
      false: {
        userSelect: "none",
        cursor: "default"
      }
    },
    /**
     * @deprecated Use ellipsis instead
     */
    ellipse: {
      true: ellipsisStyle
    },
    ellipsis: {
      true: ellipsisStyle
    }
  },
  validStyles: {
    ...import_helpers.validStyles,
    ...import_helpers.stylePropsTextOnly
  }
});
Text.displayName = "Text";
//# sourceMappingURL=Text.js.map


/***/ }),

/***/ 32676:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var Theme_exports = {};
__export(Theme_exports, {
  Theme: () => Theme,
  getThemedChildren: () => getThemedChildren
});
module.exports = __toCommonJS(Theme_exports);
var import_constants = __webpack_require__(77505), import_react = __toESM(__webpack_require__(44194)), import_createVariable = __webpack_require__(68836), import_ThemeManagerContext = __webpack_require__(99953), import_useTheme = __webpack_require__(67265), import_ThemeDebug = __webpack_require__(54109), import_log = __webpack_require__(50265), import_jsx_runtime = __webpack_require__(31549);
const Theme = (0, import_react.forwardRef)(function({ children, ...props }, ref) {
  if (props.disable)
    return children;
  const isRoot = !!props._isRoot, themeState = (0, import_useTheme.useChangeThemeEffect)(props, isRoot);
  let finalChildren = props["disable-child-theme"] ? import_react.Children.map(
    children,
    (child) => (0, import_react.cloneElement)(child, { "data-disable-theme": !0 })
  ) : children;
  if (ref)
    try {
      import_react.default.Children.only(finalChildren), finalChildren = (0, import_react.cloneElement)(finalChildren, { ref });
    } catch {
    }
   false && (0);
  const stateRef = (0, import_react.useRef)({
    hasEverThemed: !1
  });
  return getThemedChildren(themeState, finalChildren, props, isRoot, stateRef);
});
Theme.displayName = "Theme";
Theme.avoidForwardRef = !0;
function getThemedChildren(themeState, children, props, isRoot = !1, stateRef) {
  const { themeManager, isNewTheme } = themeState;
  if (!themeManager)
    throw new Error(
       false ? 0 : "\u274C 005"
    );
  const { shallow, forceClassName } = props;
  let shouldRenderChildrenWithTheme = isNewTheme || isRoot || stateRef.current.hasEverThemed || typeof props.inverse == "boolean";
  if (shouldRenderChildrenWithTheme && (stateRef.current.hasEverThemed = !0), !shouldRenderChildrenWithTheme)
    return children;
   false && 0;
  let next = children;
  shallow && (next = import_react.Children.toArray(children).map((child) => (0, import_react.isValidElement)(child) ? (0, import_react.cloneElement)(
    child,
    void 0,
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Theme, { name: themeManager.state.parentName, children: child.props.children })
  ) : child));
  const elementsWithContext = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ThemeManagerContext.ThemeManagerIDContext.Provider, { value: themeManager.id, children: next });
  return forceClassName === !1 ? elementsWithContext : import_constants.isWeb ? wrapThemeElements({
    children: elementsWithContext,
    themeState,
    forceClassName,
    isRoot
  }) : elementsWithContext;
}
function wrapThemeElements({
  children,
  themeState,
  forceClassName,
  isRoot
}) {
  if (isRoot && forceClassName === !1)
    return children;
  const inverse = themeState.inversed, requiresExtraWrapper = inverse != null || forceClassName, { className, style } = getThemeClassNameAndStyle(themeState, isRoot);
  let themedChildren = /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", { className: `${className} _dsp_contents is_Theme`, style, children });
  if (requiresExtraWrapper) {
    const name = themeState.state?.name || "", inverseClassName = name.startsWith("light") ? "t_light is_inversed" : name.startsWith("dark") ? "t_dark is_inversed" : "";
    themedChildren = /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", { className: `${inverse ? inverseClassName : ""} _dsp_contents`, children: themedChildren });
  }
  return themedChildren;
}
const emptyObj = {};
function getThemeClassNameAndStyle(themeState, isRoot = !1) {
  if (!themeState.isNewTheme)
    return { className: "", style: emptyObj };
  const themeColor = themeState.state?.theme && themeState.isNewTheme ? (0, import_createVariable.variableToString)(themeState.state.theme.color) : "", style = themeColor ? {
    color: themeColor
  } : void 0;
  let className = themeState.state?.className || "";
  return isRoot && (className = className.replace("t_sub_theme", "")), { style, className };
}
//# sourceMappingURL=Theme.js.map


/***/ }),

/***/ 54109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var ThemeDebug_exports = {};
__export(ThemeDebug_exports, {
  ThemeDebug: () => ThemeDebug
});
module.exports = __toCommonJS(ThemeDebug_exports);
var import_react = __toESM(__webpack_require__(44194)), import_use_did_finish_ssr = __webpack_require__(87899), import_use_force_update = __webpack_require__(9889), import_react_dom = __webpack_require__(56321), import_jsx_runtime = __webpack_require__(31549);
let node;
function ThemeDebug({
  themeState,
  themeProps,
  children
}) {
  if (false) {}
  return children;
}
ThemeDebug.displayName = "ThemeDebug";
//# sourceMappingURL=ThemeDebug.js.map


/***/ }),

/***/ 92198:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: !0 }) : target,
  mod
)), __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var ThemeProvider_exports = {};
__export(ThemeProvider_exports, {
  ThemeProvider: () => ThemeProvider
});
module.exports = __toCommonJS(ThemeProvider_exports);
var import_react = __toESM(__webpack_require__(44194)), import_constants = __webpack_require__(77505), import_constants2 = __webpack_require__(24881), import_Theme = __webpack_require__(32676), import_config = __webpack_require__(98211), import_jsx_runtime = __webpack_require__(31549);
const ThemeProvider = (props) => (import_constants.isClient && import_react.default.useLayoutEffect(() => {
  if (props.disableRootThemeClass) return;
  const cn = `${import_constants2.THEME_CLASSNAME_PREFIX}${props.defaultTheme}`, target = props.themeClassNameOnRoot ?? (0, import_config.getSetting)("themeClassNameOnRoot") ? document.documentElement : document.body;
  return target.classList.add(cn), () => {
    target.classList.remove(cn);
  };
}, [props.defaultTheme, props.disableRootThemeClass, props.themeClassNameOnRoot]), /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
  import_Theme.Theme,
  {
    className: props.className,
    name: props.defaultTheme,
    forceClassName: !props.disableRootThemeClass,
    _isRoot: !0,
    children: props.children
  }
));
//# sourceMappingURL=ThemeProvider.js.map


/***/ }),

/***/ 12949:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: !0 });
}, __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function")
    for (let key of __getOwnPropNames(from))
      !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);
var View_exports = {};
__export(View_exports, {
  View: () => View
});
module.exports = __toCommonJS(View_exports);
var import_helpers = __webpack_require__(89953), import_constants = __webpack_require__(24881), import_createComponent = __webpack_require__(92594);
const View = (0, import_createComponent.createComponent)({
  acceptsClassName: !0,
  defaultProps: import_constants.stackDefaultStyles,
  validStyles: import_helpers.validStyles
});
//# sourceMappingURL=View.js.map


/***/ }),

/***/ 51979:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}

}());


/***/ }),

/***/ 10063:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(99415);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 37462:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.1.4
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ 94711:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(42101)


/***/ }),

/***/ 68276:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(66021);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 80079:
/***/ (function() {

"use strict";
var _sentryCollisionFreeGlobalObject =  true ? window : 0;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {
    "id": "cosmos@fc8e385bd75ab9d65b25adb5eb5d41337a3ac64b"
};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";



/***/ }),

/***/ 12990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Yr": function() { return /* binding */ AddressAutocomplete; },
  "bY": function() { return /* binding */ CancelBuyDirectOfferStatus; },
  "h6": function() { return /* binding */ GetGeoShapeFromUserLocation; },
  "NA": function() { return /* binding */ GetPropertiesFromGeoShape; },
  "xR": function() { return /* binding */ GetUnlockPropertyInfo; },
  "BH": function() { return /* binding */ cancelBuyDirectOffer; },
  "xB": function() { return /* binding */ createMortgageLead; },
  "lX": function() { return /* binding */ createSellerInput; },
  "Tc": function() { return /* binding */ doBFFPost; },
  "gc": function() { return /* binding */ doGet; },
  "cv": function() { return /* binding */ fetchSellerReturnExperience; },
  "k8": function() { return /* binding */ getAthenaClient; },
  "X_": function() { return /* binding */ getBuyDirectPropertyInfo; },
  "OC": function() { return /* binding */ getFeatureFlag; },
  "WQ": function() { return /* binding */ getResaleOffers; },
  "DF": function() { return /* binding */ getSessionExtras; },
  "wf": function() { return /* binding */ requestNewToken; },
  "fs": function() { return /* binding */ requestNewTokenByEmail; },
  "ce": function() { return /* binding */ standardizeAddress; },
  "Y": function() { return /* binding */ unsubscribeMailer; },
  "gh": function() { return /* binding */ updateAnswers; },
  "Yj": function() { return /* binding */ updateCurrentCustomer; },
  "il": function() { return /* binding */ validatePartnerEmailAddress; }
});

// UNUSED EXPORTS: fetchTraitByAnonymousId

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(60947);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(99758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92336);
// EXTERNAL MODULE: ../observability/dist/observability-slim.mjs + 2 modules
var observability_slim = __webpack_require__(75461);
// EXTERNAL MODULE: ../../node_modules/.pnpm/graphql-request@7.4.0_graphql@16.14.0/node_modules/graphql-request/build/entrypoints/main.js + 14 modules
var main = __webpack_require__(84209);
// EXTERNAL MODULE: ../../node_modules/.pnpm/js-cookie@2.1.4/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(37462);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(15771);
// EXTERNAL MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/language/parser.mjs + 11 modules
var parser = __webpack_require__(54398);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.14.0/node_modules/graphql-tag/lib/index.js


var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function cacheKeyFromLoc(loc) {
    return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function (fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if (printFragmentWarnings) {
                    console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
                        + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
                        + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                }
            }
            else if (!sourceKeySet) {
                fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            }
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        }
        else {
            definitions.push(fragmentDefinition);
        }
    });
    return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, ast), { definitions: definitions });
}
function stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function (node) {
        if (node.loc)
            delete node.loc;
        Object.keys(node).forEach(function (key) {
            var value = node[key];
            if (value && typeof value === 'object') {
                workSet.add(value);
            }
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function parseDocument(source) {
    var cacheKey = normalize(source);
    if (!docCache.has(cacheKey)) {
        var parsed = (0,parser/* parse */.Qc)(source, {
            experimentalFragmentVariables: experimentalFragmentVariables,
            allowLegacyFragmentVariables: experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') {
            throw new Error('Not a valid GraphQL document.');
        }
        docCache.set(cacheKey, stripLoc(processFragments(parsed)));
    }
    return docCache.get(cacheKey);
}
function gql(literals) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof literals === 'string') {
        literals = [literals];
    }
    var result = literals[0];
    args.forEach(function (arg, i) {
        if (arg && arg.kind === 'Document') {
            result += arg.loc.source.body;
        }
        else {
            result += arg;
        }
        result += literals[i + 1];
    });
    return parseDocument(result);
}
function resetCaches() {
    docCache.clear();
    fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
    printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
    experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
    experimentalFragmentVariables = false;
}
var extras = {
    gql: gql,
    resetCaches: resetCaches,
    disableFragmentWarnings: disableFragmentWarnings,
    enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
    disableExperimentalFragmentVariables: disableExperimentalFragmentVariables
};
(function (gql_1) {
    gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;
/* harmony default export */ var lib = (gql);
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./src/__generated__/athena.ts


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment SimilarProperty on MarketplacePropertyListResult {\n  id\n  addressToken\n  baths\n  beds\n  city\n  dwellingType\n  estimatedMonthlyPayment\n  fullAddress\n  listPrice\n  livingSquareFootage\n  neighborhood\n  slug\n  photos\n}\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment SimilarProperties on MarketplacePropertyListQueryResult {\n  results {\n    ...SimilarProperty\n  }\n  count\n  nextPage\n}\n    ",
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment PropertyDetails on MarketplaceProperty {\n  addressToken\n  bathrooms\n  bedrooms\n  buyDirectPrice\n  canSelfTour\n  city\n  cumulativeDaysOnMarket\n  daysOnMarket\n  description\n  displayBadge\n  dwellingType\n  estimatedMonthlyPayment\n  exteriorStories\n  fhaEligible\n  fhaEligibleDate\n  garageSpaces\n  hasPrivatePool\n  hasCommunityPool\n  hoas {\n    name\n    feeAmount\n    feeFrequency\n  }\n  inGatedCommunity\n  kitchenCountertop\n  latitude\n  longitude\n  listPrice\n  listingHistory {\n    state\n    timestamp\n    mls\n    originalListPriceCents\n    soldPriceCents\n    currentListPriceCents\n  }\n  listingMetadata {\n    buyDirectDiscountPercent\n  }\n  estimatedBuyDirectMonthlyPayment\n  listingState\n  listingTags\n  market\n  masterBedroomLocation\n  floorPlanPhotos {\n    url\n    label\n  }\n  photos\n  pricePerSqFt\n  shouldShowGuarantee\n  schoolDistricts\n  schools {\n    id\n    name\n    rating\n  }\n  sellerDisclosuresDownloadUrl\n  similarProperties {\n    ...SimilarProperties\n  }\n  slug\n  sqFtLot\n  sqFtTotalLiving\n  state\n  street\n  subdivision\n  unitType\n  unitNumber\n  yearBuilt\n  zip\n}\n    ",
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment PropertiesByMarketResult on PropertySearchResult {\n  displaySlug\n  bedrooms\n  bathroomsTotal\n  originalListPrice\n  sqFtTotalLiving\n  sqFtAboveGrade\n  listPrice\n  listTimestamp\n  street\n  unitType\n  unitNumber\n  city\n  state\n  postalCode\n  longitude\n  latitude\n  sqFtLot\n  addressId\n  photos(pageInput: {first: 5}) {\n    nodes {\n      id\n      urls {\n        resizable\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment MarketplacePropertySearchResult on MarketplacePropertySearchResult {\n  id\n  addressToken\n  badges\n  beds\n  baths\n  isLiked\n  listDate\n  listPrice\n  livingSquareFootage\n  listingState\n  location {\n    lat\n    lon\n  }\n  photos\n  slug\n  state\n  street\n}\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment MarketplacePropertySearch on MarketplacePropertySearchQueryResult {\n  count\n  results {\n    ...MarketplacePropertySearchResult\n  }\n}\n    ",
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment AddressSearchResult on AddressSearchProperty {\n  addressToken\n  id\n  fullAddress\n  priceCents\n}\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment MarketplacePropertyListResult on MarketplacePropertyListResult {\n  id\n  addressToken\n  badges\n  beds\n  baths\n  city\n  dwellingType\n  estimatedMonthlyPayment\n  fullAddress\n  isLiked\n  listDate\n  listPrice\n  livingSquareFootage\n  listingState\n  neighborhood\n  photos\n  slug\n  state\n  street\n  zip\n}\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment MarketplacePropertyList on MarketplacePropertyListQueryResult {\n  count\n  nextPage\n  results {\n    ...MarketplacePropertyListResult\n  }\n}\n    ",
        ""
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment BuyerPropertyReaction on OdProtosBuyerV2Data_PropertyReaction {\n  addressId\n  reaction\n  source\n}\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment MarketConfig on OdProtosBuyerData_MarketConfig {\n  shape\n  displayName\n  identifier\n  buyingExperience\n}\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    fragment SavedSearchFields on SavedSearch {\n  id\n  name\n  createdAt\n  origin\n  location {\n    market\n    zoneIds\n    vertices {\n      lat\n      lon\n    }\n    zones {\n      uuid\n      name\n      slug\n    }\n  }\n  filters {\n    minPriceDollars\n    maxPriceDollars\n    maxMonthlyHoaFeeDollars\n    minBedrooms\n    maxBedrooms\n    minBathrooms\n    maxBathrooms\n    minSqft\n    maxSqft\n    minLotSqft\n    maxLotSqft\n    minYearBuilt\n    maxYearBuilt\n    opendoorOwnedOnly\n    selfTourableOnly\n    singleStoryOnly\n    hasPoolOnly\n    fhaEligibleOnly\n    propertyTypes\n  }\n}\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation UnsubscribeMailer($address: OdProtosWebServicesMarketing_UnsubscribeMailerRequestInput!) {\n  marketing {\n    unsubscribeMailer(input: $address) {\n      _empty\n    }\n  }\n}\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation SetMarketplacePropertyReaction($input: OdProtosBuyerV2ServicesBuyer_SetPropertyReactionRequestInput!) {\n  buyerService {\n    setPropertyReaction(input: $input) {\n      _empty\n    }\n  }\n}\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation RemoveMarketplacePropertyReaction($input: OdProtosBuyerV2ServicesBuyer_RemovePropertyReactionRequestInput!) {\n  buyerService {\n    removePropertyReaction(input: $input) {\n      _empty\n    }\n  }\n}\n    "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation SubmitTourFeedback($input: OdProtosBuyerV2ServicesBuyer_SubmitTourFeedbackRequestInput!) {\n  buyerService {\n    submitTourFeedback(input: $input) {\n      feedback {\n        tourFeedbackUuid\n        viewingAppointmentId\n        sentiment\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation SetImpression($grain: OdProtosVariantData_GrainInput, $key: String!, $variantValue: String!) {\n  variant {\n    setImpression(input: {grain: $grain, key: $key, variantValue: $variantValue}) {\n      _empty\n    }\n  }\n}\n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation UpdateCustomer($customerUuid: String!, $params: OdProtosCustomerV1Services_CustomerRequests_Update_ParamsInput!) {\n  customerService {\n    update(input: {uuid: $customerUuid, params: $params}) {\n      updatedCustomer {\n        uuid\n        createdAt\n        firstName\n        lastName\n        primaryEmail {\n          address {\n            value\n          }\n        }\n        otherEmails {\n          address {\n            value\n          }\n        }\n        primaryPhoneNumber {\n          number {\n            value\n          }\n          type\n        }\n        otherPhoneNumbers {\n          number {\n            value\n          }\n          type\n        }\n        isAgent\n        ccpaSaleOfDataOptOut\n        fullName\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation UpdateCurrentCustomer($customerUpdates: OdProtosCustomerV1Services_CustomerRequests_UpdateCurrentInput!) {\n  customerService {\n    updateCurrent(input: $customerUpdates) {\n      updatedCustomer {\n        uuid\n        createdAt\n        firstName\n        lastName\n        primaryEmail {\n          address {\n            value\n          }\n        }\n        otherEmails {\n          address {\n            value\n          }\n        }\n        primaryPhoneNumber {\n          number {\n            value\n          }\n          type\n        }\n        otherPhoneNumbers {\n          number {\n            value\n          }\n          type\n        }\n        isAgent\n        ccpaSaleOfDataOptOut\n        fullName\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation CreateViewingAppointment($customerUUID: String!, $appointmentDate: String!, $appointmentTime: String!, $listingId: Int, $duration: Int) {\n  web {\n    createViewingAppointment(\n      customerUUID: $customerUUID\n      appointmentDate: $appointmentDate\n      appointmentTime: $appointmentTime\n      listingId: $listingId\n      duration: $duration\n    ) {\n      id\n    }\n  }\n}\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation UploadAgentPhoto($key: String!) {\n  external {\n    aws {\n      s3CreatePutObjectPresignedUrl(\n        input: {clientName: IMGDROP_PRODUCTION, key: $key}\n      ) {\n        signedUrl\n        key\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation AddSavedSearch($input: SavedSearchInput!) {\n  customerAccount {\n    buying {\n      savedSearches {\n        add(input: $input) {\n          success\n          errorMessage\n          savedSearch {\n            ...SavedSearchFields\n          }\n        }\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation UpdateSavedSearch($id: ID!, $input: SavedSearchInput!) {\n  customerAccount {\n    buying {\n      savedSearches {\n        update(id: $id, input: $input) {\n          success\n          errorMessage\n          savedSearch {\n            ...SavedSearchFields\n          }\n        }\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation RemoveSavedSearch($id: ID!) {\n  customerAccount {\n    buying {\n      savedSearches {\n        remove(id: $id) {\n          success\n          errorMessage\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation InitiateCustomerTask($taskType: CustomerTaskType!, $id: String!) {\n  customerAccount {\n    buying {\n      initiateCustomerTask(input: {taskType: $taskType, id: $id}) {\n        success\n        errorMessage\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation CreateBuyDirectListingOffer($buyer: OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_CustomerInput!, $coBuyer: OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_CustomerInput, $downPaymentCents: Float, $financingType: OdProtosWebData_ListingOfferDetails_FinancingStatus, $closeOfEscrow: OdProtosCommon_DateInput, $preApprovalLetter: OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_DocumentInput, $listing: OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_ListingOneofInput, $addOns: [OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_AddOn!], $tradeInAddress: String, $requestedHeroesHomeCredit: Boolean) {\n  webBuyDirectListingOffer {\n    createBuyDirectOffer(\n      input: {buyer: $buyer, coBuyer: $coBuyer, downPaymentCents: $downPaymentCents, financingType: $financingType, closeOfEscrow: $closeOfEscrow, preApprovalLetter: $preApprovalLetter, listing: $listing, addOns: $addOns, tradeInAddress: $tradeInAddress, requestedHeroesHomeCredit: $requestedHeroesHomeCredit}\n    ) {\n      listingOfferId\n      listingOfferUuid\n      contractSignatureId\n    }\n  }\n}\n    "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetSchools($latitude: Float!, $longitude: Float!) {\n  geoDataStore {\n    getSchools(input: {latitude: $latitude, longitude: $longitude}) {\n      schools {\n        name\n        rating\n        educationLevel\n        greatSchoolsUrl\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetPropertyStatusForRoute($addressId: String!) {\n  property {\n    property(input: {addressId: $addressId}) {\n      addressId\n      displaySlug\n      isDisplayable\n      odMarketIdentifier\n    }\n  }\n}\n    "
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetMarketplacePropertyForRoute($addressId: ID!) {\n  marketplace {\n    property(addressToken: $addressId) {\n      addressToken\n      market\n      slug\n    }\n  }\n}\n    "
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetAddressForId($addressId: String!) {\n  casa {\n    find(input: {uuid: $addressId}) {\n      address {\n        street\n        unitNumber\n        city\n        state\n        postalCode\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetShortListingPropertyInfo($addressId: String!) {\n  property {\n    property(input: {addressId: $addressId}) {\n      addressId\n      sellRequestId\n      displaySlug\n      bathroomsHalf\n      bathroomsFull\n      bedrooms\n      listPrice\n      listingMetadata {\n        tags\n        buyDirectDiscountPercent\n      }\n      status\n      sqFtTotalLiving\n      sqFtAboveGrade\n      sqFtLot\n      yearBuilt\n      poolFeatures\n      publicRemarks\n      hoas {\n        name\n        feeAmount\n        feeFrequency\n        features\n      }\n      garageSpaces\n      photos(pageInput: {first: 50}) {\n        nodes {\n          id\n          urls {\n            resizable\n          }\n        }\n      }\n      sourceType\n    }\n  }\n}\n    "
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetMarketplacePropertyReaction($addressToken: ID!) {\n  marketplace {\n    property(addressToken: $addressToken) {\n      addressToken\n      isDisliked\n      isLiked\n    }\n  }\n}\n    "
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetMarketplacePropertySimilarProperties($addressToken: ID!) {\n  marketplace {\n    property(addressToken: $addressToken) {\n      similarProperties {\n        ...SimilarProperties\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetMarketplaceProperty($addressToken: ID!) {\n  marketplace {\n    property(addressToken: $addressToken) {\n      ...PropertyDetails\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetMarketplacePropertySellerDisclosures($addressToken: ID!) {\n  marketplace {\n    property(addressToken: $addressToken) {\n      sellerDisclosuresDownloadUrl\n    }\n  }\n}\n    "
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetMarketplacePropertyAccessCode($addressToken: ID!) {\n  marketplace {\n    property(addressToken: $addressToken) {\n      accessCode\n    }\n  }\n}\n    "
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetLongListingPropertyInfo($addressId: String!) {\n  property {\n    property(input: {addressId: $addressId}) {\n      addressId\n      odMarketIdentifier\n      statePropertyTaxRate\n      sellRequestId\n      city\n      displaySlug\n      postalCode\n      state\n      street\n      county\n      unitNumber\n      unitType\n      dwellingType\n      bedrooms\n      bathroomsHalf\n      bathroomsFull\n      builderName\n      exteriorStories\n      sellerDisclosuresDownloadUrl\n      listingMetadata {\n        tags\n        buyDirectDiscountPercent\n      }\n      listPrice\n      listTimestamp\n      status\n      sqFtTotalLiving\n      sqFtAboveGrade\n      sqFtLot\n      yearBuilt\n      poolFeatures\n      publicRemarks\n      hoas {\n        name\n        feeAmount\n        feeFrequency\n        features\n      }\n      inGatedCommunity\n      agent {\n        brokerage\n        firstName\n        lastName\n        fullName\n        licenseNumber\n        mls\n        mlsId\n        email\n        phoneNumber\n      }\n      listingOfficeName\n      apn\n      mls {\n        identifier\n        logoUrl\n        logoRequiredDimensions {\n          width\n          height\n        }\n        legalText\n        detailPageLogo\n        detailPageLegalText\n        detailPageAgentOffice\n        detailPageAgentName\n        detailPageMLSNumber\n        detailPageContactInfo\n      }\n      mlsDisplayPermission\n      mlsNumber\n      entryTimestamp\n      listTimestamp\n      sellRequestCreatedAt\n      newConstruction\n      opendoorOwned\n      instantTourable\n      schools {\n        id\n        name\n        rating\n        gradesOffered\n      }\n      sourceType\n      odMarketIdentifier\n      zones {\n        id\n        name\n        mapPageSlug\n      }\n      similarListings(input: {pageInput: {first: 5}}) {\n        results {\n          nodes {\n            addressId\n            displaySlug\n            city\n            postalCode\n            state\n            street\n            unitNumber\n            unitType\n            bedrooms\n            bathroomsTotal\n            listPrice\n            listTimestamp\n            status\n            photos(pageInput: {first: 1}) {\n              nodes {\n                id\n                urls {\n                  resizable\n                }\n              }\n            }\n            sqFtLot\n            sqFtTotalLiving\n            sqFtAboveGrade\n            listTimestamp\n            status\n            latitude\n            longitude\n          }\n        }\n      }\n      photos(pageInput: {first: 50}) {\n        nodes {\n          id\n          urls {\n            resizable\n          }\n        }\n      }\n      latitude\n      longitude\n      commissionBreakdown {\n        buyer {\n          value\n          type\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetMarketplacePropertySearch($market: String, $bedrooms: Int, $bathrooms: Float, $canSelfTour: Boolean, $hasPool: Boolean, $maxHoaMonthlyFee: Float, $maxSquareFootage: Int, $minSquareFootage: Int, $maxListPrice: Float, $minListPrice: Float, $maxYearBuilt: Int, $minYearBuilt: Int, $propertyTypes: [PropertyType!], $singleStoryOnly: Boolean, $vertices: [GeoPoint!], $zoneIds: [String!]) {\n  marketplace {\n    propertySearch(\n      filters: {listingState: ON_THE_MARKET, minBeds: $bedrooms, minBathrooms: $bathrooms, minListPrice: $minListPrice, maxListPrice: $maxListPrice, minSquareFootage: $minSquareFootage, maxSquareFootage: $maxSquareFootage, maxYearBuilt: $maxYearBuilt, minYearBuilt: $minYearBuilt, isSelfTourEligible: $canSelfTour, propertyType: $propertyTypes, hasSingleStory: $singleStoryOnly, hasPool: $hasPool, maxHoaMonthlyFee: $maxHoaMonthlyFee}\n      where: {market: $market, zoneIds: $zoneIds, vertices: $vertices}\n    ) {\n      ...MarketplacePropertySearch\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetMarketplacePropertyList($page: Int!, $market: String, $bedrooms: Int, $bathrooms: Float, $canSelfTour: Boolean, $hasPool: Boolean, $maxHoaMonthlyFee: Float, $maxListPrice: Float, $minListPrice: Float, $maxSquareFootage: Int, $minSquareFootage: Int, $maxYearBuilt: Int, $minYearBuilt: Int, $propertyTypes: [PropertyType!], $singleStoryOnly: Boolean, $vertices: [GeoPoint!], $zoneIds: [String!]) {\n  marketplace {\n    propertyList(\n      page: $page\n      filters: {listingState: ON_THE_MARKET, minBeds: $bedrooms, minBathrooms: $bathrooms, minListPrice: $minListPrice, maxListPrice: $maxListPrice, minSquareFootage: $minSquareFootage, maxSquareFootage: $maxSquareFootage, maxYearBuilt: $maxYearBuilt, minYearBuilt: $minYearBuilt, isSelfTourEligible: $canSelfTour, propertyType: $propertyTypes, hasSingleStory: $singleStoryOnly, hasPool: $hasPool, maxHoaMonthlyFee: $maxHoaMonthlyFee}\n      where: {market: $market, zoneIds: $zoneIds, vertices: $vertices}\n      sortBy: [LIST_DATE_DSC]\n    ) {\n      ...MarketplacePropertyList\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetPropertiesByMarket($shape: String!, $filters: PropertyFilters, $pageInput: PageInput!) {\n  property {\n    geoSearch(input: {shape: $shape, filters: $filters, pageInput: $pageInput}) {\n      results {\n        nodes {\n          ...PropertiesByMarketResult\n        }\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetIsLikedByAddressIdForCurrentUser($addressId: String!) {\n  buyer {\n    isLikedByAddressIdForCurrentUser(addressId: $addressId) {\n      isLiked\n    }\n  }\n}\n    "
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetPropertyPhotosByAddressIDs($addressIds: [String!]!, $photoCount: Int!) {\n  property {\n    properties(input: {addressIds: $addressIds}) {\n      addressId\n      listTimestamp\n      photos(pageInput: {first: $photoCount}) {\n        nodes {\n          urls {\n            fullSize\n          }\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetVariantRequest($grain: OdProtosVariantData_GrainInput, $key: String!, $props: GoogleProtobuf_StructInput, $autoImpression: Boolean) {\n  variant {\n    getVariant(\n      input: {grain: $grain, key: $key, props: $props, autoImpression: $autoImpression}\n    ) {\n      variant {\n        value\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetSeveralVariantsRequest($grain: OdProtosVariantData_GrainInput, $keys: [String!], $props: GoogleProtobuf_StructInput) {\n  variant {\n    getVariants(input: {grain: $grain, keys: $keys, props: $props}) {\n      variants {\n        key\n        value {\n          value\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetSeveralFeatureFlagsRequest($grain: OdProtosVariantData_GrainInput, $keys: [String!], $props: GoogleProtobuf_StructInput) {\n  variant {\n    getFeatureFlags(input: {grain: $grain, keys: $keys, props: $props}) {\n      variants {\n        key\n        value {\n          value\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject44 = function _templateObject44() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query ListLeadsOnUniqueAddresses($customerUuid: String!) {\n  sellDirect {\n    listLeadsOnUniqueAddresses(input: {customerUuid: $customerUuid}) {\n      leads {\n        id\n        isQualified\n        latestOffer {\n          state\n        }\n        address {\n          uuid\n          street\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject45 = function _templateObject45() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetUnlockPropertyInfo($addressId: String!) {\n  property {\n    property(input: {addressId: $addressId}) {\n      addressId\n      street\n      unitType\n      unitNumber\n      city\n      state\n      postalCode\n      odMarketIdentifier\n      sourceId\n      photos(pageInput: {first: 1}) {\n        nodes {\n          id\n          urls {\n            fullSize\n          }\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject46 = function _templateObject46() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetGeoShapeFromUserLocation($latitude: Float!, $longitude: Float!, $shapeGeoOption: OdProtosGeoDataStoreServices_ShapeGeoOption!) {\n  geoDataStore {\n    getZoneHierarchy(\n      input: {latitude: $latitude, longitude: $longitude, shapeGeoOption: $shapeGeoOption}\n    ) {\n      zones {\n        shape\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject47 = function _templateObject47() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetPropertiesFromGeoShape($shape: String!, $filters: OdProtosPropertyDataStoreServices_PropertyFiltersInput!, $paginationRequest: OdProtosPropertyDataStoreServices_PaginationRequestInput) {\n  propertyDataStore {\n    mapSearchProperties(\n      input: {shape: $shape, filters: $filters, paginationRequest: $paginationRequest}\n    ) {\n      properties {\n        addressId\n        latitude\n        longitude\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject48 = function _templateObject48() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query AddressAutocomplete($query: String!, $filters: PropertyFilters, $pageInput: PageInput!, $latitude: Float, $longitude: Float) {\n  property {\n    textSearch(\n      input: {query: $query, filters: $filters, pageInput: $pageInput, latitude: $latitude, longitude: $longitude}\n    ) {\n      results {\n        nodes {\n          addressId\n          displaySlug\n          unitNumber\n          street\n          city\n          state\n          postalCode\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject49 = function _templateObject49() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetCurrentCustomer {\n  customerService {\n    getCurrentCustomer {\n      customer {\n        uuid\n        createdAt\n        firstName\n        lastName\n        primaryEmail {\n          address {\n            value\n          }\n        }\n        otherEmails {\n          address {\n            value\n          }\n        }\n        primaryPhoneNumber {\n          number {\n            value\n          }\n          type\n        }\n        otherPhoneNumbers {\n          number {\n            value\n          }\n          type\n        }\n        isAgent\n        ccpaSaleOfDataOptOut\n        fullName\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject50 = function _templateObject50() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetViewingAppointmentsData($customerUuid: String!, $listingId: String!, $daysOut: Int, $durationMinutes: Int) {\n  web {\n    viewingAppointmentsByCustomer(customerUuid: $customerUuid) {\n      listing_address_id\n      scheduled_for\n      end_time\n      timezone\n    }\n    viewingAppointmentAvailabilityForListing(\n      listingId: $listingId\n      daysOut: $daysOut\n      durationMinutes: $durationMinutes\n    ) {\n      available_days {\n        date\n        available_slots {\n          start_time\n          end_time\n          is_now\n        }\n      }\n      timezone\n    }\n  }\n}\n    "
    ]);
    _templateObject51 = function _templateObject51() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetViewingAppointmentsByCustomer($customerUuid: String!) {\n  web {\n    viewingAppointmentsByCustomer(customerUuid: $customerUuid) {\n      listing_address_id\n      scheduled_for\n      end_time\n      timezone\n    }\n  }\n}\n    "
    ]);
    _templateObject52 = function _templateObject52() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query SearchLocations($query: String!, $types: [OdProtosGeoDataStoreData_Zone_Type!]) {\n  geoDataStore {\n    searchZonesByTextQuery(input: {queryString: $query, types: $types}) {\n      zones {\n        zone {\n          county\n          name\n          shortName\n          stateAbbr\n          uuid\n          zoneType\n          centroid\n          population\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject53 = function _templateObject53() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query SearchZonesByLocation($latitude: Float!, $longitude: Float!, $searchDistance: Float!) {\n  geoDataStore {\n    searchZonesByLocation(\n      input: {latitude: $latitude, longitude: $longitude, searchDistance: $searchDistance, types: [NEIGHBORHOOD]}\n    ) {\n      zones {\n        zoneType\n        uuid\n        name\n        slug\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject54 = function _templateObject54() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetMarketCoordinates($market: OdProtosCommonMarket_Market) {\n  buyer {\n    getMarketConfigByMarket(input: {market: $market}) {\n      marketConfig {\n        ...MarketConfig\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject55 = function _templateObject55() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetMarketplacePropertyCoreDetails($addressToken: ID!) {\n  marketplace {\n    property(addressToken: $addressToken) {\n      ...PropertyDetails\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject56 = function _templateObject56() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query HistoricalMarketMetricsQuery($zip: String, $filters: OdProtosSellerDashboardMetricsData_HistoricalMarketMetricsFiltersInput, $numWeeks: Float) {\n  sellerDashboardMetrics {\n    getHistoricalMarketMetrics(\n      input: {zip: $zip, filters: $filters, numWeeks: $numWeeks}\n    ) {\n      medianSalePrice\n      medianSalePriceMom\n      daysOnMarket\n      daysOnMarketMom\n      homesSold\n      homesSoldMom\n      homesOnMarket\n      homesOnMarketMom\n      avgListingPrice\n      avgListingPriceMom\n      unfilteredGraphs {\n        medianSalePriceGraph\n        daysOnMarketGraph\n        homesSoldGraph\n      }\n      filteredGraphs {\n        medianSalePriceGraph\n        daysOnMarketGraph\n        homesSoldGraph\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject57 = function _templateObject57() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetMarketMetricsQuery($marketIdentifier: String) {\n  sellerDashboardMetrics {\n    getMarketMetrics(input: {marketIdentifier: $marketIdentifier}) {\n      marketIdentifier\n      timePeriod\n      homesSold\n      homesSoldWow\n      newListings\n      newListingsWow\n      delistings\n      delistingsWow\n      homesOnMarket\n      homesOnMarketWow\n      averagePriceChange\n      averagePriceChangeWow\n      marketHotness\n    }\n  }\n}\n    "
    ]);
    _templateObject58 = function _templateObject58() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetBuyerPropertyReactions($customerId: String!) {\n  buyerService {\n    getBuyer(input: {customerId: $customerId}) {\n      buyer {\n        reactions {\n          ...BuyerPropertyReaction\n        }\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject59 = function _templateObject59() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetZoneData($zoneId: String!) {\n  geoDataStore {\n    getZones(input: {uuids: [$zoneId]}) {\n      zones {\n        uuid\n        name\n        slug\n        zoneType\n        boundingBox\n        centroid\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject60 = function _templateObject60() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query AddressSearch($query: String!) {\n  marketplace {\n    addressSearch(query: $query) {\n      properties {\n        ...AddressSearchResult\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject61 = function _templateObject61() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query FavoriteProperties {\n  marketplace {\n    favoriteProperties {\n      properties {\n        ...MarketplacePropertyListResult\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject62 = function _templateObject62() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetActiveBuyMarkets($first: Int) {\n  pbdb {\n    activeBuyMarket(first: $first) {\n      identifier\n      displayName\n      stateName\n      displayState\n      homesPath\n    }\n  }\n}\n    "
    ]);
    _templateObject63 = function _templateObject63() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query PurchaseTransaction($transactionId: String!) {\n  buy {\n    purchaseTransaction(transactionId: $transactionId) {\n      id\n      acceptedOfferPrice\n      agent {\n        id\n        email\n        name\n        photoUrl\n        primaryNumber\n        isPartnerAgent\n      }\n      buyerCustomerId\n      buyerEmail\n      buyerName\n      buyerPhone\n      inspectionPeriodDaysRemaining\n      listingOfferId\n      propertyV2 {\n        addressToken\n        photos\n      }\n      tasks {\n        id\n        description\n        isDone: isComplete\n        title\n        taskType\n      }\n      transactionState\n      resaleCloseOfEscrowDaysRemaining\n    }\n  }\n}\n    "
    ]);
    _templateObject64 = function _templateObject64() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query BuyerOffersMinimal {\n  customerAccount {\n    buying {\n      offers {\n        id\n        transactionState\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject65 = function _templateObject65() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query HubData {\n  customerAccount {\n    buying {\n      favorites {\n        ...MarketplacePropertyListResult\n      }\n      tours {\n        id\n        scheduledFor\n        endTime\n        timezone\n        listingId\n        listingAddressToken\n        listingReadableAddress\n      }\n      tourFeedbacks {\n        tourFeedbackUuid\n        viewingAppointmentId\n        sentiment\n      }\n      offers {\n        id\n        transactionState\n        priceDollars\n        listing {\n          id\n          property {\n            addressToken\n            slug\n            street\n            city\n            state\n            zip\n            bedrooms\n            bathrooms\n            sqFtTotalLiving\n            photos\n          }\n        }\n        taskGroups {\n          title\n          progress {\n            completed\n            total\n          }\n          tasks {\n            title\n            state\n          }\n        }\n      }\n    }\n    selling {\n      transactions {\n        __typename\n        id\n        address {\n          uuid\n          street\n          unitNumber\n          city\n          state\n          postalCode\n          latitude\n          longitude\n        }\n        sellerInput {\n          uuid\n          homeDetails {\n            physicalDetails {\n              bedrooms\n              bathrooms\n              bathroomsFull\n              bathroomsHalf\n              sqFt\n            }\n          }\n        }\n        ... on QualifiedTransaction {\n          currentStep {\n            __typename\n            ... on SellerStep {\n              id\n            }\n            ... on AgentAttributionDecisionStep {\n              referralInvitationPaymentEligibility\n            }\n            ... on ReferralInvitationDecisionStep {\n              referralInvitationPaymentEligibility\n            }\n            ... on AssessmentStep {\n              appAssessment {\n                completedAt\n              }\n              inPersonAssessment {\n                isScheduled\n                hasAvailableSlots\n              }\n              expertHandoffAssessment {\n                isScheduled\n              }\n              selfServeVirtualAssessment {\n                data {\n                  ssvaCompletedAt\n                  ssvaRecordingsSubmitted\n                  ssvaQuestionnaireSubmitted\n                  ssvaInteriorRecordingsSubmitted\n                  ssvaBackyardRecordingsSubmitted\n                  ssvaFrontyardRecordingsSubmitted\n                  ssvaWholeHomeRecordingsSubmitted\n                  ssvaSellerDisclosureDocumentRecordingsSubmitted\n                }\n              }\n            }\n            ... on ContractSigningStep {\n              contractSetup {\n                complete\n              }\n              purchaseAgreement {\n                complete\n              }\n            }\n          }\n        }\n        ... on InContractTransaction {\n          sellDirectOffer {\n            isClosed\n          }\n          currentStep {\n            __typename\n            ... on SellerStep {\n              id\n            }\n            ... on RepricingStep {\n              contractSetup {\n                complete\n              }\n              purchaseAgreement {\n                complete\n              }\n            }\n            ... on ClosingStep {\n              requiredTasks {\n                inspection {\n                  complete\n                  state\n                }\n                serviceProviders {\n                  complete\n                }\n                disclosures {\n                  complete\n                }\n                finalWalkthrough {\n                  complete\n                }\n                lateCheckoutAddendum {\n                  complete\n                }\n                changeCloseOfEscrowAddendum {\n                  complete\n                }\n                formAddendums {\n                  complete\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject66 = function _templateObject66() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query BuyerOffer($offerId: ID!) {\n  customerAccount {\n    buying {\n      offers(filter: {id: $offerId}) {\n        id\n        priceDollars\n        discountDollars\n        hasHeroHomeCredit\n        requestedEarlyCheckIn\n        requestedHomeWarranty\n        tradeInAddress\n        transactionState\n        closeOfEscrowDate\n        resaleAgent {\n          id\n          email\n          name\n          photoUrl\n          primaryNumber\n        }\n        listing {\n          id\n          property {\n            ...PropertyDetails\n          }\n        }\n        notices {\n          type\n          message\n        }\n        taskGroups {\n          title\n          icon\n          progress {\n            completed\n            total\n          }\n          tasks {\n            id\n            taskType\n            title\n            description\n            state\n            ... on InformationalTask {\n              defaultExpanded\n              expandedContent {\n                instructions\n                bulletPoints\n              }\n            }\n            ... on SingleCTATask {\n              defaultExpanded\n              expandedContent {\n                instructions\n                bulletPoints\n              }\n              action {\n                label\n                type\n                variant\n                payload {\n                  __typename\n                  ... on RevealContentPayload {\n                    content\n                  }\n                  ... on ExternalLinkPayload {\n                    url\n                    openInNewTab\n                  }\n                  ... on ModalPayload {\n                    modalId\n                    modalData\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject67 = function _templateObject67() {
        return data;
    };
    return data;
}
function _templateObject68() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetMarketInventoryCounts($markets: [String!]!) {\n  marketplace {\n    marketInventoryCounts(markets: $markets) {\n      market\n      count\n    }\n  }\n}\n    "
    ]);
    _templateObject68 = function _templateObject68() {
        return data;
    };
    return data;
}
function _templateObject69() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetBuyDirectPropertyInfo($addressToken: ID!) {\n  marketplace {\n    property(addressToken: $addressToken) {\n      addressToken\n      bathrooms\n      bedrooms\n      buyDirectPrice\n      city\n      fhaEligible\n      fhaEligibleDate\n      listPrice\n      listingTags\n      photos\n      sellerDisclosuresDownloadUrl\n      slug\n      sqFtTotalLiving\n      state\n      street\n      unitNumber\n      unitType\n      zip\n    }\n  }\n}\n    "
    ]);
    _templateObject69 = function _templateObject69() {
        return data;
    };
    return data;
}
function _templateObject70() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetResaleOffers($customerId: String!) {\n  webListingOffer {\n    listOffers(input: {identifier: {customerId: $customerId}}) {\n      offers {\n        id\n        uuid\n        address {\n          uuid\n        }\n        details {\n          contractSignatureId\n          state\n        }\n      }\n    }\n  }\n}\n    "
    ]);
    _templateObject70 = function _templateObject70() {
        return data;
    };
    return data;
}
function _templateObject71() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetBuyDirectS3Urls($bucketName: String!, $documentName: String!) {\n  seller {\n    s3DocumentUploadUrl(bucketName: $bucketName, documentName: $documentName)\n    s3DocumentDownloadUrl(bucketName: $bucketName, s3Directory: $documentName)\n  }\n}\n    "
    ]);
    _templateObject71 = function _templateObject71() {
        return data;
    };
    return data;
}
function _templateObject72() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetCloseOfEscrowHolidays {\n  buyer {\n    closeOfEscrowHolidays {\n      dates\n    }\n  }\n}\n    "
    ]);
    _templateObject72 = function _templateObject72() {
        return data;
    };
    return data;
}
function _templateObject73() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query GetSavedSearches {\n  customerAccount {\n    buying {\n      savedSearches {\n        ...SavedSearchFields\n      }\n    }\n  }\n}\n    ",
        ""
    ]);
    _templateObject73 = function _templateObject73() {
        return data;
    };
    return data;
}

var SimilarPropertyFragmentDoc = lib(_templateObject());
var SimilarPropertiesFragmentDoc = lib(_templateObject1(), SimilarPropertyFragmentDoc);
var PropertyDetailsFragmentDoc = lib(_templateObject2(), SimilarPropertiesFragmentDoc);
var PropertiesByMarketResultFragmentDoc = lib(_templateObject3());
var MarketplacePropertySearchResultFragmentDoc = lib(_templateObject4());
var MarketplacePropertySearchFragmentDoc = lib(_templateObject5(), MarketplacePropertySearchResultFragmentDoc);
var AddressSearchResultFragmentDoc = lib(_templateObject6());
var MarketplacePropertyListResultFragmentDoc = lib(_templateObject7());
var MarketplacePropertyListFragmentDoc = lib(_templateObject8(), MarketplacePropertyListResultFragmentDoc);
var BuyerPropertyReactionFragmentDoc = lib(_templateObject9());
var MarketConfigFragmentDoc = lib(_templateObject10());
var SavedSearchFieldsFragmentDoc = lib(_templateObject11());
var UnsubscribeMailerDocument = lib(_templateObject12());
var SetMarketplacePropertyReactionDocument = lib(_templateObject13());
var RemoveMarketplacePropertyReactionDocument = lib(_templateObject14());
var SubmitTourFeedbackDocument = lib(_templateObject15());
var SetImpressionDocument = lib(_templateObject16());
var UpdateCustomerDocument = lib(_templateObject17());
var UpdateCurrentCustomerDocument = lib(_templateObject18());
var CreateViewingAppointmentDocument = lib(_templateObject19());
var UploadAgentPhotoDocument = lib(_templateObject20());
var AddSavedSearchDocument = lib(_templateObject21(), SavedSearchFieldsFragmentDoc);
var UpdateSavedSearchDocument = lib(_templateObject22(), SavedSearchFieldsFragmentDoc);
var RemoveSavedSearchDocument = lib(_templateObject23());
var InitiateCustomerTaskDocument = lib(_templateObject24());
var CreateBuyDirectListingOfferDocument = lib(_templateObject25());
var GetSchoolsDocument = lib(_templateObject26());
var GetPropertyStatusForRouteDocument = lib(_templateObject27());
var GetMarketplacePropertyForRouteDocument = lib(_templateObject28());
var GetAddressForIdDocument = lib(_templateObject29());
var GetShortListingPropertyInfoDocument = lib(_templateObject30());
var GetMarketplacePropertyReactionDocument = lib(_templateObject31());
var GetMarketplacePropertySimilarPropertiesDocument = lib(_templateObject32(), SimilarPropertiesFragmentDoc);
var GetMarketplacePropertyDocument = lib(_templateObject33(), PropertyDetailsFragmentDoc);
var GetMarketplacePropertySellerDisclosuresDocument = lib(_templateObject34());
var GetMarketplacePropertyAccessCodeDocument = lib(_templateObject35());
var GetLongListingPropertyInfoDocument = lib(_templateObject36());
var GetMarketplacePropertySearchDocument = lib(_templateObject37(), MarketplacePropertySearchFragmentDoc);
var GetMarketplacePropertyListDocument = lib(_templateObject38(), MarketplacePropertyListFragmentDoc);
var GetPropertiesByMarketDocument = lib(_templateObject39(), PropertiesByMarketResultFragmentDoc);
var GetIsLikedByAddressIdForCurrentUserDocument = lib(_templateObject40());
var GetPropertyPhotosByAddressIDsDocument = lib(_templateObject41());
var GetVariantRequestDocument = lib(_templateObject42());
var GetSeveralVariantsRequestDocument = lib(_templateObject43());
var GetSeveralFeatureFlagsRequestDocument = lib(_templateObject44());
var ListLeadsOnUniqueAddressesDocument = lib(_templateObject45());
var GetUnlockPropertyInfoDocument = lib(_templateObject46());
var GetGeoShapeFromUserLocationDocument = lib(_templateObject47());
var GetPropertiesFromGeoShapeDocument = lib(_templateObject48());
var AddressAutocompleteDocument = lib(_templateObject49());
var GetCurrentCustomerDocument = lib(_templateObject50());
var GetViewingAppointmentsDataDocument = lib(_templateObject51());
var GetViewingAppointmentsByCustomerDocument = lib(_templateObject52());
var SearchLocationsDocument = lib(_templateObject53());
var SearchZonesByLocationDocument = lib(_templateObject54());
var GetMarketCoordinatesDocument = lib(_templateObject55(), MarketConfigFragmentDoc);
var GetMarketplacePropertyCoreDetailsDocument = lib(_templateObject56(), PropertyDetailsFragmentDoc);
var HistoricalMarketMetricsQueryDocument = lib(_templateObject57());
var GetMarketMetricsQueryDocument = lib(_templateObject58());
var GetBuyerPropertyReactionsDocument = lib(_templateObject59(), BuyerPropertyReactionFragmentDoc);
var GetZoneDataDocument = lib(_templateObject60());
var AddressSearchDocument = lib(_templateObject61(), AddressSearchResultFragmentDoc);
var FavoritePropertiesDocument = lib(_templateObject62(), MarketplacePropertyListResultFragmentDoc);
var GetActiveBuyMarketsDocument = lib(_templateObject63());
var PurchaseTransactionDocument = lib(_templateObject64());
var BuyerOffersMinimalDocument = lib(_templateObject65());
var HubDataDocument = lib(_templateObject66(), MarketplacePropertyListResultFragmentDoc);
var BuyerOfferDocument = lib(_templateObject67(), PropertyDetailsFragmentDoc);
var GetMarketInventoryCountsDocument = lib(_templateObject68());
var GetBuyDirectPropertyInfoDocument = lib(_templateObject69());
var GetResaleOffersDocument = lib(_templateObject70());
var GetBuyDirectS3UrlsDocument = lib(_templateObject71());
var GetCloseOfEscrowHolidaysDocument = lib(_templateObject72());
var GetSavedSearchesDocument = lib(_templateObject73(), SavedSearchFieldsFragmentDoc);
var defaultWrapper = function(action, _operationName, _operationType, _variables) {
    return action();
};
function getSdk(client) {
    var withWrapper = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultWrapper;
    return {
        UnsubscribeMailer: function UnsubscribeMailer(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: UnsubscribeMailerDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "UnsubscribeMailer", "mutation", variables);
        },
        SetMarketplacePropertyReaction: function SetMarketplacePropertyReaction(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: SetMarketplacePropertyReactionDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "SetMarketplacePropertyReaction", "mutation", variables);
        },
        RemoveMarketplacePropertyReaction: function RemoveMarketplacePropertyReaction(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: RemoveMarketplacePropertyReactionDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "RemoveMarketplacePropertyReaction", "mutation", variables);
        },
        SubmitTourFeedback: function SubmitTourFeedback(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: SubmitTourFeedbackDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "SubmitTourFeedback", "mutation", variables);
        },
        SetImpression: function SetImpression(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: SetImpressionDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "SetImpression", "mutation", variables);
        },
        UpdateCustomer: function UpdateCustomer(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: UpdateCustomerDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "UpdateCustomer", "mutation", variables);
        },
        UpdateCurrentCustomer: function UpdateCurrentCustomer(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: UpdateCurrentCustomerDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "UpdateCurrentCustomer", "mutation", variables);
        },
        CreateViewingAppointment: function CreateViewingAppointment(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: CreateViewingAppointmentDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "CreateViewingAppointment", "mutation", variables);
        },
        UploadAgentPhoto: function UploadAgentPhoto(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: UploadAgentPhotoDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "UploadAgentPhoto", "mutation", variables);
        },
        AddSavedSearch: function AddSavedSearch(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: AddSavedSearchDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "AddSavedSearch", "mutation", variables);
        },
        UpdateSavedSearch: function UpdateSavedSearch(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: UpdateSavedSearchDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "UpdateSavedSearch", "mutation", variables);
        },
        RemoveSavedSearch: function RemoveSavedSearch(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: RemoveSavedSearchDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "RemoveSavedSearch", "mutation", variables);
        },
        InitiateCustomerTask: function InitiateCustomerTask(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: InitiateCustomerTaskDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "InitiateCustomerTask", "mutation", variables);
        },
        CreateBuyDirectListingOffer: function CreateBuyDirectListingOffer(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: CreateBuyDirectListingOfferDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "CreateBuyDirectListingOffer", "mutation", variables);
        },
        GetSchools: function GetSchools(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetSchoolsDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetSchools", "query", variables);
        },
        GetPropertyStatusForRoute: function GetPropertyStatusForRoute(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetPropertyStatusForRouteDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetPropertyStatusForRoute", "query", variables);
        },
        GetMarketplacePropertyForRoute: function GetMarketplacePropertyForRoute(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetMarketplacePropertyForRouteDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetMarketplacePropertyForRoute", "query", variables);
        },
        GetAddressForId: function GetAddressForId(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetAddressForIdDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetAddressForId", "query", variables);
        },
        GetShortListingPropertyInfo: function GetShortListingPropertyInfo(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetShortListingPropertyInfoDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetShortListingPropertyInfo", "query", variables);
        },
        GetMarketplacePropertyReaction: function GetMarketplacePropertyReaction(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetMarketplacePropertyReactionDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetMarketplacePropertyReaction", "query", variables);
        },
        GetMarketplacePropertySimilarProperties: function GetMarketplacePropertySimilarProperties(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetMarketplacePropertySimilarPropertiesDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetMarketplacePropertySimilarProperties", "query", variables);
        },
        GetMarketplaceProperty: function GetMarketplaceProperty(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetMarketplacePropertyDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetMarketplaceProperty", "query", variables);
        },
        GetMarketplacePropertySellerDisclosures: function GetMarketplacePropertySellerDisclosures(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetMarketplacePropertySellerDisclosuresDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetMarketplacePropertySellerDisclosures", "query", variables);
        },
        GetMarketplacePropertyAccessCode: function GetMarketplacePropertyAccessCode(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetMarketplacePropertyAccessCodeDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetMarketplacePropertyAccessCode", "query", variables);
        },
        GetLongListingPropertyInfo: function GetLongListingPropertyInfo(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetLongListingPropertyInfoDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetLongListingPropertyInfo", "query", variables);
        },
        GetMarketplacePropertySearch: function GetMarketplacePropertySearch(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetMarketplacePropertySearchDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetMarketplacePropertySearch", "query", variables);
        },
        GetMarketplacePropertyList: function GetMarketplacePropertyList(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetMarketplacePropertyListDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetMarketplacePropertyList", "query", variables);
        },
        GetPropertiesByMarket: function GetPropertiesByMarket(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetPropertiesByMarketDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetPropertiesByMarket", "query", variables);
        },
        GetIsLikedByAddressIdForCurrentUser: function GetIsLikedByAddressIdForCurrentUser(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetIsLikedByAddressIdForCurrentUserDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetIsLikedByAddressIdForCurrentUser", "query", variables);
        },
        GetPropertyPhotosByAddressIDs: function GetPropertyPhotosByAddressIDs(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetPropertyPhotosByAddressIDsDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetPropertyPhotosByAddressIDs", "query", variables);
        },
        GetVariantRequest: function GetVariantRequest(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetVariantRequestDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetVariantRequest", "query", variables);
        },
        GetSeveralVariantsRequest: function GetSeveralVariantsRequest(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetSeveralVariantsRequestDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetSeveralVariantsRequest", "query", variables);
        },
        GetSeveralFeatureFlagsRequest: function GetSeveralFeatureFlagsRequest(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetSeveralFeatureFlagsRequestDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetSeveralFeatureFlagsRequest", "query", variables);
        },
        ListLeadsOnUniqueAddresses: function ListLeadsOnUniqueAddresses(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: ListLeadsOnUniqueAddressesDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "ListLeadsOnUniqueAddresses", "query", variables);
        },
        GetUnlockPropertyInfo: function GetUnlockPropertyInfo(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetUnlockPropertyInfoDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetUnlockPropertyInfo", "query", variables);
        },
        GetGeoShapeFromUserLocation: function GetGeoShapeFromUserLocation(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetGeoShapeFromUserLocationDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetGeoShapeFromUserLocation", "query", variables);
        },
        GetPropertiesFromGeoShape: function GetPropertiesFromGeoShape(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetPropertiesFromGeoShapeDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetPropertiesFromGeoShape", "query", variables);
        },
        AddressAutocomplete: function AddressAutocomplete(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: AddressAutocompleteDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "AddressAutocomplete", "query", variables);
        },
        GetCurrentCustomer: function GetCurrentCustomer(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetCurrentCustomerDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetCurrentCustomer", "query", variables);
        },
        GetViewingAppointmentsData: function GetViewingAppointmentsData(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetViewingAppointmentsDataDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetViewingAppointmentsData", "query", variables);
        },
        GetViewingAppointmentsByCustomer: function GetViewingAppointmentsByCustomer(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetViewingAppointmentsByCustomerDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetViewingAppointmentsByCustomer", "query", variables);
        },
        SearchLocations: function SearchLocations(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: SearchLocationsDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "SearchLocations", "query", variables);
        },
        SearchZonesByLocation: function SearchZonesByLocation(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: SearchZonesByLocationDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "SearchZonesByLocation", "query", variables);
        },
        GetMarketCoordinates: function GetMarketCoordinates(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetMarketCoordinatesDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetMarketCoordinates", "query", variables);
        },
        GetMarketplacePropertyCoreDetails: function GetMarketplacePropertyCoreDetails(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetMarketplacePropertyCoreDetailsDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetMarketplacePropertyCoreDetails", "query", variables);
        },
        HistoricalMarketMetricsQuery: function HistoricalMarketMetricsQuery(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: HistoricalMarketMetricsQueryDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "HistoricalMarketMetricsQuery", "query", variables);
        },
        GetMarketMetricsQuery: function GetMarketMetricsQuery(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetMarketMetricsQueryDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetMarketMetricsQuery", "query", variables);
        },
        GetBuyerPropertyReactions: function GetBuyerPropertyReactions(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetBuyerPropertyReactionsDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetBuyerPropertyReactions", "query", variables);
        },
        GetZoneData: function GetZoneData(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetZoneDataDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetZoneData", "query", variables);
        },
        AddressSearch: function AddressSearch(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: AddressSearchDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "AddressSearch", "query", variables);
        },
        FavoriteProperties: function FavoriteProperties(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: FavoritePropertiesDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "FavoriteProperties", "query", variables);
        },
        GetActiveBuyMarkets: function GetActiveBuyMarkets(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetActiveBuyMarketsDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetActiveBuyMarkets", "query", variables);
        },
        PurchaseTransaction: function PurchaseTransaction(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: PurchaseTransactionDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "PurchaseTransaction", "query", variables);
        },
        BuyerOffersMinimal: function BuyerOffersMinimal(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: BuyerOffersMinimalDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "BuyerOffersMinimal", "query", variables);
        },
        HubData: function HubData(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: HubDataDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "HubData", "query", variables);
        },
        BuyerOffer: function BuyerOffer(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: BuyerOfferDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "BuyerOffer", "query", variables);
        },
        GetMarketInventoryCounts: function GetMarketInventoryCounts(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetMarketInventoryCountsDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetMarketInventoryCounts", "query", variables);
        },
        GetBuyDirectPropertyInfo: function GetBuyDirectPropertyInfo(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetBuyDirectPropertyInfoDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetBuyDirectPropertyInfo", "query", variables);
        },
        GetResaleOffers: function GetResaleOffers(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetResaleOffersDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetResaleOffers", "query", variables);
        },
        GetBuyDirectS3Urls: function GetBuyDirectS3Urls(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetBuyDirectS3UrlsDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetBuyDirectS3Urls", "query", variables);
        },
        GetCloseOfEscrowHolidays: function GetCloseOfEscrowHolidays(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetCloseOfEscrowHolidaysDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetCloseOfEscrowHolidays", "query", variables);
        },
        GetSavedSearches: function GetSavedSearches(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: GetSavedSearchesDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "GetSavedSearches", "query", variables);
        }
    };
}

;// CONCATENATED MODULE: ./src/__generated__/partnerships.ts


function partnerships_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query ValidateEmail($email: String!) {\n  validateEmail(email: $email) {\n    isValid\n    normalizedEmail\n  }\n}\n    "
    ]);
    partnerships_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ValidateEmailDocument = lib(partnerships_templateObject());
var partnerships_defaultWrapper = function(action, _operationName, _operationType, _variables) {
    return action();
};
function partnerships_getSdk(client) {
    var withWrapper = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : partnerships_defaultWrapper;
    return {
        ValidateEmail: function ValidateEmail(variables, requestHeaders, signal) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.request({
                    document: ValidateEmailDocument,
                    variables: variables,
                    requestHeaders: (0,_object_spread/* default */.Z)({}, requestHeaders, wrappedRequestHeaders),
                    signal: signal
                });
            }, "ValidateEmail", "query", variables);
        }
    };
}

// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(30465);
// EXTERNAL MODULE: ./src/components/helpers/hooks.ts
var hooks = __webpack_require__(44589);
// EXTERNAL MODULE: ./src/components/shared/trackers.tsx
var trackers = __webpack_require__(24287);
;// CONCATENATED MODULE: ./src/components/api/index.ts
/* provided dependency */ var process = __webpack_require__(73656);













/**
 * A wrapper around `fetch` with optional retries.
 * Retries up to `options.retries` times (defaults to `5` if not specified)
 * with a delay of `options.retryDelay` (defaults to `500ms` if not specified)
 */ var fetchWithRetry = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(url, options) {
        var retries, retryDelay, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    retries = options.retries || 0;
                    retryDelay = options.retryDelay || 500;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        6
                    ]);
                    return [
                        4,
                        fetch(url, options)
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    err = _state.sent();
                    if (retries < 1) throw err;
                    // sleep the specified amount of time, then recursively retry
                    return [
                        4,
                        new Promise(function(r) {
                            return setTimeout(r, retryDelay);
                        })
                    ];
                case 4:
                    _state.sent();
                    return [
                        4,
                        fetchWithRetry(url, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                            retries: retries - 1
                        }))
                    ];
                case 5:
                    return [
                        2,
                        _state.sent()
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchWithRetry(url, options) {
        return _ref.apply(this, arguments);
    };
}();
var Sentry = observability_slim/* globalObservability.getSentryClient */.w.getSentryClient();
// To do: strengthen jsonParam's type
// Do not pass skip doBFFPost as it will not actually skip making the request - instead handle it conditionally
function doBFFPost(apiUrl, jsonParams) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return fetchWithRetry(apiUrl, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        retries: 5,
        retryDelay: 500,
        credentials: "include",
        method: "POST",
        body: JSON.stringify(jsonParams)
    }, options), {
        headers: (0,_object_spread/* default */.Z)({
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CSRF-Token": js_cookie_default().get(globals/* XSRF_COOKIE_KEY */.x0) || ""
        }, options.headers)
    }));
}
function getAthenaClient(incomingRequestHeaders, options) {
    // Use explicit headers if provided, otherwise try AsyncLocalStorage context
    // This allows SSR pages to wrap their logic with withRequestContext() and have
    // all nested getAthenaClient() calls automatically receive headers
    var effectiveHeaders = incomingRequestHeaders;
    // Only import requestContext on server-side to prevent webpack bundling async_hooks for client
    if (!effectiveHeaders && "object" === "undefined") { var getRequestHeaders; }
    var tivoHeaders = [];
    if (globals/* DEPLOY_ENV */.Zp === "test") {
        if (effectiveHeaders) {
            // Filter out any headers that are not prefixed with 'x-tivo-'
            tivoHeaders = Object.fromEntries(Object.entries(effectiveHeaders).filter(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 1), key = _param[0];
                return key.startsWith("x-tivo-");
            }));
        }
    }
    // Forward cookies for SSR authentication
    var headers = (0,_object_spread/* default */.Z)({
        "apollographql-client-name": "cosmos"
    }, tivoHeaders);
    // If we have request headers (explicit or from context), forward the cookie header
    if (effectiveHeaders === null || effectiveHeaders === void 0 ? void 0 : effectiveHeaders.cookie) {
        headers.cookie = effectiveHeaders.cookie;
    }
    // Local development auth bypass - send user token to local Athena
    // eslint-disable-next-line @opendoor/no-direct-env-check
    var devUserToken = process.env.ATHENA_DEV_USER_TOKEN || process.env.NEXT_PUBLIC_ATHENA_DEV_USER_TOKEN;
    if (globals/* DEPLOY_ENV */.Zp === "development" && devUserToken) {
        headers["x-athena-request-user"] = devUserToken;
    }
    var ref;
    return getSdk(new main/* GraphQLClient */.g6(globals/* ATHENA_URL */.Uw, {
        credentials: "include",
        headers: headers,
        // graphql-request vendors its own DOM type defs whose AbortSignal
        // diverges from the native type. Identical at runtime.
        signal: (ref = options === null || options === void 0 ? void 0 : options.signal) !== null && ref !== void 0 ? ref : undefined
    }));
}
function getPartnershipsClient() {
    return partnerships_getSdk(new main/* GraphQLClient */.g6("".concat(globals/* PARTNERSHIP_BFF_URL */.Ff, "/api/internal/graphql"), {
        credentials: "include",
        headers: {
            "apollographql-client-name": "cosmos"
        }
    }));
}
function doGet(path) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return fetchWithRetry("".concat(globals/* RAILS_URL */.oF).concat(path), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        retries: 5,
        retryDelay: 500,
        credentials: "include"
    }, options), {
        headers: (0,_object_spread/* default */.Z)({
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CSRF-Token": js_cookie_default().get(globals/* XSRF_COOKIE_KEY */.x0) || ""
        }, options.headers)
    }));
}
function trackLead(trackingKeywords) {
    return doGet("/track/".concat(trackingKeywords));
}
function getSessionExtras() {
    return _getSessionExtras.apply(this, arguments);
}
function _getSessionExtras() {
    _getSessionExtras = (0,_async_to_generator/* default */.Z)(function() {
        var ref, response, data, ref1, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        doGet("/session/info")
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    data = _state.sent();
                    return [
                        2,
                        {
                            has_resale_closing_dashboard: (ref1 = (ref = data.human) === null || ref === void 0 ? void 0 : ref.has_resale_closing_dashboard) !== null && ref1 !== void 0 ? ref1 : false
                        }
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        2,
                        {
                            has_resale_closing_dashboard: false
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _getSessionExtras.apply(this, arguments);
}
function validatePartnerEmailAddress(email) {
    return _validatePartnerEmailAddress.apply(this, arguments);
}
function _validatePartnerEmailAddress() {
    _validatePartnerEmailAddress = (0,_async_to_generator/* default */.Z)(function(email) {
        var ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            try {
                return [
                    2,
                    getPartnershipsClient().ValidateEmail({
                        email: email
                    })
                ];
            } catch (e) {
                ;
                (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
                return [
                    2
                ];
            }
            return [
                2
            ];
        });
    });
    return _validatePartnerEmailAddress.apply(this, arguments);
}
var createSellerInput = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param, param1) {
        var street1, unit, city, postal_code, state, product, url, ref, channel, covid19Whitelist, experimentEntityId, sellerFlowNameOverride, sellerFlowUuidOverride, trackingKeywords, partnerReferralId, addressUUID;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    street1 = param.street1, unit = param.unit, city = param.city, postal_code = param.postal_code, state = param.state, product = param1.product, url = param1.url, ref = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {}, channel = ref.channel, covid19Whitelist = ref.covid19Whitelist, experimentEntityId = ref.experiment_entity_id, sellerFlowNameOverride = ref.seller_flow_name_override, sellerFlowUuidOverride = ref.seller_flow_uuid_override, trackingKeywords = ref.trackingKeywords, partnerReferralId = ref.partnerReferralId, addressUUID = _arguments.length > 3 ? _arguments[3] : void 0;
                    if (!trackingKeywords) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        trackLead(trackingKeywords).catch(function(e) {
                            var ref;
                            return (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        doBFFPost(globals/* ATHENA_URL */.Uw, {
                            operationName: "CreateSellerInputWithTrackingDataFromCookies",
                            query: "mutation CreateSellerInputWithTrackingDataFromCookies(\n        $input: OdProtosReceptionServices_CreateSellerInputRequestInput!\n      ) {\n        reception {\n          createSellerInputWithTrackingDataFromCookies(input: $input) {\n            sellerInput {\n              uuid\n              pdpUrl\n              isInPartnershipDenialServiceRegions\n              address {\n                postalCode\n              }\n              analyticsMetadata {\n                addressEntry {\n                  product\n                  url\n                }\n              }\n            }\n          }\n        }\n      }",
                            variables: {
                                input: {
                                    address: {
                                        uuid: addressUUID,
                                        city: city,
                                        postalCode: postal_code,
                                        state: state,
                                        street: street1,
                                        unit: unit
                                    },
                                    channel: channel,
                                    partnerReferralId: partnerReferralId,
                                    experimentEntityId: experimentEntityId,
                                    sellerFlowNameOverride: sellerFlowNameOverride,
                                    sellerFlowUuidOverride: sellerFlowUuidOverride,
                                    covid19Whitelist: covid19Whitelist,
                                    analyticsMetadata: {
                                        addressEntry: {
                                            product: product,
                                            url: url
                                        }
                                    }
                                }
                            }
                        }, {
                            headers: {
                                "apollographql-client-name": "cosmos"
                            }
                        }).then(handleResponse)
                    ];
            }
        });
    });
    return function createSellerInput(_, _1) {
        return _ref.apply(this, arguments);
    };
}();
var updateAnswers = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(answers, sellerFlowLastCompletedSlug, sellerInputUUID) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                doBFFPost(globals/* ATHENA_URL */.Uw, {
                    operationName: "UpdateAnswers",
                    query: "mutation UpdateAnswers(\n        $answers: String!\n        $sellerFlowLastCompletedSlug: String!\n        $sellerInputUUID: String!\n      ) {\n        reception {\n          updateSellerInput(\n            input: {\n              uuid: $sellerInputUUID\n              answers: $answers\n              sellerFlowLastCompletedSlug: $sellerFlowLastCompletedSlug\n            }\n          ) {\n            sellerInput {\n              uuid\n            }\n          }\n        }\n      }",
                    variables: {
                        answers: JSON.stringify(answers),
                        sellerFlowLastCompletedSlug: sellerFlowLastCompletedSlug,
                        sellerInputUUID: sellerInputUUID
                    }
                }, {
                    headers: {
                        "apollographql-client-name": "cosmos"
                    }
                }).then(handleResponse)
            ];
        });
    });
    return function updateAnswers(answers, sellerFlowLastCompletedSlug, sellerInputUUID) {
        return _ref.apply(this, arguments);
    };
}();
function handleResponse(res) {
    var ref;
    if (res.ok) {
        return res.json();
    }
    (ref = Sentry.withScope) === null || ref === void 0 ? void 0 : ref.call(Sentry, function(scope) {
        var ref;
        scope.setExtras({
            resonse: res
        });
        (ref = Sentry.captureMessage) === null || ref === void 0 ? void 0 : ref.call(Sentry, "Non-200 response received in cosmos api call");
    });
    return;
}
var getGrainID = function(customerUUID, anonId) {
    var anonymousId = (0,trackers/* getAnonymousId */.y)() || anonId;
    return {
        primaryId: {
            customerUuid: customerUUID ? customerUUID : null
        },
        temporaryId: {
            anonymousId: anonymousId ? anonymousId : null
        }
    };
};
function getFeatureFlag(name, customerUUID) {
    return _getFeatureFlag.apply(this, arguments);
}
function _getFeatureFlag() {
    _getFeatureFlag = (0,_async_to_generator/* default */.Z)(function(name, customerUUID) {
        var options, anonymousId, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, _isLoading, isLoading, _defaultValue, defaultValue, props, customer, localOverride, res;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {}, anonymousId = _arguments.length > 3 ? _arguments[3] : void 0;
                    _isLoading = options.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _defaultValue = options.defaultValue, defaultValue = _defaultValue === void 0 ? "control" : _defaultValue, props = options.props;
                    customer = getGrainID(customerUUID, anonymousId);
                    localOverride = (0,hooks/* getLocalFeatureFlagOverrides */.iE)(name);
                    if (localOverride) {
                        return [
                            2,
                            Promise.resolve(localOverride)
                        ];
                    }
                    if (isLoading) {
                        return [
                            2,
                            defaultValue
                        ];
                    }
                    return [
                        4,
                        doBFFPost(globals/* ATHENA_URL */.Uw, {
                            operationName: "GetSeveralFeatureFlagsRequest",
                            query: "query GetSeveralFeatureFlagsRequest(\n          $grain: OdProtosVariantData_GrainInput\n          $keys: [String!]\n          $props: GoogleProtobuf_StructInput\n        ) {\n          variant {\n            getFeatureFlags(input: { grain: $grain, keys: $keys, props: $props }) {\n              variants {\n                key\n                value {\n                  value\n                }\n              }\n            }\n          }\n        }",
                            variables: {
                                grain: {
                                    grain: {
                                        customer: customer
                                    }
                                },
                                keys: [
                                    name
                                ],
                                props: props
                            }
                        }, {
                            headers: {
                                "apollographql-client-name": "cosmos"
                            }
                        }).then(function(res) {
                            if (res.ok) {
                                return res.json();
                            }
                            return;
                        }).catch(function(e) {
                            var ref;
                            return (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
                        })
                    ];
                case 1:
                    res = _state.sent();
                    // Returns default if there is no value for the FF
                    if (!((ref3 = res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.variant) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.getFeatureFlags) === null || ref2 === void 0 ? void 0 : ref2.variants[0].value) === null || ref3 === void 0 ? void 0 : ref3.value)) {
                        return [
                            2,
                            defaultValue
                        ];
                    }
                    return [
                        2,
                        (ref7 = (ref4 = res.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.variant) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.getFeatureFlags) === null || ref6 === void 0 ? void 0 : ref6.variants[0].value) === null || ref7 === void 0 ? void 0 : ref7.value
                    ];
            }
        });
    });
    return _getFeatureFlag.apply(this, arguments);
}
function GetUnlockPropertyInfo(addressId) {
    return _GetUnlockPropertyInfo.apply(this, arguments);
}
function _GetUnlockPropertyInfo() {
    _GetUnlockPropertyInfo = (0,_async_to_generator/* default */.Z)(function(addressId) {
        var ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            try {
                return [
                    2,
                    getAthenaClient().GetUnlockPropertyInfo({
                        addressId: addressId
                    })
                ];
            } catch (e) {
                ;
                (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
                return [
                    2
                ];
            }
            return [
                2
            ];
        });
    });
    return _GetUnlockPropertyInfo.apply(this, arguments);
}
function GetGeoShapeFromUserLocation(latitude, longitude, shapeGeoOption) {
    return _GetGeoShapeFromUserLocation.apply(this, arguments);
}
function _GetGeoShapeFromUserLocation() {
    _GetGeoShapeFromUserLocation = (0,_async_to_generator/* default */.Z)(function(latitude, longitude, shapeGeoOption) {
        var ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            try {
                return [
                    2,
                    getAthenaClient().GetGeoShapeFromUserLocation({
                        latitude: latitude,
                        longitude: longitude,
                        shapeGeoOption: shapeGeoOption
                    })
                ];
            } catch (e) {
                ;
                (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
                return [
                    2
                ];
            }
            return [
                2
            ];
        });
    });
    return _GetGeoShapeFromUserLocation.apply(this, arguments);
}
function GetPropertiesFromGeoShape(shape, filters, paginationRequest) {
    return _GetPropertiesFromGeoShape.apply(this, arguments);
}
function _GetPropertiesFromGeoShape() {
    _GetPropertiesFromGeoShape = (0,_async_to_generator/* default */.Z)(function(shape, filters, paginationRequest) {
        var ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            try {
                return [
                    2,
                    getAthenaClient().GetPropertiesFromGeoShape({
                        shape: shape,
                        filters: filters,
                        paginationRequest: paginationRequest
                    })
                ];
            } catch (e) {
                ;
                (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
                return [
                    2
                ];
            }
            return [
                2
            ];
        });
    });
    return _GetPropertiesFromGeoShape.apply(this, arguments);
}
function AddressAutocomplete(query, filters, pageInput, latitude, longitude) {
    return _AddressAutocomplete.apply(this, arguments);
}
function _AddressAutocomplete() {
    _AddressAutocomplete = (0,_async_to_generator/* default */.Z)(function(query, filters, pageInput, latitude, longitude) {
        var ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            try {
                return [
                    2,
                    getAthenaClient().AddressAutocomplete({
                        query: query,
                        filters: filters,
                        latitude: latitude,
                        longitude: longitude,
                        pageInput: pageInput
                    })
                ];
            } catch (e) {
                ;
                (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
                return [
                    2
                ];
            }
            return [
                2
            ];
        });
    });
    return _AddressAutocomplete.apply(this, arguments);
}
function fetchSellerReturnExperience(sellerInputUUID) {
    return doBFFPost(globals/* ATHENA_URL */.Uw, {
        operationName: "ReturnExperienceQuery",
        query: "query ReturnExperienceQuery($sellerInputUUID: String!) {\n      reception {\n        getSellerInput(input: { uuid: $sellerInputUUID }) {\n          sellerInput {\n            productOfferings {\n              product\n              deniedAt\n            }\n            address {\n              street\n              unitType\n              unitNumber\n              city\n              state\n              postalCode\n            }\n            answers {\n              email\n              homeGuideRegistered\n            }\n            sellerFlowLastCompletedSlug\n          }\n        }\n      }\n      sellDirect {\n        getLead(input: { lead: { source: { type: RECEPTION, id: $sellerInputUUID }} }) {\n          lead {\n            isQualified\n            customerV2 {\n              uuid\n              firstName\n            }\n            address {\n              uuid\n              street\n            }\n            latestOffer {\n              preliminaryOfferExpirationDate\n              state\n              headlinePriceCents\n              offerRequestSource\n            }\n            previousOffer {\n              headlinePriceCents\n            }\n          }\n        }\n      }\n    }",
        variables: {
            sellerInputUUID: sellerInputUUID
        }
    }, {
        headers: {
            "apollographql-client-name": "cosmos"
        }
    }).then(handleResponse).catch(function(e) {
        var ref;
        return (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
    });
}
function unsubscribeMailer(addressUuid) {
    return doBFFPost(globals/* ATHENA_URL */.Uw, {
        operationName: "UnsubscribeMailer",
        query: "mutation UnsubscribeMailer($address: OdProtosWebServicesMarketing_UnsubscribeMailerRequestInput!) {\n      marketing {\n        unsubscribeMailer(input: $address) {\n          _empty\n        }\n      }\n    }",
        variables: {
            address: {
                addressToken: addressUuid
            }
        }
    }, {
        headers: {
            "apollographql-client-name": "cosmos"
        }
    }).then(handleResponse).catch(function(e) {
        var ref;
        return (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
    });
}
function requestNewToken(expiredToken) {
    return doBFFPost(globals/* ATHENA_URL */.Uw, {
        operationName: "RequestNewToken",
        query: "mutation RequestNewToken($expiredToken: String!) {\n        passwordless {\n          requestNewToken(input: {token: $expiredToken }) {\n            token\n          }\n        }\n      }",
        variables: {
            expiredToken: expiredToken
        }
    }, {
        headers: {
            "apollographql-client-name": "cosmos"
        }
    }).then(handleResponse).catch(function(e) {
        var ref;
        return (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
    });
}
function requestNewTokenByEmail(email, redirectUrl) {
    return doBFFPost(globals/* ATHENA_URL */.Uw, {
        operationName: "RequestNewToken",
        query: "mutation RequestNewToken($email: String!, $redirectUrl: String) {\n        passwordless {\n          requestNewToken(input: {email: $email, redirectUrl: $redirectUrl}) {\n            token\n          }\n        }\n      }",
        variables: {
            email: email,
            redirectUrl: redirectUrl
        }
    }, {
        headers: {
            "apollographql-client-name": "cosmos"
        }
    }).then(handleResponse).catch(function(e) {
        var ref;
        return (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
    });
}
function updateCurrentCustomer(params) {
    return _updateCurrentCustomer.apply(this, arguments);
}
function _updateCurrentCustomer() {
    _updateCurrentCustomer = (0,_async_to_generator/* default */.Z)(function(params) {
        var e, ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        getAthenaClient().UpdateCurrentCustomer({
                            customerUpdates: params
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    e = _state.sent();
                    (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
                    return [
                        2
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _updateCurrentCustomer.apply(this, arguments);
}
function fetchTraitByAnonymousId(traitName, anonymousId) {
    return doBFFPost(ATHENA_URL, {
        operationName: "GetTrait",
        query: "query GetTrait($anonymousUuid: String, $traitName: String) {\n        insightV2 {\n          getTraitForIdentifier(\n            input: {\n              identifier: {\n                identifier: {\n                  customerIdentifier: { identifier: { anonymousId: $anonymousUuid } }\n                }\n              }\n              traitName: $traitName\n            }\n          ) {\n            trait {\n              name\n              value {\n                kind {\n                  ... on GoogleProtobuf_Value_KindOneof_StringValue {\n                    stringValue\n                  }\n                  ... on GoogleProtobuf_Value_KindOneof_ListValue {\n                    listValue {\n                      values {\n                        kind {\n                          ... on GoogleProtobuf_Value_KindOneof_StringValue {\n                            stringValue\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }",
        variables: {
            anonymousUuid: anonymousId,
            traitName: traitName
        }
    }, {
        headers: {
            "apollographql-client-name": "cosmos"
        }
    }).then(handleResponse).catch(function(e) {
        var ref;
        (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
        return null;
    });
}
var CancelBuyDirectOfferStatus = {
    SUCCESS_OFFER_CANCELLED: "SUCCESS_OFFER_CANCELLED",
    SUCCESS_TASK_CREATED: "SUCCESS_TASK_CREATED"
};
function cancelBuyDirectOffer(listingOfferUuid) {
    return doBFFPost(globals/* ATHENA_URL */.Uw, {
        operationName: "CancelBuyDirectOffer",
        query: "mutation CancelBuyDirectOffer($listingOfferUuid: String!) {\n        webBuyDirectListingOffer {\n          cancelBuyDirectOffer(input: { listingOfferUuid: $listingOfferUuid }) {\n            __typename\n            status\n          }\n        }\n      }",
        variables: {
            listingOfferUuid: listingOfferUuid
        }
    }, {
        headers: {
            "apollographql-client-name": "cosmos"
        }
    }).then(handleResponse).catch(function(e) {
        var ref;
        (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
        return null;
    });
}
// Buy Direct Checkout API functions
function getBuyDirectPropertyInfo(addressToken) {
    return _getBuyDirectPropertyInfo.apply(this, arguments);
}
function _getBuyDirectPropertyInfo() {
    _getBuyDirectPropertyInfo = (0,_async_to_generator/* default */.Z)(function(addressToken) {
        var e, ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        getAthenaClient().GetBuyDirectPropertyInfo({
                            addressToken: addressToken
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    e = _state.sent();
                    (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
                    throw e;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _getBuyDirectPropertyInfo.apply(this, arguments);
}
function getResaleOffers(customerId) {
    return _getResaleOffers.apply(this, arguments);
}
function _getResaleOffers() {
    _getResaleOffers = (0,_async_to_generator/* default */.Z)(function(customerId) {
        var e, ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        getAthenaClient().GetResaleOffers({
                            customerId: customerId
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    e = _state.sent();
                    (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
                    throw e;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _getResaleOffers.apply(this, arguments);
}
function standardizeAddress(address) {
    return doBFFPost(globals/* ATHENA_URL */.Uw, {
        operationName: "StandardizeAddress",
        query: "query StandardizeAddress($address: OdProtosCasaServices_CasaRequest_FindByFieldsInput!) {\n      casa {\n        findByFields(input: $address) {\n          address {\n            uuid\n            street\n            city\n            state\n            unitNumber\n            unitType\n            postalCode\n            latitude\n            longitude\n            result\n          }\n        }\n      }\n    }",
        variables: {
            address: {
                city: address.city,
                postalCode: address.postal_code,
                state: address.state,
                street: address.street1,
                unitNumber: address.unit
            }
        }
    }, {
        headers: {
            "apollographql-client-name": "cosmos"
        }
    }).then(handleResponse).catch(function(e) {
        var ref;
        return (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
    });
}
function createMortgageLead(input) {
    var mutation = "\n    mutation MortgageLead($input: OdProtosCustomerFinancingServiceServices_CustomerFinancingRequests_CreateMortgageLeadInput!) {\n      customerFinancingService {\n        createMortgageLead(input: $input) {\n          mortgageLead {\n            mortgageLeadId\n            customerUuid\n          }\n        }\n      }\n    }\n  ";
    return doBFFPost(globals/* ATHENA_URL */.Uw, {
        operationName: "MortgageLead",
        query: mutation,
        variables: {
            input: {
                customerUuid: input.customerUuid,
                channel: "CUSTOMER_EXPERIENCE",
                addressToken: input === null || input === void 0 ? void 0 : input.addressToken,
                propertyType: input.propertyType,
                targetMoveDate: input.targetMoveDate,
                targetPrice: input.targetPrice,
                targetDownPayment: input.targetDownPayment,
                targetLocation: input.targetLocation,
                employmentStatus: input.employmentStatus,
                householdIncomeMin: input.householdIncomeMin,
                householdIncomeMax: input.householdIncomeMax,
                firstName: input.firstName,
                lastName: input.lastName,
                phone: input.phone,
                email: input.email,
                currentAddress: input.currentAddress
            }
        }
    }, {
        headers: {
            "apollographql-client-name": "cosmos"
        }
    }).then(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(response) {
            var errorText, result;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!response.ok) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            response.text()
                        ];
                    case 1:
                        errorText = _state.sent();
                        throw new Error("GraphQL mutation failed: ".concat(errorText));
                    case 2:
                        return [
                            4,
                            response.json()
                        ];
                    case 3:
                        result = _state.sent();
                        if (result.errors) {
                            throw new Error("GraphQL errors: ".concat(JSON.stringify(result.errors)));
                        }
                        return [
                            2,
                            result
                        ];
                }
            });
        });
        return function(response) {
            return _ref.apply(this, arguments);
        };
    }()).catch(function(e) {
        var ref;
        (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
        throw e;
    });
}


/***/ }),

/***/ 30465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EQ": function() { return /* binding */ COSMOS_URL; },
/* harmony export */   "Ff": function() { return /* binding */ PARTNERSHIP_BFF_URL; },
/* harmony export */   "Kz": function() { return /* binding */ CONSUMER_URL; },
/* harmony export */   "Ut": function() { return /* binding */ REDIRECT_URLS_REGEX; },
/* harmony export */   "Uw": function() { return /* binding */ ATHENA_URL; },
/* harmony export */   "WL": function() { return /* binding */ EXCLUSIVE_RAILS_HOST; },
/* harmony export */   "Zp": function() { return /* binding */ DEPLOY_ENV; },
/* harmony export */   "eT": function() { return /* binding */ CAKE_URL; },
/* harmony export */   "ed": function() { return /* binding */ CONSUMER_FE_URL; },
/* harmony export */   "eu": function() { return /* binding */ GOOGLE_MAPS_API_KEY; },
/* harmony export */   "go": function() { return /* binding */ MITEK_SDK_PATH; },
/* harmony export */   "hW": function() { return /* binding */ MITEK_LICENSE; },
/* harmony export */   "oF": function() { return /* binding */ RAILS_URL; },
/* harmony export */   "oe": function() { return /* binding */ MITEK_SCIENCE_SDK_PATH; },
/* harmony export */   "sE": function() { return /* binding */ DATADOG_RUM_APPLICATION_CLIENT_TOKEN; },
/* harmony export */   "vt": function() { return /* binding */ DATADOG_RUM_APPLICATION_ID; },
/* harmony export */   "vu": function() { return /* binding */ MORTGAGE_API_URL; },
/* harmony export */   "x0": function() { return /* binding */ XSRF_COOKIE_KEY; },
/* harmony export */   "xR": function() { return /* binding */ MAPBOX_KEY; },
/* harmony export */   "zu": function() { return /* binding */ COSMOS_URLS; }
/* harmony export */ });
/* unused harmony exports GOOGLE_CLIENT_ID, BUYER_HOST */
/* harmony import */ var _opendoor_shared_fe_commonGlobals__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7004);
/* provided dependency */ var process = __webpack_require__(73656);

// eslint-disable-next-line @opendoor/no-direct-env-check
var DEPLOY_ENV = "production" || 0;
var secrets = _opendoor_shared_fe_commonGlobals__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[DEPLOY_ENV];
var XSRF_COOKIE_KEY = DEPLOY_ENV !== "development" ? "XSRF-G-TOKEN" : "XSRF-TOKEN";
var CAKE_URL = process.env.LOCAL_CAKE_URL || secrets.cakeUrl;
var CONSUMER_FE_URL = process.env.LOCAL_CONSUMER_URL || secrets.consumerFeUrl;
var GOOGLE_CLIENT_ID = secrets.googleClientID;
var GOOGLE_MAPS_API_KEY = secrets.googleMaps;
var RAILS_URL = process.env.LOCAL_WEB_BACKEND_URL || secrets.railsUrl;
var REDIRECT_URLS_REGEX = secrets.redirectURLsRegex;
var PARTNERSHIP_BFF_URL = secrets.partnerBffUrl;
var DATADOG_RUM_APPLICATION_ID = "a317f46d-d080-42c8-967f-147a7dfd8863";
var DATADOG_RUM_APPLICATION_CLIENT_TOKEN = "pub5745c1085abb698bce5cfc45d4c737ba";
var MAPBOX_KEY = "pk.eyJ1Ijoib3BlbmRvb3IiLCJhIjoiY2xqaGNqY294MDJ6bTNmbzNteDZreWp6bCJ9.xN6JQcm_ppepFmpk_UUBrw";
var MITEK_PATH = "/_odfiles/mitek-v5.5.0";
var MITEK_SDK_PATH = "".concat(MITEK_PATH, "/mitekSDK");
var MITEK_SCIENCE_SDK_PATH = "".concat(MITEK_PATH, "/mitek-science-sdk.js");
var MITEK_LICENSE = "eyJzaWduYXR1cmUiOiJFT2xoaURUK1FRL3VPL3hqTTE5NFBySFYwWnBYeVRLT3BqMDFZcHRQWUN4UDRpSHhzSlo4QlZ5N3k5NlNURjFYRnQrL1MyNkxWZEdEa1dmQTdGemFlZkhMQm9pY0tING45VXZ3bXQ2cjVaaVdRZHN0dW9mZVVCWjVOK2syZXNlRCtzcGxNYzhLWE03aU9NYmxPSHVNdW8veUtMMzdlWU45ZzFIOG1UdGVxUGpkRkRrQmZ2bEVGVmdZNG05dlpwVS9Ccmx6dHBFVDZabzhZcTd0STJqbFVuRm5IUjROcTlkcGNaUDZYWWVseWJEczRqSkh6b2FueUFmS0hMTzUrRzM2TmVWV0FINGFpM3BlNmRUb2hQLzNEWWtFMEpocy92Rnk3bWUzS3FPYXVrajhmNWJUbVpPdVN1TjJIK016dUFYcys0WmVuMERuOFNMTmxpa3JnZzJxTWc9PSIsInNpZ25lZCI6eyJleHBpcnkiOiIyMDI0LTA5LTA0IiwiZmVhdHVyZXMiOlsiYmFyY29kZSIsImlkIl0sImFwcGxpY2F0aW9uSWRlbnRpZmllciI6eyJ3ZWIiOlsiKi5vcGVuZG9vci5jb20iLCJvcGVuZG9vci5jb20iLCIqLnNpbXBsZXJzZWxsLmNvbSIsInNpbXBsZXJzZWxsLmNvbSJdfSwiZ3BvIjoiMTZkIiwib3JnYW5pemF0aW9uIjoiTWl0ZWsgU3lzdGVtcyBJbmMuIiwidmVyc2lvbiI6IjEuMCJ9LCJiYXJjb2RlV2ViTGljZW5zZSI6IlZiVTAxN21GcEVYUFJGWmMrN3pwLzRUL01NbkJqZ0xxakNMYUdQMEZrcXJqUmlGam5JM2tNV3V1d3hQQXQvWHpGQXZvTCt0RXVYYTN3amNYdjNOdEZ5bU5BVTVsZllPTlcxdEFhM09pVFBvdzZtZmJJT0tsNDBwNmluNktGNm9RSVcwdWg5UElublRlYVpQUGFteCs5MFJhN1NJZC9rMHZCdjZDdFM5S1Axd0FjZDhCVEZYTlhFUHhudkVMSDN3WFJIQWNReW9odU0wMHMrbCtMQ3dJNzRFVHR0cEFpNTE2MTBXUmlja3NMZlFkNEdRK1ZucVNnZkJyRCtBb0tDOVBrd2w3WVp2Qkpxakk0UnBrOENiem1uKzVNOHZoN3FneGp3S0Q1VmdYK0wzaXNmT0hhNW5qckNSc3B6NS9ESDdpanF3YitJbUNacy9OMDk1cGk4M0Z4ODBkMEU1cHlPWVM3M1psV0R4NC9LWHZtUHloVy9EbDBzMi96WmZ2Zld1ZVMwSHltSVFJS0NUQzNZaldCU2JhWjZ5clpSdzI2U3cwUmt4ZE40VjdvWUJHTThJWEFDY0IzTktLaExTc3NmSy9OMHltVVlNd2pJT1M0c28rY29uWE9WOW45ZGUzdHpYcjErTnhwQ2ZBQ2YrTkhMMmF5TURVY21rYjZCSWM0dURQIn0";
// Hit staging Athena by default in development
//
// To hit local Athena invert the comment & uncommented `development` keys
var ATHENA_URLS = {
    production: "https://graphql.apps.opendoor.com/api/graphql",
    // development: 'http://localhost:4000/api/graphql',
    development: "https://graphql.simplersell.com/api/graphql",
    // development: 'http://athena-api-nginx-vpn-http.apps.internal.opendoor.com/api/graphql',
    localdev: process.env.ODFE_ATHENA_URL || "http://localhost:4000/api/graphql",
    qa: "https://graphql.simplersell.com/api/graphql",
    staging: "https://graphql.simplersell.com/api/graphql",
    test: "https://graphql.simplersell.com/api/graphql"
};
var ATHENA_URL = ATHENA_URLS[DEPLOY_ENV];
// Mortgage API URLs
// Hit staging mortgage API by default in development
// To hit local, change development to 'http://localhost:3000/graphql/v1'
var MORTGAGE_API_URLS = {
    production: "https://mortgages.opendoor.com/graphql/v1",
    development: "https://mortgages.simplersell.com/graphql/v1",
    localdev: "http://localhost:3000/graphql/v1",
    qa: "https://mortgages.simplersell.com/graphql/v1",
    staging: "https://mortgages.simplersell.com/graphql/v1",
    test: "https://mortgages.simplersell.com/graphql/v1"
};
var MORTGAGE_API_URL = MORTGAGE_API_URLS[DEPLOY_ENV];
// Cosmos URL
var COSMOS_URLS = {
    production: "https://www.opendoor.com",
    staging: "https://demo.simplersell.com",
    qa: "https://qa.simplersell.com",
    test: "http://localhost:3011",
    development: "http://localhost:3011",
    localdev: process.env.LOCAL_COSMOS_URL || "http://localhost:3011"
};
var COSMOS_URL = COSMOS_URLS[DEPLOY_ENV];
// Hit qa Ola by default in development
//
// To hit local Ola invert the comment & uncommented `development` keys
var BUYER_HOSTS = {
    production: "https://buy.opendoor.com",
    // development: 'http://localhost:3000',
    development: "https://staging-buy.simplersell.com",
    localdev: "http://localhost:3000",
    qa: "https://staging-buy.simplersell.com",
    staging: "https://staging-buy.simplersell.com",
    test: "https://staging-buy.simplersell.com"
};
// Consumer URLs
var CONSUMER_URLS = {
    production: "https://consumer.opendoor.com",
    development: "https://consumer.simplersell.com",
    localdev: process.env.LOCAL_CONSUMER_URL || "http://localhost:3010",
    qa: "https://consumer.simplersell.com",
    staging: "https://consumer.simplersell.com",
    test: "https://consumer.simplersell.com"
};
var CONSUMER_URL = CONSUMER_URLS[DEPLOY_ENV];
var BUYER_HOST = BUYER_HOSTS[DEPLOY_ENV];
/*
 * Hit staging Rails by default in development
 * To hit local Web backend invert the comment & uncommented `development` keys
 */ var EXCLUSIVE_RAILS_HOSTS = {
    production: "https://www.opendoor.com",
    // development: 'http://localhost:5006',
    // development: 'https://www.opendoor.com',
    development: "https://demo.simplersell.com",
    localdev: process.env.LOCAL_WEB_BACKEND_URL || "http://localhost:5006",
    qa: "https://demo.simplersell.com",
    staging: "https://demo.simplersell.com",
    test: "https://demo.simplersell.com"
};
var EXCLUSIVE_RAILS_HOST = EXCLUSIVE_RAILS_HOSTS[DEPLOY_ENV];


/***/ }),

/***/ 44589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gv": function() { return /* binding */ useGetFeatureFlag; },
/* harmony export */   "iE": function() { return /* binding */ getLocalFeatureFlagOverrides; }
/* harmony export */ });
/* unused harmony export useCurrentCustomer */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12990);





/**
 * Development/QA localstorage feature flag override.
 *
 * force enabled -> window.localStorage.setItem('opendoor.cosmos.<flag>', 'true')
 *
 * Returns 'on' when overridden, else null, so the override path is shape-
 * compatible with the BFF variant strings ('on' | 'control' | ...) that
 * consumers compare against.
 */ var getLocalFeatureFlagOverrides = function(featureFlag) {
    try {
        // Ignore override check on the server
        if (false) {}
        return window.localStorage.getItem("opendoor.cosmos.".concat(featureFlag)) === "true" ? "on" : null;
    } catch (e) {
        return null;
    }
};
var useGetFeatureFlag = function(name) {
    var customerUUID = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, anonId = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(options.defaultValue || ""), featureFlag = ref[0], setFeatureFlag = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        (0,_api__WEBPACK_IMPORTED_MODULE_1__/* .getFeatureFlag */ .OC)(name, customerUUID, options, anonId).then(setFeatureFlag);
    }, []);
    return featureFlag;
};
/**
 * Gets the customer data for the currently logged in user and provides a method to update the current cutomer's data.
 */ var useCurrentCustomer = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref = useState(null), customer = ref[0], setCustomer = ref[1];
    var ref1 = useState(true), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = useState(false), isUpdating = ref2[0], setIsUpdating = ref2[1];
    var ref3 = useAuth(), _authentication = ref3.authentication, authState = _authentication.state;
    useEffect(function() {
        if (authState !== "authenticated") {
            setCustomer(null);
            setIsLoading(false);
            return;
        }
        var getCustomer = function() {
            var _ref = _async_to_generator(function() {
                var ref, customerResp, e;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setIsLoading(true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                4,
                                5
                            ]);
                            return [
                                4,
                                getAthenaClient().GetCurrentCustomer()
                            ];
                        case 2:
                            customerResp = _state.sent();
                            setCustomer(((ref = customerResp.customerService.getCurrentCustomer) === null || ref === void 0 ? void 0 : ref.customer) || null);
                            return [
                                3,
                                5
                            ];
                        case 3:
                            e = _state.sent();
                            setCustomer(null);
                            if (!options.onGetError) throw e;
                            options.onGetError(e);
                            return [
                                3,
                                5
                            ];
                        case 4:
                            setIsLoading(false);
                            return [
                                7
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getCustomer() {
                return _ref.apply(this, arguments);
            };
        }();
        getCustomer();
    }, [
        authState
    ]);
    var update = function() {
        var _ref = _async_to_generator(function(params) {
            var ref, resp, updatedCustomer, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!customer) return [
                            2
                        ];
                        setIsUpdating(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            getAthenaClient().UpdateCurrentCustomer({
                                customerUpdates: params
                            })
                        ];
                    case 2:
                        resp = _state.sent();
                        updatedCustomer = (ref = resp.customerService.updateCurrent) === null || ref === void 0 ? void 0 : ref.updatedCustomer;
                        setCustomer(updatedCustomer);
                        return [
                            2,
                            updatedCustomer
                        ];
                    case 3:
                        e = _state.sent();
                        if (!options.onUpdateError) throw e;
                        options.onUpdateError(e);
                        return [
                            2
                        ];
                    case 4:
                        setIsUpdating(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function update(params) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        customer: customer,
        isLoading: isLoading,
        isUpdating: isUpdating,
        isUserAuthenticated: authState === "authenticated",
        update: update
    };
};


/***/ }),

/***/ 24287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ setCookie; },
/* harmony export */   "y": function() { return /* binding */ getAnonymousId; }
/* harmony export */ });
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37462);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_0__);

function getAnonymousId() {
    var anonymousId = js_cookie__WEBPACK_IMPORTED_MODULE_0___default().get("ajs_anonymous_id");
    if (!anonymousId) {
        return undefined;
    }
    return anonymousId;
}
var setCookie = function(key, value, expires) {
    // For real staging and production, we need the cookie to be accessible
    // across all subdomains
    // i.e. ".domain.com" cookies are available on all subdomains, vs "www.domain.com"
    // which is only available on same-origin
    // https://www.mxsasha.eu/blog/2014/03/04/definitive-guide-to-cookie-domains/
    var cookieDomain = window.location.hostname;
    if (cookieDomain.indexOf("opendoor.com") !== -1) {
        cookieDomain = ".opendoor.com";
    } else if (window.location.hostname.indexOf("simplersell.com") !== -1) {
        cookieDomain = ".simplersell.com";
    }
    // expires is in days
    js_cookie__WEBPACK_IMPORTED_MODULE_0___default().set(key, value, {
        expires: expires,
        domain: cookieDomain
    });
};


/***/ }),

/***/ 58886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "le": function() { return /* binding */ ADDRESS_INVALID_RESULT; },
  "Pj": function() { return /* binding */ AddressValidationContextProvider; },
  "Qk": function() { return /* binding */ gateProceedToOnboardingFlow; },
  "oK": function() { return /* binding */ useAddressValidationContext; }
});

// UNUSED EXPORTS: handleAddressVerificationSuccess, trackAddressSuccess

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(60947);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(99758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92336);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(78049);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../observability/dist/observability-slim.mjs + 2 modules
var observability_slim = __webpack_require__(75461);
// EXTERNAL MODULE: ./src/components/api/index.ts + 3 modules
var api = __webpack_require__(12990);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ./src/components/shared/trackers.tsx
var trackers = __webpack_require__(24287);
;// CONCATENATED MODULE: ./src/components/api/addressInputHelpers.ts







var Sentry = observability_slim/* globalObservability.getSentryClient */.w.getSentryClient();
var getSellerFlowUUID = function() {
    var fragments = window.location.search.match(/sfuuid=([-\w]+)/);
    if (!fragments) {
        return undefined;
    }
    return fragments[1];
};
var getUrlParam = function(paramName) {
    var regExp = new RegExp("".concat(paramName, "\\=([\\w-_]+)"));
    var fragments = window.location.search.match(regExp);
    if (!fragments) {
        return undefined;
    }
    return fragments[1];
};
var getSellerFlowName = function() {
    return getUrlParam("sfname");
};
var getCovid19Whitelist = function() {
    return getUrlParam("covid19_whitelist") === "true";
};
var getChannelOverride = function() {
    var ref;
    return (ref = getUrlParam("channel_override")) === null || ref === void 0 ? void 0 : ref.toUpperCase();
};
var GRPC_ERROR_CODE = "GRPC_ERROR";
var INVALID_ARGUMENT_ERROR_CODE = 3;
/** Determines whether the errors array includes a invalid argument error */ var hasInvalidArgumentError = function(errors) {
    return errors.some(function(error) {
        var ref, ref1, ref2;
        return ((ref = error.extensions) === null || ref === void 0 ? void 0 : ref.code) === GRPC_ERROR_CODE && ((ref1 = error.extensions) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.exception) === null || ref2 === void 0 ? void 0 : ref2.code) === INVALID_ARGUMENT_ERROR_CODE;
    }) || false;
};
var startAddressVerification = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var addressUUID, address, product, channel, trackingKeywords, inputLocation, onSuccess, partnerReferralId, pageSetPath, addressEntry, options, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    addressUUID = param.addressUUID, address = param.address, product = param.product, channel = param.channel, trackingKeywords = param.trackingKeywords, inputLocation = param.inputLocation, onSuccess = param.onSuccess, partnerReferralId = param.partnerReferralId, pageSetPath = param.pageSetPath;
                    observability_slim/* analytics.trackEvent */.co.trackEvent("inputting", "address", "verifying", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, address), {
                        inputLocation: inputLocation
                    }));
                    addressEntry = {
                        product: product,
                        url: window.location.href
                    };
                    options = {
                        channel: getChannelOverride() || channel,
                        covid19Whitelist: getCovid19Whitelist(),
                        seller_flow_name_override: getSellerFlowName(),
                        seller_flow_uuid_override: getSellerFlowUUID(),
                        trackingKeywords: trackingKeywords,
                        partnerReferralId: partnerReferralId
                    };
                    return [
                        4,
                        api/* createSellerInput */.lX(address, addressEntry, options, addressUUID).then(function(resp) {
                            var ref, ref1, ref2, ref3;
                            if (!resp) {
                                throw {
                                    type: "generic-error",
                                    message: "received non-200 error or could not json parse response, check network logs"
                                };
                            }
                            if ((ref = resp.errors) === null || ref === void 0 ? void 0 : ref.length) {
                                if (hasInvalidArgumentError(resp.errors)) {
                                    throw {
                                        type: "invalid-address",
                                        message: resp.errors
                                    };
                                }
                                throw {
                                    type: "generic-error",
                                    message: resp.errors
                                };
                            }
                            var sellerInput = resp === null || resp === void 0 ? void 0 : (ref1 = resp.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.reception) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.createSellerInputWithTrackingDataFromCookies) === null || ref3 === void 0 ? void 0 : ref3.sellerInput;
                            if (!sellerInput) {
                                // in case an error is not returned in the response, but seller input is empty.
                                throw {
                                    type: "generic-error",
                                    message: "startAddressVerification: seller input from CreateSellerInputWithTrackingDataFromCookies response is undefined"
                                };
                            }
                            var uuid = sellerInput.uuid, pdpUrl = sellerInput.pdpUrl, isInPartnershipDenialServiceRegions = sellerInput.isInPartnershipDenialServiceRegions;
                            var postalCode = sellerInput.address.postalCode;
                            if (address.postal_code && postalCode !== address.postal_code) {
                                throw {
                                    type: "invalid-address",
                                    message: "startAddressVerification: postal code mismatch: ".concat(postalCode, " !== ").concat(address.postal_code)
                                };
                            }
                            (0,trackers/* setCookie */.d)("isInPartnershipDenialServiceRegions-".concat(uuid), isInPartnershipDenialServiceRegions.toString(), 1);
                            observability_slim/* analytics.register */.co.register({
                                "Offer ID": uuid,
                                "Offer Postal Code": postalCode
                            });
                            onSuccess && onSuccess(uuid, pdpUrl, pageSetPath);
                            return;
                        }).catch(function(e) {
                            var ref;
                            observability_slim/* analytics.trackEvent */.co.trackEvent("lead", "failed");
                            (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e.message, {
                                captureContext: {
                                    extra: {
                                        address: address,
                                        addressEntry: addressEntry,
                                        options: options
                                    }
                                }
                            });
                            return e;
                        })
                    ];
                case 1:
                    error = _state.sent();
                    return [
                        2,
                        error
                    ];
            }
        });
    });
    return function startAddressVerification(_) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(30465);
// EXTERNAL MODULE: ./src/helpers/queryParams.ts
var queryParams = __webpack_require__(61466);
;// CONCATENATED MODULE: ./src/helpers/AddressValidationContext.tsx












var AddressValidationContext_Sentry = observability_slim/* globalObservability.getSentryClient */.w.getSentryClient();
var ADDRESS_INVALID_RESULT = [
    "ADDRESS_NIL",
    "ADDRESS_UNKNOWN",
    "ADDRESS_MISSING_PREMISE",
    "ADDRESS_INVALID_PREMISE",
    "ADDRESS_NOT_SUPPORTED",
    "ADDRESS_NOT_REAL",
    "ADDRESS_INVALID",
    "ADDRESS_INVALID_STREET",
    "ADDRESS_INVALID_SUB_PREMISE",
    "ADDRESS_MISSING_BOX_NUMBER",
    "ADDRESS_INVALID_BOX_NUMBER",
    "ADDRESS_EXTRANEOUS_INPUT", 
];
var trackAddressSuccess = function(trackEvent, label) {
    try {
        trackEvent("inputting_address_success", label);
    } catch (err) {
        var ref;
        (ref = AddressValidationContext_Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(AddressValidationContext_Sentry, err);
    }
};
var handleAddressVerificationSuccess = function(param) {
    var address = param.address, token = param.token, trackEvent = param.trackEvent, pdpUrl = param.pdpUrl, pageSetPath = param.pageSetPath, onSuccess = param.onSuccess, relationshipAnswers = param.relationshipAnswers;
    var performRedirection = function() {
        if (pdpUrl) {
            trackAddressSuccess(trackEvent, "pdp-redirect");
            if (onSuccess) {
                return onSuccess(address, token, pdpUrl);
            }
            window.location.href = "".concat(globals/* COSMOS_URL */.EQ).concat(pdpUrl, "?utm_source=seller&utm_medium=web&utm_campaign=ae_pdp");
        } else {
            trackAddressSuccess(trackEvent, "onboarding-redirect");
            if (onSuccess) {
                return onSuccess(address, token, pdpUrl);
            }
            var redirectUrl = pageSetPath ? "".concat(globals/* CONSUMER_FE_URL */.ed, "/seller-lead/").concat(token).concat(pageSetPath) : "".concat(globals/* CONSUMER_FE_URL */.ed, "/seller-lead/").concat(token);
            window.location.href = redirectUrl;
        }
    };
    var answers = (0,_object_spread/* default */.Z)({
        "home.user_verified_address": true
    }, relationshipAnswers);
    if (relationshipAnswers === null || relationshipAnswers === void 0 ? void 0 : relationshipAnswers["seller.relation_to_owner"]) {
        answers["experimental"] = [
            {
                question_key: "seller.relation_to_owner_from_cosmos",
                string_values: {
                    values: [
                        relationshipAnswers["seller.relation_to_owner"]
                    ]
                }
            }, 
        ];
    }
    (0,api/* updateAnswers */.gh)(answers, "", token).then(function() {
        performRedirection();
    }).catch(function(err) {
        var ref;
        (ref = AddressValidationContext_Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(AddressValidationContext_Sentry, err);
    });
};
var gateProceedToOnboardingFlow = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var address, product, trackEvent, trackingTaxonomy, channel, trackingKeywords, inputLocation, onSuccess, partnerReferralId, pageSetPath, addressUUID, _canRedirect, canRedirect, relationshipAnswers, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    address = param.address, product = param.product, trackEvent = param.trackEvent, trackingTaxonomy = param.trackingTaxonomy, channel = param.channel, trackingKeywords = param.trackingKeywords, inputLocation = param.inputLocation, onSuccess = param.onSuccess, partnerReferralId = param.partnerReferralId, pageSetPath = param.pageSetPath, addressUUID = param.addressUUID, _canRedirect = param.canRedirect, canRedirect = _canRedirect === void 0 ? true : _canRedirect, relationshipAnswers = param.relationshipAnswers;
                    if (trackingTaxonomy) {
                        (0,trackers/* setCookie */.d)("sourceForTracking", trackingTaxonomy, 1);
                    }
                    return [
                        4,
                        startAddressVerification({
                            addressUUID: addressUUID,
                            address: address,
                            product: product,
                            channel: channel,
                            trackingKeywords: trackingKeywords,
                            inputLocation: inputLocation,
                            onSuccess: function(token, pdpUrl, pageSetPath) {
                                handleAddressVerificationSuccess({
                                    address: address,
                                    token: token,
                                    trackEvent: trackEvent,
                                    pdpUrl: pdpUrl,
                                    pageSetPath: pageSetPath,
                                    onSuccess: onSuccess,
                                    relationshipAnswers: relationshipAnswers
                                });
                            },
                            partnerReferralId: partnerReferralId,
                            pageSetPath: pageSetPath
                        })
                    ];
                case 1:
                    error = _state.sent();
                    if (error) {
                        if (error.type === "invalid-address") {
                            if (canRedirect) {
                                window.location.href = "/manual-address-entry";
                            } else {
                                throw new Error(error.message);
                            }
                        } else {
                            window.location.href = "/error";
                        }
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function gateProceedToOnboardingFlow(_) {
        return _ref.apply(this, arguments);
    };
}();
var AddressValidationContext = /*#__PURE__*/ react.createContext({
    validatedAddress: undefined,
    setValidatedAddress: function() {
        return null;
    },
    addressResults: [],
    setAddressResults: function() {
        return null;
    },
    isPredictionSelectLoading: false,
    setIsPredictionSelectLoading: function() {
        return null;
    },
    firstPrediction: null,
    setFirstPrediction: function() {
        return null;
    },
    partnerReferralId: undefined,
    setPartnerReferralId: function() {
        return null;
    },
    pageSetPath: undefined,
    setPageSetPath: function() {
        return null;
    },
    trackingKeywords: undefined,
    setTrackingKeywords: function() {
        return null;
    },
    channel: undefined,
    setChannel: function() {
        return null;
    }
});
var useAddressValidationContext = function() {
    return react.useContext(AddressValidationContext);
};
var AddressValidationContextProvider = function(param) {
    var children = param.children;
    var ref = (0,queryParams/* default */.Z)(), address = ref.address, result = ref.result, pageSetPathQueryParam = ref.pageSetPath, trackingKeyworksQueryParam = ref.trackingKeyword, partnerReferralIdQueryParam = ref.partnerReferralId, channelQueryParam = ref.channel;
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(function() {
        if (!address) return undefined;
        return JSON.parse(address);
    }), 2), validatedAddress = ref1[0], setValidatedAddress = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(function() {
        if (!result) return [];
        if (Array.isArray(result)) {
            return result;
        }
        return [
            result
        ];
    }), 2), addressResults = ref2[0], setAddressResults = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isPredictionSelectLoading = ref3[0], setIsPredictionSelectLoading = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), firstPrediction = ref4[0], setFirstPrediction = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)(react.useState(function() {
        if (!partnerReferralIdQueryParam) return undefined;
        return partnerReferralIdQueryParam;
    }), 2), partnerReferralId = ref5[0], setPartnerReferralId = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)(react.useState(function() {
        if (!pageSetPathQueryParam) return undefined;
        return pageSetPathQueryParam;
    }), 2), pageSetPath = ref6[0], setPageSetPath = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)(react.useState(function() {
        if (!trackingKeyworksQueryParam) return undefined;
        return trackingKeyworksQueryParam;
    }), 2), trackingKeywords = ref7[0], setTrackingKeywords = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)(react.useState(function() {
        if (!channelQueryParam) return "DEFAULT";
        return channelQueryParam;
    }), 2), channel = ref8[0], setChannel = ref8[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddressValidationContext.Provider, {
        value: {
            trackingKeywords: trackingKeywords,
            setTrackingKeywords: setTrackingKeywords,
            pageSetPath: pageSetPath,
            setPageSetPath: setPageSetPath,
            validatedAddress: validatedAddress,
            setValidatedAddress: setValidatedAddress,
            addressResults: addressResults,
            setAddressResults: setAddressResults,
            isPredictionSelectLoading: isPredictionSelectLoading,
            setIsPredictionSelectLoading: setIsPredictionSelectLoading,
            firstPrediction: firstPrediction,
            setFirstPrediction: setFirstPrediction,
            partnerReferralId: partnerReferralId,
            setPartnerReferralId: setPartnerReferralId,
            channel: channel,
            setChannel: setChannel
        },
        children: children
    });
};


/***/ }),

/***/ 70831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C3": function() { return /* binding */ useObservability; },
/* harmony export */   "FL": function() { return /* binding */ OBSERVABILITY_QUERY_PARAM_KEYS; },
/* harmony export */   "lT": function() { return /* binding */ initObservability; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60947);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48417);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92336);
/* harmony import */ var _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75461);
/* harmony import */ var _components_globals__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30465);







var EXPERIMENT_QUERY_PARAM_KEYS = [
    /* Experiment name */ "experiment",
    /* Experiment variation */ "experimentVariation", 
];
var OBSERVABILITY_QUERY_PARAM_KEYS = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(EXPERIMENT_QUERY_PARAM_KEYS).concat([
    /* Cosmos path e.g. /landing-pages/[...slug] or /articles/[...name] */ "cosmosPathname",
    /* Dynamic route value e.g. $slug in /landing-pages/[...slug] */ "slug",
    /* Dynamic route value e.g. $name in /articles/topic/[...name] */ "name", 
]);
//observability
var initObservability = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, globalContext = ref.globalContext, isBot = ref.isBot;
    // make sure we only init observability client-side
    if ( true && !_opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_0__/* .globalObservability.isInitialized */ .w.isInitialized()) {
        if (_components_globals__WEBPACK_IMPORTED_MODULE_1__/* .DEPLOY_ENV */ .Zp === "test") {
            (0,_opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_0__/* .initObservability */ .lT)({
                eventTrackingCategory: "cosmos",
                isBot: true,
                env: "development",
                appName: "cosmos",
                version: "fc8e385bd75ab9d65b25adb5eb5d41337a3ac64b" || 0
            });
            return;
        }
        (0,_opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_0__/* .initObservability */ .lT)({
            eventTrackingCategory: "cosmos",
            isBot: isBot,
            env: _components_globals__WEBPACK_IMPORTED_MODULE_1__/* .DEPLOY_ENV */ .Zp === "localdev" ? "development" : _components_globals__WEBPACK_IMPORTED_MODULE_1__/* .DEPLOY_ENV */ .Zp,
            appName: "cosmos",
            version: "fc8e385bd75ab9d65b25adb5eb5d41337a3ac64b" || 0,
            lazyLoadAnalytics: true,
            sentry: {
                dsn: "https://3414e8de867a4131a44598d29006eccc@o117144.ingest.sentry.io/1439728",
                maxBreadcrumbs: 50,
                attachStacktrace: true,
                // Only allow errors from first-party sources, to reduce sentry spam
                allowUrls: [
                    "simplersell.com",
                    "opendoor.com"
                ],
                // observability package has default ignore errors set by default
                // https://github.com/opendoor-labs/code/blob/master/js/packages/observability/src/internal/sentry.ts#L138
                init: function() {
                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(initOpts) {
                        var customBeforeSend, Sentry;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    customBeforeSend = function(event, hint) {
                                        var ref, ref1, ref2, ref3, ref4, ref5;
                                        // ref: https://github.com/getsentry/sentry-javascript/issues/7941#issuecomment-1525640063
                                        // {
                                        //   "type": "Event",
                                        //   "value": "Non-Error exception captured with keys: currentTarget, isTrusted, target, type",
                                        //   "stacktrace": {
                                        //     "frames": [
                                        //       {
                                        //         "module": "properties/21027-Manon-Ln-Spring-TX-77388/aid_1acb88dd-b5de-5b5f-89c8-66bf60db11fd",
                                        //         "filename": "app:///properties/21027-Manon-Ln-Spring-TX-77388/aid_1acb88dd-b5de-5b5f-89c8-66bf60db11fd",
                                        //         "abs_path": "app:///properties/21027-Manon-Ln-Spring-TX-77388/aid_1acb88dd-b5de-5b5f-89c8-66bf60db11fd",
                                        //         "in_app": true
                                        //       }
                                        //     ]
                                        //   },
                                        //   "mechanism": {
                                        //     "type": "onerror",
                                        //     "synthetic": true,
                                        //     "handled": false
                                        //   }
                                        // }
                                        var eventMessage = (event === null || event === void 0 ? void 0 : (ref = event.exception) === null || ref === void 0 ? void 0 : (ref1 = ref.values) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.value) || "";
                                        if ((ref3 = eventMessage.includes) === null || ref3 === void 0 ? void 0 : ref3.call(eventMessage, "Non-Error exception captured with keys: currentTarget, isTrusted, target, type")) {
                                            return null;
                                        }
                                        if (((window === null || window === void 0 ? void 0 : (ref4 = window.navigator) === null || ref4 === void 0 ? void 0 : ref4.userAgent) || "").includes("Netsparker")) {
                                            return null;
                                        }
                                        var ref6;
                                        return (ref6 = (ref5 = initOpts.beforeSend) === null || ref5 === void 0 ? void 0 : ref5.call(initOpts, event, hint)) !== null && ref6 !== void 0 ? ref6 : event;
                                    };
                                    return [
                                        4,
                                        Promise.all(/* import() */[__webpack_require__.e(3202), __webpack_require__.e(9115), __webpack_require__.e(799)]).then(__webpack_require__.bind(__webpack_require__, 30799))
                                    ];
                                case 1:
                                    Sentry = _state.sent();
                                    Sentry.init((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, initOpts), {
                                        beforeSend: customBeforeSend,
                                        enableTracing: false
                                    }));
                                    window.addEventListener("unhandledrejection", function(event) {
                                        var ref, ref1;
                                        var _reason;
                                        var reason = (_reason = event.reason) !== null && _reason !== void 0 ? _reason : new Error("Unhandled promise rejection with undefined reason");
                                        Sentry.captureException(reason, {
                                            contexts: {
                                                promiseRejection: {
                                                    hadReason: event.reason != null,
                                                    promiseType: (ref = event.promise) === null || ref === void 0 ? void 0 : (ref1 = ref.constructor) === null || ref1 === void 0 ? void 0 : ref1.name
                                                }
                                            }
                                        });
                                    });
                                    return [
                                        2,
                                        Sentry
                                    ];
                            }
                        });
                    });
                    return function(initOpts) {
                        return _ref.apply(this, arguments);
                    };
                }()
            },
            datadog: {
                service: "cosmos",
                applicationId: _components_globals__WEBPACK_IMPORTED_MODULE_1__/* .DATADOG_RUM_APPLICATION_ID */ .vt,
                clientToken: _components_globals__WEBPACK_IMPORTED_MODULE_1__/* .DATADOG_RUM_APPLICATION_CLIENT_TOKEN */ .sE,
                sessionSampleRate: 100,
                sessionReplaySampleRate: 100,
                trackUserInteractions: true,
                silentMultipleInit: true,
                trackSessionAcrossSubdomains: true,
                // Please be careful when adding tracing origins.
                // If a server is not prepared for the new Datadog headers, then it may fail with CORS errors.
                // Relevant postmortem: https://docs.google.com/document/d/1O9eWUdXZJOS4Oha2v_dtPfjO34IU3KEDpNqjk3AtXdk/edit
                allowedTracingUrls: [
                    /https:\/\/.*\.simplersell\.com/,
                    /https:\/\/.*\.opendoor\.com/
                ],
                defaultPrivacyLevel: "mask-user-input",
                init: function() {
                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(initOpts) {
                        var datadogRum;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        __webpack_require__.e(/* import() */ 4838).then(__webpack_require__.bind(__webpack_require__, 4838))
                                    ];
                                case 1:
                                    datadogRum = _state.sent().datadogRum;
                                    datadogRum.init(initOpts);
                                    datadogRum.startSessionReplayRecording();
                                    globalContext === null || globalContext === void 0 ? void 0 : globalContext.forEach(function(param) {
                                        var key = param.key, value = param.value;
                                        datadogRum.setGlobalContextProperty(key, "".concat(value));
                                    });
                                    return [
                                        2,
                                        datadogRum
                                    ];
                            }
                        });
                    });
                    return function(initOpts) {
                        return _ref.apply(this, arguments);
                    };
                }()
            },
            journeyEndpoint: "/_journey/api/v1"
        });
    }
};
var useObservability = function() {
    return (0,_opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_0__/* .useObservability */ .C3)();
};


/***/ }),

/***/ 61466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export searchParamsFromUrl */
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62281);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);

function useQueryParams() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    return router.query;
}
function searchParamsFromUrl(urlOrPathname) {
    if (!urlOrPathname) {
        return new URLSearchParams();
    }
    try {
        // http://localhost is a backup if urlOrPathname is an absolute URL
        var url = new URL(urlOrPathname, "http://localhost");
        return url.searchParams;
    } catch (e) {
        return new URLSearchParams();
    }
}
/* harmony default export */ __webpack_exports__["Z"] = (useQueryParams);


/***/ }),

/***/ 66021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ErrorApp; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(60947);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(4656);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(13459);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(99758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(77162);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92336);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(78049);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-day-picker@9.14.0_react@18.3.1/node_modules/react-day-picker/src/style.css
var style = __webpack_require__(95046);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/BricksProvider.js
var BricksProvider = __webpack_require__(15806);
// EXTERNAL MODULE: ../observability/dist/observability-slim.mjs + 2 modules
var observability_slim = __webpack_require__(75461);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ./src/helpers/observability.ts
var helpers_observability = __webpack_require__(70831);
;// CONCATENATED MODULE: ./src/components/ErrorBoundary.tsx






function ErrorBoundaryWithObservability(param) {
    var children = param.children, errorLabel = param.errorLabel;
    var observability = (0,helpers_observability/* useObservability */.C3)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorBoundary, {
        observability: observability,
        errorLabel: errorLabel !== null && errorLabel !== void 0 ? errorLabel : "cosmos",
        children: children
    });
}
// We are only using this to assert that we log any unhandled exception that we receive.
var ErrorBoundary = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ErrorBoundary, _Component);
    var _super = (0,_create_super/* default */.Z)(ErrorBoundary);
    function ErrorBoundary(props) {
        (0,_class_call_check/* default */.Z)(this, ErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
        this.props.observability.trackError(this.props.errorLabel, error, {
            componentStack: errorInfo.componentStack
        });
        throw error;
    };
    _proto.render = function render() {
        return this.props.children;
    };
    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(_error) {
        return {
            hasError: true
        };
    };
    return ErrorBoundary;
}(react.Component);
/* harmony default export */ var components_ErrorBoundary = (ErrorBoundaryWithObservability);

// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.29.0_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.99.0/node_modules/next/router.js
var next_router = __webpack_require__(62281);
;// CONCATENATED MODULE: ./src/components/NavListener.tsx



/**
 * Listens for soft navigations (i.e. navigations that don't result in a full page refresh)
 *
 * - Reports the navigation to analytics
 */ function NavListener() {
    var trackJourneyEvent = (0,helpers_observability/* useObservability */.C3)().trackJourneyEvent;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        var handleRouteChange = function(url) {
            if (url !== location.pathname + location.search) {
                trackJourneyEvent("platform", "pageViewEvent", {});
            }
        };
        router.events.on("routeChangeStart", handleRouteChange);
        // If the component is unmounted, unsubscribe
        // from the event with the `off` method:
        return function() {
            router.events.off("routeChangeStart", handleRouteChange);
        };
    }, [
        router
    ]);
    return null;
}

// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.29.0_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.99.0/node_modules/next/script.js
var script = __webpack_require__(52559);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/components/shared/OneTrust.tsx
/* provided dependency */ var process = __webpack_require__(73656);


var OneTrustScripts = function() {
    // eslint-disable-next-line @opendoor/no-direct-env-check -- this compile-time switch avoids adding shared globals to every page bundle.
    var deployEnv = "production" || 0;
    if (process.env.COOKIE_BANNER_DISABLED === "true" || deployEnv === "test") {
        return null;
    }
    var isProduction = deployEnv === "production";
    var domainScript = isProduction ? "019756e6-db1e-7dfa-97f3-4cf089c9f913" : "019756e6-db1e-7dfa-97f3-4cf089c9f913-test";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
                src: "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
                strategy: "lazyOnload",
                "data-domain-script": domainScript
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
                id: "optanon-wrapper",
                strategy: "lazyOnload",
                children: "function OptanonWrapper() { }"
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.29.0_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.99.0/node_modules/next/app.js
var app = __webpack_require__(94711);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.29.0_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.99.0/node_modules/next/head.js
var head = __webpack_require__(20315);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-modal@3.16.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-modal/lib/index.js
var lib = __webpack_require__(24940);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_set_prototype_of.mjs
var _set_prototype_of = __webpack_require__(5398);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_construct.mjs


function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () { }));
    return true;
  } catch (e) {
    return false;
  }
}

function construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    construct = Reflect.construct;
  } else {
    construct = function construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) (0,_set_prototype_of/* default */.Z)(instance, Class.prototype);
      return instance;
    };
  }

  return construct.apply(null, arguments);
}

function _construct(Parent, args, Class) {
  return construct.apply(null, arguments);
}

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_is_native_function.mjs
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(8216);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_wrap_native_super.mjs





function wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  wrapNativeSuper = function wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, (0,_get_prototype_of/* default */.Z)(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return (0,_set_prototype_of/* default */.Z)(Wrapper, Class);
  };

  return wrapNativeSuper(Class);
}

function _wrapNativeSuper(Class) {
  return wrapNativeSuper(Class);
}

// EXTERNAL MODULE: ../auth-fe/dist/auth-fe2.esm.js
var auth_fe2_esm = __webpack_require__(6677);
;// CONCATENATED MODULE: ../auth-fe/dist/auth-fe3.esm.js
//#region src/globals.ts
var ENV = [
    "development",
    "localdev",
    "qa",
    "test",
    "staging",
    "production"
];
var isEnv = function(value) {
    return ENV.includes(value);
};
var domains = {
    production: "https://www.opendoor.com",
    staging: "https://demo.simplersell.com",
    qa: "https://demo.simplersell.com",
    development: "http://localhost:3011",
    localdev: "http://localhost:3011",
    test: "https://www.opendoor.com"
};
var getDomain = function(env) {
    if (!isEnv(env) || !domains[env]) throw new Error("DEVELOPER ERROR: Invalid DOMAIN, env ".concat(env, " is not in ").concat(ENV.join(",")));
    return domains[env];
};
var getRedirectUrl = function() {
    return encodeURIComponent(window.location.href);
};
var EMAIL_PREFILL_QUERY_PARAM = "emailPrefill";
/**
* Returns the URL for normal login. If successfully authenticated, the user will be redirected to the current location.
*
* @param env - Environment to use to get the correct domain
* @param emailPrefill  - [Optional] Email to use to prefill the log-in/sign-up form
*/ var getLoginUrlWithRedirect = function(env, emailPrefill) {
    var emailPrefillParam = emailPrefill ? "&".concat(EMAIL_PREFILL_QUERY_PARAM, "=").concat(emailPrefill) : "";
    return "".concat(getDomain(env), "/login?redirectTo=").concat(getRedirectUrl()).concat(emailPrefillParam);
};
var LOGIN_LITE_ACCESS_TOKEN_QUERY_PARAM = "access_token";
/**
* @description
* Returns the URL for login lite. If successfully authenticated, the user will be redirected to the current location.
*
* Domain: `opendoor.com/token`
* Query params:
*    1. `access_token=<TOKEN>`
*    2. `redirect_url=<ENCODED_CURRENT_URL>`
*/ var getLoginLiteUrlWithRedirect = function(env, accessToken) {
    return "".concat(getDomain(env), "/token?").concat(LOGIN_LITE_ACCESS_TOKEN_QUERY_PARAM, "=").concat(accessToken, "&redirect_url=").concat(getRedirectUrl());
};
//#endregion


;// CONCATENATED MODULE: ../auth-fe/dist/auth-fe4.esm.js





//#region src/graphql.ts
var useGraphqlQuery = function(client, query, vars) {
    var queryFn = (0,react.useCallback)(function() {
        return client.query(query, vars);
    }, [
        client,
        JSON.stringify({
            query: query,
            vars: vars
        })
    ]);
    var ref = (0,react.useState)(true), runQuery = ref[0], setRunQuery = ref[1];
    var ref1 = (0,react.useState)({
        loading: true,
        error: void 0,
        data: void 0
    }), fetchState = ref1[0], setFetchState = ref1[1];
    var refreshFn = (0,react.useCallback)(function() {
        return setRunQuery(true);
    }, []);
    (0,react.useEffect)(function() {
        if (!runQuery) return;
        var unmounted = false;
        function execute() {
            return _execute.apply(this, arguments);
        }
        function _execute() {
            _execute = (0,_async_to_generator/* default */.Z)(function() {
                var result, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                3,
                                4
                            ]);
                            return [
                                4,
                                queryFn()
                            ];
                        case 1:
                            result = _state.sent();
                            if (!unmounted) setFetchState({
                                loading: false,
                                data: result.data,
                                error: result.error
                            });
                            return [
                                3,
                                4
                            ];
                        case 2:
                            e = _state.sent();
                            if (!unmounted) setFetchState({
                                loading: false,
                                data: void 0,
                                error: e
                            });
                            return [
                                3,
                                4
                            ];
                        case 3:
                            if (!unmounted) setRunQuery(false);
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return _execute.apply(this, arguments);
        }
        execute();
        return function() {
            unmounted = true;
        };
    }, [
        runQuery,
        queryFn
    ]);
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fetchState), {
        refresh: refreshFn
    });
};
//#endregion


;// CONCATENATED MODULE: ../auth-fe/dist/auth-fe5.esm.js
//#region src/helpers.ts
function convertHumanToUser(human, trackError) {
    if (!human.email) {
        var message = "invalid data returned: missing Human.email";
        trackError && trackError(message);
        return {
            state: "error",
            user: void 0,
            message: message
        };
    }
    var fullName = human.full_name || human.first_name || "Customer";
    var firstName = human.first_name || human.full_name || "Customer";
    var hasOpendoorEmail = human.email.endsWith("@opendoor.com");
    var hasOpendoorInternalAccess = human.opendoor_internal_access || false;
    var impersonated = human.impersonated || false;
    return {
        state: "authenticated",
        user: {
            humanToken: human.token,
            customerUuid: human.customer_uuid || null,
            email: human.email,
            fullName: fullName,
            firstName: firstName,
            hasOpendoorEmail: hasOpendoorEmail,
            hasOpendoorInternalAccess: hasOpendoorInternalAccess,
            primaryPhone: human.primary_phone || null,
            impersonated: impersonated
        }
    };
}
var parseAuthentication = function(queryResult, trackError) {
    var ref;
    if (queryResult.loading) return {
        state: "authenticating",
        user: void 0
    };
    if (queryResult.error) {
        trackError && trackError("UserSession error", queryResult.error);
        return {
            state: "error",
            user: void 0,
            message: queryResult.error.message
        };
    }
    var userSession = (ref = queryResult.data) === null || ref === void 0 ? void 0 : ref.web.userSession;
    if (!userSession) {
        var message = "invalid data returned: missing UserSession";
        trackError && trackError(message);
        return {
            state: "error",
            user: void 0,
            message: message
        };
    }
    if (!userSession.human) return {
        state: "not_authenticated",
        user: null
    };
    return convertHumanToUser(userSession.human, trackError);
};
//#endregion


;// CONCATENATED MODULE: ../auth-fe/dist/auth-fe7.esm.js
//#region src/UserSession.gql?raw
var UserSession_default = "query UserSession {\n  web {\n    userSession {\n      human {\n        token\n        customer_uuid\n        email\n        first_name\n        full_name\n        opendoor_internal_access\n        primary_phone\n        impersonated\n      }\n    }\n  }\n}\n";
//#endregion


;// CONCATENATED MODULE: ../auth-fe/dist/auth-fe8.esm.js
//#region src/ValidateResetPasswordToken.gql?raw
var ValidateResetPasswordToken_default = "query validateResetPasswordToken($resetPasswordToken: String!) {\n  webPassword {\n    validateResetPasswordToken(input: { resetPasswordToken: $resetPasswordToken }) {\n      valid\n    }\n  }\n}\n";
//#endregion


;// CONCATENATED MODULE: ../auth-fe/dist/auth-fe9.esm.js










//#region src/AuthContextProvider.tsx
var normalizeAuthBaseUrl = function(authBaseUrl) {
    return authBaseUrl.replace(/\/+$/, "");
};
var getAuthBaseUrl = function(authBaseUrl, env) {
    if (authBaseUrl) return normalizeAuthBaseUrl(authBaseUrl);
    if (env) return getDomain(env);
    throw new Error("DEVELOPER ERROR: AuthContextProvider requires authBaseUrl or env");
};
/** TODO: Add documentation */ var AuthContextProvider = function(param) {
    var _trackError = param.trackError, trackError = _trackError === void 0 ? function() {} : _trackError, client = param.client, tmp = param.fetch, fetchFn = tmp === void 0 ? fetch : tmp, authBaseUrl = param.authBaseUrl, env = param.env, children = param.children;
    var resolvedAuthBaseUrl = getAuthBaseUrl(authBaseUrl, env);
    var queryResult = useGraphqlQuery(client, UserSession_default, {});
    var logout = (0,react.useCallback)(function() {
        return fetchFn("".concat(resolvedAuthBaseUrl, "/session/sign-out"), {
            method: "GET",
            credentials: "include"
        }).then(function() {
            window.location.reload();
        }).catch(function(e) {
            trackError("logout", e);
            window.location.assign("".concat(resolvedAuthBaseUrl, "/logout"));
        });
    }, [
        fetchFn,
        resolvedAuthBaseUrl,
        trackError
    ]);
    var validateResetPasswordToken = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(resetPasswordToken) {
            var ref, ref1, ref2, ref3, _tmp, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        _tmp = {};
                        return [
                            4,
                            client.query(ValidateResetPasswordToken_default, {
                                resetPasswordToken: resetPasswordToken
                            })
                        ];
                    case 1:
                        return [
                            2,
                            (_tmp.success = !!((ref = _state.sent()) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.webPassword) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.validateResetPasswordToken) === null || ref3 === void 0 ? void 0 : ref3.valid), _tmp)
                        ];
                    case 2:
                        err = _state.sent();
                        return [
                            2,
                            {
                                success: false,
                                displayErrorMessage: "Error Validating Reset Password Token"
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function validateResetPasswordToken(resetPasswordToken) {
            return _ref.apply(this, arguments);
        };
    }();
    var resetPassword = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(token, password) {
            var err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            client.query("mutation resetPassword($resetPasswordToken: String!, $newPassword: String!) {\n  webPassword {\n    resetPassword(input: { resetPasswordToken: $resetPasswordToken, newPassword: $newPassword }) {\n      _empty\n    }\n  }\n}\n", {
                                resetPasswordToken: token,
                                newPassword: password
                            })
                        ];
                    case 1:
                        if (!_state.sent().error) return [
                            2,
                            {
                                success: true
                            }
                        ];
                        return [
                            2,
                            {
                                success: false
                            }
                        ];
                    case 2:
                        err = _state.sent();
                        return [
                            2,
                            {
                                success: false
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function resetPassword(token, password) {
            return _ref.apply(this, arguments);
        };
    }();
    var verifyLogin = (0,react.useCallback)(function(credentials) {
        return callVerifyLogin(resolvedAuthBaseUrl, fetchFn, trackError, credentials);
    }, [
        fetchFn,
        resolvedAuthBaseUrl,
        trackError
    ]);
    var authentication = (0,react.useMemo)(function() {
        return parseAuthentication({
            data: queryResult.data,
            loading: queryResult.loading,
            error: queryResult.error
        }, trackError);
    }, [
        queryResult.loading,
        queryResult.data,
        queryResult.error,
        logout
    ]);
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(auth_fe2_esm/* AuthContext.Provider */.Vo.Provider, {
        value: {
            authentication: authentication,
            logout: logout,
            refresh: queryResult.refresh,
            verifyLogin: verifyLogin,
            validateResetPasswordToken: validateResetPasswordToken,
            resetPassword: resetPassword
        }
    }, children);
};
function callVerifyLogin(authBaseUrl, fetchFn, trackError, credentials) {
    return _callVerifyLogin.apply(this, arguments);
}
function _callVerifyLogin() {
    _callVerifyLogin = (0,_async_to_generator/* default */.Z)(function(authBaseUrl, fetchFn, trackError, credentials) {
        var payload, resp, e, displayErrorMessage, json, e1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if ("googleIdToken" in credentials) payload = {
                        google_id_token: credentials.googleIdToken
                    };
                    else if ("facebookIdToken" in credentials) payload = {
                        facebook_id_token: credentials.facebookIdToken
                    };
                    else payload = {
                        human: {
                            email: credentials.email,
                            password: credentials.password
                        }
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetchFn("".concat(authBaseUrl, "/verify_login"), {
                            method: "POST",
                            credentials: "include",
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(payload)
                        })
                    ];
                case 2:
                    resp = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    trackError("login", e);
                    return [
                        2,
                        {
                            success: false,
                            displayErrorMessage: auth_fe2_esm/* DEFAULT_LOGIN_DISPLAY_ERROR_MESSAGE */.le
                        }
                    ];
                case 4:
                    if (!resp.ok) return [
                        3,
                        5
                    ];
                    return [
                        2,
                        {
                            success: true
                        }
                    ];
                case 5:
                    displayErrorMessage = auth_fe2_esm/* DEFAULT_LOGIN_DISPLAY_ERROR_MESSAGE */.le;
                    _state.label = 6;
                case 6:
                    _state.trys.push([
                        6,
                        8,
                        ,
                        9
                    ]);
                    return [
                        4,
                        resp.json()
                    ];
                case 7:
                    json = _state.sent();
                    if ("error" in json) displayErrorMessage = json["error"];
                    return [
                        3,
                        9
                    ];
                case 8:
                    e1 = _state.sent();
                    trackError("login error without error message", e1);
                    return [
                        3,
                        9
                    ];
                case 9:
                    return [
                        2,
                        {
                            success: false,
                            displayErrorMessage: displayErrorMessage
                        }
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
    return _callVerifyLogin.apply(this, arguments);
}
//#endregion


// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(30465);
;// CONCATENATED MODULE: ./src/components/account/AuthContextProvider.tsx
/* provided dependency */ var AuthContextProvider_process = __webpack_require__(73656);










var FetchGqlError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0,_inherits/* default */.Z)(FetchGqlError, Error1);
    var _super = (0,_create_super/* default */.Z)(FetchGqlError);
    function FetchGqlError(message, errors, networkError) {
        (0,_class_call_check/* default */.Z)(this, FetchGqlError);
        var _this;
        _this = _super.call(this, message);
        _this.graphQLErrors = errors;
        _this.networkError = networkError;
        return _this;
    }
    return FetchGqlError;
}(_wrapNativeSuper(Error));
var getQueryOperationName = function(query) {
    var ref, ref1;
    var ref2;
    return (ref2 = (ref = query.match(RegExp("query\\s+(?<operationName>[^{(\\s]+)"))) === null || ref === void 0 ? void 0 : (ref1 = ref.groups) === null || ref1 === void 0 ? void 0 : ref1.operationName) !== null && ref2 !== void 0 ? ref2 : null;
};
var fetchClient = function(opts) {
    return {
        query: function query(query1, vars) {
            return (0,_async_to_generator/* default */.Z)(function() {
                var body, headers, devUserToken, res, json;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            body = {
                                operationName: getQueryOperationName(query1),
                                query: query1,
                                variables: vars
                            };
                            headers = {
                                "Content-Type": "application/json",
                                Accept: "application/json",
                                "apollographql-client-name": opts.clientName
                            };
                            devUserToken = AuthContextProvider_process.env.NEXT_PUBLIC_ATHENA_DEV_USER_TOKEN;
                            if (globals/* DEPLOY_ENV */.Zp === "development" && devUserToken) {
                                headers["x-athena-request-user"] = devUserToken;
                            }
                            return [
                                4,
                                fetch(opts.apiEndpoint, {
                                    credentials: "include",
                                    method: "POST",
                                    headers: headers,
                                    body: JSON.stringify(body),
                                    mode: "cors"
                                })
                            ];
                        case 1:
                            res = _state.sent();
                            if (!res.ok) {
                                return [
                                    2,
                                    {
                                        error: new FetchGqlError("Failed to fetch", [], {
                                            status: res.status,
                                            statusText: res.statusText
                                        }),
                                        data: undefined
                                    }
                                ];
                            }
                            return [
                                4,
                                res.json()
                            ];
                        case 2:
                            json = _state.sent();
                            if (json.errors) {
                                return [
                                    2,
                                    {
                                        error: new FetchGqlError("Graphql request had errors", json.errors, {}),
                                        data: undefined
                                    }
                                ];
                            }
                            return [
                                2,
                                {
                                    data: json.data,
                                    error: undefined
                                }
                            ];
                    }
                });
            })();
        }
    };
};
var AuthProvider = function(param) {
    var children = param.children;
    var fetchClientMemo = (0,react.useMemo)(function() {
        return fetchClient({
            apiEndpoint: globals/* ATHENA_URL */.Uw,
            clientName: "cosmos"
        });
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AuthContextProvider, {
        authBaseUrl: globals/* COSMOS_URL */.EQ,
        client: fetchClientMemo,
        children: children
    });
};
/* harmony default export */ var account_AuthContextProvider = (AuthProvider);

// EXTERNAL MODULE: ./src/helpers/AddressValidationContext.tsx + 1 modules
var AddressValidationContext = __webpack_require__(58886);
;// CONCATENATED MODULE: ./src/helpers/apptoolboxInjection.ts
var APPTOOLBOX_FE_INJECTION_SCRIPT = "\nif (document.cookie.includes(\"qa_env=\")) {\n  const apptoolboxFeScript = document.createElement('script');\n\n  apptoolboxFeScript.setAttribute(\n    'src',\n    'https://odfil.es/313e5541776ac579b6959a58f1751d74e0e0e26a/static/embedded/embed.latest.js?ts=".concat(Date.now(), "'\n  );\n\n  // used by apptoolbox fe to validate the current app for deploy previews\n  const cosmosSha1Sum = \"094C26F496BD0DD1B77B8BAC6810D55E69BD2B16\";\n  apptoolboxFeScript.setAttribute('appId', cosmosSha1Sum);\n  apptoolboxFeScript.setAttribute('appPathPrefix','/');\n\n  // div to render apptoolbox-fe UI. div defined in _app.tsx\n  // https://github.com/opendoor-labs/code/blob/e3f0a8ec49791c220ae4b46c77001b2b84d6a692/js/packages/cosmos/src/pages/_app.tsx#L130\n  apptoolboxFeScript.setAttribute(\"apptoolboxDivId\", \"x-od-app-toolbox-root\")\n\n  // don’t block rendering thread\n  apptoolboxFeScript.setAttribute('async','');\n\n  // inject script tag into document\n  document.head.appendChild(apptoolboxFeScript);\n}");

;// CONCATENATED MODULE: ./src/polyfills/react-createFactory.ts

if (!react.createFactory) {
    react.createFactory = function(type) {
        return react.createElement.bind(null, type);
    };
}

;// CONCATENATED MODULE: ./src/pages/_app.tsx









// Global styles for the react-day-picker calendar used by the Buy Direct
// Checkout date picker. Next.js 12 (Pages Router) only allows global CSS
// imports from the custom App, so the stylesheet lives here rather than the
// component that consumes it.















if (true) {
    __webpack_require__(26233);
}
// eslint-disable-next-line @opendoor/no-direct-env-check
if (false) {}
var ErrorApp = /*#__PURE__*/ function(App) {
    "use strict";
    (0,_inherits/* default */.Z)(ErrorApp, App);
    var _super = (0,_create_super/* default */.Z)(ErrorApp);
    function ErrorApp() {
        (0,_class_call_check/* default */.Z)(this, ErrorApp);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    var _proto = ErrorApp.prototype;
    _proto.componentDidCatch = function componentDidCatch(error) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var _obj, ref, errorEventId;
            return (0,tslib_es6.__generator)(this, function(_state) {
                errorEventId = (ref = (_obj = observability_slim/* globalObservability.getSentryClient */.w.getSentryClient()).captureException) === null || ref === void 0 ? void 0 : ref.call(_obj, error);
                // Store the event id at this point as we don't have access to it within
                // `getDerivedStateFromError`.
                _this.setState({
                    errorEventId: errorEventId
                });
                return [
                    2
                ];
            });
        })();
    };
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        var // For allowed query parameters, let's add them to our global observability context
        ref;
        var _props = this.props, originPath = _props.originPath, originUrl = _props.originUrl, referer = _props.referer, cosmosPathname = _props.cosmosPathname, proxyPath = _props.proxyPath, proxyQueryMap = _props.proxyQueryMap;
        var globalContext = [
            {
                key: "cosmosPathname",
                value: cosmosPathname
            }, 
        ];
        (ref = Object.keys(this.props.router.query)) === null || ref === void 0 ? void 0 : ref.forEach(function(key) {
            var queryKey = toCamelCase(key);
            var value = _this.props.router.query[key];
            if (helpers_observability/* OBSERVABILITY_QUERY_PARAM_KEYS.includes */.FL.includes(queryKey) && value !== undefined) {
                globalContext.push({
                    key: queryKey,
                    value: "".concat(value)
                });
            }
        });
        // Always initialize observability so child components calling trackJourneyEvent/trackError
        // don't throw. Skipping initObservability causes a crash loop in staging where
        // componentDidCatch -> trackError -> throw -> componentDidCatch -> infinite loop.
        (0,helpers_observability/* initObservability */.lT)({
            globalContext: globalContext,
            isBot: this.props.isBot
        });
        // Skip analytics tracking for bot traffic — bots don't need page views or journey events
        if (!this.props.isBot) {
            // TODO: [GROWEPD-806] Remove — redundant with CF Worker Journey pageViewEvent
            observability_slim/* analytics.trackPageView */.co.trackPageView({
                originPath: originPath,
                originUrl: originUrl,
                referer: referer,
                resource: "cosmos"
            });
            observability_slim/* globalObservability.trackJourneyEvent */.w.trackJourneyEvent("platform", "pageViewEvent", {}, {
                websiteSourceContext: {
                    referrer: referer,
                    proxyPath: proxyPath,
                    proxyQueryMap: proxyQueryMap
                }
            });
        }
    };
    _proto.render = function render() {
        // Necessary for accessibility. ReactModal uses this to hide (via aria-hidden) the rest of the
        // app while the modal is active.
        // https://reactcommunity.org/react-modal/accessibility/#app-element
        lib_default().setAppElement("#__next");
        // right now, we're not doing anything with the error. We might want to redirect
        // to /error in the future (or reload the page).
        var _props = this.props, Component = _props.Component, pageProps = _props.pageProps, originPath = _props.originPath, originUrl = _props.originUrl, referer = _props.referer, err = _props.err;
        var _getLayout;
        // Support per-page layouts via getLayout pattern
        var getLayout = (_getLayout = Component.getLayout) !== null && _getLayout !== void 0 ? _getLayout : function(page) {
            return page;
        };
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(observability_slim/* AddContextualData */.up, {
            data: {
                originPath: originPath,
                originUrl: originUrl,
                referer: referer
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("style", {
                            children: 'img[width="1"][height="1"] { display: none; }'
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                            name: "description",
                            content: "Opendoor is the new way to sell your home. Skip the hassle of listing, showings and months of stress, and close on your own timeline. Get a free offer today!"
                        }, "description"),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                            property: "og:url",
                            content: "https://opendoor.com"
                        }, "og:url"),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                            property: "og:type",
                            content: "website"
                        }, "og:type"),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                            property: "og:title",
                            content: "Opendoor | Sell your home the minute you’re ready."
                        }, "og:title"),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                            property: "og:description",
                            content: "Opendoor is the new way to sell your home. Skip the hassle of listing, showings and months of stress, and close on your own timeline. Get a free offer today!"
                        }, "og:description"),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                            property: "og:image",
                            content: "https://images.opendoor.com/source/s3/imgdrop-production/2024-06-1719377665829-19976.jpg?preset=square-1024&service=cosmos&dpr=2"
                        }, "og:image"),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                            name: "twitter:card",
                            content: "summary_large_image"
                        }, "twitter:card"),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                            property: "twitter:domain",
                            content: "opendoor.com"
                        }, "twitter:domain"),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                            property: "twitter:url",
                            content: "https://opendoor.com"
                        }, "twitter:url"),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                            name: "twitter:title",
                            content: "Opendoor | Sell your home the minute you’re ready."
                        }, "twitter:title"),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                            name: "twitter:description",
                            content: "Opendoor is the new way to sell your home. Skip the hassle of listing, showings and months of stress, and close on your own timeline. Get a free offer today!"
                        }, "twitter:description"),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                            name: "twitter:image",
                            content: "https://images.opendoor.com/source/s3/imgdrop-production/4c68636ad1df40d08a114638883c30d0.png?preset=square-2048"
                        }, "twitter:image")
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
                    strategy: "afterInteractive",
                    dangerouslySetInnerHTML: {
                        __html: APPTOOLBOX_FE_INJECTION_SCRIPT
                    }
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OneTrustScripts, {}),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    id: "x-od-app-toolbox-root"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components_ErrorBoundary, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavListener, {}),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(account_AuthContextProvider, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BricksProvider/* BricksProvider */.C6, {
                                useObservability: helpers_observability/* useObservability */.C3,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddressValidationContext/* AddressValidationContextProvider */.Pj, {
                                    children: getLayout(/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
                                        err: err
                                    })))
                                })
                            })
                        })
                    ]
                })
            ]
        });
    };
    ErrorApp.getInitialProps = function getInitialProps(param) {
        var Component = param.Component, ctx = param.ctx;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, ref3, ref4, ref5, isBot, ref6, originUrl, originPath, ref7, referer, ref8, proxyPath, proxyQueryMap, pageProps, error, captureException, errorEventId;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isBot = ((ref = ctx.req) === null || ref === void 0 ? void 0 : ref.headers["x-od-is-bot"]) === "true";
                        originUrl = (ref6 = (ref1 = ctx.req) === null || ref1 === void 0 ? void 0 : ref1.headers["x-od-forwarded-url"]) !== null && ref6 !== void 0 ? ref6 : "";
                        try {
                            originPath = new URL(originUrl).pathname;
                        } catch (e) {
                            originPath = "";
                        }
                        referer = (ref7 = (ref2 = ctx.req) === null || ref2 === void 0 ? void 0 : ref2.headers["referer"]) !== null && ref7 !== void 0 ? ref7 : undefined;
                        proxyPath = (ref8 = (ref3 = ctx.req) === null || ref3 === void 0 ? void 0 : ref3.headers["Proxy-Path"]) !== null && ref8 !== void 0 ? ref8 : undefined;
                        proxyQueryMap = ((ref4 = ctx.req) === null || ref4 === void 0 ? void 0 : ref4.headers["proxy-query-map"]) ? Object.fromEntries(Object.entries(JSON.parse((ref5 = ctx.req) === null || ref5 === void 0 ? void 0 : ref5.headers["proxy-query-map"])).map(function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                            return [
                                key,
                                String(value)
                            ];
                        })) : {};
                        pageProps = {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            6
                        ]);
                        if (!Component.getInitialProps) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            Component.getInitialProps(ctx)
                        ];
                    case 2:
                        pageProps = _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2,
                            {
                                pageProps: pageProps,
                                isBot: isBot,
                                originPath: originPath,
                                originUrl: originUrl,
                                referer: referer,
                                cosmosPathname: ctx.pathname,
                                proxyPath: proxyPath,
                                proxyQueryMap: proxyQueryMap
                            }
                        ];
                    case 4:
                        error = _state.sent();
                        return [
                            4,
                            Promise.all(/* import() */[__webpack_require__.e(3202), __webpack_require__.e(9115), __webpack_require__.e(799)]).then(__webpack_require__.bind(__webpack_require__, 30799))
                        ];
                    case 5:
                        captureException = _state.sent().captureException;
                        errorEventId = captureException(error);
                        return [
                            2,
                            {
                                hasError: true,
                                errorEventId: errorEventId,
                                pageProps: pageProps,
                                isBot: isBot,
                                originUrl: originUrl,
                                originPath: originPath,
                                referer: referer,
                                cosmosPathname: ctx.pathname,
                                proxyPath: proxyPath,
                                proxyQueryMap: proxyQueryMap
                            }
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    ErrorApp.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        // If there was an error generated within getInitialProps, and we haven't
        // yet seen an error, we add it to this.state here
        return {
            hasError: props.hasError || state.hasError || false,
            errorEventId: props.errorEventId || state.errorEventId || undefined
        };
    };
    ErrorApp.getDerivedStateFromError = function getDerivedStateFromError() {
        // React Error Boundary here allows us to set state flagging the error (and
        // later render a fallback UI).
        return {
            hasError: true
        };
    };
    return ErrorApp;
}(app["default"]);

function toCamelCase(str) {
    return str.replace(/_([a-z])/g, function(_, letter) {
        return letter.toUpperCase();
    });
}


/***/ }),

/***/ 6677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R$": function() { return /* binding */ useAuthAuthenticated; },
/* harmony export */   "Vo": function() { return /* binding */ AuthContext; },
/* harmony export */   "aC": function() { return /* binding */ useAuth; },
/* harmony export */   "le": function() { return /* binding */ DEFAULT_LOGIN_DISPLAY_ERROR_MESSAGE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60947);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92336);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);






//#region src/AuthContext.ts
var DEFAULT_LOGIN_DISPLAY_ERROR_MESSAGE = "Sorry, something went wrong.";
var AuthContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    authentication: {
        state: "not_authenticated",
        user: null
    },
    logout: function() {},
    refresh: function() {},
    verifyLogin: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            return [
                2,
                {
                    success: false,
                    displayErrorMessage: DEFAULT_LOGIN_DISPLAY_ERROR_MESSAGE
                }
            ];
        });
    }),
    validateResetPasswordToken: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            return [
                2,
                {
                    success: true
                }
            ];
        });
    }),
    resetPassword: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            return [
                2,
                {
                    success: true
                }
            ];
        });
    })
});
/** Gets AuthenticationState. */ function useAuth() {
    var authContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AuthContext);
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, authContext), {
        user: authContext.authentication.user
    });
}
/**
* Gets AuthenticationState, but only if used in an authenticated context.
*
* This hook will guarantee that a user exists, but throws an error if not in an authenticated context.
*
* ```typescript
* const Hello = () => {
*   const { authentication } = useAuth();
*   if (authentication.state === 'authenticated') {
*     return <HelloAuthenticated />;
*   } else {
*     return <HelloMaybeAuthenticated />;
*   }
* };
*
* const HelloAuthenticated = () => {
*   // GOOD. This will get the user and we don't have to check for null/undefined.
*   const { user } = useAuthAuthenticated();
*   return `Hello, ${user.name}`;
* };
*
* const HelloMaybeAuthenticated = () => {
*   // BAD. This will crash.
*   const { user } = useAuthAuthenticated();
*
*   // GOOD. This will get the user but we must check for null/undefined before using it.
*   const { user } = useAuth();
*   if (user) {
*     return `Hello, ${user.name}`;
*   } else {
*     return 'Hello, stranger';
*   }
* };
* ```
* @throws an error if not in an authenticated context
*/ function useAuthAuthenticated() {
    var ref = useAuth(), authentication = ref.authentication, logout = ref.logout, refresh = ref.refresh, verifyLogin = ref.verifyLogin, validateResetPasswordToken = ref.validateResetPasswordToken, resetPassword = ref.resetPassword;
    if (authentication.state === "authenticated") return {
        authentication: authentication,
        user: authentication.user,
        logout: logout,
        refresh: refresh,
        verifyLogin: verifyLogin,
        validateResetPasswordToken: validateResetPasswordToken,
        resetPassword: resetPassword
    };
    else throw new Error("DEVELOPER ERROR: useAuthAuthenticated must be used in an authenticated context");
}
//#endregion



/***/ }),

/***/ 15806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C6": function() { return /* binding */ BricksProvider; },
/* harmony export */   "Os": function() { return /* binding */ useAnalyticsContext; }
/* harmony export */ });
/* unused harmony exports AnalyticsContext, defaultAnalyticsContext */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59106);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64978);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _tamagui_portal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67483);
/* harmony import */ var _tamagui_toast__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63081);
/* harmony import */ var _tamagui_toast__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(76738);
/* harmony import */ var _tamagui_config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63739);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31549);









var defaultAnalyticsContext = {
    useObservability: function() {
        return {
            trackJourneyEvent: function(_categoryName, _eventName, _eventData, _contextualData) {}
        };
    }
}, AnalyticsContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(defaultAnalyticsContext), useAnalyticsContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(AnalyticsContext);
};
function BricksProvider(_param) {
    var children = _param.children, useObservability = _param.useObservability, toastViewportProps = _param.toastViewportProps, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "useObservability",
        "toastViewportProps"
    ]);
    return useObservability = useObservability !== null && useObservability !== void 0 ? useObservability : defaultAnalyticsContext.useObservability, /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(AnalyticsContext.Provider, {
        value: {
            useObservability: useObservability
        },
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.TamaguiProvider, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            config: _tamagui_config__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
            defaultTheme: "light"
        }, rest), {
            children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_tamagui_portal__WEBPACK_IMPORTED_MODULE_1__/* .PortalProvider */ .Xp, {
                children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_tamagui_toast__WEBPACK_IMPORTED_MODULE_8__/* .ToastProvider */ .VW, {
                    children: [
                        children,
                        /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_tamagui_toast__WEBPACK_IMPORTED_MODULE_9__/* .ToastViewport */ ._i, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                            flexDirection: "column",
                            top: 0,
                            left: 0,
                            right: 0
                        }, toastViewportProps))
                    ]
                })
            })
        }))
    });
}



/***/ }),

/***/ 63739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tamagui_config_default; }
});

// UNUSED EXPORTS: bricksConfig

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@opendoor+tokens-studio@16.2.0/node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Novo.js
var Novo = __webpack_require__(22305);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+core@1.110.0_react@18.3.1/node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(64978);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+constants@1.110.0_react@18.3.1/node_modules/@tamagui/constants/dist/esm/index.mjs + 1 modules
var esm = __webpack_require__(21153);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+web@1.110.0_react@18.3.1/node_modules/@tamagui/web/dist/cjs/index.js
var dist_cjs = __webpack_require__(77330);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+use-presence@1.110.0_react@18.3.1/node_modules/@tamagui/use-presence/dist/esm/index.mjs + 2 modules
var dist_esm = __webpack_require__(62080);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tamagui+animations-css@1.110.0_react@18.3.1/node_modules/@tamagui/animations-css/dist/esm/createAnimations.mjs




function createAnimations(animations) {
  const reactionListeners = /* @__PURE__ */new WeakMap();
  return {
    animations,
    usePresence: dist_esm/* usePresence */.oO,
    ResetPresence: dist_esm/* ResetPresence */.il,
    supportsCSSVars: !0,
    useAnimatedNumber(initial) {
      const [val, setVal] = react.useState(initial);
      return {
        getInstance() {
          return setVal;
        },
        getValue() {
          return val;
        },
        setValue(next, config, onFinish) {
          setVal(next);
          const listeners = reactionListeners.get(setVal);
          listeners && listeners.forEach(cb => cb(next)), onFinish?.();
        },
        stop() {}
      };
    },
    useAnimatedNumberReaction({
      value
    }, onValue) {
      react.useEffect(() => {
        const instance = value.getInstance();
        let queue = reactionListeners.get(instance);
        if (!queue) {
          const next = /* @__PURE__ */new Set();
          reactionListeners.set(instance, next), queue = next;
        }
        return queue.add(onValue), () => {
          queue?.delete(onValue);
        };
      }, []);
    },
    useAnimatedNumberStyle(val, getStyle) {
      return getStyle(val.getValue());
    },
    useAnimations: ({
      props,
      presence,
      style,
      componentState,
      stateRef
    }) => {
      const isEntering = !!componentState.unmounted,
        isExiting = presence?.[0] === !1,
        sendExitComplete = presence?.[1],
        [animationKey, animationConfig] = Array.isArray(props.animation) ? props.animation : [props.animation],
        animation = animations[animationKey],
        keys = props.animateOnly ?? ["all"];
      return (0,esm/* useIsomorphicLayoutEffect */.LI)(() => {
        const host = stateRef.current.host;
        if (!sendExitComplete || !isExiting || !host) return;
        const node = host,
          onFinishAnimation = () => {
            sendExitComplete?.();
          };
        return node.addEventListener("transitionend", onFinishAnimation), node.addEventListener("transitioncancel", onFinishAnimation), () => {
          node.removeEventListener("transitionend", onFinishAnimation), node.removeEventListener("transitioncancel", onFinishAnimation);
        };
      }, [sendExitComplete, isExiting]), animation && (Array.isArray(style.transform) && (style.transform = (0,dist_cjs.transformsToString)(style.transform)), style.transition = keys.map(key => {
        const override = animations[animationConfig?.[key]] ?? animation;
        return `${key} ${override}`;
      }).join(", ")),  false && 0, animation ? {
        style,
        className: isEntering ? "t_unmounted" : ""
      } : null;
    }
  };
}

//# sourceMappingURL=createAnimations.mjs.map

;// CONCATENATED MODULE: ../bricks-next/dist/jsx/animations.js


var animationMap = {
    accelerateDecelerateFastest: Novo/* Novo.animation.timing.accelerateDecelerateFastest.web */.N.animation.timing.accelerateDecelerateFastest.web,
    accelerateDecelerateFast: Novo/* Novo.animation.timing.accelerateDecelerateFast.web */.N.animation.timing.accelerateDecelerateFast.web,
    accelerateDecelerateSlow: Novo/* Novo.animation.timing.accelerateDecelerateSlow.web */.N.animation.timing.accelerateDecelerateSlow.web,
    decelerateFastest: Novo/* Novo.animation.timing.decelerateFastest.web */.N.animation.timing.decelerateFastest.web,
    decelerateFast: Novo/* Novo.animation.timing.decelerateFast.web */.N.animation.timing.decelerateFast.web,
    accelerateFast: Novo/* Novo.animation.timing.accelerateFast.web */.N.animation.timing.accelerateFast.web,
    accelerateSlow: Novo/* Novo.animation.timing.accelerateSlow.web */.N.animation.timing.accelerateSlow.web,
    responsiveAccelerate: Novo/* Novo.animation.timing.responsiveAccelerate.web */.N.animation.timing.responsiveAccelerate.web,
    linear: Novo/* Novo.animation.timing.linear.web */.N.animation.timing.linear.web,
    contentfulArchAnimation: Novo/* Novo.animation.timing.contentfulArchAnimation.web */.N.animation.timing.contentfulArchAnimation.web
}, animations = createAnimations(animationMap);


;// CONCATENATED MODULE: ../bricks-next/dist/jsx/createTokens.js

var createTokens = function(tokens) {
    return createVariables(tokens);
}, cache = /* @__PURE__ */ new WeakMap(), createVariables = function(tokens) {
    var parentPath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    if (cache.has(tokens)) return tokens;
    var res = {};
    for(var keyIn in tokens){
        var val = tokens[keyIn], isPrefixed = keyIn[0] === "$", keyWithPrefix = isPrefixed ? keyIn : "$".concat(keyIn), key = isPrefixed ? keyWithPrefix.slice(1) : keyIn;
        if ((0,cjs.isVariable)(val)) {
            res[key] = val;
            continue;
        }
        if (val && typeof val == "object") {
            res[key] = createVariables(tokens[key], keyIn);
            continue;
        }
        var cssKey = /^\d+$/.test(keyIn) ? "bn-".concat(keyIn) : keyIn, name = "".concat(parentPath, "-").concat(cssKey), finalValue = (0,cjs.isVariable)(val) ? val : (0,cjs.createVariable)({
            val: val,
            name: name,
            key: keyWithPrefix
        });
        res[key] = finalValue;
    }
    return cache.set(res, !0), res;
};


;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tamagui+react-native-media-driver@1.110.0_react-native@0.74.5_@babel+core@7.29.0_@babe_341851a256e7ca39b4c31b335a3e72b4/node_modules/@tamagui/react-native-media-driver/dist/esm/matchMedia.mjs
const matchMedia = globalThis.matchMedia;

//# sourceMappingURL=matchMedia.mjs.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tamagui+react-native-media-driver@1.110.0_react-native@0.74.5_@babel+core@7.29.0_@babe_341851a256e7ca39b4c31b335a3e72b4/node_modules/@tamagui/react-native-media-driver/dist/esm/createMedia.mjs


function createMedia(media) {
  return (0,dist_cjs.setupMatchMedia)(matchMedia), media;
}

//# sourceMappingURL=createMedia.mjs.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tamagui+react-native-media-driver@1.110.0_react-native@0.74.5_@babel+core@7.29.0_@babe_341851a256e7ca39b4c31b335a3e72b4/node_modules/@tamagui/react-native-media-driver/dist/esm/index.mjs


//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ../bricks-next/dist/jsx/media.js

var BREAKPOINTS = {
    SM: 375,
    MD: 768,
    LG: 1201,
    XL: 1400
}, media = createMedia({
    smallerThanXL: {
        maxWidth: BREAKPOINTS.XL - 1
    },
    smallerThanLG: {
        maxWidth: BREAKPOINTS.LG - 1
    },
    smallerThanMD: {
        maxWidth: BREAKPOINTS.MD - 1
    },
    smallerThanSM: {
        maxWidth: BREAKPOINTS.SM - 1
    },
    largerThanXS: {
        minWidth: BREAKPOINTS.SM
    },
    largerThanSM: {
        minWidth: BREAKPOINTS.MD
    },
    largerThanMD: {
        minWidth: BREAKPOINTS.LG
    },
    largerThanLG: {
        minWidth: BREAKPOINTS.XL
    },
    // use to target devices that do not support hover
    hoverNone: {
        hover: "none"
    }
});


;// CONCATENATED MODULE: ../bricks-next/dist/jsx/tamagui.config.js







var bricksNextTokens = createTokens({
    color: (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Novo/* Novo.color */.N.color), {
        transparent: "transparent"
    }), Novo/* Novo.shadow.shadowColor */.N.shadow.shadowColor),
    space: (0,_object_spread/* default */.Z)({}, Novo/* Novo.space */.N.space, Novo/* Novo.sp */.N.sp, Novo/* Novo.borderWidth */.N.borderWidth),
    radius: (0,_object_spread/* default */.Z)({}, Novo/* Novo.radius */.N.radius, Novo/* Novo.rad */.N.rad),
    opacity: Novo/* Novo.opacity */.N.opacity,
    state: Novo/* Novo.state */.N.state,
    size: (0,_object_spread/* default */.Z)({}, Novo/* Novo.size */.N.size, Novo/* Novo.sz */.N.sz),
    zIndex: {},
    text: Novo/* Novo.text */.N.text,
    // shadow tokens
    elevation: Novo/* Novo.shadow.elevation */.N.shadow.elevation,
    shadowOffsetWidth: Novo/* Novo.shadow.shadowOffsetWidth */.N.shadow.shadowOffsetWidth,
    shadowOffsetHeight: Novo/* Novo.shadow.shadowOffsetHeight */.N.shadow.shadowOffsetHeight,
    shadowOpacity: Novo/* Novo.shadow.shadowOpacity */.N.shadow.shadowOpacity,
    shadowRadius: Novo/* Novo.shadow.shadowRadius */.N.shadow.shadowRadius,
    percentages: Novo/* Novo.percentage */.N.percentage,
    backgroundBlur: Novo/* Novo.backgroundBlur */.N.backgroundBlur
}), graphik = (0,cjs.createFont)({
    // Have to add "true" for default font size, etc., because it's used by tamagui components like Dialog
    size: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Novo/* Novo.typography.size */.N.typography.size), {
        true: Novo/* Novo.typography.size.bodyMedium */.N.typography.size.bodyMedium
    }),
    lineHeight: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Novo/* Novo.typography.lineHeight */.N.typography.lineHeight), {
        true: Novo/* Novo.typography.lineHeight.bodyMedium */.N.typography.lineHeight.bodyMedium
    }),
    letterSpacing: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Novo/* Novo.typography.letterSpacing */.N.typography.letterSpacing), {
        true: Novo/* Novo.typography.letterSpacing.bodyMedium */.N.typography.letterSpacing.bodyMedium
    }),
    weight: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Novo/* Novo.typography.weight */.N.typography.weight, Novo/* Novo.fontWeight */.N.fontWeight), {
        true: Novo/* Novo.typography.weight.bodyMedium */.N.typography.weight.bodyMedium
    }),
    // TODO: Tokenize fallback font families
    family: "".concat(Novo/* Novo.typography.family */.N.typography.family, ", system-ui, sans-serif"),
    // "face" is required for React Native to pick up different font weights. Can also add "italic" font names here later if needed
    // See: https://tamagui.dev/docs/core/configuration#font-tokens
    face: {
        400: {
            normal: "Graphik-Regular"
        },
        500: {
            normal: "Graphik-Medium"
        },
        600: {
            normal: "Graphik-Semibold"
        },
        800: {
            normal: "Graphik-Bold"
        }
    }
}), bricksConfig = (0,cjs.createTamagui)({
    tokens: bricksNextTokens,
    fonts: {
        // Have to have at least one font called "body" to get some of Tamagui's types to work properly (FontSizeTokens, FontWeightTokens, etc.)
        body: graphik
    },
    // Not using themes yet, but we can add them later. See: https://tamagui.dev/docs/intro/themes
    themes: {
        light: {}
    },
    // Defines breakpoints and other media queries. See: https://tamagui.dev/docs/core/use-media
    media: media,
    // See: https://tamagui.dev/docs/core/configuration#animations
    animations: animations,
    // Only including shorthands for margin and padding for now. We may want to add more later.
    // Compare with tamagui's shorthands: https://github.com/tamagui/tamagui/blob/master/packages/shorthands/src/index.tsx
    shorthands: {
        m: "margin",
        mb: "marginBottom",
        ml: "marginLeft",
        mr: "marginRight",
        mt: "marginTop",
        mx: "marginHorizontal",
        my: "marginVertical",
        p: "padding",
        pb: "paddingBottom",
        pl: "paddingLeft",
        pr: "paddingRight",
        pt: "paddingTop",
        px: "paddingHorizontal",
        py: "paddingVertical"
    },
    // Setting to false because we don't support dark mode yet
    shouldAddPrefersColorThemes: !1,
    settings: {
        // Restricts what types are allowed for style prop values. Ideally these would all
        // be "strict". See: https://tamagui.dev/docs/core/configuration#settings
        allowedStyleValues: {
            // Allow tokens, %, numbers, and css values like auto/inherit
            space: "somewhat-strict-web",
            // Allow tokens, %, numbers, and css values like auto/inherit
            size: "somewhat-strict-web",
            // Only allow tokens
            radius: "strict",
            // Allow tokens and numbers
            zIndex: "somewhat-strict",
            // Only allow tokens
            color: "strict"
        },
        // Don't autocomplete tokens like "$color.name" (just include "$name") for
        // space, size, radius, zIndex, color (prefixed tokens for custom categories
        // still included).  See: https://tamagui.dev/docs/core/configuration#settings
        autocompleteSpecificTokens: "except-special"
    }
});
var tamagui_config_default = bricksConfig;



/***/ }),

/***/ 95046:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 26233:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 20315:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(47337)


/***/ }),

/***/ 62281:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(22404)


/***/ }),

/***/ 52559:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(39691)


/***/ }),

/***/ 73656:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 31772:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(25148);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 7862:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(31772)();
}


/***/ }),

/***/ 25148:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 4507:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 99415:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(4507);
} else {}


/***/ }),

/***/ 93534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "polyfill": function() { return /* binding */ polyfill; }
/* harmony export */ });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),

/***/ 52500:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(44194);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(56321);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(7862);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(9506);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(84862);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(48418);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(93534);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;

var createHTMLElement = function createHTMLElement(name) {
  return document.createElement(name);
};

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = createHTMLElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = createHTMLElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement(
      "div",
      props,
      contentEl
    );
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement(
      "div",
      props,
      children
    );
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

if (false) {}

exports["default"] = Modal;

/***/ }),

/***/ 9506:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(44194);

var _propTypes = __webpack_require__(7862);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(15947);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(37817);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(84862);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(9528);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(48418);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _portalOpenInstances = __webpack_require__(37996);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

__webpack_require__(61318);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

/**
 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
 * `react-modal` only supports React >18 (which dropped IE support).
 */
var isTabKey = function isTabKey(event) {
  return event.code === "Tab" || event.keyCode === 9;
};
var isEscKey = function isEscKey(event) {
  return event.code === "Escape" || event.keyCode === 27;
};

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName,
          parentSelector = _this$props.parentSelector;


      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

      // Remove classes.
      bodyOpenClassName && classList.remove(parentDocument.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus(_this.props.preventScroll);
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.openAnimationFrame = requestAnimationFrame(function () {
            _this.setState({ afterOpen: true });

            if (_this.props.isOpen && _this.props.onAfterOpen) {
              _this.props.onAfterOpen({
                overlayEl: _this.overlay,
                contentEl: _this.content
              });
            }
          });
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (isTabKey(event)) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && isEscKey(event)) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {}

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
      cancelAnimationFrame(this.openAnimationFrame);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName,
          parentSelector = _props.parentSelector;


      var parentDocument = parentSelector && parentSelector().ownerDocument || document;

      // Add classes.
      bodyOpenClassName && classList.add(parentDocument.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles,
          children = _props2.children;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      if (this.shouldBeClosed()) {
        return null;
      }

      var overlayProps = {
        ref: this.setOverlayRef,
        className: this.buildClassName("overlay", overlayClassName),
        style: _extends({}, overlayStyles, this.props.style.overlay),
        onClick: this.handleOverlayOnClick,
        onMouseDown: this.handleOverlayOnMouseDown
      };

      var contentProps = _extends({
        id: id,
        ref: this.setContentRef,
        style: _extends({}, contentStyles, this.props.style.content),
        className: this.buildClassName("content", className),
        tabIndex: "-1",
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleContentOnMouseDown,
        onMouseUp: this.handleContentOnMouseUp,
        onClick: this.handleContentOnClick,
        role: this.props.role,
        "aria-label": this.props.contentLabel
      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
        "data-testid": this.props.testId
      });

      var contentElement = this.props.contentElement(contentProps, children);
      return this.props.overlayElement(overlayProps, contentElement);
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  parentSelector: _propTypes2.default.func,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports["default"] = ModalPortal;
module.exports = exports["default"];

/***/ }),

/***/ 84862:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;

var _warning = __webpack_require__(62118);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(48418);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  if (globalElement) {
    if (globalElement.removeAttribute) {
      globalElement.removeAttribute("aria-hidden");
    } else if (globalElement.length != null) {
      globalElement.forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    } else {
      document.querySelectorAll(globalElement).forEach(function (element) {
        return element.removeAttribute("aria-hidden");
      });
    }
  }
  globalElement = null;
}

/* istanbul ignore next */
function log() {
  if (false) { var check; }
}
/* eslint-enable no-console */

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  var el = appElement || globalElement;
  if (el) {
    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
  } else {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return [];
  }
}

function hide(appElement) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;

      el.setAttribute("aria-hidden", "true");
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

function show(appElement) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var el = _step2.value;

      el.removeAttribute("aria-hidden");
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

/***/ }),

/***/ 61318:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;

var _portalOpenInstances = __webpack_require__(37996);

var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  var _arr = [before, after];

  for (var _i = 0; _i < _arr.length; _i++) {
    var item = _arr[_i];
    if (!item) continue;
    item.parentNode && item.parentNode.removeChild(item);
  }
  before = after = null;
  instances = [];
}

/* istanbul ignore next */
function log() {
  console.log("bodyTrap ----------");
  console.log(instances.length);
  var _arr2 = [before, after];
  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var item = _arr2[_i2];
    var check = item || {};
    console.log(check.nodeName, check.className, check.id);
  }
  console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */

function focusContent() {
  if (instances.length === 0) {
    if (false) {}
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before && !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ }),

/***/ 9528:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
var htmlClassList = {};
var docBodyClassList = {};

/* eslint-disable no-console */
/* istanbul ignore next */
function removeClass(at, cls) {
  at.classList.remove(cls);
}

/* istanbul ignore next */
function resetState() {
  var htmlElement = document.getElementsByTagName("html")[0];
  for (var cls in htmlClassList) {
    removeClass(htmlElement, htmlClassList[cls]);
  }

  var body = document.body;
  for (var _cls in docBodyClassList) {
    removeClass(body, docBodyClassList[_cls]);
  }

  htmlClassList = {};
  docBodyClassList = {};
}

/* istanbul ignore next */
function log() {
  if (false) { var _x, x, buffer, classes; }
}
/* eslint-enable no-console */

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),

/***/ 15947:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.resetState = resetState;
exports.log = log;
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(54036);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

/* eslint-disable no-console */
/* istanbul ignore next */
function resetState() {
  focusLaterElements = [];
}

/* istanbul ignore next */
function log() {
  if (false) {}
}
/* eslint-enable no-console */

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll: preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),

/***/ 37996:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.log = log;
exports.resetState = resetState;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (false) {}
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (false) {}
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

/* eslint-disable no-console */
/* istanbul ignore next */
function log() {
  console.log("portalOpenInstances ----------");
  console.log(portalOpenInstances.openInstances.length);
  portalOpenInstances.openInstances.forEach(function (p) {
    return console.log(p);
  });
  console.log("end portalOpenInstances ----------");
}

/* istanbul ignore next */
function resetState() {
  portalOpenInstances = new PortalOpenInstances();
}
/* eslint-enable no-console */

exports["default"] = portalOpenInstances;

/***/ }),

/***/ 48418:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.canUseDOM = exports.SafeNodeList = exports.SafeHTMLCollection = undefined;

var _exenv = __webpack_require__(51979);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var SafeHTMLCollection = exports.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};

var SafeNodeList = exports.SafeNodeList = EE.canUseDOM ? window.NodeList : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports["default"] = SafeHTMLElement;

/***/ }),

/***/ 37817:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = scopeTab;

var _tabbable = __webpack_require__(54036);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getActiveElement() {
  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];
  var activeElement = getActiveElement();

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === activeElement && !shiftKey) {
    target = head;
  }

  if (head === activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];

/***/ }),

/***/ 54036:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var DISPLAY_NONE = "none";
var DISPLAY_CONTENTS = "contents";

var tabbableNode = /input|select|textarea|button|object|iframe/;

function isNotOverflowing(element, style) {
  return style.getPropertyValue("overflow") !== "visible" ||
  // if 'overflow: visible' set, check if there is actually any overflow
  element.scrollWidth <= 0 && element.scrollHeight <= 0;
}

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  try {
    // Otherwise we need to check some styles
    var style = window.getComputedStyle(element);
    var displayValue = style.getPropertyValue("display");
    return zeroSize ? displayValue !== DISPLAY_CONTENTS && isNotOverflowing(element, style) : displayValue === DISPLAY_NONE;
  } catch (exception) {
    // eslint-disable-next-line no-console
    console.warn("Failed to inspect element style");
    return false;
  }
}

function visible(element) {
  var parentElement = element;
  var rootNode = element.getRootNode && element.getRootNode();
  while (parentElement) {
    if (parentElement === document.body) break;

    // if we are not hidden yet, skip to checking outside the Web Component
    if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;

    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function (finished, el) {
    return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
  }, []);
  return descendants.filter(tabbable);
}
module.exports = exports["default"];

/***/ }),

/***/ 24940:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _Modal = __webpack_require__(52500);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = _Modal2.default;
module.exports = exports["default"];

/***/ }),

/***/ 81561:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var Platform = {
  OS: 'web',
  select: obj => 'web' in obj ? obj.web : obj.default,
  get isTesting() {
    if (false) {}
    return false;
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (Platform);

/***/ }),

/***/ 62118:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),

/***/ 98536:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 26982:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}


/***/ }),

/***/ 60947:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 4656:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 77162:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _createSuper; }
});

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(8216);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_assert_this_initialized.mjs
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(94167);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && ((0,_type_of/* default */.Z)(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0,_get_prototype_of/* default */.Z)(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0,_get_prototype_of/* default */.Z)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

/***/ }),

/***/ 37705:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 8216:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}

/***/ }),

/***/ 13459:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _set_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5398);


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) (0,_set_prototype_of_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}


/***/ }),

/***/ 4713:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 1369:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 36690:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37705);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 93089:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 59106:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 5398:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}


/***/ }),

/***/ 99758:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _slicedToArray; }
/* harmony export */ });
/* harmony import */ var _array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26982);
/* harmony import */ var _iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4713);
/* harmony import */ var _non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1369);
/* harmony import */ var _unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7910);





function _slicedToArray(arr, i) {
  return (0,_array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr, i) || (0,_unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr, i) || (0,_non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ }),

/***/ 15771:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ }),

/***/ 48417:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(98536);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(4713);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(7910);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 94167:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};


/***/ }),

/***/ 7910:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98536);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 67182:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ AnimatePresence; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tamagui+use-force-update@1.110.0_react@18.3.1/node_modules/@tamagui/use-force-update/dist/esm/index.mjs

const isServerSide = typeof window > "u",
  idFn = () => {};
function useForceUpdate() {
  return isServerSide ? idFn : react.useReducer(x => Math.random(), 0)[1];
}

//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tamagui+animate-presence@1.110.0_react@18.3.1/node_modules/@tamagui/animate-presence/dist/esm/LayoutGroupContext.mjs

const LayoutGroupContext = react.createContext({});

//# sourceMappingURL=LayoutGroupContext.mjs.map

// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+use-constant@1.110.0_react@18.3.1/node_modules/@tamagui/use-constant/dist/esm/index.mjs
var esm = __webpack_require__(48761);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+use-presence@1.110.0_react@18.3.1/node_modules/@tamagui/use-presence/dist/esm/index.mjs + 2 modules
var dist_esm = __webpack_require__(62080);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(31549);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tamagui+animate-presence@1.110.0_react@18.3.1/node_modules/@tamagui/animate-presence/dist/esm/PresenceChild.mjs





const PresenceChild = react.memo(({
  children,
  initial,
  isPresent,
  onExitComplete,
  exitVariant,
  enterVariant,
  enterExitVariant,
  presenceAffectsLayout,
  custom
}) => {
  const presenceChildren = (0,esm/* useConstant */.h)(newChildrenMap),
    id = (0,react.useId)() || "",
    context = react.useMemo(() => ({
      id,
      initial,
      isPresent,
      custom,
      exitVariant,
      enterVariant,
      enterExitVariant,
      onExitComplete: () => {
        presenceChildren.set(id, !0);
        for (const isComplete of presenceChildren.values()) if (!isComplete) return;
        onExitComplete?.();
      },
      register: () => (presenceChildren.set(id, !1), () => presenceChildren.delete(id))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    // @ts-expect-error its ok
    presenceAffectsLayout ? void 0 : [isPresent, exitVariant, enterVariant]);
  return react.useMemo(() => {
    presenceChildren.forEach((_, key) => presenceChildren.set(key, !1));
  }, [isPresent]), react.useEffect(() => {
    !isPresent && !presenceChildren.size && onExitComplete?.();
  }, [isPresent]), /* @__PURE__ */(0,jsx_runtime.jsx)(dist_esm/* PresenceContext.Provider */.Oy.Provider, {
    value: context,
    children
  });
});
function newChildrenMap() {
  return /* @__PURE__ */new Map();
}

//# sourceMappingURL=PresenceChild.mjs.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tamagui+animate-presence@1.110.0_react@18.3.1/node_modules/@tamagui/animate-presence/dist/esm/AnimatePresence.mjs





const getChildKey = child => child.key || "";
function updateChildLookup(children, allChildren) {
  children.forEach(child => {
    const key = getChildKey(child);
    allChildren.set(key, child);
  });
}
function onlyElements(children) {
  const filtered = [];
  return react.Children.forEach(children, child => {
    (0,react.isValidElement)(child) && filtered.push(child);
  }), filtered;
}
const AnimatePresence = ({
  children,
  enterVariant,
  exitVariant,
  enterExitVariant,
  initial = !0,
  onExitComplete,
  exitBeforeEnter,
  presenceAffectsLayout = !0,
  custom
}) => {
  let forceRender = (0,react.useContext)(LayoutGroupContext).forceRender ?? useForceUpdate();
  const filteredChildren = onlyElements(children),
    presentChildren = (0,react.useRef)(filteredChildren),
    allChildren = (0,react.useRef)( /* @__PURE__ */new Map()).current,
    exiting = (0,react.useRef)( /* @__PURE__ */new Set()).current;
  updateChildLookup(filteredChildren, allChildren);
  const isInitialRender = (0,react.useRef)(!0);
  if (isInitialRender.current) return isInitialRender.current = !1, /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: filteredChildren.map(child => /* @__PURE__ */(0,jsx_runtime.jsx)(PresenceChild, {
      isPresent: !0,
      enterExitVariant,
      exitVariant,
      enterVariant,
      initial: initial ? void 0 : !1,
      presenceAffectsLayout,
      custom,
      children: child
    }, getChildKey(child)))
  });
  let childrenToRender = [...filteredChildren];
  const presentKeys = presentChildren.current.map(getChildKey),
    targetKeys = filteredChildren.map(getChildKey),
    numPresent = presentKeys.length;
  for (let i = 0; i < numPresent; i++) {
    const key = presentKeys[i];
    targetKeys.indexOf(key) === -1 ? exiting.add(key) : exiting.delete(key);
  }
  return exitBeforeEnter && exiting.size && (childrenToRender = []), exiting.forEach(key => {
    if (targetKeys.indexOf(key) !== -1) return;
    const child = allChildren.get(key);
    if (!child) return;
    const insertionIndex = presentKeys.indexOf(key),
      exitingComponent = /* @__PURE__ */(0,jsx_runtime.jsx)(PresenceChild, {
        isPresent: !1,
        onExitComplete: () => {
          allChildren.delete(key), exiting.delete(key);
          const removeIndex = presentChildren.current.findIndex(presentChild => presentChild.key === key);
          presentChildren.current.splice(removeIndex, 1), exiting.size || (presentChildren.current = filteredChildren, forceRender(), onExitComplete?.());
        },
        presenceAffectsLayout,
        enterExitVariant,
        enterVariant,
        exitVariant,
        custom,
        children: child
      }, getChildKey(child));
    childrenToRender.splice(insertionIndex, 0, exitingComponent);
  }), childrenToRender = childrenToRender.map(child => {
    const key = child.key;
    return exiting.has(key) ? child : /* @__PURE__ */(0,jsx_runtime.jsx)(PresenceChild, {
      isPresent: !0,
      exitVariant,
      enterVariant,
      enterExitVariant,
      presenceAffectsLayout,
      custom,
      children: child
    }, getChildKey(child));
  }), presentChildren.current = childrenToRender, /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: exiting.size ? childrenToRender :
    // biome-ignore lint/correctness/useJsxKeyInIterable: <explanation>
    childrenToRender.map(child => (0,react.cloneElement)(child))
  });
};
AnimatePresence.displayName = "AnimatePresence";

//# sourceMappingURL=AnimatePresence.mjs.map


/***/ }),

/***/ 58235:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ createCollection; }
/* harmony export */ });
/* harmony import */ var _tamagui_compose_refs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7185);
/* harmony import */ var _tamagui_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21153);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64978);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44194);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31549);





function createCollection(name) {
  const {
      Provider: CollectionProviderImpl,
      useStyledContext: useCollectionContext
    } = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.createStyledContext)({
      collectionRef: {
        current: null
      },
      itemMap: /* @__PURE__ */new Map()
    }),
    CollectionProvider = props => {
      const {
          __scopeCollection,
          children
        } = props,
        ref = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null),
        itemMap = react__WEBPACK_IMPORTED_MODULE_1__.useRef( /* @__PURE__ */new Map()).current;
      return /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(CollectionProviderImpl, {
        scope: __scopeCollection,
        itemMap,
        collectionRef: ref,
        children
      });
    };
  CollectionProvider.displayName = "CollectionProvider";
  const COLLECTION_SLOT_NAME = name + "CollectionSlot",
    CollectionSlot = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((props, forwardedRef) => {
      const {
          __scopeCollection,
          children
        } = props,
        context = useCollectionContext(__scopeCollection),
        composedRefs = (0,_tamagui_compose_refs__WEBPACK_IMPORTED_MODULE_4__/* .useComposedRefs */ .ex)(forwardedRef, context.collectionRef);
      return /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.Slot, {
        ref: composedRefs,
        children
      });
    });
  CollectionSlot.displayName = COLLECTION_SLOT_NAME;
  const ITEM_SLOT_NAME = name + "CollectionItemSlot",
    ITEM_DATA_ATTR = "data-collection-item",
    CollectionItemSlot = react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((props, forwardedRef) => {
      const {
          __scopeCollection,
          children,
          ...itemData
        } = props,
        ref = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null),
        composedRefs = (0,_tamagui_compose_refs__WEBPACK_IMPORTED_MODULE_4__/* .useComposedRefs */ .ex)(forwardedRef, ref),
        context = useCollectionContext(__scopeCollection);
      return react__WEBPACK_IMPORTED_MODULE_1__.useEffect(() => (context.itemMap.set(ref, {
        ref,
        ...itemData
      }), () => void context.itemMap.delete(ref))), /* @__PURE__ */(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.Slot, {
        [ITEM_DATA_ATTR]: "",
        ref: composedRefs,
        children
      });
    });
  CollectionItemSlot.displayName = ITEM_SLOT_NAME;
  function useCollection(__scopeCollection) {
    const context = useCollectionContext(__scopeCollection);
    return react__WEBPACK_IMPORTED_MODULE_1__.useCallback(() => {
      if (!_tamagui_constants__WEBPACK_IMPORTED_MODULE_0__/* .isWeb */ .$L) return [];
      const collectionNode = context.collectionRef.current;
      if (!collectionNode) return [];
      const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
      return Array.from(context.itemMap.values()).sort((a, b) => orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
    }, [context.collectionRef, context.itemMap]);
  }
  return [{
    Provider: CollectionProvider,
    Slot: CollectionSlot,
    ItemSlot: CollectionItemSlot
  }, useCollection];
}

//# sourceMappingURL=Collection.mjs.map


/***/ }),

/***/ 7185:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FE": function() { return /* binding */ composeRefs; },
/* harmony export */   "ex": function() { return /* binding */ useComposedRefs; }
/* harmony export */ });
/* unused harmony export setRef */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);

function setRef(ref, value) {
  typeof ref == "function" ? ref(value) : ref && (ref.current = value);
}
function composeRefs(...refs) {
  return node => refs.forEach(ref => setRef(ref, node));
}
function useComposedRefs(...refs) {
  return react__WEBPACK_IMPORTED_MODULE_0__.useCallback(composeRefs(...refs), refs);
}

//# sourceMappingURL=compose-refs.mjs.map


/***/ }),

/***/ 21153:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ob": function() { return /* reexport */ currentPlatform; },
  "Dt": function() { return /* reexport */ isAndroid; },
  "s": function() { return /* reexport */ isIos; },
  "sk": function() { return /* reexport */ isServer; },
  "wT": function() { return /* reexport */ isTouchable; },
  "$L": function() { return /* reexport */ isWeb; },
  "LI": function() { return /* reexport */ useIsomorphicLayoutEffect; }
});

// UNUSED EXPORTS: isChrome, isClient, isWebTouchable, isWindowDefined

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tamagui+constants@1.110.0_react@18.3.1/node_modules/@tamagui/constants/dist/esm/constants.mjs

const isWeb = !0,
  isWindowDefined = typeof window < "u",
  isServer = isWeb && !isWindowDefined,
  isClient = isWeb && isWindowDefined,
  useIsomorphicLayoutEffect = isServer ? react.useEffect : react.useLayoutEffect,
  isChrome = typeof navigator < "u" && /Chrome/.test(navigator.userAgent || ""),
  isWebTouchable = isClient && ("ontouchstart" in window || navigator.maxTouchPoints > 0),
  isTouchable = !isWeb || isWebTouchable,
  isAndroid = !1,
  isIos = !1,
  currentPlatform = "web";

//# sourceMappingURL=constants.mjs.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tamagui+constants@1.110.0_react@18.3.1/node_modules/@tamagui/constants/dist/esm/index.mjs

//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 67483:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h_": function() { return /* reexport */ Portal; },
  "$2": function() { return /* reexport */ PortalHost; },
  "b5": function() { return /* reexport */ PortalItem; },
  "Xp": function() { return /* reexport */ PortalProvider; }
});

// UNUSED EXPORTS: ACTIONS, INITIAL_STATE, usePortal

// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+polyfill-dev@1.110.0/node_modules/@tamagui/polyfill-dev/index.js
var polyfill_dev = __webpack_require__(18467);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+constants@1.110.0_react@18.3.1/node_modules/@tamagui/constants/dist/esm/index.mjs + 1 modules
var esm = __webpack_require__(21153);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+stacks@1.110.0_react@18.3.1/node_modules/@tamagui/stacks/dist/esm/Stacks.mjs
var Stacks = __webpack_require__(75778);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-dom@18.3.1_react@18.3.1/node_modules/react-dom/index.js
var react_dom = __webpack_require__(56321);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+use-did-finish-ssr@1.110.0_react@18.3.1/node_modules/@tamagui/use-did-finish-ssr/dist/esm/index.mjs
var dist_esm = __webpack_require__(20915);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(31549);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tamagui+portal@1.110.0_react@18.3.1/node_modules/@tamagui/portal/dist/esm/Portal.mjs







const Portal = react.memo(({
  host = globalThis.document?.body,
  ...props
}) => {
  if (esm/* isServer */.sk) return null;
  const didFinishSSR = (0,dist_esm/* useDidFinishSSR */.SZ)(),
    contents = /* @__PURE__ */(0,jsx_runtime.jsx)(Stacks/* YStack */.FA, {
      contain: "strict",
      fullscreen: !0,
      position: "fixed",
      maxWidth: "100vw",
      maxHeight: "100vh",
      pointerEvents: "none",
      ...props
    });
  return (0,react_dom.createPortal)(didFinishSSR ? contents : null, host);
});

//# sourceMappingURL=Portal.mjs.map

// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+core@1.110.0_react@18.3.1/node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(64978);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+start-transition@1.110.0/node_modules/@tamagui/start-transition/dist/esm/index.mjs
var start_transition_dist_esm = __webpack_require__(20279);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tamagui+portal@1.110.0_react@18.3.1/node_modules/@tamagui/portal/dist/esm/GorhomPortal.mjs





var ACTIONS = /* @__PURE__ */(ACTIONS2 => (ACTIONS2[ACTIONS2.REGISTER_HOST = 0] = "REGISTER_HOST", ACTIONS2[ACTIONS2.DEREGISTER_HOST = 1] = "DEREGISTER_HOST", ACTIONS2[ACTIONS2.ADD_UPDATE_PORTAL = 2] = "ADD_UPDATE_PORTAL", ACTIONS2[ACTIONS2.REMOVE_PORTAL = 3] = "REMOVE_PORTAL", ACTIONS2))(ACTIONS || {});
const INITIAL_STATE = {};
const registerHost = (state, hostName) => (hostName in state || (state[hostName] = []), state),
  deregisterHost = (state, hostName) => (delete state[hostName], state),
  addUpdatePortal = (state, hostName, portalName, node) => {
    hostName in state || (state = registerHost(state, hostName));
    const index = state[hostName].findIndex(item => item.name === portalName);
    return index !== -1 ? state[hostName][index].node = node : state[hostName].push({
      name: portalName,
      node
    }), state;
  },
  removePortal = (state, hostName, portalName) => {
    if (!(hostName in state)) return console.info(`Failed to remove portal '${portalName}', '${hostName}' was not registered!`), state;
    const index = state[hostName].findIndex(item => item.name === portalName);
    return index !== -1 && state[hostName].splice(index, 1), state;
  },
  reducer = (state, action) => {
    const {
      type
    } = action;
    switch (type) {
      case 0 /* REGISTER_HOST */:
        return registerHost({
          ...state
        }, action.hostName);
      case 1 /* DEREGISTER_HOST */:
        return deregisterHost({
          ...state
        }, action.hostName);
      case 2 /* ADD_UPDATE_PORTAL */:
        return addUpdatePortal({
          ...state
        }, action.hostName, action.portalName, action.node);
      case 3 /* REMOVE_PORTAL */:
        return removePortal({
          ...state
        }, action.hostName, action.portalName);
      default:
        return state;
    }
  },
  PortalStateContext = (0,react.createContext)(null),
  PortalDispatchContext = (0,react.createContext)(null),
  usePortalState = hostName => {
    const state = (0,react.useContext)(PortalStateContext);
    if (state === null) throw new Error("'PortalStateContext' cannot be null, please add 'PortalProvider' to the root component.");
    return state[hostName] || [];
  },
  usePortal = (hostName = "root") => {
    const dispatch = (0,react.useContext)(PortalDispatchContext);
    if (dispatch === null) throw new Error("'PortalDispatchContext' cannot be null, please add 'PortalProvider' to the root component.");
    const registerHost2 = (0,react.useCallback)(() => {
        dispatch({
          type: 0 /* REGISTER_HOST */,
          hostName
        });
      }, []),
      deregisterHost2 = (0,react.useCallback)(() => {
        dispatch({
          type: 1 /* DEREGISTER_HOST */,
          hostName
        });
      }, []),
      addUpdatePortal2 = (0,react.useCallback)((name, node) => {
        dispatch({
          type: 2 /* ADD_UPDATE_PORTAL */,
          hostName,
          portalName: name,
          node
        });
      }, []),
      removePortal2 = (0,react.useCallback)(name => {
        dispatch({
          type: 3 /* REMOVE_PORTAL */,
          hostName,
          portalName: name
        });
      }, []);
    return {
      registerHost: registerHost2,
      deregisterHost: deregisterHost2,
      addPortal: addUpdatePortal2,
      updatePortal: addUpdatePortal2,
      removePortal: removePortal2
    };
  },
  PortalProviderComponent = ({
    rootHostName = "root",
    shouldAddRootHost = !0,
    children
  }) => {
    const [state, dispatch] = (0,react.useReducer)(reducer, INITIAL_STATE),
      transitionDispatch = (0,react.useMemo)(() => value => {
        (0,start_transition_dist_esm/* startTransition */.L)(() => {
          dispatch(value);
        });
      }, [dispatch]);
    return /* @__PURE__ */(0,jsx_runtime.jsx)(PortalDispatchContext.Provider, {
      value: transitionDispatch,
      children: /* @__PURE__ */(0,jsx_runtime.jsxs)(PortalStateContext.Provider, {
        value: state,
        children: [children, shouldAddRootHost && /* @__PURE__ */(0,jsx_runtime.jsx)(PortalHost, {
          name: rootHostName
        })]
      })
    });
  },
  PortalProvider = (0,react.memo)(PortalProviderComponent);
PortalProvider.displayName = "PortalProvider";
const defaultRenderer = children => /* @__PURE__ */(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children
  }),
  PortalHostComponent = props => {
    const {
        name,
        forwardProps,
        render = defaultRenderer
      } = props,
      state = usePortalState(name),
      {
        registerHost: registerHost2,
        deregisterHost: deregisterHost2
      } = usePortal(props.name);
    return (0,react.useEffect)(() => {
      if (!(typeof window > "u")) return registerHost2(), () => {
        deregisterHost2();
      };
    }, []), render(forwardProps ? state.map(item => {
      let next = item.node;
      return forwardProps ? react.Children.map(next, child => react.isValidElement(child) ? react.cloneElement(child, {
        key: child.key,
        ...forwardProps
      }) : child) : next;
    }) : state.map(item => item.node));
  },
  PortalHost = (0,react.memo)(PortalHostComponent);
PortalHost.displayName = "PortalHost";
const PortalComponent = props => {
    const {
        name: _providedName,
        hostName,
        handleOnMount: _providedHandleOnMount,
        handleOnUnmount: _providedHandleOnUnmount,
        handleOnUpdate: _providedHandleOnUpdate,
        children
      } = props,
      {
        addPortal: addUpdatePortal2,
        removePortal: removePortal2
      } = usePortal(hostName),
      id = (0,react.useId)(),
      name = _providedName || id,
      handleOnMount = (0,cjs.useEvent)(() => {
        _providedHandleOnMount ? _providedHandleOnMount(() => addUpdatePortal2(name, children)) : addUpdatePortal2(name, children);
      }),
      handleOnUnmount = (0,cjs.useEvent)(() => {
        _providedHandleOnUnmount ? _providedHandleOnUnmount(() => removePortal2(name)) : removePortal2(name);
      }),
      handleOnUpdate = (0,cjs.useEvent)(() => {
        _providedHandleOnUpdate ? _providedHandleOnUpdate(() => addUpdatePortal2(name, children)) : addUpdatePortal2(name, children);
      });
    return (0,esm/* useIsomorphicLayoutEffect */.LI)(() => (handleOnMount(), () => {
      handleOnUnmount();
    }), []), (0,react.useEffect)(() => {
      handleOnUpdate();
    }, [children]), null;
  },
  PortalItem = (0,react.memo)(PortalComponent);
PortalItem.displayName = "Portal";

//# sourceMappingURL=GorhomPortal.mjs.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tamagui+portal@1.110.0_react@18.3.1/node_modules/@tamagui/portal/dist/esm/index.mjs



//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 75778:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FA": function() { return /* binding */ YStack; },
/* harmony export */   "Xu": function() { return /* binding */ fullscreenStyle; },
/* harmony export */   "sL": function() { return /* binding */ XStack; }
/* harmony export */ });
/* unused harmony export ZStack */
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64978);
/* harmony import */ var _getElevation_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39116);


const fullscreenStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  getInset = val => val && typeof val == "object" ? val : {
    top: val,
    left: val,
    bottom: val,
    right: val
  },
  variants = {
    fullscreen: {
      true: fullscreenStyle
    },
    elevation: {
      "...size": _getElevation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .getElevation */ .y,
      ":number": _getElevation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .getElevation */ .y
    },
    inset: getInset
  },
  YStack = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_1__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_1__.View, {
    flexDirection: "column",
    variants
  });
YStack.displayName = "YStack";
const XStack = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_1__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_1__.View, {
  flexDirection: "row",
  variants
});
XStack.displayName = "XStack";
const ZStack = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_1__.styled)(YStack, {
  position: "relative"
}, {
  neverFlatten: !0,
  isZStack: !0
});
ZStack.displayName = "ZStack";

//# sourceMappingURL=Stacks.mjs.map


/***/ }),

/***/ 39116:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ getElevation; }
/* harmony export */ });
/* unused harmony export getSizedElevation */
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64978);

const getElevation = (size, extras) => {
    if (!size) return;
    const {
        tokens
      } = extras,
      token = tokens.size[size],
      sizeNum = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.isVariable)(token) ? +token.val : size;
    return getSizedElevation(sizeNum, extras);
  },
  getSizedElevation = (val, {
    theme,
    tokens
  }) => {
    let num = 0;
    if (val === !0) {
      const val2 = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.getVariableValue)(tokens.size.true);
      typeof val2 == "number" ? num = val2 : num = 10;
    } else num = +val;
    if (num === 0) return;
    const [height, shadowRadius] = [Math.round(num / 4 + 1), Math.round(num / 2 + 2)];
    return {
      shadowColor: theme.shadowColor,
      shadowRadius,
      shadowOffset: {
        height,
        width: 0
      },
      ...(_tamagui_core__WEBPACK_IMPORTED_MODULE_0__.isAndroid ? {
        elevationAndroid: 2 * height
      } : {})
    };
  };

//# sourceMappingURL=getElevation.mjs.map


/***/ }),

/***/ 20279:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ startTransition; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);

const startTransition = callback => {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.startTransition)(callback);
};

//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 63081:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FE": function() { return /* binding */ ToastProvider_Collection; },
  "ZD": function() { return /* binding */ ReprogapateToastProvider; },
  "VW": function() { return /* binding */ ToastProvider; },
  "Kx": function() { return /* binding */ useCollection; },
  "jz": function() { return /* binding */ useToastProviderContext; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+collection@1.110.0_react@18.3.1/node_modules/@tamagui/collection/dist/esm/Collection.mjs
var Collection = __webpack_require__(58235);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+core@1.110.0_react@18.3.1/node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(64978);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+start-transition@1.110.0/node_modules/@tamagui/start-transition/dist/esm/index.mjs
var esm = __webpack_require__(20279);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+toast@1.110.0_react@18.3.1/node_modules/@tamagui/toast/dist/esm/constants.mjs
var constants = __webpack_require__(62770);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-native-web@0.19.13_encoding@0.1.13_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-native-web/dist/exports/Platform/index.js
var Platform = __webpack_require__(81561);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tamagui+toast@1.110.0_react@18.3.1/node_modules/@tamagui/toast/dist/esm/createNativeToast.mjs
const createNativeToast = (title, {
    message,
    notificationOptions
  }) => {
    if (!("Notification" in window)) return console.error("This browser does not support notifications"), !1;
    Notification.permission;
    const showNotification = () => new Notification(title, {
      body: message,
      ...notificationOptions
    });
    return Notification.permission === "granted" ? {
      nativeToastRef: showNotification()
    } : (Notification.requestPermission().then(permission => {
      if (permission === "granted") return {
        nativeToastRef: showNotification()
      };
    }), !0);
  },
  hideNativeToast = ref => {
    if (!("Notification" in window)) {
      console.error("This browser does not support notifications");
      return;
    }
    ref && ref.close();
  };

//# sourceMappingURL=createNativeToast.mjs.map

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(31549);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tamagui+toast@1.110.0_react@18.3.1/node_modules/@tamagui/toast/dist/esm/ToastImperative.mjs





const ToastContext = react.createContext({}),
  ToastCurrentContext = react.createContext(null),
  useToastController = () => React.useContext(ToastContext),
  useToastState = () => React.useContext(ToastCurrentContext),
  useToast = () => ({
    ...useToastController(),
    currentToast: useToastState()
  }),
  ToastImperativeProvider = ({
    children,
    options
  }) => {
    const counterRef = react.useRef(0),
      [toast, setToast] = react.useState(null),
      [lastNativeToastRef, setLastNativeToastRef] = react.useState(null),
      show = react.useCallback((title, showOptions) => {
        const native = showOptions?.native ?? options.native,
          isWebNative = Array.isArray(native) ? native.includes("web") : native === "web",
          isMobileNative = Array.isArray(native) ? native.includes("mobile") : native === "mobile",
          isAndroidNative = isMobileNative || (Array.isArray(native) ? native.includes("android") : native === "android"),
          isIosNative = isMobileNative || (Array.isArray(native) ? native.includes("ios") : native === "ios"),
          isHandledNatively = native === !0 || cjs.isWeb && isWebNative || !cjs.isWeb && isMobileNative || Platform/* default.OS */.Z.OS === "android" && isAndroidNative || Platform/* default.OS */.Z.OS === "ios" && isIosNative;
        if (isHandledNatively) {
          const nativeToastResult = createNativeToast(title, showOptions ?? {});
          typeof nativeToastResult == "object" && nativeToastResult.nativeToastRef && setLastNativeToastRef(nativeToastResult.nativeToastRef);
        }
        return counterRef.current++, setToast({
          ...showOptions?.customData,
          ...showOptions,
          viewportName: showOptions?.viewportName ?? "default",
          title,
          id: counterRef.current.toString(),
          isHandledNatively
        }), !0;
      }, [setToast, options.native]),
      hide = react.useCallback(() => {
        lastNativeToastRef?.close(), setToast(null);
      }, [setToast, lastNativeToastRef]),
      contextValue = react.useMemo(() => ({
        show,
        hide,
        nativeToast: lastNativeToastRef,
        options
      }), [show, hide, lastNativeToastRef, JSON.stringify(options || null)]);
    return /* @__PURE__ */(0,jsx_runtime.jsx)(ToastContext.Provider, {
      value: contextValue,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(ToastCurrentContext.Provider, {
        value: toast,
        children
      })
    });
  };

//# sourceMappingURL=ToastImperative.mjs.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tamagui+toast@1.110.0_react@18.3.1/node_modules/@tamagui/toast/dist/esm/ToastProvider.mjs







const PROVIDER_NAME = "ToastProvider",
  [ToastProvider_Collection, useCollection] = (0,Collection/* createCollection */.B)("Toast"),
  {
    Provider: ToastProviderProvider,
    useStyledContext: useToastProviderContext
  } = (0,cjs.createStyledContext)(),
  ToastProvider = props => {
    const {
        __scopeToast,
        id: providedId,
        burntOptions,
        native,
        notificationOptions,
        label = "Notification",
        duration = 5e3,
        swipeDirection = "right",
        swipeThreshold = 50,
        children
      } = props,
      backupId = react.useId(),
      id = providedId ?? backupId,
      [viewports, setViewports] = react.useState({}),
      [toastCount, setToastCount] = react.useState(0),
      isFocusedToastEscapeKeyDownRef = react.useRef(!1),
      isClosePausedRef = react.useRef(!1),
      handleViewportChange = react.useCallback((name, viewport) => {
        (0,esm/* startTransition */.L)(() => {
          setViewports(prev => ({
            ...prev,
            [name]: viewport
          }));
        });
      }, []),
      options = react.useMemo(() => ({
        duration,
        burntOptions,
        native,
        notificationOptions
      }), [JSON.stringify([duration, burntOptions, native, notificationOptions])]);
    return /* @__PURE__ */(0,jsx_runtime.jsx)(ToastProvider_Collection.Provider, {
      __scopeCollection: __scopeToast || constants/* TOAST_CONTEXT */.B,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(ToastProviderProvider, {
        scope: __scopeToast,
        id,
        label,
        duration,
        swipeDirection,
        swipeThreshold,
        toastCount,
        viewports,
        onViewportChange: handleViewportChange,
        onToastAdd: react.useCallback(() => {
          (0,esm/* startTransition */.L)(() => {
            setToastCount(prevCount => prevCount + 1);
          });
        }, []),
        onToastRemove: react.useCallback(() => {
          (0,esm/* startTransition */.L)(() => {
            setToastCount(prevCount => prevCount - 1);
          });
        }, []),
        isFocusedToastEscapeKeyDownRef,
        isClosePausedRef,
        options,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(ToastImperativeProvider, {
          options,
          children
        })
      })
    });
  };
function ReprogapateToastProvider(props) {
  const {
    children,
    context
  } = props;
  return /* @__PURE__ */(0,jsx_runtime.jsx)(ToastProvider_Collection.Provider, {
    __scopeCollection: constants/* TOAST_CONTEXT */.B,
    children: /* @__PURE__ */(0,jsx_runtime.jsx)(ToastProviderProvider, {
      ...context,
      children: /* @__PURE__ */(0,jsx_runtime.jsx)(ToastImperativeProvider, {
        options: context.options,
        children
      })
    })
  });
}
ToastProvider.propTypes = {
  label(props) {
    if (props.label && typeof props.label == "string" && !props.label.trim()) {
      const error = `Invalid prop \`label\` supplied to \`${PROVIDER_NAME}\`. Expected non-empty \`string\`.`;
      return new Error(error);
    }
    return null;
  }
};
ToastProvider.displayName = PROVIDER_NAME;

//# sourceMappingURL=ToastProvider.mjs.map


/***/ }),

/***/ 76738:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_i": function() { return /* binding */ ToastViewport; },
  "hu": function() { return /* binding */ VIEWPORT_PAUSE; },
  "AR": function() { return /* binding */ VIEWPORT_RESUME; }
});

// UNUSED EXPORTS: VIEWPORT_DEFAULT_HOTKEY

// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+animate-presence@1.110.0_react@18.3.1/node_modules/@tamagui/animate-presence/dist/esm/AnimatePresence.mjs + 3 modules
var AnimatePresence = __webpack_require__(67182);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+compose-refs@1.110.0_react@18.3.1/node_modules/@tamagui/compose-refs/dist/esm/compose-refs.mjs
var compose_refs = __webpack_require__(7185);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+constants@1.110.0_react@18.3.1/node_modules/@tamagui/constants/dist/esm/index.mjs + 1 modules
var esm = __webpack_require__(21153);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+core@1.110.0_react@18.3.1/node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(64978);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+portal@1.110.0_react@18.3.1/node_modules/@tamagui/portal/dist/esm/index.mjs + 2 modules
var dist_esm = __webpack_require__(67483);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+stacks@1.110.0_react@18.3.1/node_modules/@tamagui/stacks/dist/esm/Stacks.mjs
var Stacks = __webpack_require__(75778);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+visually-hidden@1.110.0_react@18.3.1/node_modules/@tamagui/visually-hidden/dist/esm/VisuallyHidden.mjs
var VisuallyHidden = __webpack_require__(31265);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+toast@1.110.0_react@18.3.1/node_modules/@tamagui/toast/dist/esm/constants.mjs
var constants = __webpack_require__(62770);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-native-web@0.19.13_encoding@0.1.13_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-native-web/dist/exports/Platform/index.js
var Platform = __webpack_require__(81561);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+toast@1.110.0_react@18.3.1/node_modules/@tamagui/toast/dist/esm/ToastProvider.mjs + 2 modules
var ToastProvider = __webpack_require__(63081);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(31549);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tamagui+toast@1.110.0_react@18.3.1/node_modules/@tamagui/toast/dist/esm/ToastPortal.mjs




function ToastPortal({
  children,
  zIndex
}) {
  let content = children;
  return Platform/* default.OS */.Z.OS === "android" && (content = /* @__PURE__ */(0,jsx_runtime.jsx)(ToastProvider/* ReprogapateToastProvider */.ZD, {
    context: (0,ToastProvider/* useToastProviderContext */.jz)(),
    children
  })), /* @__PURE__ */(0,jsx_runtime.jsx)(dist_esm/* Portal */.h_, {
    zIndex: zIndex || 1e9,
    children: content
  });
}

//# sourceMappingURL=ToastPortal.mjs.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tamagui+toast@1.110.0_react@18.3.1/node_modules/@tamagui/toast/dist/esm/ToastViewport.mjs
/* provided dependency */ var process = __webpack_require__(73656);












const VIEWPORT_NAME = "ToastViewport",
  VIEWPORT_DEFAULT_HOTKEY = ["F8"],
  VIEWPORT_PAUSE = "toast.viewportPause",
  VIEWPORT_RESUME = "toast.viewportResume",
  ToastViewportWrapperFrame = (0,cjs.styled)(Stacks/* YStack */.FA, {
    name: "ViewportWrapper",
    variants: {
      unstyled: {
        false: {
          pointerEvents: "box-none",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          position: esm/* isWeb */.$L ? "fixed" : "absolute",
          maxWidth: "100%",
          tabIndex: 0,
          zIndex: 1e5
        }
      }
    },
    defaultVariants: {
      unstyled: process.env.TAMAGUI_HEADLESS === "1"
    }
  }),
  ToastViewportFrame = (0,cjs.styled)(Stacks/* YStack */.FA, {
    name: VIEWPORT_NAME,
    variants: {
      unstyled: {
        false: {
          pointerEvents: "box-none",
          position: esm/* isWeb */.$L ? "fixed" : "absolute",
          maxWidth: "100%"
        }
      }
    },
    defaultVariants: {
      unstyled: process.env.TAMAGUI_HEADLESS === "1"
    }
  }),
  ToastViewport = react.memo(react.forwardRef((props, forwardedRef) => {
    const {
        __scopeToast,
        hotkey = VIEWPORT_DEFAULT_HOTKEY,
        label = "Notifications ({hotkey})",
        name = "default",
        multipleToasts,
        zIndex,
        portalToRoot,
        ...viewportProps
      } = props,
      context = (0,ToastProvider/* useToastProviderContext */.jz)(__scopeToast),
      getItems = (0,ToastProvider/* useCollection */.Kx)(__scopeToast || constants/* TOAST_CONTEXT */.B),
      headFocusProxyRef = react.useRef(null),
      tailFocusProxyRef = react.useRef(null),
      wrapperRef = react.useRef(null),
      ref = react.useRef(null),
      onViewportChange = react.useCallback(el => {
        context.viewports[name] !== el && context.onViewportChange(name, el);
      }, [name, context.viewports]),
      composedRefs = (0,compose_refs/* useComposedRefs */.ex)(forwardedRef, ref, onViewportChange),
      hotkeyLabel = hotkey.join("+").replace(/Key/g, "").replace(/Digit/g, ""),
      hasToasts = context.toastCount > 0;
    react.useEffect(() => {
      if (!esm/* isWeb */.$L || context.toastCount === 0) return;
      const handleKeyDown = event => {
        hotkey.every(key => event[key] || event.code === key) && ref.current?.focus();
      };
      return document.addEventListener("keydown", handleKeyDown), () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    }, [hotkey, context.toastCount]), react.useEffect(() => {
      if (!esm/* isWeb */.$L || context.toastCount === 0) return;
      const wrapper = wrapperRef.current,
        viewport = ref.current;
      if (hasToasts && wrapper && viewport) {
        const handlePause = () => {
            if (!context.isClosePausedRef.current) {
              const pauseEvent = new CustomEvent(VIEWPORT_PAUSE);
              viewport.dispatchEvent(pauseEvent), context.isClosePausedRef.current = !0;
            }
          },
          handleResume = () => {
            if (context.isClosePausedRef.current) {
              const resumeEvent = new CustomEvent(VIEWPORT_RESUME);
              viewport.dispatchEvent(resumeEvent), context.isClosePausedRef.current = !1;
            }
          },
          handleFocusOutResume = event => {
            !wrapper.contains(event.relatedTarget) && handleResume();
          },
          handlePointerLeaveResume = () => {
            wrapper.contains(document.activeElement) || handleResume();
          };
        return wrapper.addEventListener("focusin", handlePause), wrapper.addEventListener("focusout", handleFocusOutResume), wrapper.addEventListener("pointermove", handlePause), wrapper.addEventListener("pointerleave", handlePointerLeaveResume), window.addEventListener("blur", handlePause), window.addEventListener("focus", handleResume), () => {
          wrapper.removeEventListener("focusin", handlePause), wrapper.removeEventListener("focusout", handleFocusOutResume), wrapper.removeEventListener("pointermove", handlePause), wrapper.removeEventListener("pointerleave", handlePointerLeaveResume), window.removeEventListener("blur", handlePause), window.removeEventListener("focus", handleResume);
        };
      }
    }, [hasToasts, context.isClosePausedRef, context.toastCount]);
    const getSortedTabbableCandidates = react.useCallback(({
      tabbingDirection
    }) => {
      const tabbableCandidates = getItems().map(toastItem => {
        const toastNode = toastItem.ref.current,
          toastTabbableCandidates = [toastNode, ...getTabbableCandidates(toastNode)];
        return tabbingDirection === "forwards" ? toastTabbableCandidates : toastTabbableCandidates.reverse();
      });
      return (tabbingDirection === "forwards" ? tabbableCandidates.reverse() : tabbableCandidates).flat();
    }, [getItems]);
    react.useEffect(() => {
      if (!esm/* isWeb */.$L || context.toastCount === 0) return;
      const viewport = ref.current;
      if (viewport) {
        const handleKeyDown = event => {
          const isMetaKey = event.altKey || event.ctrlKey || event.metaKey;
          if (event.key === "Tab" && !isMetaKey) {
            const focusedElement = document.activeElement,
              isTabbingBackwards = event.shiftKey;
            if (event.target === viewport && isTabbingBackwards) {
              headFocusProxyRef.current?.focus();
              return;
            }
            const sortedCandidates = getSortedTabbableCandidates({
                tabbingDirection: isTabbingBackwards ? "backwards" : "forwards"
              }),
              index = sortedCandidates.findIndex(candidate => candidate === focusedElement);
            focusFirst(sortedCandidates.slice(index + 1)) ? event.preventDefault() : isTabbingBackwards ?
            // @ts-ignore ali TODO type
            headFocusProxyRef.current?.focus() :
            // @ts-ignore ali TODO type
            tailFocusProxyRef.current?.focus();
          }
        };
        return viewport.addEventListener("keydown", handleKeyDown), () => viewport.removeEventListener("keydown", handleKeyDown);
      }
    }, [getItems, getSortedTabbableCandidates, context.toastCount]);
    const contents = /* @__PURE__ */(0,jsx_runtime.jsxs)(ToastViewportWrapperFrame, {
      ref: wrapperRef,
      role: "region",
      "aria-label": label.replace("{hotkey}", hotkeyLabel),
      tabIndex: -1,
      children: [hasToasts && /* @__PURE__ */(0,jsx_runtime.jsx)(FocusProxy, {
        __scopeToast,
        viewportName: name,
        ref: headFocusProxyRef,
        onFocusFromOutsideViewport: () => {
          const tabbableCandidates = getSortedTabbableCandidates({
            tabbingDirection: "forwards"
          });
          focusFirst(tabbableCandidates);
        }
      }), /* @__PURE__ */(0,jsx_runtime.jsx)(ToastProvider/* Collection.Slot */.FE.Slot, {
        __scopeCollection: __scopeToast || constants/* TOAST_CONTEXT */.B,
        children: /* @__PURE__ */(0,jsx_runtime.jsx)(ToastViewportFrame, {
          focusable: context.toastCount > 0,
          ref: composedRefs,
          ...viewportProps,
          children: /* @__PURE__ */(0,jsx_runtime.jsx)(dist_esm/* PortalHost */.$2, {
            render: children => /* @__PURE__ */(0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
              exitBeforeEnter: !multipleToasts,
              children
            }),
            name: name ?? "default"
          })
        })
      }), hasToasts && /* @__PURE__ */(0,jsx_runtime.jsx)(FocusProxy, {
        __scopeToast,
        viewportName: name,
        ref: tailFocusProxyRef,
        onFocusFromOutsideViewport: () => {
          const tabbableCandidates = getSortedTabbableCandidates({
            tabbingDirection: "backwards"
          });
          focusFirst(tabbableCandidates);
        }
      })]
    });
    return portalToRoot ? /* @__PURE__ */(0,jsx_runtime.jsx)(ToastPortal, {
      ...(typeof zIndex == "number" ? {
        zIndex
      } : {}),
      children: contents
    }) : contents;
  }));
ToastViewport.displayName = VIEWPORT_NAME;
const FOCUS_PROXY_NAME = "ToastFocusProxy",
  FocusProxy = react.forwardRef((props, forwardedRef) => {
    const {
        __scopeToast,
        onFocusFromOutsideViewport,
        viewportName,
        ...proxyProps
      } = props,
      viewport = (0,ToastProvider/* useToastProviderContext */.jz)(__scopeToast).viewports[viewportName];
    return /* @__PURE__ */(0,jsx_runtime.jsx)(VisuallyHidden/* VisuallyHidden */.T, {
      "aria-hidden": !0,
      tabIndex: 0,
      ...proxyProps,
      ref: forwardedRef,
      position: esm/* isWeb */.$L ? "fixed" : "absolute",
      onFocus: event => {
        if (!esm/* isWeb */.$L) return;
        const prevFocusedElement = event.relatedTarget;
        !viewport?.contains(prevFocusedElement) && onFocusFromOutsideViewport();
      }
    });
  });
FocusProxy.displayName = FOCUS_PROXY_NAME;
function focusFirst(candidates) {
  if (!esm/* isWeb */.$L) return;
  const previouslyFocusedElement = document.activeElement;
  return candidates.some(candidate => candidate === previouslyFocusedElement ? !0 : (candidate.focus(), document.activeElement !== previouslyFocusedElement));
}
function getTabbableCandidates(container) {
  if (!esm/* isWeb */.$L) return [];
  const containerHtml = container,
    nodes = [],
    walker = document.createTreeWalker(containerHtml, NodeFilter.SHOW_ELEMENT, {
      acceptNode: node => {
        const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
        return node.disabled || node.hidden || isHiddenInput ? NodeFilter.FILTER_SKIP : node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
  for (; walker.nextNode();) nodes.push(walker.currentNode);
  return nodes;
}

//# sourceMappingURL=ToastViewport.mjs.map


/***/ }),

/***/ 62770:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ TOAST_CONTEXT; },
/* harmony export */   "F": function() { return /* binding */ TOAST_NAME; }
/* harmony export */ });
const TOAST_NAME = "Toast",
  TOAST_CONTEXT = "Toast";

//# sourceMappingURL=constants.mjs.map


/***/ }),

/***/ 48761:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useConstant; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);

function useConstant(fn) {
  if (typeof document > "u") return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => fn(), []);
  const ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  return ref.current || (ref.current = {
    v: fn()
  }), ref.current.v;
}

//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 20915:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SZ": function() { return /* binding */ useDidFinishSSR; }
/* harmony export */ });
/* unused harmony exports useClientValue, useDidFinishSSRSync */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);

const emptyFn = () => {},
  emptyFnFn = () => emptyFn;
function useDidFinishSSR(value, options) {
  if (options?.sync) return react__WEBPACK_IMPORTED_MODULE_0__.useSyncExternalStore(emptyFnFn, () => value ?? !0, () => !1);
  const [cur, setCur] = react__WEBPACK_IMPORTED_MODULE_0__.useState(value);
  return react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    setCur(value ?? !0);
  }, []), cur ?? !1;
}
function useDidFinishSSRSync(value) {
  return useDidFinishSSR(value, {
    sync: !0
  });
}
function useClientValue(value) {
  return useDidFinishSSR() ? typeof value == "function" ? value() : value : void 0;
}

//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 62080:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Oy": function() { return /* reexport */ PresenceContext; },
  "il": function() { return /* reexport */ ResetPresence; },
  "hO": function() { return /* reexport */ useIsPresent; },
  "oO": function() { return /* reexport */ usePresence; }
});

// UNUSED EXPORTS: isPresent

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(31549);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tamagui+use-presence@1.110.0_react@18.3.1/node_modules/@tamagui/use-presence/dist/esm/PresenceContext.mjs


const PresenceContext = react.createContext(null),
  ResetPresence = props => /* @__PURE__ */(0,jsx_runtime.jsx)(PresenceContext.Provider, {
    value: null,
    children: props.children
  });

//# sourceMappingURL=PresenceContext.mjs.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tamagui+use-presence@1.110.0_react@18.3.1/node_modules/@tamagui/use-presence/dist/esm/usePresence.mjs


function usePresence() {
  const context = react.useContext(PresenceContext);
  if (!context) return [!0, null, context];
  const {
    id,
    isPresent: isPresent2,
    onExitComplete,
    register
  } = context;
  return react.useEffect(() => register(id), []), !isPresent2 && onExitComplete ? [!1, () => onExitComplete?.(id), context] : [!0, void 0, context];
}
function useIsPresent() {
  return isPresent(react.useContext(PresenceContext));
}
function isPresent(context) {
  return context === null ? !0 : context.isPresent;
}

//# sourceMappingURL=usePresence.mjs.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tamagui+use-presence@1.110.0_react@18.3.1/node_modules/@tamagui/use-presence/dist/esm/index.mjs


//# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 31265:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ VisuallyHidden; }
/* harmony export */ });
/* harmony import */ var _tamagui_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77330);

const VisuallyHidden = (0,_tamagui_web__WEBPACK_IMPORTED_MODULE_0__.styled)(_tamagui_web__WEBPACK_IMPORTED_MODULE_0__.Text, {
  position: "absolute",
  width: 1,
  height: 1,
  margin: -1,
  zIndex: -1e4,
  overflow: "hidden",
  opacity: 1e-8,
  pointerEvents: "none",
  variants: {
    preserveDimensions: {
      true: {
        position: "relative",
        width: "auto",
        height: "auto"
      }
    },
    visible: {
      true: {
        position: "relative",
        width: "auto",
        height: "auto",
        margin: 0,
        zIndex: 1,
        overflow: "visible",
        opacity: 1,
        pointerEvents: "auto"
      }
    }
  }
});
VisuallyHidden.isVisuallyHidden = !0;

//# sourceMappingURL=VisuallyHidden.mjs.map


/***/ }),

/***/ 84209:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "XF": function() { return /* reexport */ ClientError; },
  "g6": function() { return /* reexport */ GraphQLClient_GraphQLClient; }
});

// UNUSED EXPORTS: analyzeDocument, batchRequests, default, gql, rawRequest, request

;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql-request@7.4.0_graphql@16.14.0/node_modules/graphql-request/build/legacy/classes/ClientError.js
class ClientError extends Error {
    response;
    request;
    constructor(response, request) {
        const message = `${ClientError.extractMessage(response)}: ${JSON.stringify({
            response,
            request,
        })}`;
        super(message);
        Object.setPrototypeOf(this, ClientError.prototype);
        this.response = response;
        this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === `function`) {
            Error.captureStackTrace(this, ClientError);
        }
    }
    static extractMessage(response) {
        return response.errors?.[0]?.message ?? `GraphQL Error (Code: ${String(response.status)})`;
    }
}
//# sourceMappingURL=ClientError.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql-request@7.4.0_graphql@16.14.0/node_modules/graphql-request/build/lib/prelude.js
/* provided dependency */ var process = __webpack_require__(73656);
const uppercase = (str) => str.toUpperCase();
const callOrIdentity = (value) => {
    return typeof value === `function` ? value() : value;
};
const zip = (a, b) => a.map((k, i) => [k, b[i]]);
const HeadersInitToPlainObject = (headers) => {
    let oHeaders = {};
    if (headers instanceof Headers) {
        oHeaders = HeadersInstanceToPlainObject(headers);
    }
    else if (Array.isArray(headers)) {
        headers.forEach(([name, value]) => {
            if (name && value !== undefined) {
                oHeaders[name] = value;
            }
        });
    }
    else if (headers) {
        oHeaders = headers;
    }
    return oHeaders;
};
const HeadersInstanceToPlainObject = (headers) => {
    const o = {};
    headers.forEach((v, k) => {
        o[k] = v;
    });
    return o;
};
const tryCatch = (fn) => {
    try {
        const result = fn();
        if (isPromiseLikeValue(result)) {
            return result.catch((error) => {
                return errorFromMaybeError(error);
            });
        }
        return result;
    }
    catch (error) {
        return errorFromMaybeError(error);
    }
};
/**
 * Ensure that the given value is an error and return it. If it is not an error than
 * wrap it in one, passing the given value as the error message.
 */
const errorFromMaybeError = (maybeError) => {
    if (maybeError instanceof Error)
        return maybeError;
    return new Error(String(maybeError));
};
const isPromiseLikeValue = (value) => {
    return (typeof value === `object`
        && value !== null
        && `then` in value
        && typeof value.then === `function`
        && `catch` in value
        && typeof value.catch === `function`
        && `finally` in value
        && typeof value.finally === `function`);
};
const casesExhausted = (value) => {
    throw new Error(`Unhandled case: ${String(value)}`);
};
const isPlainObject = (value) => {
    return typeof value === `object` && value !== null && !Array.isArray(value);
};
const entries = (obj) => Object.entries(obj);
const values = (obj) => Object.values(obj);
const mapValues = (object, fn) => {
    return Object.fromEntries(Object.entries(object).map(([key, value]) => {
        return [key, fn(value, key)];
    }));
};
const lowerCaseFirstLetter = (s) => {
    return s.charAt(0).toLowerCase() + s.slice(1);
};
function assertArray(v) {
    if (!Array.isArray(v))
        throw new Error(`Expected array. Got: ${String(v)}`);
}
function assertObject(v) {
    if (v === null || typeof v !== `object`)
        throw new Error(`Expected object. Got: ${String(v)}`);
}
const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);
const createDeferred = (options) => {
    let isResolved = false;
    let resolve;
    let reject;
    const promise = new Promise(($resolve, $reject) => {
        resolve = $resolve;
        reject = $reject;
    });
    return {
        promise,
        isResolved: () => isResolved,
        resolve: (value) => {
            isResolved = true;
            if (options?.strict && isResolved) {
                throw new Error(`Deferred is already resolved. Attempted to resolve with: ${JSON.stringify(value)}`);
            }
            resolve(value);
        },
        reject: (error) => reject(error),
    };
};
const debug = (...args) => {
    if (process.env[`DEBUG`]) {
        console.log(...args);
    }
};
const debugSub = (...args) => (...subArgs) => {
    debug(...args, ...subArgs);
};
const partitionErrors = (array) => {
    const errors = [];
    const values = [];
    for (const item of array) {
        if (item instanceof Error) {
            errors.push(item);
        }
        else {
            values.push(item);
        }
    }
    return [values, errors];
};
//# sourceMappingURL=prelude.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql-request@7.4.0_graphql@16.14.0/node_modules/graphql-request/build/legacy/functions/batchRequests.js

/**
 * Send a batch of GraphQL Document to the GraphQL server for execution.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await batchRequests('https://foo.bar/graphql', [
 * {
 *  query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * },
 * {
 *   query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * }])
 *
 * // You can also pass a GraphQL DocumentNode as query. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await batchRequests('https://foo.bar/graphql', [{ query: gql`...` }])
 * ```
 */
const batchRequests = async (...args) => {
    const params = parseBatchRequestsArgsExtended(args);
    const client = new GraphQLClient(params.url);
    return client.batchRequests(params);
};
const parseBatchRequestsArgsExtended = (args) => {
    if (args.length === 1) {
        return args[0];
    }
    else {
        return {
            url: args[0],
            documents: args[1],
            requestHeaders: args[2],
            signal: undefined,
        };
    }
};
const parseBatchRequestArgs = (documentsOrOptions, requestHeaders) => {
    // eslint-disable-next-line
    return documentsOrOptions.documents
        ? documentsOrOptions
        : {
            documents: documentsOrOptions,
            requestHeaders: requestHeaders,
            signal: undefined,
        };
};
//# sourceMappingURL=batchRequests.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql-request@7.4.0_graphql@16.14.0/node_modules/graphql-request/build/legacy/functions/rawRequest.js

/**
 * Send a GraphQL Query to the GraphQL server for execution.
 */
const rawRequest = async (...args) => {
    const [urlOrOptions, query, ...variablesAndRequestHeaders] = args;
    const requestOptions = parseRawRequestExtendedArgs(urlOrOptions, query, ...variablesAndRequestHeaders);
    const client = new GraphQLClient(requestOptions.url);
    return client.rawRequest({
        ...requestOptions,
    });
};
const parseRawRequestExtendedArgs = (urlOrOptions, query, ...variablesAndRequestHeaders) => {
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return typeof urlOrOptions === `string`
        ? {
            url: urlOrOptions,
            query: query,
            variables,
            requestHeaders,
            signal: undefined,
        }
        : urlOrOptions;
};
const parseRawRequestArgs = (queryOrOptions, variables, requestHeaders) => {
    return queryOrOptions.query
        ? queryOrOptions
        : {
            query: queryOrOptions,
            variables: variables,
            requestHeaders: requestHeaders,
            signal: undefined,
        };
};
//# sourceMappingURL=rawRequest.js.map
// EXTERNAL MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(5387);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql-request@7.4.0_graphql@16.14.0/node_modules/graphql-request/build/lib/http.js
const ACCEPT_HEADER = `Accept`;
const CONTENT_TYPE_HEADER = `Content-Type`;
const CONTENT_TYPE_JSON = `application/json`;
const CONTENT_TYPE_GQL = `application/graphql-response+json`;
const statusCodes = {
    success: 200,
};
//# sourceMappingURL=http.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql-request@7.4.0_graphql@16.14.0/node_modules/graphql-request/build/legacy/lib/graphql.js



/**
 * Clean a GraphQL document to send it via a GET query
 */
const cleanQuery = (str) => str.replace(/([\s,]|#[^\n\r]+)+/g, ` `).trim();
const isGraphQLContentType = (contentType) => {
    const contentTypeLower = contentType.toLowerCase();
    return contentTypeLower.includes(CONTENT_TYPE_GQL) || contentTypeLower.includes(CONTENT_TYPE_JSON);
};
const parseGraphQLExecutionResult = (result) => {
    try {
        if (Array.isArray(result)) {
            return {
                _tag: `Batch`,
                executionResults: result.map(parseExecutionResult),
            };
        }
        else if (isPlainObject(result)) {
            return {
                _tag: `Single`,
                executionResult: parseExecutionResult(result),
            };
        }
        else {
            throw new Error(`Invalid execution result: result is not object or array. \nGot:\n${String(result)}`);
        }
    }
    catch (e) {
        return e;
    }
};
/**
 * Example result:
 *
 * ```
 * {
 *  "data": null,
 *  "errors": [{
 *    "message": "custom error",
 *    "locations": [{ "line": 2, "column": 3 }],
 *    "path": ["playerNew"]
 *  }]
 * }
 * ```
 */
const parseExecutionResult = (result) => {
    if (typeof result !== `object` || result === null) {
        throw new Error(`Invalid execution result: result is not object`);
    }
    let errors = undefined;
    let data = undefined;
    let extensions = undefined;
    if (`errors` in result) {
        if (!isPlainObject(result.errors) && !Array.isArray(result.errors)) {
            throw new Error(`Invalid execution result: errors is not plain object OR array`); // prettier-ignore
        }
        errors = result.errors;
    }
    // todo add test coverage for case of null. @see https://github.com/jasonkuhrt/graphql-request/issues/739
    if (`data` in result) {
        if (!isPlainObject(result.data) && result.data !== null) {
            throw new Error(`Invalid execution result: data is not plain object`); // prettier-ignore
        }
        data = result.data;
    }
    if (`extensions` in result) {
        if (!isPlainObject(result.extensions))
            throw new Error(`Invalid execution result: extensions is not plain object`); // prettier-ignore
        extensions = result.extensions;
    }
    return {
        data,
        errors,
        extensions,
    };
};
const isRequestResultHaveErrors = (result) => result._tag === `Batch`
    ? result.executionResults.some(isExecutionResultHaveErrors)
    : isExecutionResultHaveErrors(result.executionResult);
const isExecutionResultHaveErrors = (result) => Array.isArray(result.errors) ? result.errors.length > 0 : Boolean(result.errors);
const isOperationDefinitionNode = (definition) => {
    return (typeof definition === `object`
        && definition !== null
        && `kind` in definition
        && definition.kind === kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION);
};
//# sourceMappingURL=graphql.js.map
// EXTERNAL MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/language/parser.mjs + 11 modules
var parser = __webpack_require__(54398);
// EXTERNAL MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(95317);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/language/printString.mjs
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */
function printString(str) {
  return `"${str.replace(escapedRegExp, escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex

const escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;

function escapedReplacer(str) {
  return escapeSequences[str.charCodeAt(0)];
} // prettier-ignore

const escapeSequences = [
  '\\u0000',
  '\\u0001',
  '\\u0002',
  '\\u0003',
  '\\u0004',
  '\\u0005',
  '\\u0006',
  '\\u0007',
  '\\b',
  '\\t',
  '\\n',
  '\\u000B',
  '\\f',
  '\\r',
  '\\u000E',
  '\\u000F',
  '\\u0010',
  '\\u0011',
  '\\u0012',
  '\\u0013',
  '\\u0014',
  '\\u0015',
  '\\u0016',
  '\\u0017',
  '\\u0018',
  '\\u0019',
  '\\u001A',
  '\\u001B',
  '\\u001C',
  '\\u001D',
  '\\u001E',
  '\\u001F',
  '',
  '',
  '\\"',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 2F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 3F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 4F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\\\',
  '',
  '',
  '', // 5F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 6F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\u007F',
  '\\u0080',
  '\\u0081',
  '\\u0082',
  '\\u0083',
  '\\u0084',
  '\\u0085',
  '\\u0086',
  '\\u0087',
  '\\u0088',
  '\\u0089',
  '\\u008A',
  '\\u008B',
  '\\u008C',
  '\\u008D',
  '\\u008E',
  '\\u008F',
  '\\u0090',
  '\\u0091',
  '\\u0092',
  '\\u0093',
  '\\u0094',
  '\\u0095',
  '\\u0096',
  '\\u0097',
  '\\u0098',
  '\\u0099',
  '\\u009A',
  '\\u009B',
  '\\u009C',
  '\\u009D',
  '\\u009E',
  '\\u009F',
];

// EXTERNAL MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/jsutils/devAssert.mjs
var devAssert = __webpack_require__(65408);
// EXTERNAL MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/jsutils/inspect.mjs
var inspect = __webpack_require__(49993);
// EXTERNAL MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/language/ast.mjs
var ast = __webpack_require__(63452);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/language/visitor.mjs




/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */

const BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 * ```ts
 * const editedAST = visit(ast, {
 *   enter(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: skip visiting this node
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   },
 *   leave(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: no action
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   }
 * });
 * ```
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to three permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind(node) {
 *     // enter the "Kind" node
 *   }
 * })
 * ```
 *
 * 2) Named visitors that trigger upon entering and leaving a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind: {
 *     enter(node) {
 *       // enter the "Kind" node
 *     }
 *     leave(node) {
 *       // leave the "Kind" node
 *     }
 *   }
 * })
 * ```
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 * ```ts
 * visit(ast, {
 *   enter(node) {
 *     // enter any node
 *   },
 *   leave(node) {
 *     // leave any node
 *   }
 * })
 * ```
 */

function visit(root, visitor, visitorKeys = ast/* QueryDocumentKeys */.h8) {
  const enterLeaveMap = new Map();

  for (const kind of Object.values(kinds/* Kind */.h)) {
    enterLeaveMap.set(kind, getEnterLeaveForKind(visitor, kind));
  }
  /* eslint-disable no-undef-init */

  let stack = undefined;
  let inArray = Array.isArray(root);
  let keys = [root];
  let index = -1;
  let edits = [];
  let node = root;
  let key = undefined;
  let parent = undefined;
  const path = [];
  const ancestors = [];
  /* eslint-enable no-undef-init */

  do {
    index++;
    const isLeaving = index === keys.length;
    const isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
          let editOffset = 0;

          for (const [editKey, editValue] of edits) {
            const arrayKey = editKey - editOffset;

            if (editValue === null) {
              node.splice(arrayKey, 1);
              editOffset++;
            } else {
              node[arrayKey] = editValue;
            }
          }
        } else {
          node = { ...node };

          for (const [editKey, editValue] of edits) {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else if (parent) {
      key = inArray ? index : keys[index];
      node = parent[key];

      if (node === null || node === undefined) {
        continue;
      }

      path.push(key);
    }

    let result;

    if (!Array.isArray(node)) {
      var _enterLeaveMap$get, _enterLeaveMap$get2;

      (0,ast/* isNode */.UG)(node) || (0,devAssert/* devAssert */.a)(false, `Invalid AST Node: ${(0,inspect/* inspect */.X)(node)}.`);
      const visitFn = isLeaving
        ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get === void 0
          ? void 0
          : _enterLeaveMap$get.leave
        : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get2 === void 0
        ? void 0
        : _enterLeaveMap$get2.enter;
      result =
        visitFn === null || visitFn === void 0
          ? void 0
          : visitFn.call(visitor, node, key, parent, path, ancestors);

      if (result === BREAK) {
        break;
      }

      if (result === false) {
        if (!isLeaving) {
          path.pop();
          continue;
        }
      } else if (result !== undefined) {
        edits.push([key, result]);

        if (!isLeaving) {
          if ((0,ast/* isNode */.UG)(result)) {
            node = result;
          } else {
            path.pop();
            continue;
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      var _node$kind;

      stack = {
        inArray,
        index,
        keys,
        edits,
        prev: stack,
      };
      inArray = Array.isArray(node);
      keys = inArray
        ? node
        : (_node$kind = visitorKeys[node.kind]) !== null &&
          _node$kind !== void 0
        ? _node$kind
        : [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    // New root
    return edits[edits.length - 1][1];
  }

  return root;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */

function visitInParallel(visitors) {
  const skipping = new Array(visitors.length).fill(null);
  const mergedVisitor = Object.create(null);

  for (const kind of Object.values(Kind)) {
    let hasVisitor = false;
    const enterList = new Array(visitors.length).fill(undefined);
    const leaveList = new Array(visitors.length).fill(undefined);

    for (let i = 0; i < visitors.length; ++i) {
      const { enter, leave } = getEnterLeaveForKind(visitors[i], kind);
      hasVisitor || (hasVisitor = enter != null || leave != null);
      enterList[i] = enter;
      leaveList[i] = leave;
    }

    if (!hasVisitor) {
      continue;
    }

    const mergedEnterLeave = {
      enter(...args) {
        const node = args[0];

        for (let i = 0; i < visitors.length; i++) {
          if (skipping[i] === null) {
            var _enterList$i;

            const result =
              (_enterList$i = enterList[i]) === null || _enterList$i === void 0
                ? void 0
                : _enterList$i.apply(visitors[i], args);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      },

      leave(...args) {
        const node = args[0];

        for (let i = 0; i < visitors.length; i++) {
          if (skipping[i] === null) {
            var _leaveList$i;

            const result =
              (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0
                ? void 0
                : _leaveList$i.apply(visitors[i], args);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          } else if (skipping[i] === node) {
            skipping[i] = null;
          }
        }
      },
    };
    mergedVisitor[kind] = mergedEnterLeave;
  }

  return mergedVisitor;
}
/**
 * Given a visitor instance and a node kind, return EnterLeaveVisitor for that kind.
 */

function getEnterLeaveForKind(visitor, kind) {
  const kindVisitor = visitor[kind];

  if (typeof kindVisitor === 'object') {
    // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
  } else if (typeof kindVisitor === 'function') {
    // { Kind() {} }
    return {
      enter: kindVisitor,
      leave: undefined,
    };
  } // { enter() {}, leave() {} }

  return {
    enter: visitor.enter,
    leave: visitor.leave,
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 *
 * @deprecated Please use `getEnterLeaveForKind` instead. Will be removed in v17
 */

/* c8 ignore next 8 */

function getVisitFn(visitor, kind, isLeaving) {
  const { enter, leave } = getEnterLeaveForKind(visitor, kind);
  return isLeaving ? leave : enter;
}

;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/language/printer.mjs



/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */

function print(ast) {
  return visit(ast, printDocASTReducer);
}
const MAX_LINE_LENGTH = 80;
const printDocASTReducer = {
  Name: {
    leave: (node) => node.value,
  },
  Variable: {
    leave: (node) => '$' + node.name,
  },
  // Document
  Document: {
    leave: (node) => join(node.definitions, '\n\n'),
  },
  OperationDefinition: {
    leave(node) {
      const varDefs = hasMultilineItems(node.variableDefinitions)
        ? wrap('(\n', join(node.variableDefinitions, '\n'), '\n)')
        : wrap('(', join(node.variableDefinitions, ', '), ')');
      const prefix =
        wrap('', node.description, '\n') +
        join(
          [
            node.operation,
            join([node.name, varDefs]),
            join(node.directives, ' '),
          ],
          ' ',
        ); // Anonymous queries with no directives or variable definitions can use
      // the query short form.

      return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
    },
  },
  VariableDefinition: {
    leave: ({ variable, type, defaultValue, directives, description }) =>
      wrap('', description, '\n') +
      variable +
      ': ' +
      type +
      wrap(' = ', defaultValue) +
      wrap(' ', join(directives, ' ')),
  },
  SelectionSet: {
    leave: ({ selections }) => block(selections),
  },
  Field: {
    leave({ alias, name, arguments: args, directives, selectionSet }) {
      const prefix = wrap('', alias, ': ') + name;
      let argsLine = prefix + wrap('(', join(args, ', '), ')');

      if (argsLine.length > MAX_LINE_LENGTH) {
        argsLine = prefix + wrap('(\n', indent(join(args, '\n')), '\n)');
      }

      return join([argsLine, join(directives, ' '), selectionSet], ' ');
    },
  },
  Argument: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name, directives }) =>
      '...' + name + wrap(' ', join(directives, ' ')),
  },
  InlineFragment: {
    leave: ({ typeCondition, directives, selectionSet }) =>
      join(
        [
          '...',
          wrap('on ', typeCondition),
          join(directives, ' '),
          selectionSet,
        ],
        ' ',
      ),
  },
  FragmentDefinition: {
    leave: ({
      name,
      typeCondition,
      variableDefinitions,
      directives,
      selectionSet,
      description,
    }) =>
      wrap('', description, '\n') + // Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      `fragment ${name}${wrap('(', join(variableDefinitions, ', '), ')')} ` +
      `on ${typeCondition} ${wrap('', join(directives, ' '), ' ')}` +
      selectionSet,
  },
  // Value
  IntValue: {
    leave: ({ value }) => value,
  },
  FloatValue: {
    leave: ({ value }) => value,
  },
  StringValue: {
    leave: ({ value, block: isBlockString }) =>
      isBlockString ? (0,blockString/* printBlockString */.LZ)(value) : printString(value),
  },
  BooleanValue: {
    leave: ({ value }) => (value ? 'true' : 'false'),
  },
  NullValue: {
    leave: () => 'null',
  },
  EnumValue: {
    leave: ({ value }) => value,
  },
  ListValue: {
    leave: ({ values }) => '[' + join(values, ', ') + ']',
  },
  ObjectValue: {
    leave: ({ fields }) => '{' + join(fields, ', ') + '}',
  },
  ObjectField: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Directive
  Directive: {
    leave: ({ name, arguments: args }) =>
      '@' + name + wrap('(', join(args, ', '), ')'),
  },
  // Type
  NamedType: {
    leave: ({ name }) => name,
  },
  ListType: {
    leave: ({ type }) => '[' + type + ']',
  },
  NonNullType: {
    leave: ({ type }) => type + '!',
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description, directives, operationTypes }) =>
      wrap('', description, '\n') +
      join(['schema', join(directives, ' '), block(operationTypes)], ' '),
  },
  OperationTypeDefinition: {
    leave: ({ operation, type }) => operation + ': ' + type,
  },
  ScalarTypeDefinition: {
    leave: ({ description, name, directives }) =>
      wrap('', description, '\n') +
      join(['scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap('', description, '\n') +
      join(
        [
          'type',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  FieldDefinition: {
    leave: ({ description, name, arguments: args, type, directives }) =>
      wrap('', description, '\n') +
      name +
      (hasMultilineItems(args)
        ? wrap('(\n', indent(join(args, '\n')), '\n)')
        : wrap('(', join(args, ', '), ')')) +
      ': ' +
      type +
      wrap(' ', join(directives, ' ')),
  },
  InputValueDefinition: {
    leave: ({ description, name, type, defaultValue, directives }) =>
      wrap('', description, '\n') +
      join(
        [name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')],
        ' ',
      ),
  },
  InterfaceTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap('', description, '\n') +
      join(
        [
          'interface',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeDefinition: {
    leave: ({ description, name, directives, types }) =>
      wrap('', description, '\n') +
      join(
        ['union', name, join(directives, ' '), wrap('= ', join(types, ' | '))],
        ' ',
      ),
  },
  EnumTypeDefinition: {
    leave: ({ description, name, directives, values }) =>
      wrap('', description, '\n') +
      join(['enum', name, join(directives, ' '), block(values)], ' '),
  },
  EnumValueDefinition: {
    leave: ({ description, name, directives }) =>
      wrap('', description, '\n') + join([name, join(directives, ' ')], ' '),
  },
  InputObjectTypeDefinition: {
    leave: ({ description, name, directives, fields }) =>
      wrap('', description, '\n') +
      join(['input', name, join(directives, ' '), block(fields)], ' '),
  },
  DirectiveDefinition: {
    leave: ({
      description,
      name,
      arguments: args,
      directives,
      repeatable,
      locations,
    }) =>
      wrap('', description, '\n') +
      'directive @' +
      name +
      (hasMultilineItems(args)
        ? wrap('(\n', indent(join(args, '\n')), '\n)')
        : wrap('(', join(args, ', '), ')')) +
      wrap(' ', join(directives, ' ')) +
      (repeatable ? ' repeatable' : '') +
      ' on ' +
      join(locations, ' | '),
  },
  SchemaExtension: {
    leave: ({ directives, operationTypes }) =>
      join(
        ['extend schema', join(directives, ' '), block(operationTypes)],
        ' ',
      ),
  },
  ScalarTypeExtension: {
    leave: ({ name, directives }) =>
      join(['extend scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend type',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  InterfaceTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend interface',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeExtension: {
    leave: ({ name, directives, types }) =>
      join(
        [
          'extend union',
          name,
          join(directives, ' '),
          wrap('= ', join(types, ' | ')),
        ],
        ' ',
      ),
  },
  EnumTypeExtension: {
    leave: ({ name, directives, values }) =>
      join(['extend enum', name, join(directives, ' '), block(values)], ' '),
  },
  InputObjectTypeExtension: {
    leave: ({ name, directives, fields }) =>
      join(['extend input', name, join(directives, ' '), block(fields)], ' '),
  },
  DirectiveExtension: {
    leave: ({ name, directives }) =>
      join(['extend directive @' + name, join(directives, ' ')], ' '),
  },
  // Schema Coordinates
  TypeCoordinate: {
    leave: ({ name }) => name,
  },
  MemberCoordinate: {
    leave: ({ name, memberName }) => join([name, wrap('.', memberName)]),
  },
  ArgumentCoordinate: {
    leave: ({ name, fieldName, argumentName }) =>
      join([name, wrap('.', fieldName), wrap('(', argumentName, ':)')]),
  },
  DirectiveCoordinate: {
    leave: ({ name }) => join(['@', name]),
  },
  DirectiveArgumentCoordinate: {
    leave: ({ name, argumentName }) =>
      join(['@', name, wrap('(', argumentName, ':)')]),
  },
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */

function join(maybeArray, separator = '') {
  var _maybeArray$filter$jo;

  return (_maybeArray$filter$jo =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.filter((x) => x).join(separator)) !== null &&
    _maybeArray$filter$jo !== void 0
    ? _maybeArray$filter$jo
    : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */

function block(array) {
  return wrap('{\n', indent(join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */

function wrap(start, maybeString, end = '') {
  return maybeString != null && maybeString !== ''
    ? start + maybeString + end
    : '';
}

function indent(str) {
  return wrap('  ', str.replace(/\n/g, '\n  '));
}

function hasMultilineItems(maybeArray) {
  var _maybeArray$some;

  // FIXME: https://github.com/graphql/graphql-js/issues/2203

  /* c8 ignore next */
  return (_maybeArray$some =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.some((str) => str.includes('\n'))) !== null &&
    _maybeArray$some !== void 0
    ? _maybeArray$some
    : false;
}

;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql-request@7.4.0_graphql@16.14.0/node_modules/graphql-request/build/legacy/helpers/analyzeDocument.js




/**
 * helpers
 */
const extractOperationName = (document) => {
    let operationName = undefined;
    const defs = document.definitions.filter(isOperationDefinitionNode);
    if (defs.length === 1) {
        operationName = defs[0].name?.value;
    }
    return operationName;
};
const extractIsMutation = (document) => {
    let isMutation = false;
    const defs = document.definitions.filter(isOperationDefinitionNode);
    if (defs.length === 1) {
        /* eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison --
         * graphql@15's `OperationTypeNode` is a type, but graphql@16's `OperationTypeNode` is a native TypeScript enum
         * Therefore, we cannot use `OperationTypeNode.MUTATION` here because it wouldn't work with graphql@15
         **/
        isMutation = defs[0].operation === `mutation`;
    }
    return isMutation;
};
const analyzeDocument = (document, excludeOperationName) => {
    /**
     * Normalize boxed String objects to primitive strings for compatibility with TypedDocumentString.
     *
     * Problem: \@graphql-codegen with `documentMode: 'string'` generates a TypedDocumentString class that
     * extends the built-in String class, creating "boxed String" instances:
     *
     * @see https://github.com/dotansimha/graphql-code-generator/blob/c87b779b9b400813d733fa89dcb16724b30c6d16/packages/plugins/typescript/typed-document-node/src/index.ts#L40-L57
     *
     * ```
     * class TypedDocumentString<TResult, TVariables> extends String
     *   constructor(value: string)
     *     super(value)  // Creates a boxed String object, not a primitive string
     * ```
     *
     * Boxed Strings are objects, not primitives:
     * - `typeof "hello" === "string"` returns true
     * - `typeof new String("hello") === "string"` returns false (returns "object")
     *
     * Without normalization, TypedDocumentString instances would fail the `typeof === 'string'` check
     * and incorrectly be passed to `print()`, which expects a DocumentNode AST, causing a crash.
     *
     * Solution: Detect and convert boxed Strings to primitives using template literal coercion.
     * - Primitive strings pass through (typeof === "string")
     * - DocumentNode objects pass through (have .kind property)
     * - Boxed Strings get converted to primitives (template literal to primitive string)
     *
     * @see https://github.com/graffle-js/graffle/issues/1453
     */
    const normalizedDocument = typeof document === `string` || `kind` in document
        ? document
        : String(document);
    const expression = typeof normalizedDocument === `string` ? normalizedDocument : print(normalizedDocument);
    let isMutation = false;
    let operationName = undefined;
    if (excludeOperationName) {
        return { expression, isMutation, operationName };
    }
    const docNode = tryCatch(() => (typeof normalizedDocument === `string` ? (0,parser/* parse */.Qc)(normalizedDocument) : normalizedDocument));
    if (docNode instanceof Error) {
        return { expression, isMutation, operationName };
    }
    operationName = extractOperationName(docNode);
    isMutation = extractIsMutation(docNode);
    return { expression, operationName, isMutation };
};
//# sourceMappingURL=analyzeDocument.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql-request@7.4.0_graphql@16.14.0/node_modules/graphql-request/build/legacy/helpers/defaultJsonSerializer.js
const defaultJsonSerializer = JSON;
//# sourceMappingURL=defaultJsonSerializer.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql-request@7.4.0_graphql@16.14.0/node_modules/graphql-request/build/legacy/helpers/runRequest.js





// @ts-expect-error todo
const runRequest = async (input) => {
    // todo make a Config type
    const config = {
        ...input,
        method: input.request._tag === `Single`
            ? input.request.document.isMutation
                ? `POST`
                : uppercase(input.method ?? `post`)
            : input.request.hasMutations
                ? `POST`
                : uppercase(input.method ?? `post`),
        fetchOptions: {
            ...input.fetchOptions,
            errorPolicy: input.fetchOptions.errorPolicy ?? `none`,
        },
    };
    const fetcher = createFetcher(config.method);
    const fetchResponse = await fetcher(config);
    // Read response body text first (can only be read once)
    const body = await fetchResponse.text();
    // Parse response body FIRST, regardless of HTTP status
    // This allows GraphQL errors to be extracted even when HTTP status is 4xx/5xx (fixes #1281)
    let result;
    try {
        result = parseResultFromText(body, fetchResponse.headers.get(CONTENT_TYPE_HEADER), input.fetchOptions.jsonSerializer ?? defaultJsonSerializer);
    }
    catch (error) {
        // If parsing fails, we'll handle it below based on HTTP status
        result = error;
    }
    const clientResponseBase = {
        status: fetchResponse.status,
        headers: fetchResponse.headers,
        body,
    };
    // Handle non-2xx HTTP status codes
    if (!fetchResponse.ok) {
        if (result instanceof Error) {
            // Parse failed - return ClientError without GraphQL data
            // Still returns ClientError (not generic Error) to allow status code access
            return new ClientError({ ...clientResponseBase }, {
                query: input.request._tag === `Single` ? input.request.document.expression : input.request.query,
                variables: input.request.variables,
            });
        }
        // Parse succeeded - return ClientError WITH GraphQL errors/data (fixes #1281)
        const clientResponse = result._tag === `Batch`
            ? { ...result.executionResults, ...clientResponseBase }
            : {
                ...result.executionResult,
                ...clientResponseBase,
            };
        // @ts-expect-error todo
        return new ClientError(clientResponse, {
            query: input.request._tag === `Single` ? input.request.document.expression : input.request.query,
            variables: input.request.variables,
        });
    }
    // For 2xx responses, parse errors should throw
    if (result instanceof Error)
        throw result;
    if (isRequestResultHaveErrors(result) && config.fetchOptions.errorPolicy === `none`) {
        // todo this client response on error is not consistent with the data type for success
        const clientResponse = result._tag === `Batch`
            ? { ...result.executionResults, ...clientResponseBase }
            : {
                ...result.executionResult,
                ...clientResponseBase,
            };
        // @ts-expect-error todo
        return new ClientError(clientResponse, {
            query: input.request._tag === `Single` ? input.request.document.expression : input.request.query,
            variables: input.request.variables,
        });
    }
    switch (result._tag) {
        case `Single`:
            // @ts-expect-error todo
            return {
                ...clientResponseBase,
                ...executionResultClientResponseFields(config)(result.executionResult),
            };
        case `Batch`:
            return {
                ...clientResponseBase,
                data: result.executionResults.map(executionResultClientResponseFields(config)),
            };
        default:
            casesExhausted(result);
    }
};
const executionResultClientResponseFields = ($params) => (executionResult) => {
    return {
        extensions: executionResult.extensions,
        data: executionResult.data,
        errors: $params.fetchOptions.errorPolicy === `all` ? executionResult.errors : undefined,
    };
};
const parseResultFromText = (text, contentType, jsonSerializer) => {
    if (contentType && isGraphQLContentType(contentType)) {
        return parseGraphQLExecutionResult(jsonSerializer.parse(text));
    }
    else {
        // todo what is this good for...? Seems very random/undefined
        return parseGraphQLExecutionResult(text);
    }
};
const createFetcher = (method) => async (params) => {
    const headers = new Headers(params.headers);
    let searchParams = null;
    let body = undefined;
    if (!headers.has(ACCEPT_HEADER)) {
        headers.set(ACCEPT_HEADER, [CONTENT_TYPE_GQL, CONTENT_TYPE_JSON].join(`, `));
    }
    if (method === `POST`) {
        const $jsonSerializer = params.fetchOptions.jsonSerializer ?? defaultJsonSerializer;
        body = $jsonSerializer.stringify(buildBody(params));
        if (typeof body === `string` && !headers.has(CONTENT_TYPE_HEADER)) {
            headers.set(CONTENT_TYPE_HEADER, CONTENT_TYPE_JSON);
        }
    }
    else {
        searchParams = buildQueryParams(params);
    }
    const init = { method, headers, body, ...params.fetchOptions };
    let url = new URL(params.url);
    let initResolved = init;
    if (params.middleware) {
        const result = await Promise.resolve(params.middleware({
            ...init,
            url: params.url,
            operationName: params.request._tag === `Single` ? params.request.document.operationName : undefined,
            variables: params.request.variables,
        }));
        const { url: urlNew, ...initNew } = result;
        url = new URL(urlNew);
        initResolved = initNew;
    }
    if (searchParams) {
        searchParams.forEach((value, name) => {
            url.searchParams.append(name, value);
        });
    }
    const $fetch = params.fetch ?? fetch;
    return await $fetch(url, initResolved);
};
const buildBody = (params) => {
    switch (params.request._tag) {
        case `Single`:
            return {
                query: params.request.document.expression,
                variables: params.request.variables,
                operationName: params.request.document.operationName,
            };
        case `Batch`:
            return zip(params.request.query, params.request.variables ?? []).map(([query, variables]) => ({
                query,
                variables,
            }));
        default:
            throw casesExhausted(params.request);
    }
};
const buildQueryParams = (params) => {
    const $jsonSerializer = params.fetchOptions.jsonSerializer ?? defaultJsonSerializer;
    const searchParams = new URLSearchParams();
    switch (params.request._tag) {
        case `Single`: {
            searchParams.append(`query`, cleanQuery(params.request.document.expression));
            if (params.request.variables) {
                searchParams.append(`variables`, $jsonSerializer.stringify(params.request.variables));
            }
            if (params.request.document.operationName) {
                searchParams.append(`operationName`, params.request.document.operationName);
            }
            return searchParams;
        }
        case `Batch`: {
            const variablesSerialized = params.request.variables?.map((v) => $jsonSerializer.stringify(v)) ?? [];
            const queriesCleaned = params.request.query.map(cleanQuery);
            const payload = zip(queriesCleaned, variablesSerialized).map(([query, variables]) => ({
                query,
                variables,
            }));
            searchParams.append(`query`, $jsonSerializer.stringify(payload));
            return searchParams;
        }
        default:
            throw casesExhausted(params.request);
    }
};
//# sourceMappingURL=runRequest.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql-request@7.4.0_graphql@16.14.0/node_modules/graphql-request/build/legacy/classes/GraphQLClient.js






/**
 * GraphQL Client.
 */
class GraphQLClient_GraphQLClient {
    url;
    requestConfig;
    constructor(url, requestConfig = {}) {
        this.url = url;
        this.requestConfig = requestConfig;
    }
    /**
     * Send a GraphQL query to the server.
     */
    rawRequest = async (...args) => {
        const [queryOrOptions, variables, requestHeaders] = args;
        const rawRequestOptions = parseRawRequestArgs(queryOrOptions, variables, requestHeaders);
        const { headers, fetch = globalThis.fetch, method = `POST`, requestMiddleware, responseMiddleware, excludeOperationName, ...fetchOptions } = this.requestConfig;
        const { url } = this;
        if (rawRequestOptions.signal !== undefined) {
            fetchOptions.signal = rawRequestOptions.signal;
        }
        const document = analyzeDocument(rawRequestOptions.query, excludeOperationName);
        const response = await runRequest({
            url,
            request: {
                _tag: `Single`,
                document,
                variables: rawRequestOptions.variables,
            },
            headers: {
                ...HeadersInitToPlainObject(callOrIdentity(headers)),
                ...HeadersInitToPlainObject(rawRequestOptions.requestHeaders),
            },
            fetch,
            method,
            fetchOptions,
            middleware: requestMiddleware,
        });
        if (responseMiddleware) {
            await responseMiddleware(response, {
                operationName: document.operationName,
                variables,
                url: this.url,
            });
        }
        if (response instanceof Error) {
            throw response;
        }
        return response;
    };
    async request(documentOrOptions, ...variablesAndRequestHeaders) {
        const [variables, requestHeaders] = variablesAndRequestHeaders;
        const requestOptions = parseRequestArgs(documentOrOptions, variables, requestHeaders);
        const { headers, fetch = globalThis.fetch, method = `POST`, requestMiddleware, responseMiddleware, excludeOperationName, ...fetchOptions } = this.requestConfig;
        const { url } = this;
        if (requestOptions.signal !== undefined) {
            fetchOptions.signal = requestOptions.signal;
        }
        const analyzedDocument = analyzeDocument(requestOptions.document, excludeOperationName);
        const response = await runRequest({
            url,
            request: {
                _tag: `Single`,
                document: analyzedDocument,
                variables: requestOptions.variables,
            },
            headers: {
                ...HeadersInitToPlainObject(callOrIdentity(headers)),
                ...HeadersInitToPlainObject(requestOptions.requestHeaders),
            },
            fetch,
            method,
            fetchOptions,
            middleware: requestMiddleware,
        });
        if (responseMiddleware) {
            await responseMiddleware(response, {
                operationName: analyzedDocument.operationName,
                variables: requestOptions.variables,
                url: this.url,
            });
        }
        if (response instanceof Error) {
            throw response;
        }
        return response.data;
    }
    async batchRequests(documentsOrOptions, requestHeaders) {
        const batchRequestOptions = parseBatchRequestArgs(documentsOrOptions, requestHeaders);
        const { headers, excludeOperationName, ...fetchOptions } = this.requestConfig;
        if (batchRequestOptions.signal !== undefined) {
            fetchOptions.signal = batchRequestOptions.signal;
        }
        const analyzedDocuments = batchRequestOptions.documents.map(({ document }) => analyzeDocument(document, excludeOperationName));
        const expressions = analyzedDocuments.map(({ expression }) => expression);
        const hasMutations = analyzedDocuments.some(({ isMutation }) => isMutation);
        const variables = batchRequestOptions.documents.map(({ variables }) => variables);
        const response = await runRequest({
            url: this.url,
            request: {
                _tag: `Batch`,
                operationName: undefined,
                query: expressions,
                hasMutations,
                variables,
            },
            headers: {
                ...HeadersInitToPlainObject(callOrIdentity(headers)),
                ...HeadersInitToPlainObject(batchRequestOptions.requestHeaders),
            },
            fetch: this.requestConfig.fetch ?? globalThis.fetch,
            method: this.requestConfig.method || `POST`,
            fetchOptions,
            middleware: this.requestConfig.requestMiddleware,
        });
        if (this.requestConfig.responseMiddleware) {
            await this.requestConfig.responseMiddleware(response, {
                operationName: undefined,
                variables,
                url: this.url,
            });
        }
        if (response instanceof Error) {
            throw response;
        }
        return response.data;
    }
    setHeaders(headers) {
        this.requestConfig.headers = headers;
        return this;
    }
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */
    setHeader(key, value) {
        const { headers } = this.requestConfig;
        if (headers) {
            // todo what if headers is in nested array form... ?
            // @ts-expect-error todo
            headers[key] = value;
        }
        else {
            this.requestConfig.headers = { [key]: value };
        }
        return this;
    }
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */
    setEndpoint(value) {
        this.url = value;
        return this;
    }
}
//# sourceMappingURL=GraphQLClient.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql-request@7.4.0_graphql@16.14.0/node_modules/graphql-request/build/legacy/functions/request.js

// dprint-ignore
// eslint-disable-next-line
async function request_request(urlOrOptions, document, ...variablesAndRequestHeaders) {
    const requestOptions = parseRequestExtendedArgs(urlOrOptions, document, ...variablesAndRequestHeaders);
    const client = new GraphQLClient(requestOptions.url);
    return client.request({
        ...requestOptions,
    });
}
const parseRequestArgs = (documentOrOptions, variables, requestHeaders) => {
    return documentOrOptions.document
        ? documentOrOptions
        : {
            document: documentOrOptions,
            variables: variables,
            requestHeaders: requestHeaders,
            signal: undefined,
        };
};
const parseRequestExtendedArgs = (urlOrOptions, document, ...variablesAndRequestHeaders) => {
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return typeof urlOrOptions === `string`
        ? {
            url: urlOrOptions,
            document: document,
            variables,
            requestHeaders,
            signal: undefined,
        }
        : urlOrOptions;
};
//# sourceMappingURL=request.js.map
;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql-request@7.4.0_graphql@16.14.0/node_modules/graphql-request/build/entrypoints/main.js








/* harmony default export */ var main = ((/* unused pure expression or super */ null && (request)));
//# sourceMappingURL=main.js.map

/***/ }),

/***/ 65408:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ devAssert; }
/* harmony export */ });
function devAssert(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(message);
  }
}


/***/ }),

/***/ 49993:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ inspect; }
/* harmony export */ });
const MAX_ARRAY_LENGTH = 10;
const MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (typeof value) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? `[function ${value.name}]` : '[function]';

    case 'object':
      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (value === null) {
    return 'null';
  }

  if (previouslySeenValues.includes(value)) {
    return '[Circular]';
  }

  const seenValues = [...previouslySeenValues, value];

  if (isJSONable(value)) {
    const jsonValue = value.toJSON(); // check for infinite recursion

    if (jsonValue !== value) {
      return typeof jsonValue === 'string'
        ? jsonValue
        : formatValue(jsonValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function isJSONable(value) {
  return typeof value.toJSON === 'function';
}

function formatObject(object, seenValues) {
  const entries = Object.entries(object);

  if (entries.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  const properties = entries.map(
    ([key, value]) => key + ': ' + formatValue(value, seenValues),
  );
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  const len = Math.min(MAX_ARRAY_LENGTH, array.length);
  const remaining = array.length - len;
  const items = [];

  for (let i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push(`... ${remaining} more items`);
  }

  return '[' + items.join(', ') + ']';
}

function getObjectTag(object) {
  const tag = Object.prototype.toString
    .call(object)
    .replace(/^\[object /, '')
    .replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    const name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}


/***/ }),

/***/ 63452:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UG": function() { return /* binding */ isNode; },
/* harmony export */   "WU": function() { return /* binding */ Token; },
/* harmony export */   "Ye": function() { return /* binding */ Location; },
/* harmony export */   "h8": function() { return /* binding */ QueryDocumentKeys; },
/* harmony export */   "ku": function() { return /* binding */ OperationTypeNode; }
/* harmony export */ });
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
class Location {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  constructor(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  get [Symbol.toStringTag]() {
    return 'Location';
  }

  toJSON() {
    return {
      start: this.start,
      end: this.end,
    };
  }
}
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

class Token {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(kind, start, end, line, column, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

    this.value = value;
    this.prev = null;
    this.next = null;
  }

  get [Symbol.toStringTag]() {
    return 'Token';
  }

  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column,
    };
  }
}
/**
 * The list of all possible AST node types.
 */

/**
 * @internal
 */
const QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: [
    'description',
    'name',
    'variableDefinitions',
    'directives',
    'selectionSet',
  ],
  VariableDefinition: [
    'description',
    'variable',
    'type',
    'defaultValue',
    'directives',
  ],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: [
    'description',
    'name', // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    'variableDefinitions',
    'typeCondition',
    'directives',
    'selectionSet',
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['description', 'directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: [
    'description',
    'name',
    'type',
    'defaultValue',
    'directives',
  ],
  InterfaceTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: [
    'description',
    'name',
    'arguments',
    'directives',
    'locations',
  ],
  SchemaExtension: ['directives', 'operationTypes'],
  DirectiveExtension: ['name', 'directives'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields'],
  TypeCoordinate: ['name'],
  MemberCoordinate: ['name', 'memberName'],
  ArgumentCoordinate: ['name', 'fieldName', 'argumentName'],
  DirectiveCoordinate: ['name'],
  DirectiveArgumentCoordinate: ['name', 'argumentName'],
};
const kindValues = new Set(Object.keys(QueryDocumentKeys));
/**
 * @internal
 */

function isNode(maybeNode) {
  const maybeKind =
    maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
  return typeof maybeKind === 'string' && kindValues.has(maybeKind);
}
/** Name */

var OperationTypeNode;

(function (OperationTypeNode) {
  OperationTypeNode['QUERY'] = 'query';
  OperationTypeNode['MUTATION'] = 'mutation';
  OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})(OperationTypeNode || (OperationTypeNode = {}));




/***/ }),

/***/ 95317:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LZ": function() { return /* binding */ printBlockString; },
/* harmony export */   "wv": function() { return /* binding */ dedentBlockStringLines; }
/* harmony export */ });
/* unused harmony export isPrintableAsBlockString */
/* harmony import */ var _characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96583);

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */

function dedentBlockStringLines(lines) {
  var _firstNonEmptyLine2;

  let commonIndent = Number.MAX_SAFE_INTEGER;
  let firstNonEmptyLine = null;
  let lastNonEmptyLine = -1;

  for (let i = 0; i < lines.length; ++i) {
    var _firstNonEmptyLine;

    const line = lines[i];
    const indent = leadingWhitespace(line);

    if (indent === line.length) {
      continue; // skip empty lines
    }

    firstNonEmptyLine =
      (_firstNonEmptyLine = firstNonEmptyLine) !== null &&
      _firstNonEmptyLine !== void 0
        ? _firstNonEmptyLine
        : i;
    lastNonEmptyLine = i;

    if (i !== 0 && indent < commonIndent) {
      commonIndent = indent;
    }
  }

  return lines // Remove common indentation from all lines but first.
    .map((line, i) => (i === 0 ? line : line.slice(commonIndent))) // Remove leading and trailing blank lines.
    .slice(
      (_firstNonEmptyLine2 = firstNonEmptyLine) !== null &&
        _firstNonEmptyLine2 !== void 0
        ? _firstNonEmptyLine2
        : 0,
      lastNonEmptyLine + 1,
    );
}

function leadingWhitespace(str) {
  let i = 0;

  while (i < str.length && (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */ .FD)(str.charCodeAt(i))) {
    ++i;
  }

  return i;
}
/**
 * @internal
 */

function isPrintableAsBlockString(value) {
  if (value === '') {
    return true; // empty string is printable
  }

  let isEmptyLine = true;
  let hasIndent = false;
  let hasCommonIndent = true;
  let seenNonEmptyLine = false;

  for (let i = 0; i < value.length; ++i) {
    switch (value.codePointAt(i)) {
      case 0x0000:
      case 0x0001:
      case 0x0002:
      case 0x0003:
      case 0x0004:
      case 0x0005:
      case 0x0006:
      case 0x0007:
      case 0x0008:
      case 0x000b:
      case 0x000c:
      case 0x000e:
      case 0x000f:
        return false;
      // Has non-printable characters

      case 0x000d:
        //  \r
        return false;
      // Has \r or \r\n which will be replaced as \n

      case 10:
        //  \n
        if (isEmptyLine && !seenNonEmptyLine) {
          return false; // Has leading new line
        }

        seenNonEmptyLine = true;
        isEmptyLine = true;
        hasIndent = false;
        break;

      case 9: //   \t

      case 32:
        //  <space>
        hasIndent || (hasIndent = isEmptyLine);
        break;

      default:
        hasCommonIndent && (hasCommonIndent = hasIndent);
        isEmptyLine = false;
    }
  }

  if (isEmptyLine) {
    return false; // Has trailing empty lines
  }

  if (hasCommonIndent && seenNonEmptyLine) {
    return false; // Has internal indent
  }

  return true;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */

function printBlockString(value, options) {
  const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.

  const lines = escapedValue.split(/\r\n|[\n\r]/g);
  const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line

  const forceLeadingNewLine =
    lines.length > 1 &&
    lines
      .slice(1)
      .every((line) => line.length === 0 || (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */ .FD)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line

  const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line

  const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
  const hasTrailingSlash = value.endsWith('\\');
  const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
  const printAsMultipleLines =
    !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine ||
      value.length > 70 ||
      forceTrailingNewline ||
      forceLeadingNewLine ||
      hasTrailingTripleQuotes);
  let result = ''; // Format a multi-line block quote to account for leading space.

  const skipLeadingNewLine = isSingleLine && (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */ .FD)(value.charCodeAt(0));

  if ((printAsMultipleLines && !skipLeadingNewLine) || forceLeadingNewLine) {
    result += '\n';
  }

  result += escapedValue;

  if (printAsMultipleLines || forceTrailingNewline) {
    result += '\n';
  }

  return '"""' + result + '"""';
}


/***/ }),

/***/ 96583:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FD": function() { return /* binding */ isWhiteSpace; },
/* harmony export */   "HQ": function() { return /* binding */ isNameContinue; },
/* harmony export */   "LQ": function() { return /* binding */ isNameStart; },
/* harmony export */   "X1": function() { return /* binding */ isDigit; }
/* harmony export */ });
/* unused harmony export isLetter */
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */
function isWhiteSpace(code) {
  return code === 0x0009 || code === 0x0020;
}
/**
 * ```
 * Digit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 * ```
 * @internal
 */

function isDigit(code) {
  return code >= 0x0030 && code <= 0x0039;
}
/**
 * ```
 * Letter :: one of
 *   - `A` `B` `C` `D` `E` `F` `G` `H` `I` `J` `K` `L` `M`
 *   - `N` `O` `P` `Q` `R` `S` `T` `U` `V` `W` `X` `Y` `Z`
 *   - `a` `b` `c` `d` `e` `f` `g` `h` `i` `j` `k` `l` `m`
 *   - `n` `o` `p` `q` `r` `s` `t` `u` `v` `w` `x` `y` `z`
 * ```
 * @internal
 */

function isLetter(code) {
  return (
    (code >= 0x0061 && code <= 0x007a) || // A-Z
    (code >= 0x0041 && code <= 0x005a) // a-z
  );
}
/**
 * ```
 * NameStart ::
 *   - Letter
 *   - `_`
 * ```
 * @internal
 */

function isNameStart(code) {
  return isLetter(code) || code === 0x005f;
}
/**
 * ```
 * NameContinue ::
 *   - Letter
 *   - Digit
 *   - `_`
 * ```
 * @internal
 */

function isNameContinue(code) {
  return isLetter(code) || isDigit(code) || code === 0x005f;
}


/***/ }),

/***/ 5387:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Kind; }
/* harmony export */ });
/**
 * The set of allowed kind values for AST nodes.
 */
var Kind;

(function (Kind) {
  Kind['NAME'] = 'Name';
  Kind['DOCUMENT'] = 'Document';
  Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
  Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
  Kind['SELECTION_SET'] = 'SelectionSet';
  Kind['FIELD'] = 'Field';
  Kind['ARGUMENT'] = 'Argument';
  Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
  Kind['INLINE_FRAGMENT'] = 'InlineFragment';
  Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
  Kind['VARIABLE'] = 'Variable';
  Kind['INT'] = 'IntValue';
  Kind['FLOAT'] = 'FloatValue';
  Kind['STRING'] = 'StringValue';
  Kind['BOOLEAN'] = 'BooleanValue';
  Kind['NULL'] = 'NullValue';
  Kind['ENUM'] = 'EnumValue';
  Kind['LIST'] = 'ListValue';
  Kind['OBJECT'] = 'ObjectValue';
  Kind['OBJECT_FIELD'] = 'ObjectField';
  Kind['DIRECTIVE'] = 'Directive';
  Kind['NAMED_TYPE'] = 'NamedType';
  Kind['LIST_TYPE'] = 'ListType';
  Kind['NON_NULL_TYPE'] = 'NonNullType';
  Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
  Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
  Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
  Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
  Kind['FIELD_DEFINITION'] = 'FieldDefinition';
  Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
  Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
  Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
  Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
  Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
  Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
  Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
  Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
  Kind['DIRECTIVE_EXTENSION'] = 'DirectiveExtension';
  Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
  Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
  Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
  Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
  Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
  Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
  Kind['TYPE_COORDINATE'] = 'TypeCoordinate';
  Kind['MEMBER_COORDINATE'] = 'MemberCoordinate';
  Kind['ARGUMENT_COORDINATE'] = 'ArgumentCoordinate';
  Kind['DIRECTIVE_COORDINATE'] = 'DirectiveCoordinate';
  Kind['DIRECTIVE_ARGUMENT_COORDINATE'] = 'DirectiveArgumentCoordinate';
})(Kind || (Kind = {}));


/**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */


/***/ }),

/***/ 54398:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Qc": function() { return /* binding */ parse; }
});

// UNUSED EXPORTS: Parser, parseConstValue, parseSchemaCoordinate, parseType, parseValue

;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/jsutils/isObjectLike.mjs
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return typeof value == 'object' && value !== null;
}

;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/jsutils/invariant.mjs
function invariant(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(
      message != null ? message : 'Unexpected invariant triggered.',
    );
  }
}

;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/language/location.mjs

const LineRegExp = /\r\n|[\n\r]/g;
/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  let lastLineStart = 0;
  let line = 1;

  for (const match of source.body.matchAll(LineRegExp)) {
    typeof match.index === 'number' || invariant(false);

    if (match.index >= position) {
      break;
    }

    lastLineStart = match.index + match[0].length;
    line += 1;
  }

  return {
    line,
    column: position + 1 - lastLineStart,
  };
}

;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/language/printLocation.mjs


/**
 * Render a helpful description of the location in the GraphQL Source document.
 */
function printLocation(location) {
  return printSourceLocation(
    location.source,
    getLocation(location.source, location.start),
  );
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  const firstLineColumnOffset = source.locationOffset.column - 1;
  const body = ''.padStart(firstLineColumnOffset) + source.body;
  const lineIndex = sourceLocation.line - 1;
  const lineOffset = source.locationOffset.line - 1;
  const lineNum = sourceLocation.line + lineOffset;
  const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  const columnNum = sourceLocation.column + columnOffset;
  const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
  const lines = body.split(/\r\n|[\n\r]/g);
  const locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    const subLineIndex = Math.floor(columnNum / 80);
    const subLineColumnNum = columnNum % 80;
    const subLines = [];

    for (let i = 0; i < locationLine.length; i += 80) {
      subLines.push(locationLine.slice(i, i + 80));
    }

    return (
      locationStr +
      printPrefixedLines([
        [`${lineNum} |`, subLines[0]],
        ...subLines.slice(1, subLineIndex + 1).map((subLine) => ['|', subLine]),
        ['|', '^'.padStart(subLineColumnNum)],
        ['|', subLines[subLineIndex + 1]],
      ])
    );
  }

  return (
    locationStr +
    printPrefixedLines([
      // Lines specified like this: ["prefix", "string"],
      [`${lineNum - 1} |`, lines[lineIndex - 1]],
      [`${lineNum} |`, locationLine],
      ['|', '^'.padStart(columnNum)],
      [`${lineNum + 1} |`, lines[lineIndex + 1]],
    ])
  );
}

function printPrefixedLines(lines) {
  const existingLines = lines.filter(([_, line]) => line !== undefined);
  const padLen = Math.max(...existingLines.map(([prefix]) => prefix.length));
  return existingLines
    .map(([prefix, line]) => prefix.padStart(padLen) + (line ? ' ' + line : ''))
    .join('\n');
}

;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/error/GraphQLError.mjs




function toNormalizedOptions(args) {
  const firstArg = args[0];

  if (firstArg == null || 'kind' in firstArg || 'length' in firstArg) {
    return {
      nodes: firstArg,
      source: args[1],
      positions: args[2],
      path: args[3],
      originalError: args[4],
      extensions: args[5],
    };
  }

  return firstArg;
}
/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

class GraphQLError extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */

  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(message, ...rawArgs) {
    var _this$nodes, _nodeLocations$, _ref;

    const { nodes, source, positions, path, originalError, extensions } =
      toNormalizedOptions(rawArgs);
    super(message);
    this.name = 'GraphQLError';
    this.path = path !== null && path !== void 0 ? path : undefined;
    this.originalError =
      originalError !== null && originalError !== void 0
        ? originalError
        : undefined; // Compute list of blame nodes.

    this.nodes = undefinedIfEmpty(
      Array.isArray(nodes) ? nodes : nodes ? [nodes] : undefined,
    );
    const nodeLocations = undefinedIfEmpty(
      (_this$nodes = this.nodes) === null || _this$nodes === void 0
        ? void 0
        : _this$nodes.map((node) => node.loc).filter((loc) => loc != null),
    ); // Compute locations in the source for the given nodes/positions.

    this.source =
      source !== null && source !== void 0
        ? source
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : (_nodeLocations$ = nodeLocations[0]) === null ||
          _nodeLocations$ === void 0
        ? void 0
        : _nodeLocations$.source;
    this.positions =
      positions !== null && positions !== void 0
        ? positions
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => loc.start);
    this.locations =
      positions && source
        ? positions.map((pos) => getLocation(source, pos))
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => getLocation(loc.source, loc.start));
    const originalExtensions = isObjectLike(
      originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions,
    )
      ? originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions
      : undefined;
    this.extensions =
      (_ref =
        extensions !== null && extensions !== void 0
          ? extensions
          : originalExtensions) !== null && _ref !== void 0
        ? _ref
        : Object.create(null); // Only properties prescribed by the spec should be enumerable.
    // Keep the rest as non-enumerable.

    Object.defineProperties(this, {
      message: {
        writable: true,
        enumerable: true,
      },
      name: {
        enumerable: false,
      },
      nodes: {
        enumerable: false,
      },
      source: {
        enumerable: false,
      },
      positions: {
        enumerable: false,
      },
      originalError: {
        enumerable: false,
      },
    }); // Include (non-enumerable) stack trace.

    /* c8 ignore start */
    // FIXME: https://github.com/graphql/graphql-js/issues/2317

    if (
      originalError !== null &&
      originalError !== void 0 &&
      originalError.stack
    ) {
      Object.defineProperty(this, 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true,
      });
    } else if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GraphQLError);
    } else {
      Object.defineProperty(this, 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true,
      });
    }
    /* c8 ignore stop */
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLError';
  }

  toString() {
    let output = this.message;

    if (this.nodes) {
      for (const node of this.nodes) {
        if (node.loc) {
          output += '\n\n' + printLocation(node.loc);
        }
      }
    } else if (this.source && this.locations) {
      for (const location of this.locations) {
        output += '\n\n' + printSourceLocation(this.source, location);
      }
    }

    return output;
  }

  toJSON() {
    const formattedError = {
      message: this.message,
    };

    if (this.locations != null) {
      formattedError.locations = this.locations;
    }

    if (this.path != null) {
      formattedError.path = this.path;
    }

    if (this.extensions != null && Object.keys(this.extensions).length > 0) {
      formattedError.extensions = this.extensions;
    }

    return formattedError;
  }
}

function undefinedIfEmpty(array) {
  return array === undefined || array.length === 0 ? undefined : array;
}
/**
 * See: https://spec.graphql.org/draft/#sec-Errors
 */

/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 *
 * @deprecated Please use `error.toString` instead. Will be removed in v17
 */
function printError(error) {
  return error.toString();
}
/**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 *
 * @deprecated Please use `error.toJSON` instead. Will be removed in v17
 */

function formatError(error) {
  return error.toJSON();
}

;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/error/syntaxError.mjs

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new GraphQLError(`Syntax Error: ${description}`, {
    source,
    positions: [position],
  });
}

// EXTERNAL MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/language/ast.mjs
var ast = __webpack_require__(63452);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/language/directiveLocation.mjs
/**
 * The set of allowed directive location values.
 */
var DirectiveLocation;

(function (DirectiveLocation) {
  DirectiveLocation['QUERY'] = 'QUERY';
  DirectiveLocation['MUTATION'] = 'MUTATION';
  DirectiveLocation['SUBSCRIPTION'] = 'SUBSCRIPTION';
  DirectiveLocation['FIELD'] = 'FIELD';
  DirectiveLocation['FRAGMENT_DEFINITION'] = 'FRAGMENT_DEFINITION';
  DirectiveLocation['FRAGMENT_SPREAD'] = 'FRAGMENT_SPREAD';
  DirectiveLocation['INLINE_FRAGMENT'] = 'INLINE_FRAGMENT';
  DirectiveLocation['VARIABLE_DEFINITION'] = 'VARIABLE_DEFINITION';
  DirectiveLocation['SCHEMA'] = 'SCHEMA';
  DirectiveLocation['SCALAR'] = 'SCALAR';
  DirectiveLocation['OBJECT'] = 'OBJECT';
  DirectiveLocation['FIELD_DEFINITION'] = 'FIELD_DEFINITION';
  DirectiveLocation['ARGUMENT_DEFINITION'] = 'ARGUMENT_DEFINITION';
  DirectiveLocation['INTERFACE'] = 'INTERFACE';
  DirectiveLocation['UNION'] = 'UNION';
  DirectiveLocation['ENUM'] = 'ENUM';
  DirectiveLocation['ENUM_VALUE'] = 'ENUM_VALUE';
  DirectiveLocation['INPUT_OBJECT'] = 'INPUT_OBJECT';
  DirectiveLocation['INPUT_FIELD_DEFINITION'] = 'INPUT_FIELD_DEFINITION';
  DirectiveLocation['DIRECTIVE_DEFINITION'] = 'DIRECTIVE_DEFINITION';
})(DirectiveLocation || (DirectiveLocation = {}));


/**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */

// EXTERNAL MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(5387);
// EXTERNAL MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(95317);
// EXTERNAL MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/language/characterClasses.mjs
var characterClasses = __webpack_require__(96583);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/language/tokenKind.mjs
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var tokenKind_TokenKind;

(function (TokenKind) {
  TokenKind['SOF'] = '<SOF>';
  TokenKind['EOF'] = '<EOF>';
  TokenKind['BANG'] = '!';
  TokenKind['DOLLAR'] = '$';
  TokenKind['AMP'] = '&';
  TokenKind['PAREN_L'] = '(';
  TokenKind['PAREN_R'] = ')';
  TokenKind['DOT'] = '.';
  TokenKind['SPREAD'] = '...';
  TokenKind['COLON'] = ':';
  TokenKind['EQUALS'] = '=';
  TokenKind['AT'] = '@';
  TokenKind['BRACKET_L'] = '[';
  TokenKind['BRACKET_R'] = ']';
  TokenKind['BRACE_L'] = '{';
  TokenKind['PIPE'] = '|';
  TokenKind['BRACE_R'] = '}';
  TokenKind['NAME'] = 'Name';
  TokenKind['INT'] = 'Int';
  TokenKind['FLOAT'] = 'Float';
  TokenKind['STRING'] = 'String';
  TokenKind['BLOCK_STRING'] = 'BlockString';
  TokenKind['COMMENT'] = 'Comment';
})(tokenKind_TokenKind || (tokenKind_TokenKind = {}));


/**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */

;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/language/lexer.mjs





/**
 * A Lexer interface which provides common properties and methods required for
 * lexing GraphQL source.
 *
 * @internal
 */

/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */
class Lexer {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  constructor(source) {
    const startOfFileToken = new ast/* Token */.WU(tokenKind_TokenKind.SOF, 0, 0, 0, 0);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }

  get [Symbol.toStringTag]() {
    return 'Lexer';
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */

  advance() {
    this.lastToken = this.token;
    const token = (this.token = this.lookahead());
    return token;
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */

  lookahead() {
    let token = this.token;

    if (token.kind !== tokenKind_TokenKind.EOF) {
      do {
        if (token.next) {
          token = token.next;
        } else {
          // Read the next token and form a link in the token linked-list.
          const nextToken = readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.

          token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.

          nextToken.prev = token;
          token = nextToken;
        }
      } while (token.kind === tokenKind_TokenKind.COMMENT);
    }

    return token;
  }
}
/**
 * @internal
 */

function isPunctuatorTokenKind(kind) {
  return (
    kind === tokenKind_TokenKind.BANG ||
    kind === tokenKind_TokenKind.DOLLAR ||
    kind === tokenKind_TokenKind.AMP ||
    kind === tokenKind_TokenKind.PAREN_L ||
    kind === tokenKind_TokenKind.PAREN_R ||
    kind === tokenKind_TokenKind.DOT ||
    kind === tokenKind_TokenKind.SPREAD ||
    kind === tokenKind_TokenKind.COLON ||
    kind === tokenKind_TokenKind.EQUALS ||
    kind === tokenKind_TokenKind.AT ||
    kind === tokenKind_TokenKind.BRACKET_L ||
    kind === tokenKind_TokenKind.BRACKET_R ||
    kind === tokenKind_TokenKind.BRACE_L ||
    kind === tokenKind_TokenKind.PIPE ||
    kind === tokenKind_TokenKind.BRACE_R
  );
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */

function isUnicodeScalarValue(code) {
  return (
    (code >= 0x0000 && code <= 0xd7ff) || (code >= 0xe000 && code <= 0x10ffff)
  );
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */

function isSupplementaryCodePoint(body, location) {
  return (
    isLeadingSurrogate(body.charCodeAt(location)) &&
    isTrailingSurrogate(body.charCodeAt(location + 1))
  );
}

function isLeadingSurrogate(code) {
  return code >= 0xd800 && code <= 0xdbff;
}

function isTrailingSurrogate(code) {
  return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 *
 * @internal
 */

function printCodePointAt(lexer, location) {
  const code = lexer.source.body.codePointAt(location);

  if (code === undefined) {
    return tokenKind_TokenKind.EOF;
  } else if (code >= 0x0020 && code <= 0x007e) {
    // Printable ASCII
    const char = String.fromCodePoint(code);
    return char === '"' ? "'\"'" : `"${char}"`;
  } // Unicode code point

  return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}
/**
 * Create a token with line and column location information.
 *
 * @internal
 */

function createToken(lexer, kind, start, end, value) {
  const line = lexer.line;
  const col = 1 + start - lexer.lineStart;
  return new ast/* Token */.WU(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */

function readNextToken(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // SourceCharacter

    switch (code) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 0xfeff: // <BOM>

      case 0x0009: // \t

      case 0x0020: // <space>

      case 0x002c:
        // ,
        ++position;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"

      case 0x000a:
        // \n
        ++position;
        ++lexer.line;
        lexer.lineStart = position;
        continue;

      case 0x000d:
        // \r
        if (body.charCodeAt(position + 1) === 0x000a) {
          position += 2;
        } else {
          ++position;
        }

        ++lexer.line;
        lexer.lineStart = position;
        continue;
      // Comment

      case 0x0023:
        // #
        return readComment(lexer, position);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }

      case 0x0021:
        // !
        return createToken(lexer, tokenKind_TokenKind.BANG, position, position + 1);

      case 0x0024:
        // $
        return createToken(lexer, tokenKind_TokenKind.DOLLAR, position, position + 1);

      case 0x0026:
        // &
        return createToken(lexer, tokenKind_TokenKind.AMP, position, position + 1);

      case 0x0028:
        // (
        return createToken(lexer, tokenKind_TokenKind.PAREN_L, position, position + 1);

      case 0x0029:
        // )
        return createToken(lexer, tokenKind_TokenKind.PAREN_R, position, position + 1);

      case 0x002e:
        // .
        if (
          body.charCodeAt(position + 1) === 0x002e &&
          body.charCodeAt(position + 2) === 0x002e
        ) {
          return createToken(lexer, tokenKind_TokenKind.SPREAD, position, position + 3);
        }

        break;

      case 0x003a:
        // :
        return createToken(lexer, tokenKind_TokenKind.COLON, position, position + 1);

      case 0x003d:
        // =
        return createToken(lexer, tokenKind_TokenKind.EQUALS, position, position + 1);

      case 0x0040:
        // @
        return createToken(lexer, tokenKind_TokenKind.AT, position, position + 1);

      case 0x005b:
        // [
        return createToken(lexer, tokenKind_TokenKind.BRACKET_L, position, position + 1);

      case 0x005d:
        // ]
        return createToken(lexer, tokenKind_TokenKind.BRACKET_R, position, position + 1);

      case 0x007b:
        // {
        return createToken(lexer, tokenKind_TokenKind.BRACE_L, position, position + 1);

      case 0x007c:
        // |
        return createToken(lexer, tokenKind_TokenKind.PIPE, position, position + 1);

      case 0x007d:
        // }
        return createToken(lexer, tokenKind_TokenKind.BRACE_R, position, position + 1);
      // StringValue

      case 0x0022:
        // "
        if (
          body.charCodeAt(position + 1) === 0x0022 &&
          body.charCodeAt(position + 2) === 0x0022
        ) {
          return readBlockString(lexer, position);
        }

        return readString(lexer, position);
    } // IntValue | FloatValue (Digit | -)

    if ((0,characterClasses/* isDigit */.X1)(code) || code === 0x002d) {
      return readNumber(lexer, position, code);
    } // Name

    if ((0,characterClasses/* isNameStart */.LQ)(code)) {
      return readName(lexer, position);
    }

    throw syntaxError(
      lexer.source,
      position,
      code === 0x0027
        ? 'Unexpected single quote character (\'), did you mean to use a double quote (")?'
        : isUnicodeScalarValue(code) || isSupplementaryCodePoint(body, position)
        ? `Unexpected character: ${printCodePointAt(lexer, position)}.`
        : `Invalid character: ${printCodePointAt(lexer, position)}.`,
    );
  }

  return createToken(lexer, tokenKind_TokenKind.EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */

function readComment(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    tokenKind_TokenKind.COMMENT,
    start,
    position,
    body.slice(start + 1, position),
  );
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */

function readNumber(lexer, start, firstCode) {
  const body = lexer.source.body;
  let position = start;
  let code = firstCode;
  let isFloat = false; // NegativeSign (-)

  if (code === 0x002d) {
    code = body.charCodeAt(++position);
  } // Zero (0)

  if (code === 0x0030) {
    code = body.charCodeAt(++position);

    if ((0,characterClasses/* isDigit */.X1)(code)) {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid number, unexpected digit after 0: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  } else {
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Full stop (.)

  if (code === 0x002e) {
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // E e

  if (code === 0x0045 || code === 0x0065) {
    isFloat = true;
    code = body.charCodeAt(++position); // + -

    if (code === 0x002b || code === 0x002d) {
      code = body.charCodeAt(++position);
    }

    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or NameStart

  if (code === 0x002e || (0,characterClasses/* isNameStart */.LQ)(code)) {
    throw syntaxError(
      lexer.source,
      position,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        position,
      )}.`,
    );
  }

  return createToken(
    lexer,
    isFloat ? tokenKind_TokenKind.FLOAT : tokenKind_TokenKind.INT,
    start,
    position,
    body.slice(start, position),
  );
}
/**
 * Returns the new position in the source after reading one or more digits.
 */

function readDigits(lexer, start, firstCode) {
  if (!(0,characterClasses/* isDigit */.X1)(firstCode)) {
    throw syntaxError(
      lexer.source,
      start,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        start,
      )}.`,
    );
  }

  const body = lexer.source.body;
  let position = start + 1; // +1 to skip first firstCode

  while ((0,characterClasses/* isDigit */.X1)(body.charCodeAt(position))) {
    ++position;
  }

  return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */

function readString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;
  let chunkStart = position;
  let value = '';

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Quote (")

    if (code === 0x0022) {
      value += body.slice(chunkStart, position);
      return createToken(lexer, tokenKind_TokenKind.STRING, start, position + 1, value);
    } // Escape Sequence (\)

    if (code === 0x005c) {
      value += body.slice(chunkStart, position);
      const escape =
        body.charCodeAt(position + 1) === 0x0075 // u
          ? body.charCodeAt(position + 2) === 0x007b // {
            ? readEscapedUnicodeVariableWidth(lexer, position)
            : readEscapedUnicodeFixedWidth(lexer, position)
          : readEscapedCharacter(lexer, position);
      value += escape.value;
      position += escape.size;
      chunkStart = position;
      continue;
    } // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
} // The string value and lexed size of an escape sequence.

function readEscapedUnicodeVariableWidth(lexer, position) {
  const body = lexer.source.body;
  let point = 0;
  let size = 3; // Cannot be larger than 12 chars (\u{00000000}).

  while (size < 12) {
    const code = body.charCodeAt(position + size++); // Closing Brace (})

    if (code === 0x007d) {
      // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
      if (size < 5 || !isUnicodeScalarValue(point)) {
        break;
      }

      return {
        value: String.fromCodePoint(point),
        size,
      };
    } // Append this hex digit to the code point.

    point = (point << 4) | readHexDigit(code);

    if (point < 0) {
      break;
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(
      position,
      position + size,
    )}".`,
  );
}

function readEscapedUnicodeFixedWidth(lexer, position) {
  const body = lexer.source.body;
  const code = read16BitHexCode(body, position + 2);

  if (isUnicodeScalarValue(code)) {
    return {
      value: String.fromCodePoint(code),
      size: 6,
    };
  } // GraphQL allows JSON-style surrogate pair escape sequences, but only when
  // a valid pair is formed.

  if (isLeadingSurrogate(code)) {
    // \u
    if (
      body.charCodeAt(position + 6) === 0x005c &&
      body.charCodeAt(position + 7) === 0x0075
    ) {
      const trailingCode = read16BitHexCode(body, position + 8);

      if (isTrailingSurrogate(trailingCode)) {
        // JavaScript defines strings as a sequence of UTF-16 code units and
        // encodes Unicode code points above U+FFFF using a surrogate pair of
        // code units. Since this is a surrogate pair escape sequence, just
        // include both codes into the JavaScript string value. Had JavaScript
        // not been internally based on UTF-16, then this surrogate pair would
        // be decoded to retrieve the supplementary code point.
        return {
          value: String.fromCodePoint(code, trailingCode),
          size: 12,
        };
      }
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`,
  );
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */

function read16BitHexCode(body, position) {
  // readHexDigit() returns -1 on error. ORing a negative value with any other
  // value always produces a negative value.
  return (
    (readHexDigit(body.charCodeAt(position)) << 12) |
    (readHexDigit(body.charCodeAt(position + 1)) << 8) |
    (readHexDigit(body.charCodeAt(position + 2)) << 4) |
    readHexDigit(body.charCodeAt(position + 3))
  );
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */

function readHexDigit(code) {
  return code >= 0x0030 && code <= 0x0039 // 0-9
    ? code - 0x0030
    : code >= 0x0041 && code <= 0x0046 // A-F
    ? code - 0x0037
    : code >= 0x0061 && code <= 0x0066 // a-f
    ? code - 0x0057
    : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */

function readEscapedCharacter(lexer, position) {
  const body = lexer.source.body;
  const code = body.charCodeAt(position + 1);

  switch (code) {
    case 0x0022:
      // "
      return {
        value: '\u0022',
        size: 2,
      };

    case 0x005c:
      // \
      return {
        value: '\u005c',
        size: 2,
      };

    case 0x002f:
      // /
      return {
        value: '\u002f',
        size: 2,
      };

    case 0x0062:
      // b
      return {
        value: '\u0008',
        size: 2,
      };

    case 0x0066:
      // f
      return {
        value: '\u000c',
        size: 2,
      };

    case 0x006e:
      // n
      return {
        value: '\u000a',
        size: 2,
      };

    case 0x0072:
      // r
      return {
        value: '\u000d',
        size: 2,
      };

    case 0x0074:
      // t
      return {
        value: '\u0009',
        size: 2,
      };
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid character escape sequence: "${body.slice(
      position,
      position + 2,
    )}".`,
  );
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */

function readBlockString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let lineStart = lexer.lineStart;
  let position = start + 3;
  let chunkStart = position;
  let currentLine = '';
  const blockLines = [];

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Triple-Quote (""")

    if (
      code === 0x0022 &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);
      const token = createToken(
        lexer,
        tokenKind_TokenKind.BLOCK_STRING,
        start,
        position + 3, // Return a string of the lines joined with U+000A.
        (0,blockString/* dedentBlockStringLines */.wv)(blockLines).join('\n'),
      );
      lexer.line += blockLines.length - 1;
      lexer.lineStart = lineStart;
      return token;
    } // Escaped Triple-Quote (\""")

    if (
      code === 0x005c &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022 &&
      body.charCodeAt(position + 3) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      chunkStart = position + 1; // skip only slash

      position += 4;
      continue;
    } // LineTerminator

    if (code === 0x000a || code === 0x000d) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);

      if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) {
        position += 2;
      } else {
        ++position;
      }

      currentLine = '';
      chunkStart = position;
      lineStart = position;
      continue;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 *
 * @internal
 */

function readName(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position);

    if ((0,characterClasses/* isNameContinue */.HQ)(code)) {
      ++position;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    tokenKind_TokenKind.NAME,
    start,
    position,
    body.slice(start, position),
  );
}

// EXTERNAL MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/jsutils/devAssert.mjs
var devAssert = __webpack_require__(65408);
// EXTERNAL MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/jsutils/inspect.mjs
var inspect = __webpack_require__(49993);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/jsutils/instanceOf.mjs

/* c8 ignore next 3 */

const isProduction =
  globalThis.process && // eslint-disable-next-line no-undef
  "production" === 'production';
/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 * See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
 * See: https://webpack.js.org/guides/production/
 */

const instanceOf =
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  isProduction
    ? function instanceOf(value, constructor) {
        return value instanceof constructor;
      }
    : function instanceOf(value, constructor) {
        if (value instanceof constructor) {
          return true;
        }

        if (typeof value === 'object' && value !== null) {
          var _value$constructor;

          // Prefer Symbol.toStringTag since it is immune to minification.
          const className = constructor.prototype[Symbol.toStringTag];
          const valueClassName = // We still need to support constructor's name to detect conflicts with older versions of this library.
            Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
              ? value[Symbol.toStringTag]
              : (_value$constructor = value.constructor) === null ||
                _value$constructor === void 0
              ? void 0
              : _value$constructor.name;

          if (className === valueClassName) {
            const stringifiedValue = (0,inspect/* inspect */.X)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
          }
        }

        return false;
      };

;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/language/source.mjs




/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */
class source_Source {
  constructor(
    body,
    name = 'GraphQL request',
    locationOffset = {
      line: 1,
      column: 1,
    },
  ) {
    typeof body === 'string' ||
      (0,devAssert/* devAssert */.a)(false, `Body must be a string. Received: ${(0,inspect/* inspect */.X)(body)}.`);
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 ||
      (0,devAssert/* devAssert */.a)(
        false,
        'line in locationOffset is 1-indexed and must be positive.',
      );
    this.locationOffset.column > 0 ||
      (0,devAssert/* devAssert */.a)(
        false,
        'column in locationOffset is 1-indexed and must be positive.',
      );
  }

  get [Symbol.toStringTag]() {
    return 'Source';
  }
}
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */

function source_isSource(source) {
  return instanceOf(source, source_Source);
}

;// CONCATENATED MODULE: ../../node_modules/.pnpm/graphql@16.14.0/node_modules/graphql/language/parser.mjs








/**
 * Configuration options to control parser behavior
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  const parser = new Parser(source, options);
  const document = parser.parseDocument();
  Object.defineProperty(document, 'tokenCount', {
    enumerable: false,
    value: parser.tokenCount,
  });
  return document;
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */

function parseValue(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const value = parser.parseValueLiteral(false);
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Similar to parseValue(), but raises a parse error if it encounters a
 * variable. The return type will be a constant value.
 */

function parseConstValue(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const value = parser.parseConstValueLiteral();
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */

function parseType(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const type = parser.parseTypeReference();
  parser.expectToken(TokenKind.EOF);
  return type;
}
/**
 * Given a string containing a GraphQL Schema Coordinate (ex. `Type.field`),
 * parse the AST for that schema coordinate.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * Consider providing the results to the utility function:
 * resolveASTSchemaCoordinate(). Or calling resolveSchemaCoordinate() directly
 * with an unparsed source.
 */

function parseSchemaCoordinate(source) {
  const sourceObj = isSource(source) ? source : new Source(source);
  const lexer = new SchemaCoordinateLexer(sourceObj);
  const parser = new Parser(source, {
    lexer,
  });
  parser.expectToken(TokenKind.SOF);
  const coordinate = parser.parseSchemaCoordinate();
  parser.expectToken(TokenKind.EOF);
  return coordinate;
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */

class Parser {
  constructor(source, options = {}) {
    const { lexer, ..._options } = options;

    if (lexer) {
      this._lexer = lexer;
    } else {
      const sourceObj = source_isSource(source) ? source : new source_Source(source);
      this._lexer = new Lexer(sourceObj);
    }

    this._options = _options;
    this._tokenCounter = 0;
  }

  get tokenCount() {
    return this._tokenCounter;
  }
  /**
   * Converts a name lex token into a name parse node.
   */

  parseName() {
    const token = this.expectToken(tokenKind_TokenKind.NAME);
    return this.node(token, {
      kind: kinds/* Kind.NAME */.h.NAME,
      value: token.value,
    });
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */

  parseDocument() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.DOCUMENT */.h.DOCUMENT,
      definitions: this.many(
        tokenKind_TokenKind.SOF,
        this.parseDefinition,
        tokenKind_TokenKind.EOF,
      ),
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */

  parseDefinition() {
    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } // Many definitions begin with a description and require a lookahead.

    const hasDescription = this.peekDescription();
    const keywordToken = hasDescription
      ? this._lexer.lookahead()
      : this._lexer.token;

    if (hasDescription && keywordToken.kind === tokenKind_TokenKind.BRACE_L) {
      throw syntaxError(
        this._lexer.source,
        this._lexer.token.start,
        'Unexpected description, descriptions are not supported on shorthand queries.',
      );
    }

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }

      switch (keywordToken.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();
      }

      if (hasDescription) {
        throw syntaxError(
          this._lexer.source,
          this._lexer.token.start,
          'Unexpected description, only GraphQL definitions support descriptions.',
        );
      }

      switch (keywordToken.value) {
        case 'extend':
          return this.parseTypeSystemExtension();
      }
    }

    throw this.unexpected(keywordToken);
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */

  parseOperationDefinition() {
    const start = this._lexer.token;

    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.node(start, {
        kind: kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
        operation: ast/* OperationTypeNode.QUERY */.ku.QUERY,
        description: undefined,
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
      });
    }

    const description = this.parseDescription();
    const operation = this.parseOperationType();
    let name;

    if (this.peek(tokenKind_TokenKind.NAME)) {
      name = this.parseName();
    }

    return this.node(start, {
      kind: kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
      operation,
      description,
      name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */

  parseOperationType() {
    const operationToken = this.expectToken(tokenKind_TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return ast/* OperationTypeNode.QUERY */.ku.QUERY;

      case 'mutation':
        return ast/* OperationTypeNode.MUTATION */.ku.MUTATION;

      case 'subscription':
        return ast/* OperationTypeNode.SUBSCRIPTION */.ku.SUBSCRIPTION;
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */

  parseVariableDefinitions() {
    return this.optionalMany(
      tokenKind_TokenKind.PAREN_L,
      this.parseVariableDefinition,
      tokenKind_TokenKind.PAREN_R,
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */

  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.VARIABLE_DEFINITION */.h.VARIABLE_DEFINITION,
      description: this.parseDescription(),
      variable: this.parseVariable(),
      type: (this.expectToken(tokenKind_TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(tokenKind_TokenKind.EQUALS)
        ? this.parseConstValueLiteral()
        : undefined,
      directives: this.parseConstDirectives(),
    });
  }
  /**
   * Variable : $ Name
   */

  parseVariable() {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.DOLLAR);
    return this.node(start, {
      kind: kinds/* Kind.VARIABLE */.h.VARIABLE,
      name: this.parseName(),
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */

  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.SELECTION_SET */.h.SELECTION_SET,
      selections: this.many(
        tokenKind_TokenKind.BRACE_L,
        this.parseSelection,
        tokenKind_TokenKind.BRACE_R,
      ),
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */

  parseSelection() {
    return this.peek(tokenKind_TokenKind.SPREAD)
      ? this.parseFragment()
      : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */

  parseField() {
    const start = this._lexer.token;
    const nameOrAlias = this.parseName();
    let alias;
    let name;

    if (this.expectOptionalToken(tokenKind_TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return this.node(start, {
      kind: kinds/* Kind.FIELD */.h.FIELD,
      alias,
      name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(tokenKind_TokenKind.BRACE_L)
        ? this.parseSelectionSet()
        : undefined,
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */

  parseArguments(isConst) {
    const item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, item, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */

  parseArgument(isConst = false) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return this.node(start, {
      kind: kinds/* Kind.ARGUMENT */.h.ARGUMENT,
      name,
      value: this.parseValueLiteral(isConst),
    });
  }

  parseConstArgument() {
    return this.parseArgument(true);
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */

  parseFragment() {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.SPREAD);
    const hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(tokenKind_TokenKind.NAME)) {
      return this.node(start, {
        kind: kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
      });
    }

    return this.node(start, {
      kind: kinds/* Kind.INLINE_FRAGMENT */.h.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */

  parseFragmentDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('fragment'); // Legacy support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (this._options.allowLegacyFragmentVariables === true) {
      return this.node(start, {
        kind: kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
        description,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
      });
    }

    return this.node(start, {
      kind: kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
      description,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentName : Name but not `on`
   */

  parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseValueLiteral(isConst) {
    const token = this._lexer.token;

    switch (token.kind) {
      case tokenKind_TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case tokenKind_TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case tokenKind_TokenKind.INT:
        this.advanceLexer();
        return this.node(token, {
          kind: kinds/* Kind.INT */.h.INT,
          value: token.value,
        });

      case tokenKind_TokenKind.FLOAT:
        this.advanceLexer();
        return this.node(token, {
          kind: kinds/* Kind.FLOAT */.h.FLOAT,
          value: token.value,
        });

      case tokenKind_TokenKind.STRING:
      case tokenKind_TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case tokenKind_TokenKind.NAME:
        this.advanceLexer();

        switch (token.value) {
          case 'true':
            return this.node(token, {
              kind: kinds/* Kind.BOOLEAN */.h.BOOLEAN,
              value: true,
            });

          case 'false':
            return this.node(token, {
              kind: kinds/* Kind.BOOLEAN */.h.BOOLEAN,
              value: false,
            });

          case 'null':
            return this.node(token, {
              kind: kinds/* Kind.NULL */.h.NULL,
            });

          default:
            return this.node(token, {
              kind: kinds/* Kind.ENUM */.h.ENUM,
              value: token.value,
            });
        }

      case tokenKind_TokenKind.DOLLAR:
        if (isConst) {
          this.expectToken(tokenKind_TokenKind.DOLLAR);

          if (this._lexer.token.kind === tokenKind_TokenKind.NAME) {
            const varName = this._lexer.token.value;
            throw syntaxError(
              this._lexer.source,
              token.start,
              `Unexpected variable "$${varName}" in constant value.`,
            );
          } else {
            throw this.unexpected(token);
          }
        }

        return this.parseVariable();

      default:
        throw this.unexpected();
    }
  }

  parseConstValueLiteral() {
    return this.parseValueLiteral(true);
  }

  parseStringLiteral() {
    const token = this._lexer.token;
    this.advanceLexer();
    return this.node(token, {
      kind: kinds/* Kind.STRING */.h.STRING,
      value: token.value,
      block: token.kind === tokenKind_TokenKind.BLOCK_STRING,
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */

  parseList(isConst) {
    const item = () => this.parseValueLiteral(isConst);

    return this.node(this._lexer.token, {
      kind: kinds/* Kind.LIST */.h.LIST,
      values: this.any(tokenKind_TokenKind.BRACKET_L, item, tokenKind_TokenKind.BRACKET_R),
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */

  parseObject(isConst) {
    const item = () => this.parseObjectField(isConst);

    return this.node(this._lexer.token, {
      kind: kinds/* Kind.OBJECT */.h.OBJECT,
      fields: this.any(tokenKind_TokenKind.BRACE_L, item, tokenKind_TokenKind.BRACE_R),
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */

  parseObjectField(isConst) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return this.node(start, {
      kind: kinds/* Kind.OBJECT_FIELD */.h.OBJECT_FIELD,
      name,
      value: this.parseValueLiteral(isConst),
    });
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */

  parseDirectives(isConst) {
    const directives = [];

    while (this.peek(tokenKind_TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }

  parseConstDirectives() {
    return this.parseDirectives(true);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */

  parseDirective(isConst) {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.AT);
    return this.node(start, {
      kind: kinds/* Kind.DIRECTIVE */.h.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
    });
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */

  parseTypeReference() {
    const start = this._lexer.token;
    let type;

    if (this.expectOptionalToken(tokenKind_TokenKind.BRACKET_L)) {
      const innerType = this.parseTypeReference();
      this.expectToken(tokenKind_TokenKind.BRACKET_R);
      type = this.node(start, {
        kind: kinds/* Kind.LIST_TYPE */.h.LIST_TYPE,
        type: innerType,
      });
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(tokenKind_TokenKind.BANG)) {
      return this.node(start, {
        kind: kinds/* Kind.NON_NULL_TYPE */.h.NON_NULL_TYPE,
        type,
      });
    }

    return type;
  }
  /**
   * NamedType : Name
   */

  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.NAMED_TYPE */.h.NAMED_TYPE,
      name: this.parseName(),
    });
  } // Implements the parsing rules in the Type Definition section.

  peekDescription() {
    return this.peek(tokenKind_TokenKind.STRING) || this.peek(tokenKind_TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */

  parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */

  parseSchemaDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.many(
      tokenKind_TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
    return this.node(start, {
      kind: kinds/* Kind.SCHEMA_DEFINITION */.h.SCHEMA_DEFINITION,
      description,
      directives,
      operationTypes,
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */

  parseOperationTypeDefinition() {
    const start = this._lexer.token;
    const operation = this.parseOperationType();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseNamedType();
    return this.node(start, {
      kind: kinds/* Kind.OPERATION_TYPE_DEFINITION */.h.OPERATION_TYPE_DEFINITION,
      operation,
      type,
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */

  parseScalarTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.SCALAR_TYPE_DEFINITION */.h.SCALAR_TYPE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */

  parseObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind.OBJECT_TYPE_DEFINITION */.h.OBJECT_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */

  parseImplementsInterfaces() {
    return this.expectOptionalKeyword('implements')
      ? this.delimitedMany(tokenKind_TokenKind.AMP, this.parseNamedType)
      : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */

  parseFieldsDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseFieldDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */

  parseFieldDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseTypeReference();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.FIELD_DEFINITION */.h.FIELD_DEFINITION,
      description,
      name,
      arguments: args,
      type,
      directives,
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */

  parseArgumentDefs() {
    return this.optionalMany(
      tokenKind_TokenKind.PAREN_L,
      this.parseInputValueDef,
      tokenKind_TokenKind.PAREN_R,
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */

  parseInputValueDef() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseTypeReference();
    let defaultValue;

    if (this.expectOptionalToken(tokenKind_TokenKind.EQUALS)) {
      defaultValue = this.parseConstValueLiteral();
    }

    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.INPUT_VALUE_DEFINITION */.h.INPUT_VALUE_DEFINITION,
      description,
      name,
      type,
      defaultValue,
      directives,
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */

  parseInterfaceTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind.INTERFACE_TYPE_DEFINITION */.h.INTERFACE_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */

  parseUnionTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();
    return this.node(start, {
      kind: kinds/* Kind.UNION_TYPE_DEFINITION */.h.UNION_TYPE_DEFINITION,
      description,
      name,
      directives,
      types,
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */

  parseUnionMemberTypes() {
    return this.expectOptionalToken(tokenKind_TokenKind.EQUALS)
      ? this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseNamedType)
      : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */

  parseEnumTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();
    return this.node(start, {
      kind: kinds/* Kind.ENUM_TYPE_DEFINITION */.h.ENUM_TYPE_DEFINITION,
      description,
      name,
      directives,
      values,
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */

  parseEnumValuesDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseEnumValueDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */

  parseEnumValueDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseEnumValueName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.ENUM_VALUE_DEFINITION */.h.ENUM_VALUE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseEnumValueName() {
    if (
      this._lexer.token.value === 'true' ||
      this._lexer.token.value === 'false' ||
      this._lexer.token.value === 'null'
    ) {
      throw syntaxError(
        this._lexer.source,
        this._lexer.token.start,
        `${getTokenDesc(
          this._lexer.token,
        )} is reserved and cannot be used for an enum value.`,
      );
    }

    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */

  parseInputObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind.INPUT_OBJECT_TYPE_DEFINITION */.h.INPUT_OBJECT_TYPE_DEFINITION,
      description,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */

  parseInputFieldsDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseInputValueDef,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   *   - DirectiveDefinitionExtension
   */

  parseTypeSystemExtension() {
    const keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();

        case 'directive':
          if (this._options.experimentalDirectivesOnDirectiveDefinitions) {
            return this.parseDirectiveDefinitionExtension();
          }

          break;
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */

  parseSchemaExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      tokenKind_TokenKind.BRACE_R,
    );

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.SCHEMA_EXTENSION */.h.SCHEMA_EXTENSION,
      directives,
      operationTypes,
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */

  parseScalarTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.SCALAR_TYPE_EXTENSION */.h.SCALAR_TYPE_EXTENSION,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */

  parseObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.OBJECT_TYPE_EXTENSION */.h.OBJECT_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */

  parseInterfaceTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.INTERFACE_TYPE_EXTENSION */.h.INTERFACE_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */

  parseUnionTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.UNION_TYPE_EXTENSION */.h.UNION_TYPE_EXTENSION,
      name,
      directives,
      types,
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */

  parseEnumTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.ENUM_TYPE_EXTENSION */.h.ENUM_TYPE_EXTENSION,
      name,
      directives,
      values,
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */

  parseInputObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.INPUT_OBJECT_TYPE_EXTENSION */.h.INPUT_OBJECT_TYPE_EXTENSION,
      name,
      directives,
      fields,
    });
  }

  parseDirectiveDefinitionExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('directive');
    this.expectToken(tokenKind_TokenKind.AT);
    const name = this.parseName();
    const directives = this.parseConstDirectives();

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.DIRECTIVE_EXTENSION */.h.DIRECTIVE_EXTENSION,
      name,
      directives,
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */

  parseDirectiveDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(tokenKind_TokenKind.AT);
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    const directives = this._options
      .experimentalDirectivesOnDirectiveDefinitions
      ? this.parseConstDirectives()
      : [];
    const repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    const locations = this.parseDirectiveLocations();
    return this.node(start, {
      kind: kinds/* Kind.DIRECTIVE_DEFINITION */.h.DIRECTIVE_DEFINITION,
      description,
      name,
      arguments: args,
      directives,
      repeatable,
      locations,
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */

  parseDirectiveLocations() {
    return this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   *   `DIRECTIVE_DEFINITION`
   */

  parseDirectiveLocation() {
    const start = this._lexer.token;
    const name = this.parseName();

    if (Object.prototype.hasOwnProperty.call(DirectiveLocation, name.value)) {
      return name;
    }

    throw this.unexpected(start);
  } // Schema Coordinates

  /**
   * SchemaCoordinate :
   *   - Name
   *   - Name . Name
   *   - Name . Name ( Name : )
   *   - \@ Name
   *   - \@ Name ( Name : )
   */

  parseSchemaCoordinate() {
    const start = this._lexer.token;
    const ofDirective = this.expectOptionalToken(tokenKind_TokenKind.AT);
    const name = this.parseName();
    let memberName;

    if (!ofDirective && this.expectOptionalToken(tokenKind_TokenKind.DOT)) {
      memberName = this.parseName();
    }

    let argumentName;

    if (
      (ofDirective || memberName) &&
      this.expectOptionalToken(tokenKind_TokenKind.PAREN_L)
    ) {
      argumentName = this.parseName();
      this.expectToken(tokenKind_TokenKind.COLON);
      this.expectToken(tokenKind_TokenKind.PAREN_R);
    }

    if (ofDirective) {
      if (argumentName) {
        return this.node(start, {
          kind: kinds/* Kind.DIRECTIVE_ARGUMENT_COORDINATE */.h.DIRECTIVE_ARGUMENT_COORDINATE,
          name,
          argumentName,
        });
      }

      return this.node(start, {
        kind: kinds/* Kind.DIRECTIVE_COORDINATE */.h.DIRECTIVE_COORDINATE,
        name,
      });
    } else if (memberName) {
      if (argumentName) {
        return this.node(start, {
          kind: kinds/* Kind.ARGUMENT_COORDINATE */.h.ARGUMENT_COORDINATE,
          name,
          fieldName: memberName,
          argumentName,
        });
      }

      return this.node(start, {
        kind: kinds/* Kind.MEMBER_COORDINATE */.h.MEMBER_COORDINATE,
        name,
        memberName,
      });
    }

    return this.node(start, {
      kind: kinds/* Kind.TYPE_COORDINATE */.h.TYPE_COORDINATE,
      name,
    });
  } // Core parsing utility functions

  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */

  node(startToken, node) {
    if (this._options.noLocation !== true) {
      node.loc = new ast/* Location */.Ye(
        startToken,
        this._lexer.lastToken,
        this._lexer.source,
      );
    }

    return node;
  }
  /**
   * Determines if the next token is of a given kind
   */

  peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this.advanceLexer();
      return token;
    }

    throw syntaxError(
      this._lexer.source,
      token.start,
      `Expected ${getTokenKindDesc(kind)}, found ${getTokenDesc(token)}.`,
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this.advanceLexer();
      return true;
    }

    return false;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this.advanceLexer();
    } else {
      throw syntaxError(
        this._lexer.source,
        token.start,
        `Expected "${value}", found ${getTokenDesc(token)}.`,
      );
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this.advanceLexer();
      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */

  unexpected(atToken) {
    const token =
      atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return syntaxError(
      this._lexer.source,
      token.start,
      `Unexpected ${getTokenDesc(token)}.`,
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      const nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */

  delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));

    return nodes;
  }

  advanceLexer() {
    const { maxTokens } = this._options;

    const token = this._lexer.advance();

    if (token.kind !== tokenKind_TokenKind.EOF) {
      ++this._tokenCounter;

      if (maxTokens !== undefined && this._tokenCounter > maxTokens) {
        throw syntaxError(
          this._lexer.source,
          token.start,
          `Document contains more that ${maxTokens} tokens. Parsing aborted.`,
        );
      }
    }
  }
}
/**
 * A helper function to describe a token as a string for debugging.
 */

function getTokenDesc(token) {
  const value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */

function getTokenKindDesc(kind) {
  return isPunctuatorTokenKind(kind) ? `"${kind}"` : kind;
}


/***/ }),

/***/ 75461:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "up": function() { return /* reexport */ AddContextualData; },
  "co": function() { return /* reexport */ analytics_exports; },
  "w": function() { return /* reexport */ globalObservability; },
  "lT": function() { return /* binding */ initObservability; },
  "C3": function() { return /* reexport */ useObservability; }
});

// UNUSED EXPORTS: ContextualDataContext, DebugObservability, NON_CATEGORY_FIELDS, RealObservability, UTM_ADGID, UTM_CAMPAIGN, UTM_CAT, UTM_CONTENT, UTM_CTA, UTM_EXTERNALID, UTM_GEO, UTM_MEDIUM, UTM_NTWK, UTM_SOURCE, UTM_SUBSITE, UTM_TERM, addDatadogRUMGlobalContext, emptyContextualData, emptyJourneyEventContextualData, mergeContextualData, readUtmCookie, testonly, useContextualData, useFakeObservability

;// CONCATENATED MODULE: ../../node_modules/.pnpm/js-cookie@3.0.8/node_modules/js-cookie/dist/js.cookie.mjs
/*! js-cookie v3.0.8 | MIT */
function js_cookie_assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (key === '__proto__') continue
      target[key] = source[key];
    }
  }
  return target
}

var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};

function init(converter, defaultAttributes) {
  function set(name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = js_cookie_assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get(name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        if (!(found in jar)) jar[found] = converter.read(value, found);
        if (name === found) {
          break
        }
      } catch (_e) {
        // Do nothing...
      }
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set: set,
      get: get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          js_cookie_assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, js_cookie_assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(js_cookie_assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });



// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
;// CONCATENATED MODULE: ../observability/dist/chunk-SEH5UZKX.mjs
var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/internal/deployEnv.ts
var getDeployEnv = () => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return "development";
  }
  const hostname = window?.location?.hostname;
  if (hostname === void 0) {
    return "development";
  }
  const port = window?.location?.port;
  const locationHasPort = port && port !== "";
  const onLocalhost = hostname === "localhost";
  const onNgrok = hostname.includes(".ngrok.io");
  const onXipIO = hostname.includes(".xip.io");
  const inAndroidEmulator = hostname.includes("10.0.2.2");
  const inDevelopment = onLocalhost && locationHasPort || onNgrok || onXipIO || inAndroidEmulator;
  if (inDevelopment) {
    return "development";
  }
  const inRailsCI = hostname === "127.0.0.1";
  if (inRailsCI || onLocalhost) {
    return "test";
  }
  const onStagingManagedDomain = hostname.includes("-staging.managed.services.opendoor.com");
  const onSimplersell = hostname.includes(".simplersell.com");
  const onODMortgage = hostname.includes(".odmortgage.com");
  const inStaging = onStagingManagedDomain || onSimplersell || onODMortgage;
  const onOpendoorHomeLoans = hostname.includes("opendoorhomeloans.com");
  const onOpendoor = hostname.includes(".opendoor.com") && !hostname.includes("-staging");
  const inProduction = onOpendoor || onOpendoorHomeLoans;
  const inProdOrStaging = inStaging || inProduction;
  const onQADomain = hostname.includes("-qa-");
  const hasQACookie = document?.cookie?.includes("qa=") && document?.cookie?.includes("qa_env=");
  const inQA = onQADomain || inProdOrStaging && hasQACookie;
  if (inQA) {
    return "qa";
  } else if (inStaging) {
    return "staging";
  } else if (inProduction) {
    return "production";
  }
  return "development";
};

// src/contextualData.ts
var emptyContextualData = {
  user: void 0,
  data: {},
  adClickContext: void 0,
  campaignContext: void 0,
  customerContext: void 0,
  exclusiveOffersContext: void 0,
  leadContext: void 0,
  sellDirectContext: void 0
};
var emptyJourneyEventContextualData = {
  customerContext: void 0,
  campaignContext: void 0,
  websiteSourceContext: void 0
};
function mergeContextualData(parent, child = emptyContextualData) {
  if (getDeployEnv() !== "production" && parent.user && child.user) {
    throw new Error("User already set. This error only shows in non-production environments.");
  }
  return {
    user: child.user || parent.user,
    data: { ...parent.data, ...child.data },
    campaignContext: child.campaignContext || parent.campaignContext,
    customerContext: child.customerContext || parent.customerContext,
    exclusiveOffersContext: child.exclusiveOffersContext || parent.exclusiveOffersContext,
    leadContext: child.leadContext || parent.leadContext,
    sellDirectContext: child.sellDirectContext || parent.sellDirectContext,
    adClickContext: child.adClickContext || parent.adClickContext
  };
}

// src/global.ts
var ProxyObservabilityInstance = class {
  currentInstance = null;
  setCurrentInstance(instance) {
    this.currentInstance = instance;
  }
  // This is only used for testing.
  _destroyCurrentInstance() {
    this.currentInstance = null;
  }
  /**
   * Track events not performed by a user but meaningful internally. For events performed
   * by a user, use `trackUserEvent`.
   *
   * TODO (@core-experience-platform): rename to `trackInternalEvent`
   */
  trackEvent(action, label, contextualData, options) {
    this.currentInstance?.trackEvent(action, label, contextualData, options);
  }
  /**
   * @deprecated Use trackJourneyEvent instead
   * @see https://opendoor.atlassian.net/wiki/spaces/CONSUMER/pages/2283536444/How+to+Create+Journey+2.0+Events
   */
  trackUserEvent(event, contextualData) {
    this.currentInstance?.trackUserEvent(event, contextualData);
  }
  trackJourneyEvent(categoryName, eventName, eventData, contextualData = emptyJourneyEventContextualData, options) {
    this.currentInstance?.trackJourneyEvent(
      categoryName,
      eventName,
      eventData,
      contextualData,
      options
    );
  }
  trackError(label, error, contextualData, options) {
    this.currentInstance?.trackError(label, error, contextualData, options);
  }
  // All of the "getXXXClient" methods return a Proxy object, that capture requests
  // and then re-evaluate and forward the request to the currentInstance every time.
  // This ensures that if the currentInstance is changed, the new instance will be used.
  // And it also allows for behavior like:
  // import { Sentry } from '@opendoor/observability';
  // If you don't do this, and Sentry is delayed in initializing, then the user will
  // have a reference to an empty object forever, instead of a reference to an object
  // that will eventually have methods in it.
  // The only downside of this is that users have to handle undefined for the methods
  // but that tradeoff is okay.
  getDatadogRumClient() {
    return new Proxy(
      {},
      {
        get: (_, prop) => {
          return this.currentInstance ? this.currentInstance.getDatadogRumClient()[prop] : void 0;
        }
      }
    );
  }
  getJourneyUserClient() {
    return new Proxy(
      {},
      {
        get: (_, prop) => {
          return this.currentInstance ? this.currentInstance.getJourneyUserClient()[prop] : void 0;
        },
        set: (_, prop, value) => {
          return this.currentInstance ? this.currentInstance.getJourneyUserClient()[prop] = value : void 0;
        }
      }
    );
  }
  getJourneyEventClient() {
    return new Proxy(
      {},
      {
        get: (_, prop) => {
          return this.currentInstance ? this.currentInstance.getJourneyEventClient()[prop] : void 0;
        },
        set: (_, prop, value) => {
          return this.currentInstance ? this.currentInstance.getJourneyEventClient()[prop] = value : void 0;
        }
      }
    );
  }
  getSentryClient() {
    return new Proxy(
      {},
      {
        get: (_, prop) => this.currentInstance ? this.currentInstance.getSentryClient()[prop] : void 0
      }
    );
  }
  isInitialized() {
    return this.currentInstance !== null;
  }
};
var globalObservability = new ProxyObservabilityInstance();

// src/internal/datadog.ts
var buildDefaultDatadogOptions = (opts) => {
  const { appName, env, version } = opts;
  return {
    site: "datadoghq.com",
    version,
    env,
    service: appName
  };
};
function getContextualDataFromDatadog() {
  const sessionId = globalObservability.getDatadogRumClient().getInternalContext?.()?.session_id;
  if (sessionId) {
    return {
      data: {
        "datadog-rum-session-id": sessionId,
        "datadog-rum-session-replay": `https://app.datadoghq.com/rum/replay/sessions/${sessionId}`,
        "datadog-rum-session-search": `https://app.datadoghq.com/rum/explorer?query=%40session.id%3A${sessionId}`
      }
    };
  } else {
    return emptyContextualData;
  }
}
function trackPerformanceInDatadog(eventName) {
  globalObservability.getDatadogRumClient().addTiming?.(eventName);
}
function addRUMGlobalContext(context) {
  globalObservability.getDatadogRumClient()?.setGlobalContext?.({
    ...globalObservability.getDatadogRumClient().getGlobalContext?.(),
    ...context
  });
}
function trackEventInDatadog(action, label, contextualData = emptyContextualData) {
  globalObservability.getDatadogRumClient().addAction?.(action, {
    ...contextualData.data,
    adClickContext: contextualData.adClickContext,
    campaignContext: contextualData.campaignContext,
    customerContext: contextualData.customerContext,
    exclusiveOffersContext: contextualData.exclusiveOffersContext,
    leadContext: contextualData.leadContext,
    sellDirectContext: contextualData.sellDirectContext,
    label
  });
}
function trackUserEventInDatadog(event, contextualData = emptyContextualData) {
  globalObservability.getDatadogRumClient().addAction?.(Object.keys(event)?.[0] ?? "unknownUserEvent", {
    ...event,
    ...contextualData.data,
    adClickContext: contextualData.adClickContext,
    campaignContext: contextualData.campaignContext,
    customerContext: contextualData.customerContext,
    exclusiveOffersContext: contextualData.exclusiveOffersContext,
    leadContext: contextualData.leadContext,
    sellDirectContext: contextualData.sellDirectContext
  });
}
function trackJourneyEventInDatadog(event, contextualData) {
  const category = Object.keys(event)[0] ?? "unknownUserEvent";
  globalObservability.getDatadogRumClient().addAction?.(category, {
    ...event,
    campaignContext: contextualData.campaignContext
  });
}
function trackErrorInDatadog(label, error, contextualData = emptyContextualData) {
  if (shouldExcludeErrorByMessage(error)) {
    return;
  }
  globalObservability.getDatadogRumClient().addError?.(error || new Error(label), {
    ...contextualData.data,
    label
  });
}
var ERROR_MESSAGES_TO_EXCLUDE = [
  // Error that MAY indicate a performance issue due to browser implementation, but has been shown to be safe to ignore.
  // https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
  "ResizeObserver loop limit exceeded"
];
var shouldExcludeErrorByMessage = (error) => {
  return ERROR_MESSAGES_TO_EXCLUDE.includes(error?.message || "");
};
function setRUMUser(user) {
  globalObservability.getDatadogRumClient().setUser?.(user);
}
function setRUMUserProperty(user) {
  Object.entries(user).forEach(([key, value]) => {
    globalObservability.getDatadogRumClient().setUserProperty?.(key, value);
  });
}

// src/internal/googleTagManager.ts
var loadGoogleTagManager = (lazyLoad) => {
  const injectScript = () => {
    if (typeof window !== "undefined") {
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
          "gtm.start": (/* @__PURE__ */ new Date()).getTime(),
          event: "gtm.js"
        });
        const f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l !== "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "//www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", "GTM-MSX7NS");
    }
  };
  if (lazyLoad) {
    window.addEventListener("load", injectScript);
  } else {
    injectScript();
  }
};

// src/internal/journey.ts

var BASE_JOURNEY_ENDPOINT = getDeployEnv() === "production" ? "https://journey.apps.opendoor.com/_journey/api/v1" : "https://journey.apps-staging.opendoor.com/_journey/api/v1";
var getJourneyEndpoint = (journeyEndpoint) => {
  if (journeyEndpoint) {
    return `${journeyEndpoint}/events`;
  } else {
    trackErrorInDatadog("the old journey endpoint is still being used", void 0, {
      data: {
        location: "observability"
      }
    });
    return `${BASE_JOURNEY_ENDPOINT}/events`;
  }
};
function initJourney(journeyEndpoint, batchInterval = 5e3) {
  if (typeof window === "undefined") {
    return {};
  }
  const userEventClient = new JourneyClientImpl({
    batchInterval,
    journeyEndpoint: `${BASE_JOURNEY_ENDPOINT}/user_event_batch`,
    jsonKey: "userEvents",
    maxNumRequest: 10
  });
  userEventClient.start();
  const eventWrapperClient = new JourneyClientImpl({
    batchInterval,
    journeyEndpoint: getJourneyEndpoint(journeyEndpoint),
    jsonKey: "eventWrappers",
    maxNumRequest: 20
  });
  eventWrapperClient.start();
  window.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      userEventClient?.send();
      eventWrapperClient?.send();
    }
  });
  window.addEventListener("beforeunload", () => {
    userEventClient?.send();
    eventWrapperClient?.send();
  });
  return {
    userClient: userEventClient,
    eventClient: eventWrapperClient
  };
}
var getWebsiteSource = (overrides) => {
  let url = "";
  let language = [];
  let userAgent = "";
  let host = "";
  let pathname = "";
  let queryMap = {};
  let screen = void 0;
  let proxyPath = overrides?.proxyPath ?? void 0;
  let proxyQueryMap = overrides?.proxyQueryMap ?? {};
  let referrer = overrides?.referrer ?? void 0;
  if (typeof window !== "undefined") {
    url = window.location.href;
    userAgent = typeof navigator !== "undefined" ? navigator.userAgent : "";
    language = typeof navigator !== "undefined" ? [...navigator.languages] : [];
    host = window.location.host;
    pathname = window.location.pathname;
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.forEach((value, key) => {
      queryMap[key] = queryMap[key] ? `${queryMap[key]},${value}` : value;
    });
    screen = {
      width: Math.round(window.innerWidth),
      height: Math.round(window.innerHeight),
      density: Math.round(window.devicePixelRatio)
    };
  }
  return {
    url,
    userAgent,
    host,
    pathname,
    queryMap,
    eventOrigin: 2 /* CLIENT */,
    proxyQueryMap,
    referrer,
    proxyPath,
    screen,
    language,
    isWebview: false
    // Gets overridden in Journey Service for http events based on the user agent
  };
};
var trackUserEventInJourney = (userEvent, contextualData) => {
  const anonymousId = getAnonymousID();
  const websiteSource = getWebsiteSource();
  if (!anonymousId) {
    trackErrorInDatadog("ajs_anonymous_id is empty or undefined", void 0, {
      data: {
        location: "observability",
        anonymousId,
        event: userEvent
      }
    });
  }
  const protobufUserEvent = {
    ...userEvent,
    uuid: "",
    // journey generates this
    timestamp: /* @__PURE__ */ new Date(),
    anonymousId,
    humanId: contextualData.user?.humanID,
    websiteSource,
    adClickContext: contextualData.adClickContext,
    campaignContext: contextualData.campaignContext,
    customerContext: contextualData.customerContext,
    exclusiveOffersContext: contextualData.exclusiveOffersContext,
    leadContext: contextualData.leadContext,
    sellDirectContext: contextualData.sellDirectContext
  };
  globalObservability.getJourneyUserClient().enqueue?.(JSON.stringify(protobufUserEvent));
};
var getAnalyticsCookieData = () => {
  if (typeof document === "undefined") {
    return {};
  }
  const cookies = document.cookie.split(";").reduce(
    (acc, cookie) => {
      const [key, value] = cookie.trim().split("=");
      if (key && value) {
        acc[key] = value;
      }
      return acc;
    },
    {}
  );
  const analyticsContext = {};
  if (cookies["_fbp"]) {
    analyticsContext.fbBrowserId = cookies["_fbp"];
  }
  if (cookies["_fbc"]) {
    analyticsContext.fbClickId = cookies["_fbc"];
  }
  if (cookies["_rdt_uuid"]) {
    analyticsContext.redditBrowserId = cookies["_rdt_uuid"];
  }
  if (cookies["_ttp"]) {
    analyticsContext.tiktokBrowserId = cookies["_ttp"];
  }
  const ndclidCookie = cookies["ndclid"];
  if (ndclidCookie) {
    analyticsContext.nextdoorClickId = ndclidCookie;
  }
  return analyticsContext;
};
var trackJourneyEventInJourney = (event, contextualData, sendJourneyEventsInDev, clientEventId) => {
  const anonymousId = getAnonymousID();
  const websiteSource = getWebsiteSource(contextualData.websiteSourceContext);
  if (!anonymousId) {
    if (sendJourneyEventsInDev) {
      console.log(
        "Please copy your odAuthAid cookie value and set it as the ajs_anonymous_id cookie value for your localhost to send journey events"
      );
    } else {
      trackErrorInDatadog("ajs_anonymous_id is empty or undefined", void 0, {
        data: {
          location: "observability",
          anonymousId,
          event
        }
      });
    }
  }
  const analyticsCookieData = getAnalyticsCookieData();
  const protobufJourneyEvent = {
    ...event,
    timestamp: /* @__PURE__ */ new Date(),
    websiteSource,
    anonymousId,
    customerUuid: contextualData.customerContext?.customerUuid,
    campaignContext: contextualData.campaignContext,
    analyticsContext: Object.keys(analyticsCookieData).length > 0 ? analyticsCookieData : void 0,
    clientEventId
  };
  globalObservability.getJourneyEventClient().enqueue?.(JSON.stringify(protobufJourneyEvent));
};
var getAnonymousID = () => {
  let anonymousID = api.get("ajs_anonymous_id");
  if (!anonymousID) {
    return void 0;
  }
  return anonymousID;
};
var MAX_PAYLOAD_SIZE = 512;
function computeSizeInKilobytes(buffer) {
  const size = buffer.map((s) => s.length).reduce((prev, cur) => prev + cur, 0);
  return size / 1024;
}
function isApproachingBatchAPILimit(buffer) {
  return computeSizeInKilobytes(buffer) >= MAX_PAYLOAD_SIZE - 50;
}
var fetchWithRetry = async (url, init) => {
  let retries = 5;
  const retryDelay = 500;
  let response = void 0;
  while (retries > 0) {
    try {
      response = await fetch(url, init);
      const statusCode = response.status;
      if (statusCode === 202) {
        return;
      }
      if (statusCode >= 500 && retries >= 1) {
        await new Promise((r) => setTimeout(r, retryDelay));
        retries = retries - 1;
      } else {
        break;
      }
    } catch (err) {
      if (retries >= 1) {
        await new Promise((r) => setTimeout(r, retryDelay));
        retries = retries - 1;
      }
    }
  }
  if (init.headers?.toString().includes("Puppeteer")) {
    return;
  }
  const sentry = globalObservability.getSentryClient();
  sentry.withScope?.((scope) => {
    scope.setExtra("body", init.body);
    sentry.captureException?.(
      `failed to track events in journey,statusCode: ${response?.status}, response available: ${!!response}`
    );
  });
};
var JourneyClientImpl = class {
  buffer;
  batchInterval;
  journeyEndpoint;
  jsonKey;
  maxNumRequest;
  timer;
  constructor({ batchInterval, journeyEndpoint, jsonKey, maxNumRequest }) {
    this.buffer = [];
    this.batchInterval = batchInterval;
    this.journeyEndpoint = journeyEndpoint;
    this.jsonKey = jsonKey;
    this.maxNumRequest = maxNumRequest;
  }
  start() {
    this.timer = setInterval(() => this.send(), this.batchInterval);
  }
  stop() {
    this.timer && clearInterval(this.timer);
  }
  send() {
    if (this.buffer.length === 0) {
      return;
    }
    fetchWithRetry(this.journeyEndpoint, {
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-Journey-Client-Name": "observability",
        "X-Journey-Client-Version": "1.0"
      },
      // Using keepalive:true ensures that the request is made even if the page is being unloaded.
      // There are actually benefits to using keep-alive true: https://www.stackpath.com/edge-academy/what-is-keep-alive/
      keepalive: true,
      method: "POST",
      body: `{"${this.jsonKey}":[${this.buffer.join(",")}]}`
    });
    this.buffer = [];
  }
  enqueue(json) {
    this.buffer.push(json);
    if (this.buffer.length >= this.maxNumRequest || isApproachingBatchAPILimit(this.buffer)) {
      this.send();
    }
  }
};

// src/internal/segment.ts
var SEGMENT_METHODS = [
  "trackSubmit",
  "trackClick",
  "trackLink",
  "trackForm",
  "pageview",
  "identify",
  "reset",
  "group",
  "track",
  "ready",
  "alias",
  "debug",
  "page",
  "once",
  "off",
  "on",
  "addSourceMiddleware",
  "addIntegrationMiddleware",
  "setAnonymousId",
  "addDestinationMiddleware"
];
var RESET_PASSWORD_TOKEN_REGEX = /reset_password_token=[a-zA-Z0-9_\-.]+?(?=&|$)/;
var ACCESS_TOKEN_REGEX = /access_token=[a-zA-Z0-9_\-.]+?(?=&|$)/;
if (typeof window !== "undefined") {
  const segment = [];
  window.analytics = window.analytics || segment;
  segment.factory = function(method) {
    return function() {
      const args = Array.prototype.slice.call(arguments);
      args.unshift(method);
      segment.push(args);
      return segment;
    };
  };
  for (let i = 0; i < SEGMENT_METHODS.length; i++) {
    const key = SEGMENT_METHODS[i];
    segment[key] = segment.factory(key);
  }
  segment.SNIPPET_VERSION = "4.15.2";
  segment._loadOptions = { user: { localStorageFallbackDisabled: true } };
  segment.page({
    url: window.location.href.replace(RESET_PASSWORD_TOKEN_REGEX, "reset_password_token=REDACTED").replace(ACCESS_TOKEN_REGEX, "access_token=REDACTED"),
    search: window.location.search.replace(RESET_PASSWORD_TOKEN_REGEX, "reset_password_token=REDACTED").replace(ACCESS_TOKEN_REGEX, "access_token=REDACTED")
  });
}
var segmentWrapper = {};
SEGMENT_METHODS.forEach((methodName) => {
  segmentWrapper[methodName] = async function(...args) {
    try {
      await window.analytics[methodName](...args);
    } catch (e) {
      let error = new Error("Error sending to Segment");
      let extraErrorData = {
        method: methodName
      };
      if (methodName === "track") {
        error = new Error("Failed to send Segment Event or Error");
        extraErrorData["event"] = args[0];
        extraErrorData["value"] = args[1]?.value;
        extraErrorData["team"] = args[1]?.team || "";
        extraErrorData["pathname"] = args[1]?.pathname || "";
      }
      globalObservability.getSentryClient().withScope?.((scope) => {
        scope.setExtras({
          error: e,
          ...extraErrorData
        });
        globalObservability.getSentryClient().captureException?.(error);
      });
    }
  };
});
var loadSegment = (key, lazyLoad) => {
  const injectScript = () => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    if (key) {
      script.src = ("https:" === document.location.protocol ? "https://" : "http://") + "trkcdn.opendoor.com/analytics.js/v1/" + key + "/analytics.min.js";
    } else {
      script.src = ("https:" === document.location.protocol ? "https://" : "http://") + (getDeployEnv() === "production" ? "www.opendoor.com" : "demo.simplersell.com") + "/_scripts/sgm.min.js";
    }
    const first = document.getElementsByTagName("script")[0];
    first.parentNode.insertBefore(script, first);
  };
  if (lazyLoad) {
    window.addEventListener("load", injectScript);
  } else {
    injectScript();
  }
};
var segment_default = segmentWrapper;

// src/internal/sentry.ts
function buildDefaultSentryOpts(opts) {
  const { env, appName, version } = opts;
  return {
    environment: env,
    release: `${appName}@${version}`,
    ignoreErrors: [...DEFAULT_IGNORE_ERRORS],
    beforeSend
  };
}
function trackEventInSentry(action, label, contextualData = emptyContextualData) {
  globalObservability.getSentryClient().addBreadcrumb?.({
    category: action,
    message: label,
    data: {
      ...contextualData.data,
      adClickContext: contextualData.adClickContext,
      campaignContext: contextualData.campaignContext,
      customerContext: contextualData.customerContext,
      exclusiveOffersContext: contextualData.exclusiveOffersContext,
      leadContext: contextualData.leadContext,
      sellDirectContext: contextualData.sellDirectContext
    },
    timestamp: Date.now()
  });
}
function trackUserEventInSentry(event, contextualData = emptyContextualData) {
  globalObservability.getSentryClient().addBreadcrumb?.({
    category: Object.keys(event)[0] ?? "unknownUserEvent",
    data: {
      ...event,
      ...contextualData.data,
      adClickContext: contextualData.adClickContext,
      campaignContext: contextualData.campaignContext,
      customerContext: contextualData.customerContext,
      exclusiveOffersContext: contextualData.exclusiveOffersContext,
      leadContext: contextualData.leadContext,
      sellDirectContext: contextualData.sellDirectContext
    },
    timestamp: Date.now()
  });
}
function trackJourneyEventInSentry(event, contextualData) {
  const category = Object.keys(event)[0] ?? "unknownUserEvent";
  globalObservability.getSentryClient().addBreadcrumb?.({
    category,
    data: {
      ...event,
      campaignContext: contextualData.campaignContext
    },
    timestamp: Date.now()
  });
}
function trackErrorInSentry(label, error, contextualData = emptyContextualData) {
  let newContextualData = emptyContextualData;
  globalObservability.getSentryClient().withScope?.((scope) => {
    scope.setFingerprint([label]);
    scope.setUser(
      contextualData.user ? {
        ...contextualData.user,
        id: contextualData.user.humanID
      } : null
    );
    scope.setTags({
      ...contextualDataToTags(contextualData.data),
      label
      // add label as a tag so we can search for it
    });
    scope.setExtras(contextualData.data);
    const eventId = globalObservability.getSentryClient().captureException?.(error || new Error(label));
    newContextualData = {
      data: {
        "sentry-event-id": eventId
      }
    };
  });
  return newContextualData;
}
function contextualDataToTags(data) {
  let tags = {};
  Object.keys(data).forEach((key) => {
    const value = data[key];
    switch (typeof value) {
      case "undefined":
      case "boolean":
      case "number":
      case "bigint":
      case "string":
      case "symbol":
        tags[key] = String(value);
        break;
      case "object":
        if (value === null) {
          tags[key] = "null";
        }
        break;
    }
  });
  return tags;
}
var DEFAULT_IGNORE_ERRORS = [
  // Error generated by a bug in auto-fill library from Chrome Mobile on iOS
  // https://github.com/getsentry/sentry/issues/5267
  "Blocked a frame with origin",
  // error generated by microsoft outlook's safelink crawler on pages we email out
  // https://forum.sentry.io/t/unhandledrejection-non-error-promise-rejection-captured-with-value/14062
  "Object Not Found Matching Id",
  // Error that MAY indicate a performance issue due to browser implementation, but has been shown to be safe to ignore.
  // https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
  "ResizeObserver loop limit exceeded",
  "ResizeObserver loop completed with undelivered notifications"
];
var beforeSendFn = (mappers, event) => {
  return mappers.reduce((acc, mapper) => mapper(acc), event);
};
var beforeSend = (event) => {
  if (!event) {
    return null;
  }
  return beforeSendFn(MAPPERS, event);
};
var isPhantomJs = (event) => {
  if (typeof window === "undefined") {
    return event;
  }
  const isPhantomJS = /PhantomJS/.test(window.navigator.userAgent);
  return !isPhantomJS ? event : null;
};
var isInvalidArgumentError = (event) => {
  const firstFrameFilename = event?.exception?.values?.[0]?.stacktrace?.frames?.[0]?.filename || "";
  const eventMessage = event?.exception?.values?.[0]?.value || "";
  if (eventMessage.includes("Invalid argument") && firstFrameFilename.includes("maps-api-v3")) {
    return null;
  }
  if (eventMessage.includes('Could not load "map"') || eventMessage.includes('Could not load "marker"') || // Error occurs when watching Vimeo videos on Safari
  eventMessage.includes("The operation was aborted.")) {
    return null;
  }
  return event;
};
var isCloudflareWafBlock = (event) => {
  if (!event) {
    return event;
  }
  const message = typeof event.message === "string" ? event.message : "";
  const exceptionValue = event.exception?.values?.[0]?.value || "";
  const extras = event.extra ?? {};
  const extrasBlob = Object.values(extras).map((v) => {
    if (typeof v === "string") {
      return v;
    }
    if (v === null || v === void 0) {
      return "";
    }
    try {
      return JSON.stringify(v);
    } catch {
      return "";
    }
  }).join("\n");
  const haystack = `${message}
${exceptionValue}
${extrasBlob}`.toLowerCase();
  const isHtmlBlocked403 = haystack.includes("<!doctype html>") && haystack.includes("code: 403)");
  const isCloudflareSpecific = haystack.includes("errorcode: 1005") || haystack.includes("used cloudflare to restrict access");
  return isHtmlBlocked403 || isCloudflareSpecific ? null : event;
};
var MAPPERS = [isPhantomJs, isInvalidArgumentError, isCloudflareWafBlock];

// src/constants.ts
var UTM_MEDIUM = "utm_medium";
var UTM_SOURCE = "utm_source";
var UTM_CAMPAIGN = "utm_campaign";
var UTM_CONTENT = "utm_content";
var UTM_TERM = "utm_term";
var UTM_ADGID = "utm_adgid";
var UTM_NTWK = "utm_ntwk";
var UTM_SUBSITE = "utm_subsite";
var UTM_CTA = "utm_cta";
var UTM_EXTERNALID = "utm_externalid";
var UTM_GEO = "utm_geo";
var UTM_CAT = "utm_cat";

// src/devtools-events.ts
var subscribers = /* @__PURE__ */ new Set();
var MAX_BUFFERED_EVENTS = 500;
var eventBuffer = [];
function subscribeToDevtoolsEvents(callback) {
  eventBuffer.forEach((event) => callback(event));
  subscribers.add(callback);
  return () => subscribers.delete(callback);
}
function emitDevtoolsEvent(event) {
  eventBuffer.push(event);
  if (eventBuffer.length > MAX_BUFFERED_EVENTS) {
    eventBuffer.shift();
  }
  subscribers.forEach((callback) => callback(event));
}

// src/internal/analytics.ts
var analytics_exports = {};
__export(analytics_exports, {
  register: () => register,
  registerWithUserID: () => registerWithUserID,
  trackEvent: () => trackEvent,
  trackPageView: () => trackPageView
});

// src/internal/isQuotaExceededError.ts
var isQuotaExceededError = (e) => {
  let quotaExceeded = false;
  if (e) {
    if (e.code) {
      switch (e.code) {
        case 22:
          quotaExceeded = true;
          break;
        case 1014:
          if (e.name === "NS_ERROR_DOM_QUOTA_REACHED") {
            quotaExceeded = true;
          }
          break;
        default:
          break;
      }
    } else if (e.number === -2147024882) {
      quotaExceeded = true;
    }
  }
  return quotaExceeded;
};

// src/internal/analytics.ts
var LOG_LEVEL_CONFIG_NAME = "opendoor_log_level";
var log = (..._args) => {
  if (typeof window !== "undefined" && window.localStorage.getItem(LOG_LEVEL_CONFIG_NAME) === "true") {
    console.log(..._args);
  }
};
var wrapQuotaError = (cb) => {
  try {
    cb();
  } catch (e) {
    if (!isQuotaExceededError(e)) {
      globalObservability.getSentryClient().captureException?.(e);
    }
  }
};
var register = (traits) => {
  if (typeof ga === "function" && typeof traits === "object") {
    ga("set", traits);
  }
  segment_default.identify(traits);
  if (getDeployEnv() !== "production") {
    log(`[DEBUG] Analytics.register: 
${JSON.stringify(traits, null, 2)}`);
  }
};
var registerWithUserID = (userId, traits) => {
  if (typeof ga === "function" && typeof traits === "object") {
    ga("set", traits);
  }
  segment_default.identify(userId, traits);
  if (getDeployEnv() !== "production") {
    log(`[DEBUG] Analytics.register: 
${userId} ${JSON.stringify(traits, null, 2)}`);
  }
};
var trackEvent = (category, action, value, extra) => {
  wrapQuotaError(() => {
    if (typeof ga === "function") {
      ga("send", "event", category, action, value, extra);
    }
  });
  wrapQuotaError(() => {
    segment_default.track(`${category}-${action}`, {
      channel: "web",
      domain: window.location.host,
      screen: {
        height: window.screen.height,
        width: window.screen.width
      },
      value,
      ...extra
    });
  });
  wrapQuotaError(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: `${category}.${action}.${value}`, extra });
  });
  if (getDeployEnv() !== "production") {
    log(
      `[DEBUG] Analytics.trackEvent: 
${category}-${action} ${JSON.stringify(
        {
          value,
          ...extra
        },
        null,
        2
      )}`
    );
  }
};
var matchInAppQueryParam = (queryParams) => {
  const fragments = queryParams && queryParams.match(/app\=(\d+)/);
  if (!fragments) {
    return false;
  }
  return !!fragments[1];
};
var trackPageView = (extra) => {
  const location = window.location;
  const pathname = location.pathname;
  const search = location.search;
  trackEvent("page", "view", "page", {
    app: matchInAppQueryParam(search),
    pathname,
    search,
    ...extra
  });
};

// src/internal/gtmEvents.ts
function trackJourneyEventInGTM(categoryName, eventName, clientEventId) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "journey_event",
    journey_category: categoryName,
    journey_event_name: eventName,
    journey_event_id: clientEventId
  });
}

// src/observability-base.ts
var OD_UTM_COOKIE = "od_utm";
function readUtmCookie() {
  if (typeof document === "undefined") return void 0;
  try {
    const match = document.cookie.split(";").find((c) => c.trim().startsWith(`${OD_UTM_COOKIE}=`));
    if (!match) return void 0;
    const value = match.split("=").slice(1).join("=");
    return JSON.parse(decodeURIComponent(value.trim()));
  } catch {
    return void 0;
  }
}
var RealObservability = class {
  constructor(eventTrackingCategory) {
    this.eventTrackingCategory = eventTrackingCategory;
  }
  eventTrackingCategory;
  sentryClient = {};
  datadogRumClient = {};
  journeyUserClient = {};
  journeyEventClient = {};
  setSentryClient(sentryClient) {
    this.sentryClient = sentryClient;
  }
  getSentryClient() {
    return this.sentryClient;
  }
  setJourneyUserClient(journeyClient) {
    this.journeyUserClient = journeyClient;
  }
  setJourneyEventClient(journeyClient) {
    this.journeyEventClient = journeyClient;
  }
  getJourneyUserClient() {
    return this.journeyUserClient;
  }
  getJourneyEventClient() {
    return this.journeyEventClient;
  }
  setDatadogRumClient(datadogRumClient) {
    this.datadogRumClient = datadogRumClient;
  }
  getDatadogRumClient() {
    return this.datadogRumClient;
  }
  /**
   * Updates contextual data to add campaign context from URL search params.
   * When UTMs are in the URL, uses them directly (the CF Worker sets the od_utm cookie server-side).
   * When UTMs are not in the URL, falls back to reading the od_utm cookie.
   * This ensures SPA navigations retain campaign attribution from the landing page.
   */
  updateJourneyContextualData(contextualData = emptyJourneyEventContextualData) {
    if (typeof window !== "undefined") {
      const searchParams = new URLSearchParams(window.location.search);
      const utmParameters = [UTM_MEDIUM, UTM_SOURCE, UTM_CAMPAIGN, UTM_CONTENT, UTM_TERM];
      if (utmParameters.some((param) => searchParams.get(param))) {
        const campaignContext = {
          utmMedium: searchParams.get(UTM_MEDIUM) ?? void 0,
          utmSource: searchParams.get(UTM_SOURCE) ?? void 0,
          utmCampaign: searchParams.get(UTM_CAMPAIGN) ?? void 0,
          utmContent: searchParams.get(UTM_CONTENT) ?? void 0,
          utmTerm: searchParams.get(UTM_TERM) ?? void 0,
          utmAdgid: searchParams.get(UTM_ADGID) ?? void 0,
          utmNtwk: searchParams.get(UTM_NTWK) ?? void 0,
          utmSubsite: searchParams.get(UTM_SUBSITE) ?? void 0,
          utmCta: searchParams.get(UTM_CTA) ?? void 0,
          utmExternalid: searchParams.get(UTM_EXTERNALID) ?? void 0,
          utmGeo: searchParams.get(UTM_GEO) ?? void 0,
          utmCat: searchParams.get(UTM_CAT) ?? void 0
        };
        return { ...contextualData, campaignContext };
      }
      if (!contextualData.campaignContext) {
        const cookieCampaign = readUtmCookie();
        if (cookieCampaign) {
          return { ...contextualData, campaignContext: cookieCampaign };
        }
      }
    }
    return contextualData;
  }
  /**
   * Updates contextual data for non-journey events
   * This will be removed when we remove old versions of tracking data
   */
  updateDeprecatedContextualData(contextualData = emptyContextualData) {
    if (typeof window !== "undefined") {
      const searchParams = new URLSearchParams(window.location.search);
      const utmParameters = [UTM_MEDIUM, UTM_SOURCE, UTM_CAMPAIGN, UTM_CONTENT, UTM_TERM];
      if (utmParameters.some((param) => searchParams.get(param))) {
        const campaignContext = {
          utmMedium: searchParams.get(UTM_MEDIUM) ?? void 0,
          utmSource: searchParams.get(UTM_SOURCE) ?? void 0,
          utmCampaign: searchParams.get(UTM_CAMPAIGN) ?? void 0,
          utmContent: searchParams.get(UTM_CONTENT) ?? void 0,
          utmTerm: searchParams.get(UTM_TERM) ?? void 0
        };
        return {
          ...contextualData,
          campaignContext
        };
      }
    }
    return contextualData;
  }
  /**
   * Track events not performed by a user but meaningful internally. For events performed
   * by a user, use `trackUserEvent`.
   *
   * TODO (@core-experience-platform): rename to `trackInternalEvent`
   */
  trackEvent(action, label, contextualData = emptyContextualData, options) {
    contextualData = this.updateDeprecatedContextualData(contextualData);
    contextualData = mergeContextualData(contextualData, getContextualDataFromDatadog());
    if (getDeployEnv() !== "production") {
      const categoryOverride = options?.categoryOverride ? String(options.categoryOverride) : void 0;
      emitDevtoolsEvent({
        type: "trackEvent",
        action: String(action),
        label,
        categoryOverride,
        contextualData
      });
    }
    trackEvent(
      options?.categoryOverride ?? this.eventTrackingCategory,
      action,
      label,
      contextualData.data
    );
    trackEventInDatadog(action, label, contextualData);
    trackEventInSentry(action, label, contextualData);
    if (options?.addTiming) {
      trackPerformanceInDatadog(`${this.eventTrackingCategory}-${action}-${label}`);
    }
  }
  /**
   * @deprecated Use trackJourneyEvent instead
   * @see https://opendoor.atlassian.net/wiki/spaces/CONSUMER/pages/2283536444/How+to+Create+Journey+2.0+Events
   */
  trackUserEvent(event, contextualData = emptyContextualData) {
    contextualData = this.updateDeprecatedContextualData(contextualData);
    trackUserEventInJourney(event, contextualData);
    trackUserEventInDatadog(event, contextualData);
    trackUserEventInSentry(event, contextualData);
  }
  trackJourneyEvent(categoryName, eventName, eventData, contextualData = emptyJourneyEventContextualData, options) {
    const eventWrapper = {
      [categoryName]: {
        [eventName]: eventData
      }
    };
    contextualData = this.updateJourneyContextualData(contextualData);
    if (getDeployEnv() !== "production") {
      emitDevtoolsEvent({
        type: "trackJourneyEvent",
        categoryName: String(categoryName),
        eventName: String(eventName),
        eventData,
        contextualData
      });
    }
    const clientEventId = typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : void 0;
    trackJourneyEventInJourney(eventWrapper, contextualData, void 0, clientEventId);
    if (clientEventId) {
      trackJourneyEventInGTM(String(categoryName), String(eventName), clientEventId);
    }
    trackJourneyEventInDatadog(eventWrapper, contextualData);
    trackJourneyEventInSentry(eventWrapper, contextualData);
    if (options?.flush) {
      globalObservability.getJourneyEventClient().send?.();
    }
  }
  trackError(label, error, contextualData = emptyContextualData, options) {
    contextualData = this.updateDeprecatedContextualData(contextualData);
    contextualData = mergeContextualData(contextualData, getContextualDataFromDatadog());
    if (!options?.skipSentry) {
      const sentryContextualData = trackErrorInSentry(label, error, contextualData);
      contextualData = mergeContextualData(contextualData, sentryContextualData);
    }
    trackErrorInDatadog(label, error, contextualData);
    trackEvent(this.eventTrackingCategory, "error", label, contextualData.data);
    if (options?.addTiming) {
      trackPerformanceInDatadog(`${this.eventTrackingCategory}-error-${label}`);
    }
  }
};
var testonly = {
  initDebugObservability(opts = {}) {
    globalObservability.setCurrentInstance(new DebugObservability({ log: true, ...opts }));
  }
};
function useFakeObservability() {
  return {
    trackJourneyEvent: (categoryName, eventName, eventData) => {
      const eventWrapper = {
        [categoryName]: {
          [eventName]: eventData
        }
      };
      console.info(`trackClientJourneyEvent(${JSON.stringify(eventWrapper)})`);
    }
  };
}
var DebugObservability = class {
  constructor(opts = {}, eventTrackingCategory) {
    this.eventTrackingCategory = eventTrackingCategory;
    this.sentryClient = opts?.sentryClient || {};
    this.journeyUserClient = opts?.journeyUserClient || {};
    this.journeyEventClient = opts?.journeyEventClient || {};
    this.datadogRumClient = opts?.datadogRumClient || {};
    this.log = opts?.log || false;
    this.sendJourneyEventsInDev = opts?.sendJourneyEventsInDev || false;
    this.env = opts?.env;
  }
  eventTrackingCategory;
  sentryClient = {};
  journeyUserClient = {};
  journeyEventClient = {};
  datadogRumClient = {};
  log = false;
  sendJourneyEventsInDev = false;
  env = getDeployEnv();
  /**
   * Updates contextual data to add campaign context from URL search params.
   * When UTMs are in the URL, uses them directly (the CF Worker sets the od_utm cookie server-side).
   * When UTMs are not in the URL, falls back to reading the od_utm cookie.
   * This ensures SPA navigations retain campaign attribution from the landing page.
   */
  updateJourneyContextualData(contextualData = emptyJourneyEventContextualData) {
    if (typeof window !== "undefined") {
      const searchParams = new URLSearchParams(window.location.search);
      const utmParameters = [UTM_MEDIUM, UTM_SOURCE, UTM_CAMPAIGN, UTM_CONTENT, UTM_TERM];
      if (utmParameters.some((param) => searchParams.get(param))) {
        const campaignContext = {
          utmMedium: searchParams.get(UTM_MEDIUM) ?? void 0,
          utmSource: searchParams.get(UTM_SOURCE) ?? void 0,
          utmCampaign: searchParams.get(UTM_CAMPAIGN) ?? void 0,
          utmContent: searchParams.get(UTM_CONTENT) ?? void 0,
          utmTerm: searchParams.get(UTM_TERM) ?? void 0,
          utmAdgid: searchParams.get(UTM_ADGID) ?? void 0,
          utmNtwk: searchParams.get(UTM_NTWK) ?? void 0,
          utmSubsite: searchParams.get(UTM_SUBSITE) ?? void 0,
          utmCta: searchParams.get(UTM_CTA) ?? void 0,
          utmExternalid: searchParams.get(UTM_EXTERNALID) ?? void 0,
          utmGeo: searchParams.get(UTM_GEO) ?? void 0,
          utmCat: searchParams.get(UTM_CAT) ?? void 0
        };
        return { ...contextualData, campaignContext };
      }
      if (!contextualData.campaignContext) {
        const cookieCampaign = readUtmCookie();
        if (cookieCampaign) {
          return { ...contextualData, campaignContext: cookieCampaign };
        }
      }
    }
    return contextualData;
  }
  /**
   * Updates contextual data for non-journey events
   * This will be removed when we remove old versions of tracking data
   */
  updateDeprecatedContextualData(contextualData = emptyContextualData) {
    if (typeof window !== "undefined") {
      const searchParams = new URLSearchParams(window.location.search);
      const utmParameters = [UTM_MEDIUM, UTM_SOURCE, UTM_CAMPAIGN, UTM_CONTENT, UTM_TERM];
      if (utmParameters.some((param) => searchParams.get(param))) {
        const campaignContext = {
          utmMedium: searchParams.get(UTM_MEDIUM) ?? void 0,
          utmSource: searchParams.get(UTM_SOURCE) ?? void 0,
          utmCampaign: searchParams.get(UTM_CAMPAIGN) ?? void 0,
          utmContent: searchParams.get(UTM_CONTENT) ?? void 0,
          utmTerm: searchParams.get(UTM_TERM) ?? void 0
        };
        return {
          ...contextualData,
          campaignContext
        };
      }
    }
    return contextualData;
  }
  trackEvent(action, label, contextualData = emptyContextualData, options) {
    contextualData = this.updateDeprecatedContextualData(contextualData);
    const categoryOverride = options?.categoryOverride ? String(options.categoryOverride) : void 0;
    emitDevtoolsEvent({
      type: "trackEvent",
      action: String(action),
      label,
      categoryOverride,
      contextualData
    });
    if (this.log) {
      const categoryPrefix = categoryOverride ? `${categoryOverride}, ` : "";
      console.info(`trackEvent(${categoryPrefix}${action}, ${label})`, contextualData);
    }
  }
  trackUserEvent(event, contextualData = emptyContextualData) {
    contextualData = this.updateDeprecatedContextualData(contextualData);
    this.log && console.info(`trackUserEvent(${JSON.stringify(event)})`, contextualData);
  }
  trackJourneyEvent(categoryName, eventName, eventData, contextualData = emptyJourneyEventContextualData, options) {
    const eventWrapper = {
      [categoryName]: {
        [eventName]: eventData
      }
    };
    contextualData = this.updateJourneyContextualData(contextualData);
    emitDevtoolsEvent({
      type: "trackJourneyEvent",
      categoryName: String(categoryName),
      eventName: String(eventName),
      eventData,
      contextualData
    });
    const clientEventId = typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : void 0;
    if (this.sendJourneyEventsInDev && this.env === "development") {
      trackJourneyEventInJourney(
        eventWrapper,
        contextualData,
        this.sendJourneyEventsInDev,
        clientEventId
      );
      if (clientEventId) {
        trackJourneyEventInGTM(String(categoryName), String(eventName), clientEventId);
      }
      if (options?.flush) {
        globalObservability.getJourneyEventClient().send?.();
      }
    }
    this.log && console.info(`trackJourneyEvent(${JSON.stringify(eventWrapper)})`, {
      clientEventId,
      ...contextualData
    });
  }
  trackError(label, error, contextualData = emptyContextualData) {
    contextualData = this.updateDeprecatedContextualData(contextualData);
    this.log && console.error(`trackError(${label})`, error, contextualData);
  }
  setDatadogRumClient(datadogRumClient) {
    this.datadogRumClient = datadogRumClient;
  }
  getDatadogRumClient() {
    return this.datadogRumClient;
  }
  setJourneyUserClient(journeyClient) {
    this.journeyUserClient = journeyClient;
  }
  setJourneyEventClient(journeyClient) {
    this.journeyEventClient = journeyClient;
  }
  getJourneyUserClient() {
    return this.journeyUserClient;
  }
  getJourneyEventClient() {
    return this.journeyEventClient;
  }
  setSentClient(sentryClient) {
    this.sentryClient = sentryClient;
  }
  getSentryClient() {
    return this.sentryClient;
  }
};
var addDatadogRUMGlobalContext = (context) => {
  addRUMGlobalContext(context);
};

// src/declarations/JourneyEvent.ts
var NON_CATEGORY_FIELDS = (/* unused pure expression or super */ null && ([
  "timestamp",
  "websiteSource",
  "mobileSource",
  "backendSource",
  "edgeSource",
  "backfillSource",
  "anonymousId",
  "customerUuid",
  "campaignContext",
  "analyticsContext",
  "clientEventId"
]));

// src/react/ContextualDataContext.tsx

var ContextualDataContext = react.createContext(emptyContextualData);
var useContextualData = () => {
  return (0,react.useContext)(ContextualDataContext);
};
var AddContextualData = ({
  children,
  user,
  data = {},
  campaignContext,
  customerContext,
  exclusiveOffersContext,
  leadContext,
  sellDirectContext
}) => {
  const parent = useContextualData();
  return /* @__PURE__ */ react.createElement(
    ContextualDataContext.Provider,
    {
      value: mergeContextualData(parent, {
        user,
        data,
        campaignContext,
        customerContext,
        exclusiveOffersContext,
        leadContext,
        sellDirectContext
      })
    },
    children
  );
};

// src/react/useObservability.ts

function useObservability() {
  const env = getDeployEnv();
  const contextualData = useContextualData();
  const contextualDataRef = (0,react.useRef)(contextualData);
  (0,react.useEffect)(() => {
    contextualDataRef.current = contextualData;
  }, [contextualData]);
  return (0,react.useMemo)(
    () => ({
      /**
       * Track events not performed by a user but meaningful internally. For events performed
       * by a user, use `trackUserEvent`.
       *
       * TODO (@core-experience-platform): rename to `trackInternalEvent`
       */
      trackEvent: (action, label, data, options) => {
        if (!globalObservability.isInitialized()) {
          if (env === "production") {
            return;
          }
          throw new Error("Call initObservability before trackEvent");
        }
        globalObservability.trackEvent(
          action,
          label,
          mergeContextualData(contextualDataRef.current, { data }),
          options
        );
      },
      /**
       * @deprecated Use trackJourneyEvent instead
       * @see https://opendoor.atlassian.net/wiki/spaces/CONSUMER/pages/2283536444/How+to+Create+Journey+2.0+Events
       */
      trackUserEvent: (event) => {
        if (!globalObservability.isInitialized()) {
          if (env === "production") {
            return;
          }
          throw new Error("Call initObservability before trackUserEvent");
        }
        globalObservability.trackUserEvent(event, contextualDataRef.current);
      },
      trackJourneyEvent: (categoryName, eventName, eventData, options) => {
        if (!globalObservability.isInitialized()) {
          if (env === "production") {
            return;
          }
          throw new Error("Call initObservability before trackJourneyEvent");
        }
        globalObservability.trackJourneyEvent(
          categoryName,
          eventName,
          eventData,
          contextualDataRef.current,
          options
        );
      },
      trackError: (label, error, data, options) => {
        if (!globalObservability.isInitialized()) {
          if (env === "production") {
            return;
          }
          throw new Error("Call initObservability before trackError");
        }
        globalObservability.trackError(
          label,
          error,
          mergeContextualData(contextualDataRef.current, { data }),
          options
        );
      }
    }),
    [env]
  );
}



;// CONCATENATED MODULE: ../observability/dist/observability-slim.mjs


// src/observability-slim.ts
function initObservability({
  appName,
  env,
  version,
  eventTrackingCategory,
  sentry,
  datadog,
  debug,
  sendJourneyEventsInDev,
  journeyEndpoint,
  lazyLoadAnalytics,
  isBot
}) {
  if (globalObservability.isInitialized()) {
    throw new Error("initObservability was already called");
  }
  env = env || getDeployEnv();
  if (env === "development") {
    let journeyEventClient = void 0;
    if (sendJourneyEventsInDev) {
      const { eventClient } = initJourney(BASE_JOURNEY_ENDPOINT);
      journeyEventClient = eventClient;
    }
    globalObservability.setCurrentInstance(
      new DebugObservability(
        {
          log: debug,
          sendJourneyEventsInDev,
          journeyEventClient,
          env
        },
        eventTrackingCategory
      )
    );
  } else {
    if (typeof window !== "undefined" && !isBot) {
      loadGoogleTagManager(lazyLoadAnalytics);
      loadSegment(void 0, lazyLoadAnalytics);
    }
    const realObservabilityInstance = new RealObservability(
      eventTrackingCategory
    );
    if (!isBot) {
      const { eventClient, userClient } = initJourney(journeyEndpoint);
      userClient && realObservabilityInstance.setJourneyUserClient(userClient);
      eventClient && realObservabilityInstance.setJourneyEventClient(eventClient);
    }
    globalObservability.setCurrentInstance(realObservabilityInstance);
    sentry?.init({ ...buildDefaultSentryOpts({ appName, env, version }), ...sentry }).then((sentryClient) => {
      realObservabilityInstance.setSentryClient(sentryClient);
    }).catch((e) => {
      console.error("Error initializing Sentry", e);
    });
    datadog?.init({ ...buildDefaultDatadogOptions({ appName, env, version }), ...datadog }).then((datadogRumClient) => {
      realObservabilityInstance.setDatadogRumClient(datadogRumClient);
    }).catch((e) => {
      console.error("Error initializing Datadog", e);
    });
  }
}



/***/ }),

/***/ 7004:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ commonGlobals_default; }
/* harmony export */ });
//#region src/commonGlobals.ts
var commonGlobals_default = {
	development: {
		sentryUrl: "https://afc1da46c22d4c72b8cc5f5551fd6cb8@sentry.io/1232559",
		googleMaps: "AIzaSyDoC3xVaCEZ2_S9Law-RubacPfYNZSQkBY",
		segment: "piNVbkzXee9duAVuZBuTbCIJSmZ23KLL",
		webApiUrl: "https://demo.simplersell.com",
		facebookAppID: "",
		googleClientID: "776479837796-ape5m5sc6ig7ei2oe2bd2modqdkhrm1a.apps.googleusercontent.com",
		hellosignClientID: "d1c7dd4be8cc9bf9913beed4bff4fe29",
		intercomAppId: "c505rgbd",
		consumerFeUrl: "http://localhost:3010",
		partnerBffUrl: "http://localhost:2995",
		partnerWebappUrl: "http://localhost:3003",
		railsUrl: "https://demo.simplersell.com",
		adminUrl: "https://admin.simplersell.com",
		redirectURLsRegex: /.*/,
		buyerUrl: "http://localhost:3000",
		cakeUrl: "http://localhost:3016",
		partnershipDashboardUrl: "http://localhost:3003",
		cityUrl: "http://localhost:3001",
		nomadUrl: "http://localhost:3000",
		maestroUrl: "http://localhost:3000"
	},
	qa: {
		googleMaps: "AIzaSyCTWhHrbB0MQB1LLI00jmhtgsOJi9m2NnE",
		segment: "piNVbkzXee9duAVuZBuTbCIJSmZ23KLL",
		webApiUrl: "https://demo.simplersell.com",
		facebookAppID: "",
		hellosignClientID: "d1c7dd4be8cc9bf9913beed4bff4fe29",
		googleClientID: "",
		intercomAppId: "c505rgbd",
		consumerFeUrl: "https://consumer.simplersell.com",
		partnerBffUrl: "https://partner.simplersell.com",
		partnerWebappUrl: "https://partner.simplersell.com",
		railsUrl: "https://demo.simplersell.com",
		adminUrl: "https://admin.simplersell.com",
		redirectURLsRegex: /^https?:\/\/([a-z-]+\.)*(simplersell|qa.buy.opendoor)\.com(?=\/|$)/,
		buyerUrl: "https://staging-buy.simplersell.com",
		cakeUrl: "https://consumer.simplersell.com",
		partnershipDashboardUrl: "https://partner.simplersell.com",
		cityUrl: "http://city.apps-staging.opendoor.com",
		nomadUrl: "https://nomad.apps-staging.opendoor.com",
		maestroUrl: "https://maestro.apps-staging.opendoor.com"
	},
	staging: {
		googleMaps: "AIzaSyCTWhHrbB0MQB1LLI00jmhtgsOJi9m2NnE",
		segment: "hi0UliZdyDxaQblHZWB3HfgghAAuegGx",
		webApiUrl: "https://demo.simplersell.com",
		facebookAppID: "534640070339580",
		hellosignClientID: "d1c7dd4be8cc9bf9913beed4bff4fe29",
		googleClientID: "121750171886-1udhbfom8jjascfnsscaupb7n4p17csm.apps.googleusercontent.com",
		intercomAppId: "c505rgbd",
		consumerFeUrl: "https://consumer.simplersell.com",
		partnerBffUrl: "https://partner.simplersell.com",
		partnerWebappUrl: "https://partner.simplersell.com",
		railsUrl: "https://demo.simplersell.com",
		adminUrl: "https://admin.simplersell.com",
		redirectURLsRegex: /^https?:\/\/([a-z0-9-]+\.)*(simplersell|(qa|staging)\.buy\.opendoor|apps-staging\.opendoor)\.com(?=\/|$)/,
		buyerUrl: "https://staging-buy.simplersell.com",
		cakeUrl: "https://consumer.simplersell.com",
		partnershipDashboardUrl: "https://partner.simplersell.com",
		cityUrl: "http://city.apps-staging.opendoor.com",
		nomadUrl: "https://nomad.apps-staging.opendoor.com",
		maestroUrl: "https://maestro.apps-staging.opendoor.com"
	},
	production: {
		googleMaps: "AIzaSyCPmXHjINLKF7UeKQgCsgZ4r8AUGGNzhNk",
		segment: "Wx5CZGhLsaRDV4ILcNSKgxn5iZG7ErOU",
		webApiUrl: "https://www.opendoor.com",
		facebookAppID: "293808974545537",
		hellosignClientID: "8260c9a5cd5402d13ce6f37342e3f881",
		googleClientID: "121750171886-1udhbfom8jjascfnsscaupb7n4p17csm.apps.googleusercontent.com",
		intercomAppId: "xu4pjti7",
		consumerFeUrl: "https://consumer.opendoor.com",
		partnerBffUrl: "https://partner.opendoor.com",
		partnerWebappUrl: "https://partner.opendoor.com",
		railsUrl: "https://www.opendoor.com",
		adminUrl: "https://admin.opendoor.com",
		redirectURLsRegex: /^https?:\/\/([a-z-]+\.)*opendoor\.com(?=\/|$)/,
		buyerUrl: "https://buy.opendoor.com",
		cakeUrl: "https://consumer.opendoor.com",
		partnershipDashboardUrl: "https://partner.opendoor.com",
		cityUrl: "https://city.apps.opendoor.com",
		nomadUrl: "https://nomad.ops.opendoor.com",
		maestroUrl: "https://maestro.apps.opendoor.com"
	},
	localdev: {
		sentryUrl: "",
		googleMaps: "",
		segment: "",
		webApiUrl: "http://localhost:5006",
		facebookAppID: "",
		googleClientID: "",
		hellosignClientID: "",
		intercomAppId: "",
		consumerFeUrl: "http://localhost:3010",
		partnerBffUrl: "http://localhost:2995",
		partnerWebappUrl: "http://localhost:3003",
		railsUrl: "http://localhost:5006",
		adminUrl: "http://localhost:5006",
		redirectURLsRegex: /.*/,
		buyerUrl: "http://localhost:3000",
		cakeUrl: "http://localhost:3016",
		partnershipDashboardUrl: "http://localhost:3003",
		cityUrl: "http://localhost:3001",
		nomadUrl: "http://localhost:3000",
		maestroUrl: "http://localhost:3000"
	},
	test: {
		sentryUrl: "",
		googleMaps: "AIzaSyB1lEtzN4O0FqRqG9ouIq6D-W93ZHSIZ34",
		segment: "",
		facebookAppID: "",
		googleClientID: "",
		hellosignClientID: "",
		webApiUrl: "http://localhost:5006",
		intercomAppId: "test",
		consumerFeUrl: "http://localhost:3010",
		partnerBffUrl: "http://localhost:2995",
		partnerWebappUrl: "http://localhost:3003",
		railsUrl: "http://localhost:5006",
		adminUrl: "http://localhost:5006",
		redirectURLsRegex: /.*/,
		buyerUrl: "http://localhost:3000",
		cakeUrl: "http://localhost:3016",
		partnershipDashboardUrl: "http://localhost:3003",
		cityUrl: "http://localhost:3001",
		nomadUrl: "http://localhost:3000",
		maestroUrl: "http://localhost:3000"
	}
};
//#endregion


//# sourceMappingURL=commonGlobals.mjs.map

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(80079), __webpack_exec__(68276), __webpack_exec__(22404); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);